/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} toolBarAlignmentMenuClickParams
* @property {string} category - {Move Forward, Move Backward, Move to Front, Move to Back}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tool_Bar_Alignment_Menu_Click. Evid: 262.
 * Event description: Tool_Bar_Alignment_Menu_Click.

 * category - Type: string. Desc: {Move Forward, Move Backward, Move to Front, Move to Back}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toolBarAlignmentMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolBarAlignmentMenuClick = function (params) {
    return { evid: 262, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsAllSetUpActionFinishedParams
* @property {string} app_id - app_id
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> all set up action finished. Evid: 1287.
 * Event description: ALL set up action finished.

 * app_id - Type: string. Desc: app_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsAllSetUpActionFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsAllSetUpActionFinished = function (params) {
    return { evid: 1287, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderValueRangeChangedParams
* @property {string} behavior - null
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} section - minValue/maxValue/min/max/prefix/suffix
* @property {string} selection - 1,2,3..
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_value_range_changed. Evid: 1324.
 * Event description: range_slider_value_range_changed.

 * behavior - Type: string.
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string. Desc: minValue/maxValue/min/max/prefix/suffix
 *
 * selection - Type: string. Desc: 1,2,3..
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderValueRangeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderValueRangeChanged = function (params) {
    return { evid: 1324, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} platformAppAddedParams
* @property {string} adding_method - {click,drag}
* @property {string} allAppsToInstall - array of all the apps that installed on this session
* @property {string} app_id - app_id
* @property {string} app_name - app name
* @property {string} app_type - TPA SECTION/ TPAWidget/ PLATFORM
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration from 38:755
* @property {GUID} esi - esi
* @property {GUID} flowId - Silent install flow id
* @property {boolean} isProvision - if app was first app in provision process
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {add panel, my uploads panel.}
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: platform App Added. Evid: 746.
 * Event description: platform App added to stage.

 * adding_method - Type: string. Desc: {click,drag}
 *
 * allAppsToInstall - Type: string. Desc: array of all the apps that installed on this session
 *
 * app_id - Type: string. Desc: app_id
 *
 * app_name - Type: string. Desc: app name
 *
 * app_type - Type: string. Desc: TPA SECTION/ TPAWidget/ PLATFORM
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration from 38:755
 *
 * esi - Type: guid. Desc: esi
 *
 * flowId - Type: guid. Desc: Silent install flow id
 *
 * isProvision - Type: bool. Desc: if app was first app in provision process
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {add panel, my uploads panel.}
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {platformAppAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var platformAppAdded = function (params) {
    return { evid: 746, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startNowClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Start now click. Evid: 491.
 * Event description: Intro video for new users: Start now click: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startNowClick = function (params) {
    return { evid: 491, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} singleVideoPlayerCoverImageFadeOutChangedParams
* @property {string} component_type - video
* @property {string} dm_version - null
* @property {string} ds_origin - editor / editor x ...
* @property {GUID} esi - esi
* @property {boolean} isEnabled - fade out true / false
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoId - video ID
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: singleVideoPlayer.coverImage.fadeOut.changed. Evid: 1511.
 * Event description: User click on toggle for Cove Image Fade-Out true/false.

 * component_type - Type: string. Desc: video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: editor / editor x ...
 *
 * esi - Type: guid. Desc: esi
 *
 * isEnabled - Type: bool. Desc: fade out true / false
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoId - Type: string. Desc: video ID
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {singleVideoPlayerCoverImageFadeOutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var singleVideoPlayerCoverImageFadeOutChanged = function (params) {
    return { evid: 1511, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorpickerMainpanelMycolorsSelectParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - text_color_picker / theme_color_picker
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - color #
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorpicker_mainpanel_mycolors_select. Evid: 135.
 * Event description: ColorPicker_MainPanel_MyColors_Select.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: text_color_picker / theme_color_picker
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: color #
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorpickerMainpanelMycolorsSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorpickerMainpanelMycolorsSelect = function (params) {
    return { evid: 135, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderManageChoicesDeleteChoiceParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - Manage Choices- Delete Choice. Evid: 1163.
 * Event description: Form widget --> Multiple choices field --> Manage Choices- Delete Choice.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderManageChoicesDeleteChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderManageChoicesDeleteChoice = function (params) {
    return { evid: 1163, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageOrPopUpHideParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_or_popup - {page, pop up,members page}
* @property {number} page_popup_id - {}
* @property {string} page_popup_name - {}
* @property {string} page_popup_string_id - {mainPage,zxc5v,...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_or_pop_up _hide. Evid: 709.
 * Event description: page_or_pop_up _hide.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_or_popup - Type: string. Desc: {page, pop up,members page}
 *
 * page_popup_id - Type: numeric. Desc: {}
 *
 * page_popup_name - Type: string. Desc: {}
 *
 * page_popup_string_id - Type: string. Desc: {mainPage,zxc5v,...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageOrPopUpHideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageOrPopUpHide = function (params) {
    return { evid: 709, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateResize637Params
* @property {string} component_id - component_id
* @property {string} component_type - {}
* @property {string} devMode - dev mode on/off
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {boolean} out_of_grid - if element currently is out of grid (true/false)
* @property {boolean} out_of_grid_previously - if element was out of grid (true/false
* @property {string} pageContext - page context
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_RESIZE. Evid: 637.
 * Event description: frame view rate for RESIZE.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {}
 *
 * devMode - Type: string. Desc: dev mode on/off
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * out_of_grid - Type: bool. Desc: if element currently is out of grid (true/false)
 *
 * out_of_grid_previously - Type: bool. Desc: if element was out of grid (true/false
 *
 * pageContext - Type: string. Desc: page context
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateResize637Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateResize637 = function (params) {
    return { evid: 637, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changeThePositionOfAComponentInTheToolbarParams
* @property {string} component_id - component_id
* @property {string} component_type - component actual name from the code: wysiwyg.....
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} entry_type - manual / calculation
* @property {GUID} esi - .
* @property {boolean} isChanged - true/false (send true when user has resized)
* @property {boolean} is_rollout - true / false
* @property {boolean} isSection - true / false
* @property {boolean} isSiteCreation - true / false
* @property {boolean} isZoomOut - true / false
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} parent_component_id - parent_component_id (example: id of strip/ section the component is in)
* @property {string} parent_component_type - parent_component_type parent_component_id (example: type strip/ section the component is in
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
* @property {string} xCoordinate_new - {X value of component's New location}
* @property {string} xCoordinate_old - {X value of component's Old location}
* @property {string} yCoordinate_new - {Y value of component's New location}
* @property {string} yCoordinate_old - {Y value of component's Old location}
**/
/**
 * Name: Change the position of a component in the toolbar. Evid: 1394.
 * Event description: manually change position of the component.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component actual name from the code: wysiwyg.....
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * entry_type - Type: string. Desc: manual / calculation
 *
 * esi - Type: guid. Desc: .
 *
 * isChanged - Type: bool. Desc: true/false (send true when user has resized)
 *
 * is_rollout - Type: bool. Desc: true / false
 *
 * isSection - Type: bool. Desc: true / false
 *
 * isSiteCreation - Type: bool. Desc: true / false
 *
 * isZoomOut - Type: bool. Desc: true / false
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * parent_component_id - Type: string. Desc: parent_component_id (example: id of strip/ section the component is in)
 *
 * parent_component_type - Type: string. Desc: parent_component_type parent_component_id (example: type strip/ section the component is in
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 *
 * xCoordinate_new - Type: string. Desc: {X value of component's New location}
 *
 * xCoordinate_old - Type: string. Desc: {X value of component's Old location}
 *
 * yCoordinate_new - Type: string. Desc: {Y value of component's New location}
 *
 * yCoordinate_old - Type: string. Desc: {Y value of component's Old location}
 * @param {changeThePositionOfAComponentInTheToolbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeThePositionOfAComponentInTheToolbar = function (params) {
    return { evid: 1394, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardStartParams
* @property {string} appsToInstall - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - null
* @property {string} flow - .
* @property {string} industryId - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} screenResolution - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} structureId - .
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - null
* @property {string} view - first view in Wizard
* @property {string} viewerName - .
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: start. Evid: 1249.
 * Event description: When user saw the first screen of Editor 2.0 SiteCreation Wizard.

 * appsToInstall - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid.
 *
 * flow - Type: string. Desc: .
 *
 * industryId - Type: string. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * structureId - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid.
 *
 * view - Type: string. Desc: first view in Wizard
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardStart = function (params) {
    return { evid: 1249, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dataCorruptionMessageParams
* @property {string} date_corruption_type - date_corruption_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} messageType - type of message sent to user
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: data_corruption_message. Evid: 840.
 * Event description: When a data corruption has occurred user gets a popup the explains  that "something went went wrong please reload the page ".

 * date_corruption_type - Type: string. Desc: date_corruption_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * messageType - Type: string. Desc: type of message sent to user
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dataCorruptionMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dataCorruptionMessage = function (params) {
    return { evid: 840, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelLinkClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - menu_click / link / unlink
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Link_Click. Evid: 240.
 * Event description: Text_Panel_Link_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: menu_click / link / unlink
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelLinkClick = function (params) {
    return { evid: 240, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesDeleteChoiceParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} choice_name - choice_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices-  Delete Choice. Evid: 908.
 * Event description: user click on delete choice.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * choice_name - Type: string. Desc: choice_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesDeleteChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesDeleteChoice = function (params) {
    return { evid: 908, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerLayoutPlayButtonSizeChangedParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - desktop / mobile
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.layout.playButtonSize.changed. Evid: 828.
 * Event description: User changed play button size.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: desktop / mobile
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerLayoutPlayButtonSizeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerLayoutPlayButtonSizeChanged = function (params) {
    return { evid: 828, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteAdvancedSettingsChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} previous_value - previous colour name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - colour name
* @property {string} totalJsHeapSize - null
* @property {string} type - linked, unlinked
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette advanced settings changed. Evid: 1436.
 * Event description: Color palette advanced settings changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * previous_value - Type: string. Desc: previous colour name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: colour name
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: linked, unlinked
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteAdvancedSettingsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteAdvancedSettingsChanged = function (params) {
    return { evid: 1436, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editMainColorMoreColorsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Main_Color_MoreColors. Evid: 409.
 * Event description: Edit_Main_Color_MoreColors.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editMainColorMoreColorsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editMainColorMoreColors = function (params) {
    return { evid: 409, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuSubPageCreatedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {drag, quick actions}
* @property {GUID} site_id - {}
* @property {string} source - {site menu ,members menu, custom menu}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_menu_sub_page_created. Evid: 417.
 * Event description: PAGES_menu_sub_page_created.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {drag, quick actions}
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {site menu ,members menu, custom menu}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuSubPageCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuSubPageCreated = function (params) {
    return { evid: 417, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishShoutOutShareClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_ShoutOut_Share_click. Evid: 391.
 * Event description: Second_Publish_ShoutOut_Share_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishShoutOutShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishShoutOutShareClick = function (params) {
    return { evid: 391, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsBoltIsForcedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} open_method - editor 2.0 wizard / templates
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Sections - bolt is forced. Evid: 1294.
 * Event description: if the editor senses during the editor Loading process that the Sections Experience is on and viewer is TB, then we redirect the user to the same URL but with forced BOLT (petri_ovr=specs.UseTbInPreview:false).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * open_method - Type: string. Desc: editor 2.0 wizard / templates
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionsBoltIsForcedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsBoltIsForced = function (params) {
    return { evid: 1294, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} adiToEditorWarningBeforeSaveActionClickedParams
* @property {string} action - {Go Back to Wix ADI, Save Changes, Cancel, Help, Learn More}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: adi_to_editor_warning_before_save_action_clicked. Evid: 619.
 * Event description: adi_to_editor_warning_before_save_action_clicked.

 * action - Type: string. Desc: {Go Back to Wix ADI, Save Changes, Cancel, Help, Learn More}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {adiToEditorWarningBeforeSaveActionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adiToEditorWarningBeforeSaveActionClicked = function (params) {
    return { evid: 619, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} customPageInfoShownParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} info_text - {text of info}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {custom page, app pages}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Custom Page Info Shown. Evid: 1444.
 * Event description: Custom Page Info Shown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * info_text - Type: string. Desc: {text of info}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {custom page, app pages}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {customPageInfoShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customPageInfoShown = function (params) {
    return { evid: 1444, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} autoSaveDiffsRestoredParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: auto_save_diffs_restored. Evid: 623.
 * Event description: auto_save_diffs_restored.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {autoSaveDiffsRestoredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autoSaveDiffsRestored = function (params) {
    return { evid: 623, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationErrorOfMigrationFallbackParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - init / tpa / navigation
* @property {number} revision - revision
* @property {number} sections_number - sections_number
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} undo_label - undo_label
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - error of migration fallback. Evid: 1400.
 * Event description: Fallback is not possible.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: init / tpa / navigation
 *
 * revision - Type: numeric. Desc: revision
 *
 * sections_number - Type: numeric. Desc: sections_number
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * undo_label - Type: string. Desc: undo_label
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationErrorOfMigrationFallbackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationErrorOfMigrationFallback = function (params) {
    return { evid: 1400, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchItemHoverParams
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} clickOrigin - mouse / keyboard
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} itemId - item name / id
* @property {number} itemIndex - item index
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.item.hover. Evid: 996.
 * Event description: Item hover in search results.

 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * clickOrigin - Type: string. Desc: mouse / keyboard
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * itemId - Type: string. Desc: item name / id
 *
 * itemIndex - Type: numeric. Desc: item index
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchItemHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchItemHover = function (params) {
    return { evid: 996, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pauseAnimationParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pause_animation. Evid: 784.
 * Event description: pause_animation.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pauseAnimationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pauseAnimation = function (params) {
    return { evid: 784, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} toolBarMatchSizeMenuClickParams
* @property {string} category - {To Width, To Height, To Both}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tool_Bar_Match_Size_menu_click. Evid: 266.
 * Event description: Tool_Bar_Match_Size_menu_click.

 * category - Type: string. Desc: {To Width, To Height, To Both}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toolBarMatchSizeMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolBarMatchSizeMenuClick = function (params) {
    return { evid: 266, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbIconSeparatorChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} display_mode - wrap/ellipsis
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - vshape/backslash
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_icon_separator_changed. Evid: 1239.
 * Event description: breadcrumb_icon_separator_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * display_mode - Type: string. Desc: wrap/ellipsis
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: vshape/backslash
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbIconSeparatorChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbIconSeparatorChanged = function (params) {
    return { evid: 1239, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuTabClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {pages, pop ups}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pages_menu_tab_click. Evid: 563.
 * Event description: pages_menu_tab_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {pages, pop ups}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuTabClick = function (params) {
    return { evid: 563, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesAddPagesClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_Add_pages_click. Evid: 413.
 * Event description: PAGES_Add_pages_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesAddPagesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesAddPagesClick = function (params) {
    return { evid: 413, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressCloseButtonOnFontsManagerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press close button on fonts manager. Evid: 596.
 * Event description: press close button on fonts manager.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressCloseButtonOnFontsManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressCloseButtonOnFontsManager = function (params) {
    return { evid: 596, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} localSaveClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {top_bar, top_bar_site_menu, top_bar_preview_page, keyboard, remember_to_save_active_save_popup}
* @property {string} platform - {editor/app_studio}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: local_save_click. Evid: 916.
 * Event description: fires when a user clicks in the local save button.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {top_bar, top_bar_site_menu, top_bar_preview_page, keyboard, remember_to_save_active_save_popup}
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {localSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var localSaveClick = function (params) {
    return { evid: 916, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} bizManagerTrackAndAnalyzeRemoveToolParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} tool_type - {Google Analytics, Facebook Pixel, Yandex Metrica, Google AdWords, Verification Code, Custom}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Biz Manager - Track and Analyze - Remove tool. Evid: 762.
 * Event description: Final Remove Track and Analyze tool (After confirming the warning message).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * tool_type - Type: string. Desc: {Google Analytics, Facebook Pixel, Yandex Metrica, Google AdWords, Verification Code, Custom}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {bizManagerTrackAndAnalyzeRemoveToolParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerTrackAndAnalyzeRemoveTool = function (params) {
    return { evid: 762, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changeCustomShapeClickedParams
* @property {string} component_id - {}
* @property {string} component_name - {slide gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: change custom shape clicked. Evid: 1355.
 * Event description: Fired when a userShot when user clicks on ‘Change’ button inside shape divider panel.

 * component_id - Type: string. Desc: {}
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {changeCustomShapeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeCustomShapeClicked = function (params) {
    return { evid: 1355, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gridColumnManagerAddColumnDoneParams
* @property {string} column_title - column_title
* @property {string} component_id - comp id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field_name - field_name
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - column type
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: grid - column manager  add column done. Evid: 651.
 * Event description: click on done adding column to grid.

 * column_title - Type: string. Desc: column_title
 *
 * component_id - Type: string. Desc: comp id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field_name - Type: string. Desc: field_name
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: column type
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {gridColumnManagerAddColumnDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gridColumnManagerAddColumnDone = function (params) {
    return { evid: 651, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesAddPagesSelectionClickParams
* @property {string} button - top/bottom
* @property {string} category - {page, link, dropdown menu, popup, dynamic page}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click}
* @property {string} page_id - page_id
* @property {GUID} site_id - {}
* @property {string} source - {main menu,  members menu, custom menu, store, lightbox,router, router welcome}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_Add_pages_selection_click. Evid: 412.
 * Event description: PAGES_Add_pages_selection_click.

 * button - Type: string. Desc: top/bottom
 *
 * category - Type: string. Desc: {page, link, dropdown menu, popup, dynamic page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click}
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu,  members menu, custom menu, store, lightbox,router, router welcome}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesAddPagesSelectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesAddPagesSelectionClick = function (params) {
    return { evid: 412, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} footerLabelAppearParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop zoom, mobile zoom, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: footer_label_appear. Evid: 555.
 * Event description: footer_label_appear **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop zoom, mobile zoom, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {footerLabelAppearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var footerLabelAppear = function (params) {
    return { evid: 555, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelDesignNavigateRceParams
* @property {string} category - design
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
* @property {string} subcategory - background / texts / button and links
* @property {number} timeSpent - time from 309 open event in ms
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel Design Navigate RCE. Evid: 1127.
 * Event description: user navigate inside the Design panel of RCE.

 * category - Type: string. Desc: design
 *
 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
 *
 * subcategory - Type: string. Desc: background / texts / button and links
 *
 * timeSpent - Type: numeric. Desc: time from 309 open event in ms
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {panelDesignNavigateRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelDesignNavigateRce = function (params) {
    return { evid: 1127, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorBrowserWindowCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_browser_window_close. Evid: 1138.
 * Event description: Sent when a user want to quit editor by closing browser or clicking on Leave on Browser (Changes May not be saved) pop up.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorBrowserWindowCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorBrowserWindowClose = function (params) {
    return { evid: 1138, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityPanelOpenedParams
* @property {string} automatically_order_dom_toggle - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} skip_to_content_toggle - on,off
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} visual_ind_toggle - on,off
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility panel opened. Evid: 690.
 * Event description: Panel of "Make your site accessible" opened.

 * automatically_order_dom_toggle - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * skip_to_content_toggle - Type: string. Desc: on,off
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * visual_ind_toggle - Type: string. Desc: on,off
 *
 * workspace_mode - Type: string.
 * @param {accessibilityPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityPanelOpened = function (params) {
    return { evid: 690, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pastePageParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} error_type - error type
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} media_content - {yes/no/NULL} null - no media content, yes - upload media content, no - don't upload media content
* @property {string} multilingual - null
* @property {GUID} origin_msid - msid of a site from which the component was copied
* @property {string} origin_page_id - origin page id
* @property {string} paste_option - {keyboard/rcm/toolbar}
* @property {string} placement - {panel/stage}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - paste success
* @property {string} theme - {target/origin}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: paste_page. Evid: 945.
 * Event description: paste page.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * error_type - Type: string. Desc: error type
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * media_content - Type: string. Desc: {yes/no/NULL} null - no media content, yes - upload media content, no - don't upload media content
 *
 * multilingual - Type: string.
 *
 * origin_msid - Type: guid. Desc: msid of a site from which the component was copied
 *
 * origin_page_id - Type: string. Desc: origin page id
 *
 * paste_option - Type: string. Desc: {keyboard/rcm/toolbar}
 *
 * placement - Type: string. Desc: {panel/stage}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: paste success
 *
 * theme - Type: string. Desc: {target/origin}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pastePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pastePage = function (params) {
    return { evid: 945, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_manual_publish - on the moment of click
* @property {boolean} isPremium - on the moment of click
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} numberOfManualPublish - 1,2,3,4...
* @property {string} origin - {top_bar, keyboard...}
* @property {string} platform - {editor/app_studio}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewModeSource - editor,editor_preview,mobile_editor,mobile_editor_preview
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish_click. Evid: 222.
 * Event description: publish_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_manual_publish - Type: bool. Desc: on the moment of click
 *
 * isPremium - Type: bool. Desc: on the moment of click
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * numberOfManualPublish - Type: numeric. Desc: 1,2,3,4...
 *
 * origin - Type: string. Desc: {top_bar, keyboard...}
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewModeSource - Type: string. Desc: editor,editor_preview,mobile_editor,mobile_editor_preview
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishClick = function (params) {
    return { evid: 222, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeAddComponentParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} parent_component_id - parent component id
* @property {string} parent_component_type - parent component type
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_add_component. Evid: 1041.
 * Event description: Add component in interaction mode.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * parent_component_id - Type: string. Desc: parent component id
 *
 * parent_component_type - Type: string. Desc: parent component type
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionModeAddComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeAddComponent = function (params) {
    return { evid: 1041, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderSubmissionSettingsButtonClick1173Params
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - submission settings button - click. Evid: 1173.
 * Event description: Change the label of one of these fields: CheckboxGroup, RadioGroup, Dropdown.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderSubmissionSettingsButtonClick1173Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderSubmissionSettingsButtonClick1173 = function (params) {
    return { evid: 1173, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} customErrorPageParams
* @property {string} action - {upgrade/create_custom_error_page/open_custom_error_page}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} flow - {custom_error_page_panel/pages_quick_actions_menu}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: custom_error_page. Evid: 947.
 * Event description: click on the custom 404-page panel elements and creating custom 404 pages on the page quick actions menu.

 * action - Type: string. Desc: {upgrade/create_custom_error_page/open_custom_error_page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * flow - Type: string. Desc: {custom_error_page_panel/pages_quick_actions_menu}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {customErrorPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customErrorPage = function (params) {
    return { evid: 947, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} htmlLoadingStepEditorLoadedParams
* @property {number} base_version - X.Y.Z
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - (1,0)
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {boolean} prefetch - Resources prefetched
* @property {boolean} request_from_adi - {1,0}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: html loading step - editor loaded. Evid: 459.
 * Event description: html loading step - editor loaded.

 * base_version - Type: numeric. Desc: X.Y.Z
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool. Desc: (1,0)
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * prefetch - Type: bool. Desc: Resources prefetched
 *
 * request_from_adi - Type: bool. Desc: {1,0}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {htmlLoadingStepEditorLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var htmlLoadingStepEditorLoaded = function (params) {
    return { evid: 459, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorpickerMainpanelChangesitecolorsClickParams
* @property {string} component_id - .
* @property {string} component_type - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} index_selected_color - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorpicker_mainpanel_changesitecolors_click. Evid: 131.
 * Event description: ColorPicker_MainPanel_ChangeSiteColors_Click.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * index_selected_color - Type: string. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorpickerMainpanelChangesitecolorsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorpickerMainpanelChangesitecolorsClick = function (params) {
    return { evid: 131, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpOverlayClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_overlay_clicked. Evid: 562.
 * Event description: pop_up_overlay_clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpOverlayClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpOverlayClicked = function (params) {
    return { evid: 562, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorTooltipTooltipClosedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - switch to mobile btn/esc./x/click outside
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile editor tooltip --> tooltip closed. Evid: 95.
 * Event description: Mobile editor tooltip closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: switch to mobile btn/esc./x/click outside
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorTooltipTooltipClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorTooltipTooltipClosed = function (params) {
    return { evid: 95, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileInputSettingsRadioButtonParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - null
* @property {string} fieldName - fieldName
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - chosen radio button value
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - input settings - radio button. Evid: 1226.
 * Event description: Form Builder - upload file - input settings - radio button.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid.
 *
 * fieldName - Type: string. Desc: fieldName
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: chosen radio button value
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileInputSettingsRadioButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileInputSettingsRadioButton = function (params) {
    return { evid: 1226, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} toolBarAlignmentClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tool_Bar_Alignment_click. Evid: 261.
 * Event description: Tool_Bar_Alignment_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toolBarAlignmentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolBarAlignmentClick = function (params) {
    return { evid: 261, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contentInjectionSiteBusinessTypeClickSuggestionParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {string} fieldName - business type/business name
* @property {boolean} is_changed - true if user chose another bt
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - null
* @property {string} newValue - what user selected
* @property {string} origin - Add Section/Page panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Content Injection - Site Business Type - Click Suggestion. Evid: 1410.
 * Event description: Fires when user clicked suggestion in a search bar.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * fieldName - Type: string. Desc: business type/business name
 *
 * is_changed - Type: bool. Desc: true if user chose another bt
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string.
 *
 * newValue - Type: string. Desc: what user selected
 *
 * origin - Type: string. Desc: Add Section/Page panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {contentInjectionSiteBusinessTypeClickSuggestionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentInjectionSiteBusinessTypeClickSuggestion = function (params) {
    return { evid: 1410, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterTextOptionSectionClickedParams
* @property {string} businessType - {industry:”x”; structure: “y”}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} subject - subject
* @property {string} target - titles / paragraphs
* @property {number} textLength - text_length
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.switchTab.clicked. Evid: 1032.


 * businessType - Type: string. Desc: {industry:”x”; structure: “y”}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * subject - Type: string. Desc: subject
 *
 * target - Type: string. Desc: titles / paragraphs
 *
 * textLength - Type: numeric. Desc: text_length
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterTextOptionSectionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterTextOptionSectionClicked = function (params) {
    return { evid: 1032, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textSaveThemeDialogSaveClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: text_save_theme_dialog_save_click. Evid: 269.
 * Event description: text_save_theme_dialog_save_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textSaveThemeDialogSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textSaveThemeDialogSaveClick = function (params) {
    return { evid: 269, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMenuItemRenamedParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item_id - id of the menu item renamed
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {string} new_name - .
* @property {string} old_name - .
* @property {string} page_id - .
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} source_type - {double_click / quick_actions_menu}
* @property {string} stage_type - null
* @property {string} target - page / link / dropdown / menu_set
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_menu_item_renamed. Evid: 976.
 * Event description: any menu_item_renamed.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_id - Type: string. Desc: id of the menu item renamed
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * new_name - Type: string. Desc: .
 *
 * old_name - Type: string. Desc: .
 *
 * page_id - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * source_type - Type: string. Desc: {double_click / quick_actions_menu}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: page / link / dropdown / menu_set
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuMenuItemRenamedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMenuItemRenamed = function (params) {
    return { evid: 976, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuCategoryOpenedParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {boolean} category_under_scroll - user opened category that was under scroll
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isScrollable - scroll is available to the user
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_vertical_installed - is vertical installed already installed
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - editor search or null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {number} window_height - initial height of client window
* @property {number} window_width - initial width of client window
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> category opened. Evid: 715.
 * Event description: add menu -> category opened (similar to 38:102)
category is opened on hover - with a 3 sec delay.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * category_under_scroll - Type: bool. Desc: user opened category that was under scroll
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isScrollable - Type: bool. Desc: scroll is available to the user
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_vertical_installed - Type: bool. Desc: is vertical installed already installed
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: editor search or null
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * window_height - Type: numeric. Desc: initial height of client window
 *
 * window_width - Type: numeric. Desc: initial width of client window
 *
 * workspace_mode - Type: string.
 * @param {addMenuCategoryOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuCategoryOpened = function (params) {
    return { evid: 715, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openDashboardAppClickParams
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp, settings}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open dashboard app click. Evid: 278.
 * Event description: open dashboard app click.

 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp, settings}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openDashboardAppClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openDashboardAppClick = function (params) {
    return { evid: 278, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} goingBackToWixAdiPopupOpenedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: going_back_to_wix_ADI_popup_opened. Evid: 786.
 * Event description: going_back_to_wix_ADI_popup_opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {goingBackToWixAdiPopupOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goingBackToWixAdiPopupOpened = function (params) {
    return { evid: 786, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuClickedOnSettingsParams
* @property {string} category - { clicked title, like: Advanced URL settings, Delete Store etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - {main menu, members menu, custom menu, blog, tpa etc, lightbox, router}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_menu_clicked_on_settings. Evid: 705.
 * Event description: PAGES_menu_clicked_on_settings.

 * category - Type: string. Desc: { clicked title, like: Advanced URL settings, Delete Store etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu, members menu, custom menu, blog, tpa etc, lightbox, router}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuClickedOnSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuClickedOnSettings = function (params) {
    return { evid: 705, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorOpenClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - place where button was clicked
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MobileEditor.Open.Click. Evid: 1132.
 * Event description: MobileEditor.Open.Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: place where button was clicked
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorOpenClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorOpenClick = function (params) {
    return { evid: 1132, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchShowMoreClickParams
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} clickOrigin - click / keyboard
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.showMore.click. Evid: 993.
 * Event description: Click on Show More.

 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * clickOrigin - Type: string. Desc: click / keyboard
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchShowMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchShowMoreClick = function (params) {
    return { evid: 993, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} learnMoreClickWithoutBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Learn More click (without back option). Evid: 480.
 * Event description: Without back to old editor option: Learn More click: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {learnMoreClickWithoutBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var learnMoreClickWithoutBackOption = function (params) {
    return { evid: 480, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorSpaceAddNewColorOkParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} isChanged - true in case color was changed
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - text_color_picker / theme_color_picker
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color_Space_Add_New_Color_OK. Evid: 401.
 * Event description: Color_Space_Add_New_Color_OK.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isChanged - Type: bool. Desc: true in case color was changed
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: text_color_picker / theme_color_picker
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorSpaceAddNewColorOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorSpaceAddNewColorOk = function (params) {
    return { evid: 401, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog1EditWixDomainSetFieldClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_1_edit_wix_domain_set_field_click. Evid: 316.
 * Event description: First_Save_Dialog_1_edit_wix_domain_set_field_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog1EditWixDomainSetFieldClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog1EditWixDomainSetFieldClick = function (params) {
    return { evid: 316, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonWrapTextToggleChangedParams
* @property {string} component_id - component id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - text/icon/text&icon
* @property {string} page_id - page id
* @property {string} selection - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: StylableButton.wrap_text_toggle_changed. Evid: 1345.
 * Event description: StylableButton.wrap_text_toggle_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: text/icon/text&icon
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonWrapTextToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonWrapTextToggleChanged = function (params) {
    return { evid: 1345, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} wixSearchAppSetLayoutChangedParams
* @property {string} choice - left|right
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - layout, icon, text
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: wixSearch.appSet.layout.changed. Evid: 920.
 * Event description: User changed layout/alignment in Search Box Layouts.

 * choice - Type: string. Desc: left|right
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: layout, icon, text
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {wixSearchAppSetLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixSearchAppSetLayoutChanged = function (params) {
    return { evid: 920, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickedAdvancedAccessibilitySettingsParams
* @property {string} dm_version - null
* @property {string} ds_origin - {]
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {ON/OFF}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: clicked Advanced Accessibility Settings. Evid: 926.
 * Event description: Clicked Advanced Accessibility Settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {]
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {ON/OFF}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickedAdvancedAccessibilitySettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickedAdvancedAccessibilitySettings = function (params) {
    return { evid: 926, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsOutOfGridWarningParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_out_of_grid_warning. Evid: 584.
 * Event description: columns_out_of_grid_warning.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsOutOfGridWarningParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsOutOfGridWarning = function (params) {
    return { evid: 584, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} shapeDividerPanelDesignSavedParams
* @property {string} color - .
* @property {string} component_id - {}
* @property {string} component_name - {slide gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} flip - .
* @property {string} height_dividers - dividers height
* @property {boolean} invert - .
* @property {boolean} isPresetModified - true if user changed values via ‘Customize Design’ option, false if only change that has been made is svgId
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {boolean} keepAspectRatio - .
* @property {string} layersEffect - .
* @property {string} layersSpread - .
* @property {string} multilingual - .
* @property {string} offsetX - .
* @property {string} padding - .
* @property {number} repeatCount - .
* @property {boolean} shouldRepeat - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} svgId - divider's ID
* @property {string} tab - top/bottom
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: shape divider panel design saved. Evid: 1354.
 * Event description: Fired when user exits preset (by clicking 'x' or outside the preset) and changes been applied to a shape divider.

 * color - Type: string. Desc: .
 *
 * component_id - Type: string. Desc: {}
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * flip - Type: bool. Desc: .
 *
 * height_dividers - Type: string. Desc: dividers height
 *
 * invert - Type: bool. Desc: .
 *
 * isPresetModified - Type: bool. Desc: true if user changed values via ‘Customize Design’ option, false if only change that has been made is svgId
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * keepAspectRatio - Type: bool. Desc: .
 *
 * layersEffect - Type: string. Desc: .
 *
 * layersSpread - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * offsetX - Type: string. Desc: .
 *
 * padding - Type: string. Desc: .
 *
 * repeatCount - Type: numeric. Desc: .
 *
 * shouldRepeat - Type: bool. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * svgId - Type: string. Desc: divider's ID
 *
 * tab - Type: string. Desc: top/bottom
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {shapeDividerPanelDesignSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shapeDividerPanelDesignSaved = function (params) {
    return { evid: 1354, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardErrorShownParams
* @property {string} appsToInstall - .
* @property {number} curatedTemplateId - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - null
* @property {string} flow - null
* @property {string} industryId - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} structureId - .
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Error Shown. Evid: 1278.
 * Event description: an error BI for the site creation, so we’ll can send a BI if fetching presets from ADI service failed.

 * appsToInstall - Type: string. Desc: .
 *
 * curatedTemplateId - Type: numeric. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid.
 *
 * flow - Type: string.
 *
 * industryId - Type: string. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * structureId - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardErrorShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardErrorShown = function (params) {
    return { evid: 1278, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbItemAlignmentChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} display_mode - wrap/ellipsis
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - left/middle/right
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_item_alignment_changed. Evid: 1241.
 * Event description: breadcrumb_item_alignment_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * display_mode - Type: string. Desc: wrap/ellipsis
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: left/middle/right
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbItemAlignmentChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbItemAlignmentChanged = function (params) {
    return { evid: 1241, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} htmlLoadingStepMainRLoadedParams
* @property {number} base_version - X.Y.Z
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - (1,0)
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} navigationType - {}
* @property {boolean} prefetch - Resources prefetched
* @property {boolean} request_from_adi - {1,0}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: html loading step - main-r-loaded. Evid: 458.
 * Event description: html loading step - main-r-loaded.

 * base_version - Type: numeric. Desc: X.Y.Z
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool. Desc: (1,0)
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * navigationType - Type: numeric. Desc: {}
 *
 * prefetch - Type: bool. Desc: Resources prefetched
 *
 * request_from_adi - Type: bool. Desc: {1,0}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {htmlLoadingStepMainRLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var htmlLoadingStepMainRLoaded = function (params) {
    return { evid: 458, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} previewWidthParams
* @property {number} browser_width - browser_width
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - open / mobile / tablet / desktop / slider / full_screen / browser_change
* @property {string} preview_mode - mobile / tablet / desktop / full_screen
* @property {number} preview_width - actual preview width
* @property {GUID} site_id - {}
* @property {string} stage_type - .
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Preview width. Evid: 1507.
 * Event description: event which indicates the width which user look on the site in preview mode.

 * browser_width - Type: numeric. Desc: browser_width
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: open / mobile / tablet / desktop / slider / full_screen / browser_change
 *
 * preview_mode - Type: string. Desc: mobile / tablet / desktop / full_screen
 *
 * preview_width - Type: numeric. Desc: actual preview width
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {previewWidthParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewWidth = function (params) {
    return { evid: 1507, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishTrafficAppsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_Traffic_Apps_click. Evid: 393.
 * Event description: Second_Publish_Traffic_Apps_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishTrafficAppsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishTrafficAppsClick = function (params) {
    return { evid: 393, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog2GetNewDomainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_2_get_new_domain_click. Evid: 327.
 * Event description: First_Save_Dialog_2_get_new_domain_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog2GetNewDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog2GetNewDomainClick = function (params) {
    return { evid: 327, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} prefetchCompleteParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Prefetch complete. Evid: 589.
 * Event description: Prefetch of editor resources has finished (resource download completed).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {prefetchCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var prefetchComplete = function (params) {
    return { evid: 589, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteBackgroundChangeScrollEffectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} scroll_type - freeze,scroll,parallax,etc...
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Background - change scroll effect. Evid: 685.
 * Event description: Site Background - change scroll effect - Will be sent only when user changes the scroll effect.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * scroll_type - Type: string. Desc: freeze,scroll,parallax,etc...
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteBackgroundChangeScrollEffectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteBackgroundChangeScrollEffect = function (params) {
    return { evid: 685, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextAlignChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id
* @property {string} selection - center/left/right
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.text_align_changed. Evid: 1339.


 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string. Desc: center/left/right
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextAlignChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextAlignChanged = function (params) {
    return { evid: 1339, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dragGapParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} gap_size_end - gap size in pixels after change
* @property {number} gap_size_start - gap size in pixels before change
* @property {string} gap_type - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: drag_gap. Evid: 752.
 * Event description: Closing/expanding a gap between components.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * gap_size_end - Type: numeric. Desc: gap size in pixels after change
 *
 * gap_size_start - Type: numeric. Desc: gap size in pixels before change
 *
 * gap_type - Type: string. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dragGapParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dragGap = function (params) {
    return { evid: 752, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} platformSilentInstallRequestBeginParams
* @property {string} appsToInstall - list that platform got from Editor
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} origin - null
* @property {string} payload - step in the process
* @property {string} screenResolution - .
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - .
* @property {string} view - first view in Wizard
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Platform silent install request. Evid: 1371.
 * Event description: fire at the begin of request of the silent install.

 * appsToInstall - Type: string. Desc: list that platform got from Editor
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string.
 *
 * payload - Type: string. Desc: step in the process
 *
 * screenResolution - Type: string. Desc: .
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: .
 *
 * view - Type: string. Desc: first view in Wizard
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {platformSilentInstallRequestBeginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var platformSilentInstallRequestBegin = function (params) {
    return { evid: 1371, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelFirstTimeLearnMoreClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_FirstTime_LearnMoreClick. Evid: 347.
 * Event description: Panel_FirstTime_LearnMoreClick.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelFirstTimeLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelFirstTimeLearnMoreClick = function (params) {
    return { evid: 347, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityAttributeThreeDotsClickParams
* @property {string} aria_prop - activedescendant,atomic,autocomplete,busy,checked,colcount,colindex,colspan,controls,current,describedby,details,disabled,dragged,dropeffect,errormessage,expanded,flowto,haspopup,hidden,invalid,label,labelledby,level,live,modal,multiline,multiselectable,orientation,owns,placeholder,posinset,pressed,readonly,relevant,required,rowcount,rowindex,rowspan,selected,setsize,sort,valuemax,valuemin,valuenow,valuetext,tabindex,role
* @property {string} componentId - .
* @property {string} componentName - button/text_input/dropdown/radio/checkbox/date_picker/range/lightbox/text/box/strip/repeater
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} prop_token - depends on the aria_prop
* @property {string} prop_category - relationships,live,description,state,DND
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - edit / remove
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility - Attribute three dots Click. Evid: 1230.
 * Event description: Accessibility - Attribute three dots Click.

 * aria_prop - Type: string. Desc: activedescendant,atomic,autocomplete,busy,checked,colcount,colindex,colspan,controls,current,describedby,details,disabled,dragged,dropeffect,errormessage,expanded,flowto,haspopup,hidden,invalid,label,labelledby,level,live,modal,multiline,multiselectable,orientation,owns,placeholder,posinset,pressed,readonly,relevant,required,rowcount,rowindex,rowspan,selected,setsize,sort,valuemax,valuemin,valuenow,valuetext,tabindex,role
 *
 * componentId - Type: string. Desc: .
 *
 * componentName - Type: string. Desc: button/text_input/dropdown/radio/checkbox/date_picker/range/lightbox/text/box/strip/repeater
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * prop_token - Type: string. Desc: depends on the aria_prop
 *
 * prop_category - Type: string. Desc: relationships,live,description,state,DND
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: edit / remove
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {accessibilityAttributeThreeDotsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityAttributeThreeDotsClick = function (params) {
    return { evid: 1230, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSiteColorsCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Back, Close button, Cancel, Done, Esc, Click Outside}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Site_Colors_Close. Evid: 404.
 * Event description: Edit_Site_Colors_Close.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Back, Close button, Cancel, Done, Esc, Click Outside}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editSiteColorsCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSiteColorsClose = function (params) {
    return { evid: 404, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} seoLetsGoParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: seo lets go. Evid: 661.
 * Event description: click on "lets go" on the new SEO tab in the pages panel to open the new wizard.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {seoLetsGoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var seoLetsGo = function (params) {
    return { evid: 661, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startCreatingRcClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor, editor1.4
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar/publish/ preview/ test_site
* @property {string} platform - {editor/app_studio}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Start creating RC clicked. Evid: 892.
 * Event description: Fires when the user clicks on 'Create release candidate' from 'site' section in top-bar or from the 'publish' button in Dev mode.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor, editor1.4
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar/publish/ preview/ test_site
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startCreatingRcClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startCreatingRcClicked = function (params) {
    return { evid: 892, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog2MaybeLaterClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_2_maybe_later_click. Evid: 329.
 * Event description: First_Save_Dialog_2_maybe_later_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog2MaybeLaterClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog2MaybeLaterClick = function (params) {
    return { evid: 329, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} adi2editorPreloaderStepStartParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} step_name - name of the step
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: ADI2Editor - preloader step start. Evid: 1152.
 * Event description: ADI2Editor - preloader step start.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * step_name - Type: string. Desc: name of the step
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {adi2editorPreloaderStepStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adi2editorPreloaderStepStart = function (params) {
    return { evid: 1152, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorNotificationAppearParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} location - where the notification first appeared on load. 1/2/3.. from bottom
* @property {string} multilingual - null
* @property {string} origin - rcm/...
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} topic - notification topic
* @property {string} totalJsHeapSize - null
* @property {string} type - info/warning/success/error
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_notification_appear. Evid: 811.
 * Event description: editor notification appears

where the notification appeared when first appeared on load. 1/2/3.. from bottom.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * location - Type: numeric. Desc: where the notification first appeared on load. 1/2/3.. from bottom
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: rcm/...
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * topic - Type: string. Desc: notification topic
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: info/warning/success/error
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorNotificationAppearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorNotificationAppear = function (params) {
    return { evid: 811, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteChangeTypeButtonsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - Primary Button, Secondary Button
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette Change type buttons. Evid: 1432.
 * Event description: Color palette Change type buttons.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: Primary Button, Secondary Button
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteChangeTypeButtonsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteChangeTypeButtons = function (params) {
    return { evid: 1432, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} doneClickInTheWelcomeScreenPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add_welcome_screen. Evid: 886.
 * Event description: "Done " click at the welcome screen panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {doneClickInTheWelcomeScreenPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var doneClickInTheWelcomeScreenPanel = function (params) {
    return { evid: 886, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAppearanceParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {string} section_size - small,medium,large
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: section_appearance. Evid: 470.
 * Event description: section_appearance.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * section_size - Type: string. Desc: small,medium,large
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionAppearanceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAppearance = function (params) {
    return { evid: 470, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeSetUpQuickActionsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} number_of_quick_actions - number of quick actions on bar, when panel closed
* @property {string} quick_actions_list - ordered list of quick actions on bar
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: close_set_up_quick_actions. Evid: 720.
 * Event description: close_set_up_quick_actions.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * number_of_quick_actions - Type: numeric. Desc: number of quick actions on bar, when panel closed
 *
 * quick_actions_list - Type: string. Desc: ordered list of quick actions on bar
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeSetUpQuickActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeSetUpQuickActions = function (params) {
    return { evid: 720, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerLayoutShowVideoTitleChangedParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {boolean} toggle - true / false
* @property {string} totalJsHeapSize - null
* @property {string} type - desktop / mobile
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.layout.showVideoTitle.changed. Evid: 829.
 * Event description: User changed Show video title toggle.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: true / false
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: desktop / mobile
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerLayoutShowVideoTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerLayoutShowVideoTitleChanged = function (params) {
    return { evid: 829, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} slideActionSelectedParams
* @property {string} action - rename,duplicate,delete
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_id - tab id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Slide Action Selected. Evid: 533.
 * Event description: Slide Action Selected.

 * action - Type: string. Desc: rename,duplicate,delete
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_id - Type: string. Desc: tab id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {slideActionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var slideActionSelected = function (params) {
    return { evid: 533, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeHelpCenterClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_help_center_click. Evid: 1093.
 * Event description: Event fires when clicking the 'browse help center' button inside the popular articles section, under the help home panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeHelpCenterClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeHelpCenterClick = function (params) {
    return { evid: 1093, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorNotificationCloseParams
* @property {string} action - action clicked
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} finish_method - how the notification closed - {time_out, X,action_clicked, oldest_from_three_on_screen}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {number} time_since_load - how long notification appeared (ms)
* @property {string} topic - notification topic
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_notification_close. Evid: 812.
 * Event description: editor notification close.

 * action - Type: string. Desc: action clicked
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * finish_method - Type: string. Desc: how the notification closed - {time_out, X,action_clicked, oldest_from_three_on_screen}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * time_since_load - Type: numeric. Desc: how long notification appeared (ms)
 *
 * topic - Type: string. Desc: notification topic
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorNotificationCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorNotificationClose = function (params) {
    return { evid: 812, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} leading_back_to_panel_name - {}
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} panel_type - {type of the panel}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: back_button_click. Evid: 451.
 * Event description: back_button_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * leading_back_to_panel_name - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * panel_type - Type: string. Desc: {type of the panel}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backButtonClick = function (params) {
    return { evid: 451, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageContentPanelActionClickParams
* @property {string} action_name - {Go_to_collection, Update_connection_settings}
* @property {string} component_id -
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - {gfpp, rce_panel}
* @property {GUID} site_id - null
* @property {string} source - edit_section
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage_Content_Panel_Action_Click. Evid: 1038.


 * action_name - Type: string. Desc: {Go_to_collection, Update_connection_settings}
 *
 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: {gfpp, rce_panel}
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: edit_section
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageContentPanelActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageContentPanelActionClick = function (params) {
    return { evid: 1038, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardErrorClickParams
* @property {string} appsToInstall - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - .
* @property {string} flow - initPresets, fetchPresets, addPreset
* @property {string} industryId - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} structureId - .
* @property {string} target - what user clicked
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - null
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Error Click. Evid: 1279.
 * Event description: an error BI for the site creation, so we’ll can send a BI if fetching presets from ADI service failed.

 * appsToInstall - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: .
 *
 * flow - Type: string. Desc: initPresets, fetchPresets, addPreset
 *
 * industryId - Type: string. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * structureId - Type: string. Desc: .
 *
 * target - Type: string. Desc: what user clicked
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardErrorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardErrorClick = function (params) {
    return { evid: 1279, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesReplaceWithCustomPageChoiceParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {cancel, create}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Pages_replace_with_custom_page_choice. Evid: 1442.
 * Event description: Click inside replace with custom page panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {cancel, create}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesReplaceWithCustomPageChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesReplaceWithCustomPageChoice = function (params) {
    return { evid: 1442, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsManagerActionClickParams
* @property {string} action - {right, left, delete, duplicate, mobile hide}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_manager_action_click. Evid: 624.
 * Event description: columns_manager_action_click.

 * action - Type: string. Desc: {right, left, delete, duplicate, mobile hide}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsManagerActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsManagerActionClick = function (params) {
    return { evid: 624, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelFontLanguageLinkClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Font_Language_Link_Click. Evid: 229.
 * Event description: Text_Panel_Font_Language_Link_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelFontLanguageLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelFontLanguageLinkClick = function (params) {
    return { evid: 229, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardThemeThemeSelectParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} name - theme name
* @property {number} position - 1-6 {which theme user chose}
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Theme - theme select. Evid: 1256.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * name - Type: string. Desc: theme name
 *
 * position - Type: numeric. Desc: 1-6 {which theme user chose}
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardThemeThemeSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardThemeThemeSelect = function (params) {
    return { evid: 1256, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoboxBigplayParams
* @property {string} bigplay_colors - ‘rrggbb_rrggbb’ <bg color>_<foreground color>
* @property {number} bigplay_index - {0,1, 2, 4...}
* @property {string} bigplay_media_name - SVG uri (+suffix)
* @property {number} bigplay_opacity - 0-100 (percent)
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videobox_bigplay. Evid: 804.
 * Event description: sent once bigplay panel closed.

 * bigplay_colors - Type: string. Desc: ‘rrggbb_rrggbb’ <bg color>_<foreground color>
 *
 * bigplay_index - Type: numeric. Desc: {0,1, 2, 4...}
 *
 * bigplay_media_name - Type: string. Desc: SVG uri (+suffix)
 *
 * bigplay_opacity - Type: numeric. Desc: 0-100 (percent)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoboxBigplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoboxBigplay = function (params) {
    return { evid: 804, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stretchToScreenOnStageResizeParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} handle_used - {left,right}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} margin_units - {pixels, percentage}
* @property {number} margins_value - {numeric value of margins set by user}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {GUID} siteid - []
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: stretch_to_screen_on_stage_resize. Evid: 522.
 * Event description: stretch_to_screen_on_stage_resize.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * handle_used - Type: string. Desc: {left,right}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * margin_units - Type: string. Desc: {pixels, percentage}
 *
 * margins_value - Type: numeric. Desc: {numeric value of margins set by user}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * siteid - Type: guid. Desc: []
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stretchToScreenOnStageResizeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stretchToScreenOnStageResize = function (params) {
    return { evid: 522, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsTabClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} prev_tab_name - previous tab name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tab_name - app id or tab name if app id is null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> tab click. Evid: 1086.
 * Event description: Manage My App tab selected.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * prev_tab_name - Type: string. Desc: previous tab name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: app id or tab name if app id is null
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsTabClick = function (params) {
    return { evid: 1086, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardFinishParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {number} duration - time (in ms) user spent between wizard start and finish
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - last view in Wizard
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: finish. Evid: 1260.
 * Event description: Site Creation Wizard: finish.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * duration - Type: numeric. Desc: time (in ms) user spent between wizard start and finish
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: last view in Wizard
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardFinishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardFinish = function (params) {
    return { evid: 1260, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationSettingsBackClickParams
* @property {string} component_id - .
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_settings_back_click. Evid: 1150.
 * Event description: user click BACK in the animation settings panel.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {animationSettingsBackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationSettingsBackClick = function (params) {
    return { evid: 1150, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeHideComponentParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - del/backspace/rcm/gfpp
* @property {string} parent_component_id - parent component id
* @property {string} parent_component_type - parent component type
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_hide_component. Evid: 1011.
 * Event description: Hide component in interaction mode.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: del/backspace/rcm/gfpp
 *
 * parent_component_id - Type: string. Desc: parent component id
 *
 * parent_component_type - Type: string. Desc: parent component type
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionModeHideComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeHideComponent = function (params) {
    return { evid: 1011, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backToTopShowToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} toggle_status - {on,off}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: back_to_top_show_toggle. Evid: 303.
 * Event description: back_to_top_show_toggle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle_status - Type: string. Desc: {on,off}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backToTopShowToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backToTopShowToggle = function (params) {
    return { evid: 303, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addClickToActionParams
* @property {string} action_type - Phone, Email, Facebook etc.
* @property {string} component_type - component_type
* @property {string} data - content of the link
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field_type - URL/address/phone number/etc...
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of stores components who calls specific panel will be null for others
* @property {GUID} site_id - {}
* @property {string} source - panel opening source
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} i1 - link or generated_automatically
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Add click to action. Evid: 627.
 * Event description: When user add in the editor an actionable link for the mobile site.

 * action_type - Type: string. Desc: Phone, Email, Facebook etc.
 *
 * component_type - Type: string. Desc: component_type
 *
 * data - Type: string. Desc: content of the link
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field_type - Type: string. Desc: URL/address/phone number/etc...
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of stores components who calls specific panel will be null for others
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: panel opening source
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * i1 - Type: string. Desc: link or generated_automatically
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addClickToActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addClickToAction = function (params) {
    return { evid: 627, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addQuickActionParams
* @property {string} action_type - type of action added
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add_quick_action. Evid: 722.
 * Event description: add_quick_action.

 * action_type - Type: string. Desc: type of action added
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addQuickAction = function (params) {
    return { evid: 722, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stretchToScreenMarginsControlParams
* @property {GUID} appId - app_id
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} handle_used - {left,right}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} margins_units - {px, pct}
* @property {number} margins_value - {numeric value of margins set by user}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {GUID} siteid - []
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value_change_origin - input / slider
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: stretch_to_screen_margins_control. Evid: 527.
 * Event description: stretch_to_screen_margins_control.

 * appId - Type: guid. Desc: app_id
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * handle_used - Type: string. Desc: {left,right}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * margins_units - Type: string. Desc: {px, pct}
 *
 * margins_value - Type: numeric. Desc: {numeric value of margins set by user}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * siteid - Type: guid. Desc: []
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value_change_origin - Type: string. Desc: input / slider
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stretchToScreenMarginsControlParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stretchToScreenMarginsControl = function (params) {
    return { evid: 527, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} loadingPhaseInInitStartParams
* @property {string} app_name - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isTemplate - new / existing
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} loadTime - load time from the beginning of load
* @property {string} multilingual - null
* @property {string} phaseName - phase name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} subPhaseName - {}
* @property {string} subphase - subphase
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: loading - phase in init - start. Evid: 77.
 * Event description: Module: builder. Flow: a phase in the init has started.

 * app_name - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isTemplate - Type: bool. Desc: new / existing
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * loadTime - Type: numeric. Desc: load time from the beginning of load
 *
 * multilingual - Type: string.
 *
 * phaseName - Type: string. Desc: phase name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * subPhaseName - Type: string. Desc: {}
 *
 * subphase - Type: string. Desc: subphase
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {loadingPhaseInInitStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingPhaseInInitStart = function (params) {
    return { evid: 77, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} resizeTheFrameInCropModeParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: resize_the_frame_in_crop_mode. Evid: 514.
 * Event description: resize_the_frame_in_crop_mode.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {resizeTheFrameInCropModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var resizeTheFrameInCropMode = function (params) {
    return { evid: 514, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelBulletsSelectedParams
* @property {string} category - {Bullets, numbering, none}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Bullets_Selected. Evid: 237.
 * Event description: Text_Panel_Bullets_Selected.

 * category - Type: string. Desc: {Bullets, numbering, none}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelBulletsSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelBulletsSelected = function (params) {
    return { evid: 237, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyStyleRcmClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: copy_style_rcm_click. Evid: 318.
 * Event description: copy_style_rcm_click.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyStyleRcmClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyStyleRcmClick = function (params) {
    return { evid: 318, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputElementsManageItemsPanelEditLabelStartParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Input Elements - Manage Items Panel - Edit label start. Evid: 1179.
 * Event description: Edit label start in multiple choices manage items panel
Copy of event 5:1167.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {inputElementsManageItemsPanelEditLabelStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputElementsManageItemsPanelEditLabelStart = function (params) {
    return { evid: 1179, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} attachToParams
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_source_repeated - {true,false} Is source contained in a repeater
* @property {boolean} is_target_hover - is target hover box or hover repeater
* @property {boolean} is_target_repeated - {true,false} Is target contained in a repeater
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {add Pannel, stage}
* @property {GUID} site_id - {}
* @property {string} source_component - {compType} of the parent component
* @property {string} stage_type - null
* @property {string} target_component - {box,shape,text etc}
* @property {string} target_component_id - target_component_id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: attach to. Evid: 158.
 * Event description: attach to.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_source_repeated - Type: bool. Desc: {true,false} Is source contained in a repeater
 *
 * is_target_hover - Type: bool. Desc: is target hover box or hover repeater
 *
 * is_target_repeated - Type: bool. Desc: {true,false} Is target contained in a repeater
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {add Pannel, stage}
 *
 * site_id - Type: guid. Desc: {}
 *
 * source_component - Type: string. Desc: {compType} of the parent component
 *
 * stage_type - Type: string.
 *
 * target_component - Type: string. Desc: {box,shape,text etc}
 *
 * target_component_id - Type: string. Desc: target_component_id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {attachToParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var attachTo = function (params) {
    return { evid: 158, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsChangeCoverClickParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.changeCover.click. Evid: 1206.
 * Event description: change Cover clicked in Audio Player settings.

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsChangeCoverClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsChangeCoverClick = function (params) {
    return { evid: 1206, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorTourClickOutTryParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - AdiToEditorTour
* @property {string} panel_name - name of panel which was opened
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor tour: Click out try. Evid: 1372.
 * Event description: User try to close the panel with click out (relevant for tour only, where it's impossible to do).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: AdiToEditorTour
 *
 * panel_name - Type: string. Desc: name of panel which was opened
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editorTourClickOutTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorTourClickOutTry = function (params) {
    return { evid: 1372, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMigrationFailParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} errorMessage - error message
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Menu migration fail. Evid: 1427.
 * Event description: Menu migration failed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * errorMessage - Type: string. Desc: error message
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {menuMigrationFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMigrationFail = function (params) {
    return { evid: 1427, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} unlockParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar,component edit box}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: unlock. Evid: 143.
 * Event description: unlock.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar,component edit box}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {unlockParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var unlock = function (params) {
    return { evid: 143, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionComponentChangedParams
* @property {string} action_origin - edit_section / <name>_settings (example: button_settings)
* @property {string} component_id - id of selected component
* @property {string} component_parent_id - id of component that contain element
* @property {string} component_parent_type - for component that contain element (example: BoxSlideShowSlide)
* @property {string} component_type - type of the component that was changed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_changed - true/false
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} parent_component_id - id of selected section
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {string} session_id - same as in (26:608 mediaManager.file.chosen) for image / button image
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} target - what was changed (section_background, title / button_link / button_name/ image / button_icon e.t.c)
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: Component Changed. Evid: 1374.
 * Event description: the component inside the "Edit Section" panel has been changed.

 * action_origin - Type: string. Desc: edit_section / <name>_settings (example: button_settings)
 *
 * component_id - Type: string. Desc: id of selected component
 *
 * component_parent_id - Type: string. Desc: id of component that contain element
 *
 * component_parent_type - Type: string. Desc: for component that contain element (example: BoxSlideShowSlide)
 *
 * component_type - Type: string. Desc: type of the component that was changed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_changed - Type: bool. Desc: true/false
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * parent_component_id - Type: string. Desc: id of selected section
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * session_id - Type: string. Desc: same as in (26:608 mediaManager.file.chosen) for image / button image
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what was changed (section_background, title / button_link / button_name/ image / button_icon e.t.c)
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionComponentChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionComponentChanged = function (params) {
    return { evid: 1374, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textComponentGfppButtonsShowParams
* @property {string} all_gfpp_actions - list of available gfpp buttons
* @property {string} app_id - id of app (if component is app widget)
* @property {string} component_id - for text
* @property {string} component_type - wysiwyg.viewer.components.WRichText
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_parent_hover - is parent hover box or hover repeater
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWithinBlocksWidget - true - if the component contained inside a blocks widget or if that's the widget itself
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - not empty if event was triggered by tour
* @property {string} pageId - page_id
* @property {string} parentComponentId - for component than contain textt box
* @property {string} parentComponentType - for component than contain textt box
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {GUID} widget_id - .
* @property {string} workspace_mode - null
**/
/**
 * Name: gfppButtons.show. Evid: 1049.
 * Event description: Sends on GFPP buttons shown.

 * all_gfpp_actions - Type: string. Desc: list of available gfpp buttons
 *
 * app_id - Type: string. Desc: id of app (if component is app widget)
 *
 * component_id - Type: string. Desc: for text
 *
 * component_type - Type: string. Desc: wysiwyg.viewer.components.WRichText
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_parent_hover - Type: bool. Desc: is parent hover box or hover repeater
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWithinBlocksWidget - Type: bool. Desc: true - if the component contained inside a blocks widget or if that's the widget itself
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: not empty if event was triggered by tour
 *
 * pageId - Type: string. Desc: page_id
 *
 * parentComponentId - Type: string. Desc: for component than contain textt box
 *
 * parentComponentType - Type: string. Desc: for component than contain textt box
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * widget_id - Type: guid. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {textComponentGfppButtonsShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textComponentGfppButtonsShow = function (params) {
    return { evid: 1049, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishGetOwnMailboxLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_get_own_Mailbox_link_click. Evid: 384.
 * Event description: First_Publish_get_own_Mailbox_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstPublishGetOwnMailboxLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishGetOwnMailboxLinkClick = function (params) {
    return { evid: 384, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageTabClickParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_installed - true/false (if app is installed)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - about/project/contact/etc
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - tab click. Evid: 1073.
 * Event description: AddPage - tab click.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_installed - Type: bool. Desc: true/false (if app is installed)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: about/project/contact/etc
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageTabClick = function (params) {
    return { evid: 1073, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editDomainFieldClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_save_or_publish - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} save_or_publish - {save, publish}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_domain_field_click. Evid: 444.
 * Event description: edit_domain_field_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_save_or_publish - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * save_or_publish - Type: string. Desc: {save, publish}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editDomainFieldClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editDomainFieldClick = function (params) {
    return { evid: 444, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorpickerMainpanelSitecolorsSelectParams
* @property {number} column_in_color_palette - {}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} index_selected_color - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {colorPickerPanel}
* @property {string} parent_item_id - parent component id
* @property {number} row_in_color_palette - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorpicker_mainpanel_sitecolors_select. Evid: 132.
 * Event description: ColorPicker_MainPanel_SiteColors_Select **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * column_in_color_palette - Type: numeric. Desc: {}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * index_selected_color - Type: string. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {colorPickerPanel}
 *
 * parent_item_id - Type: string. Desc: parent component id
 *
 * row_in_color_palette - Type: numeric. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorpickerMainpanelSitecolorsSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorpickerMainpanelSitecolorsSelect = function (params) {
    return { evid: 132, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaAddClickParams
* @property {string} adding_method - {direct_add, drag, }
* @property {GUID} app_id - [guid]
* @property {string} category - {add_panel: text, image..., market: featured, new, search, pending....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first - {0,1}
* @property {number} is_permissions_app - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_add_click. Evid: 167.
 * Event description: tpa_add_click.

 * adding_method - Type: string. Desc: {direct_add, drag, }
 *
 * app_id - Type: guid. Desc: [guid]
 *
 * category - Type: string. Desc: {add_panel: text, image..., market: featured, new, search, pending....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first - Type: bool. Desc: {0,1}
 *
 * is_permissions_app - Type: numeric. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tpaAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaAddClick = function (params) {
    return { evid: 167, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} saveFlowSiteDomainValidationSuccessParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {string} errorName - error_name
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isSuccess - t/f
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} loadingTime - time for server to response
* @property {string} multilingual - null
* @property {string} origin - first_save / second_save
* @property {string} siteDisplayName - checked site domain
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: saveFlow.siteDomainValidation.success. Evid: 1039.
 * Event description: Answer on Request for checking if domain is available sent to server.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * errorName - Type: string. Desc: error_name
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isSuccess - Type: bool. Desc: t/f
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * loadingTime - Type: numeric. Desc: time for server to response
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: first_save / second_save
 *
 * siteDisplayName - Type: string. Desc: checked site domain
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {saveFlowSiteDomainValidationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveFlowSiteDomainValidationSuccess = function (params) {
    return { evid: 1039, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} appLoadingTimesEditorParams
* @property {string} app_id - distinct id for every app (app_def_id)
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: app_loading_times_editor. Evid: 797.
 * Event description: time to app manifest from editor ready (38:429).

 * app_id - Type: string. Desc: distinct id for every app (app_def_id)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {appLoadingTimesEditorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLoadingTimesEditor = function (params) {
    return { evid: 797, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarGetYearlyUnlimitedClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Get-Yearly-Unlimited_click. Evid: 455.
 * Event description: top_bar_Get-Yearly-Unlimited_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarGetYearlyUnlimitedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarGetYearlyUnlimitedClick = function (params) {
    return { evid: 455, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} glassBoxRecordStartedParams
* @property {string} dm_version - null
* @property {string} ds_origin - []
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - []
* @property {string} multilingual - []
* @property {GUID} site_id - []
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - []
* @property {string} usedJsHeapSize - []
* @property {string} videoSessionId - GlassBox video sessionId
* @property {Url} videoUrl - video url
* @property {string} viewerName - []
* @property {string} viewerVersion - []
* @property {string} workspace_mode - null
**/
/**
 * Name: FullStory.record.started. Evid: 89.
 * Event description: FullStory started the recording session.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: []
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: []
 *
 * multilingual - Type: string. Desc: []
 *
 * site_id - Type: guid. Desc: []
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: []
 *
 * usedJsHeapSize - Type: string. Desc: []
 *
 * videoSessionId - Type: string. Desc: GlassBox video sessionId
 *
 * videoUrl - Type: url. Desc: video url
 *
 * viewerName - Type: string. Desc: []
 *
 * viewerVersion - Type: string. Desc: []
 *
 * workspace_mode - Type: string.
 * @param {glassBoxRecordStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var glassBoxRecordStarted = function (params) {
    return { evid: 89, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} enterClickToTriggerSelectedComponentMainActionParams
* @property {string} componentId - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Enter click to trigger selected component main action. Evid: 874.
 * Event description: Enter click to trigger selected component main action.

 * componentId - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {enterClickToTriggerSelectedComponentMainActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var enterClickToTriggerSelectedComponentMainAction = function (params) {
    return { evid: 874, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelAddLayerClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel ---> Add layer click. Evid: 933.
 * Event description: user adds layer anywhere in the panel (fill, shadow ,text-shadow).

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelAddLayerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelAddLayerClick = function (params) {
    return { evid: 933, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderCategoryPickerInAddPanelClickParams
* @property {string} category - 'Contact' / 'Lightbox' / ..
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} sub_category - 'Contact' / 'Payment Form' / 'Job Application' / etc...
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - category picker in add panel - click. Evid: 953.
 * Event description: Form Builder - category picker in add panel.

 * category - Type: string. Desc: 'Contact' / 'Lightbox' / ..
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * sub_category - Type: string. Desc: 'Contact' / 'Payment Form' / 'Job Application' / etc...
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderCategoryPickerInAddPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderCategoryPickerInAddPanelClick = function (params) {
    return { evid: 953, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} prefetchStartParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Prefetch start. Evid: 588.
 * Event description: Prefetch of editor resources has started (resource download about to begin).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {prefetchStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var prefetchStart = function (params) {
    return { evid: 588, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcViewYourSiteClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor, editor1.4
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {number} revision - revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: RC created panel - View RC as a live site clicked. Evid: 893.
 * Event description: Fires when a user clicks on 'view site'  from the release candidate creation panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor, editor1.4
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * revision - Type: numeric. Desc: revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rcViewYourSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcViewYourSiteClick = function (params) {
    return { evid: 893, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} slideActionsMenuOpenedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_id - tab id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Slide Actions menu opened. Evid: 536.
 * Event description: Slide Actions menu opened.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_id - Type: string. Desc: tab id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {slideActionsMenuOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var slideActionsMenuOpened = function (params) {
    return { evid: 536, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tooltipContentCheckedParams
* @property {string} category - specific category of the opened panel (e.g. for add section panel - About, Team, Stores)
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {number} duration - milliseconds user checked tooltip content
* @property {GUID} esi - editor session guid
* @property {boolean} is_rollout - -
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - flag for actions that were done in multilingual mode
* @property {string} origin - opened panel (e.g. add_section_panel)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: tooltip_content_checked. Evid: 1352.
 * Event description: user checked tooltip content.

 * category - Type: string. Desc: specific category of the opened panel (e.g. for add section panel - About, Team, Stores)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * duration - Type: numeric. Desc: milliseconds user checked tooltip content
 *
 * esi - Type: guid. Desc: editor session guid
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: flag for actions that were done in multilingual mode
 *
 * origin - Type: string. Desc: opened panel (e.g. add_section_panel)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {tooltipContentCheckedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tooltipContentChecked = function (params) {
    return { evid: 1352, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stretchHandleParams
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - stretch button/indicator line
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: stretch handle. Evid: 156.
 * Event description: stretch handle.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: stretch button/indicator line
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stretchHandleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stretchHandle = function (params) {
    return { evid: 156, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hiddenElementsHideParams
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} component_id - guid
* @property {string} component_type - {gallery, box...}
* @property {string} current_page_name - {page name}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hide_method - {}
* @property {string} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp, delete, right click}
* @property {GUID} site_id - {}
* @property {string} site_segment - site_header,site_footer,etc...
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hidden_elements_hide. Evid: 299.
 * Event description: hidden_elements_hide.

 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * current_page_name - Type: string. Desc: {page name}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hide_method - Type: string. Desc: {}
 *
 * instance_id - Type: string. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp, delete, right click}
 *
 * site_id - Type: guid. Desc: {}
 *
 * site_segment - Type: string. Desc: site_header,site_footer,etc...
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hiddenElementsHideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hiddenElementsHide = function (params) {
    return { evid: 299, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderSubmissionSettingsButtonClick1165Params
* @property {string} component_id - component_id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - submission settings button - click. Evid: 1165.
 * Event description: Add a new choice to multiple choices.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderSubmissionSettingsButtonClick1165Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderSubmissionSettingsButtonClick1165 = function (params) {
    return { evid: 1165, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerResetVideoProportionsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video_player_reset_video_proportions_click. Evid: 678.
 * Event description: click on reset video proportions.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerResetVideoProportionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerResetVideoProportionsClick = function (params) {
    return { evid: 678, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressUploadFontsInFontsDialogParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press upload fonts in fonts dialog. Evid: 593.
 * Event description: pressing upload fonts in the fonts dialog.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressUploadFontsInFontsDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressUploadFontsInFontsDialog = function (params) {
    return { evid: 593, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog2PublishNowClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_2_Publish_now_click. Evid: 324.
 * Event description: First_Save_Dialog_2_Publish_now_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog2PublishNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog2PublishNowClick = function (params) {
    return { evid: 324, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileSupportedFileTypeSelectParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} option - which type was chosen
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - supported file type - select. Evid: 1170.
 * Event description: Form Builder - upload file - supported file type - select. (When fileType is actually selected).

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * option - Type: string. Desc: which type was chosen
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileSupportedFileTypeSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileSupportedFileTypeSelect = function (params) {
    return { evid: 1170, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} keepAddPanelOpenWhileAddingKeyboardShortcutParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: keep add panel open while adding keyboard shortcut. Evid: 873.
 * Event description: user click CTRL on components in the add panel and keep the add panel open..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {keepAddPanelOpenWhileAddingKeyboardShortcutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var keepAddPanelOpenWhileAddingKeyboardShortcut = function (params) {
    return { evid: 873, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderManageChoicesEditChoiceParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - Manage Choices -Edit Choice. Evid: 1167.
 * Event description: Form widget --> Multiple choices field --> Manage Choices --> Edit Choice.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderManageChoicesEditChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderManageChoicesEditChoice = function (params) {
    return { evid: 1167, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changeIconQuickActionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} icon - icon chosen
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: change_icon_quick_action. Evid: 726.
 * Event description: change_icon_quick_action.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * icon - Type: string. Desc: icon chosen
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {changeIconQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeIconQuickAction = function (params) {
    return { evid: 726, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceChangemaincolorMycolorsSelectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_changemaincolor_mycolors_select. Evid: 219.
 * Event description: colorspace_changemaincolor_mycolors_select.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceChangemaincolorMycolorsSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceChangemaincolorMycolorsSelect = function (params) {
    return { evid: 219, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderStepSettingChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - Value/Number
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_step_setting_changed. Evid: 1322.
 * Event description: range_slider_step_setting_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: Value/Number
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderStepSettingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderStepSettingChanged = function (params) {
    return { evid: 1322, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} spaceTopDragParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {string} section_size - small,medium,large
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: space_top_drag. Evid: 473.
 * Event description: space_top_drag.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * section_size - Type: string. Desc: small,medium,large
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {spaceTopDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var spaceTopDrag = function (params) {
    return { evid: 473, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpClickParams
* @property {string} category - preview/ test site
* @property {string} component - {box, button...}
* @property {string} component_id - .
* @property {string} control_name - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} helpId - what gfpp was clicked
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {boolean} learn_more - {1,0}
* @property {string} multilingual - null
* @property {string} origin - {gfpp, panel, tool bar, top bar, add menu}
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} panel_name - {header settings, add a button...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_click. Evid: 254.
 * Event description: help_click.

 * category - Type: string. Desc: preview/ test site
 *
 * component - Type: string. Desc: {box, button...}
 *
 * component_id - Type: string. Desc: .
 *
 * control_name - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * helpId - Type: string. Desc: what gfpp was clicked
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * learn_more - Type: bool. Desc: {1,0}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp, panel, tool bar, top bar, add menu}
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * panel_name - Type: string. Desc: {header settings, add a button...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpClick = function (params) {
    return { evid: 254, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backToTopButtonButtonLayoutChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layoutName - layout_name
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Back to top button Button: Layout changed. Evid: 1156.
 * Event description: Back to top button Button: Layout changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layoutName - Type: string. Desc: layout_name
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backToTopButtonButtonLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backToTopButtonButtonLayoutChanged = function (params) {
    return { evid: 1156, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} upgradeTopBarHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {string} editor_view_mode - desktop zoom, mobile zoom, mobile
* @property {GUID} esi - -
* @property {boolean} has_sale_indication - indicates if hover happens when sale indication is visible to the user
* @property {boolean} is_rollout - -
* @property {boolean} is_sale - indicates if hover happens during sale period
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: upgrade_top_bar_hover. Evid: 1384.
 * Event description: user is hovering over upgrade button on the top bar.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * editor_view_mode - Type: string. Desc: desktop zoom, mobile zoom, mobile
 *
 * esi - Type: guid. Desc: -
 *
 * has_sale_indication - Type: bool. Desc: indicates if hover happens when sale indication is visible to the user
 *
 * is_rollout - Type: bool. Desc: -
 *
 * is_sale - Type: bool. Desc: indicates if hover happens during sale period
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {upgradeTopBarHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeTopBarHover = function (params) {
    return { evid: 1384, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} arenaStartNowClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - {'top bar','help_home'}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Arena --> Start now click. Evid: 82.
 * Event description: Click on Start now on Arena popover opens in the top bar.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: {'top bar','help_home'}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {arenaStartNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var arenaStartNowClick = function (params) {
    return { evid: 82, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSiteColorsPaletteSelectParams
* @property {string} component_id - .
* @property {string} component_type - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - theme_panel / ...
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {index of selected palette}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Site_Colors_PaletteSelect. Evid: 405.
 * Event description: Edit_Site_Colors_PaletteSelect.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: theme_panel / ...
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {index of selected palette}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editSiteColorsPaletteSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSiteColorsPaletteSelect = function (params) {
    return { evid: 405, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsSeoKeywordsSetParams
* @property {string} category - {social,private}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_seo_keywords_set. Evid: 435.
 * Event description: PAGES_settings_seo_keywords_set.

 * category - Type: string. Desc: {social,private}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsSeoKeywordsSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsSeoKeywordsSet = function (params) {
    return { evid: 435, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchTooltipHoverParams
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} itemId - item name / id
* @property {number} itemIndex - item index
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.tooltip.hover. Evid: 998.
 * Event description: Search result item tooltip hover.

 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * itemId - Type: string. Desc: item name / id
 *
 * itemIndex - Type: numeric. Desc: item index
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchTooltipHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchTooltipHover = function (params) {
    return { evid: 998, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverInTooltipParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {hover over the i in section; Hover over the mininav}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tooltipname - {key}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hover in tooltip. Evid: 672.
 * Event description: send event for 10% of the sessions. hover with mouse on tooltip.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {hover over the i in section; Hover over the mininav}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tooltipname - Type: string. Desc: {key}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverInTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverInTooltip = function (params) {
    return { evid: 672, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationPanelCustomizeClickParams
* @property {string} behavior_name - {float-in, expand...}
* @property {string} component_id - component_id
* @property {string} component_name - {slide gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} trigger_type - entrance, loop, e.t.c
* @property {string} usedJsHeapSize - null
* @property {string} action_name - {screen-in, page-in...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_panel_customize_click. Evid: 372.
 * Event description: animation_panel_costumize_click.

 * behavior_name - Type: string. Desc: {float-in, expand...}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * trigger_type - Type: string. Desc: entrance, loop, e.t.c
 *
 * usedJsHeapSize - Type: string.
 *
 * action_name - Type: string. Desc: {screen-in, page-in...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {animationPanelCustomizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationPanelCustomizeClick = function (params) {
    return { evid: 372, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} canvasOverlayLoadedParams
* @property {string} appDefinitionId - app_definition_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} url - url
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Canvas overlay loaded. Evid: 1460.
 * Event description: Canvas overlay loaded.

 * appDefinitionId - Type: string. Desc: app_definition_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * url - Type: string. Desc: url
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {canvasOverlayLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var canvasOverlayLoaded = function (params) {
    return { evid: 1460, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} reorderSlideParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_order - JSON with tabs names in new order
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Reorder slide. Evid: 535.
 * Event description: Reorder slide.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_order - Type: string. Desc: JSON with tabs names in new order
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {reorderSlideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reorderSlide = function (params) {
    return { evid: 535, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contentInjectionSiteBusinessTypeOpenSearchDropdownParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {string} fieldName - business type/business name
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - Add Section/Page panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Content Injection - Site Business Type - Open Search Dropdown. Evid: 1409.
 * Event description: Fires after user typed in at least 1 symbol in a search bar.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * fieldName - Type: string. Desc: business type/business name
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: Add Section/Page panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {contentInjectionSiteBusinessTypeOpenSearchDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentInjectionSiteBusinessTypeOpenSearchDropdown = function (params) {
    return { evid: 1409, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} megaMenuPopupClickedParams
* @property {string} button - clicked button
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} homepage_displaying - text/icon
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} menuId - menuId
* @property {string} multilingual - multilingual
* @property {string} name - popup name
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Mega Menu - Popup Clicked. Evid: 1358.
 * Event description: Mega Menu - Popup Clicked.

 * button - Type: string. Desc: clicked button
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * homepage_displaying - Type: string. Desc: text/icon
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * menuId - Type: string. Desc: menuId
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * name - Type: string. Desc: popup name
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {megaMenuPopupClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var megaMenuPopupClicked = function (params) {
    return { evid: 1358, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextSpacingChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id
* @property {string} selection - 0ps/1ps/..
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Text_spacing_changed. Evid: 1224.
 * Event description: TextEllipsis.Text_spacing_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string. Desc: 0ps/1ps/..
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextSpacingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextSpacingChanged = function (params) {
    return { evid: 1224, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverOverRulersParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hover over rulers. Evid: 520.
 * Event description: hover_over_rulers.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverOverRulersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverOverRulers = function (params) {
    return { evid: 520, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuImageUploadAnImageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu ->image ->upload an image click. Evid: 126.
 * Event description: add menu ->image ->upload an image click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuImageUploadAnImageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuImageUploadAnImageClick = function (params) {
    return { evid: 126, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsLayoutMigrationAutoCloseGapParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} gap_size - gap size in pixels
* @property {string} gap_type - {}
* @property {boolean} is_closed - did the fixer close the gap
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: SectionsLayoutMigration_auto_close_gap. Evid: 754.
 * Event description: Automatically closing a gap during SectionsLayoutMigration fixer.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * gap_size - Type: numeric. Desc: gap size in pixels
 *
 * gap_type - Type: string. Desc: {}
 *
 * is_closed - Type: bool. Desc: did the fixer close the gap
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionsLayoutMigrationAutoCloseGapParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsLayoutMigrationAutoCloseGap = function (params) {
    return { evid: 754, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionZoomInParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {number} scale - 10,15
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: section_zoom_in. Evid: 475.
 * Event description: section_zoom_in.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * scale - Type: numeric. Desc: 10,15
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionZoomInParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionZoomIn = function (params) {
    return { evid: 475, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesAddAChoiceClickParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices-  Add a Choice - click. Evid: 898.
 * Event description: user  click on Add A Choice in Manage Choices page.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesAddAChoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesAddAChoiceClick = function (params) {
    return { evid: 898, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishedToAllClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Published to all clicked. Evid: 918.
 * Event description: After a click on the Publish Button in the top bar the user can choose whether to publish to all or just to create a release candidate. This event stands for the first option..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishedToAllClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishedToAllClicked = function (params) {
    return { evid: 918, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelItalicClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} panelName - .
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Italic_Click. Evid: 232.
 * Event description: Text_Panel_Italic_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * panelName - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelItalicClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelItalicClick = function (params) {
    return { evid: 232, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorSpaceAddNewColorCancelParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - text_color_picker / theme_color_picker
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color_Space_Add_New_Color_Cancel. Evid: 402.
 * Event description: Color_Space_Add_New_Color_Cancel.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: text_color_picker / theme_color_picker
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorSpaceAddNewColorCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorSpaceAddNewColorCancel = function (params) {
    return { evid: 402, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} directionSelectedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} direction - right/left
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Direction selected. Evid: 542.
 * Event description: Direction selected.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * direction - Type: string. Desc: right/left
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {directionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var directionSelected = function (params) {
    return { evid: 542, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressDownloadFontsFromFontsManagerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press download fonts from fonts manager. Evid: 598.
 * Event description: press download fonts from fonts manager.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressDownloadFontsFromFontsManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressDownloadFontsFromFontsManager = function (params) {
    return { evid: 598, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} shapeComponentSettingsPanelChangesParams
* @property {string} component_id - {a,b,c...}
* @property {string} component_type - .
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} fieldName - the actual change  link / google / proportions
* @property {string} fieldValue - the value of the change
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Shape_Component_Settings_Panel_Changes. Evid: 1141.
 * Event description: Shape_Component_Settings_Panel_Changes.

 * component_id - Type: string. Desc: {a,b,c...}
 *
 * component_type - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * fieldName - Type: string. Desc: the actual change  link / google / proportions
 *
 * fieldValue - Type: string. Desc: the value of the change
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {shapeComponentSettingsPanelChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shapeComponentSettingsPanelChanges = function (params) {
    return { evid: 1141, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} canvasOverlayRemovedParams
* @property {string} appDefinitionId - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} url - url
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Canvas overlay removed. Evid: 1461.
 * Event description: Canvas overlay removed.

 * appDefinitionId - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * url - Type: string. Desc: url
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {canvasOverlayRemovedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var canvasOverlayRemoved = function (params) {
    return { evid: 1461, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentPartTabEmptyParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} skin_name - skin_name
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Component_Part_Tab_Empty. Evid: 98.
 * Event description: debug a bug fix in an error message (once component part tab is empty).

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * skin_name - Type: string. Desc: skin_name
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {componentPartTabEmptyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentPartTabEmpty = function (params) {
    return { evid: 98, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editMainColorTintsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {index of selected Tint}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Main_Color_Tints. Evid: 407.
 * Event description: Edit_Main_Color_Tints.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {index of selected Tint}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editMainColorTintsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editMainColorTints = function (params) {
    return { evid: 407, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} applyCropParams
* @property {string} component_id - id of component which change was applied to
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} flip_horizontally - flip_horizontally
* @property {boolean} flip_vertically - flip_vertically
* @property {number} image_scale - image_scale
* @property {boolean} is_changed - whether one of the images params (w,h,x,y) were changed
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - V/enter
* @property {number} shape_index - shape_index
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: apply_crop. Evid: 513.
 * Event description: apply_crop.

 * component_id - Type: string. Desc: id of component which change was applied to
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * flip_horizontally - Type: bool. Desc: flip_horizontally
 *
 * flip_vertically - Type: bool. Desc: flip_vertically
 *
 * image_scale - Type: numeric. Desc: image_scale
 *
 * is_changed - Type: bool. Desc: whether one of the images params (w,h,x,y) were changed
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: V/enter
 *
 * shape_index - Type: numeric. Desc: shape_index
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {applyCropParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var applyCrop = function (params) {
    return { evid: 513, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerChangeVideoSourceClickParams
* @property {string} clickOrigin - click / autochange
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} source - panel opening origin
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoSource - media_manager / facebook / youtube etc
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.changeVideoSource.click. Evid: 861.
 * Event description: User clicked on 'Select video from' or source automatically changed after url was parsed.

 * clickOrigin - Type: string. Desc: click / autochange
 *
 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: panel opening origin
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoSource - Type: string. Desc: media_manager / facebook / youtube etc
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerChangeVideoSourceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerChangeVideoSourceClick = function (params) {
    return { evid: 861, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} learnMoreClickUpgradeToMenuAsContainerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {settings,help_gpp,pinned_teaser}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Learn more click (Upgrade to Menu as Container). Evid: 882.
 * Event description: update mobile menu -Learn more click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {settings,help_gpp,pinned_teaser}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {learnMoreClickUpgradeToMenuAsContainerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var learnMoreClickUpgradeToMenuAsContainer = function (params) {
    return { evid: 882, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerVideoSetUpDoneParams
* @property {string} clickOrigin - gfpp / settings / right_click
* @property {string} component_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} source - panel opening origin
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} video_id - video_id
* @property {string} videoSource - media_manager / facebook / youtube / other_url etc
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.videoSetUp.done. Evid: 820.
 * Event description: User changed video in Editor Player.

 * clickOrigin - Type: string. Desc: gfpp / settings / right_click
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: panel opening origin
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_id - Type: string. Desc: video_id
 *
 * videoSource - Type: string. Desc: media_manager / facebook / youtube / other_url etc
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerVideoSetUpDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerVideoSetUpDone = function (params) {
    return { evid: 820, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageAddNewPageClick1079Params
* @property {string} app_list - list of the apps
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} button - dd_page_modal / preview / add_shop_page
* @property {string} category - {page, link, dropdown menu, popup, dynamic page}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - []
* @property {string} multilingual - []
* @property {string} name - name of the page
* @property {string} origin - From where user opened pages panel
* @property {GUID} site_id - {}
* @property {string} source - {main menu,  members menu, custom menu, store, lightbox, router, router welcome}
* @property {string} stage_type - null
* @property {string} target - blank/about/project/contact/stores/etc
* @property {string} totalJsHeapSize - []
* @property {string} usedJsHeapSize - []
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - add new page click. Evid: 1079.
 * Event description: User chose to add new Page from templates or just click Add Blank.

 * app_list - Type: string. Desc: list of the apps
 *
 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * button - Type: string. Desc: dd_page_modal / preview / add_shop_page
 *
 * category - Type: string. Desc: {page, link, dropdown menu, popup, dynamic page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: []
 *
 * multilingual - Type: string. Desc: []
 *
 * name - Type: string. Desc: name of the page
 *
 * origin - Type: string. Desc: From where user opened pages panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu,  members menu, custom menu, store, lightbox, router, router welcome}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: blank/about/project/contact/stores/etc
 *
 * totalJsHeapSize - Type: string. Desc: []
 *
 * usedJsHeapSize - Type: string. Desc: []
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageAddNewPageClick1079Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageAddNewPageClick1079 = function (params) {
    return { evid: 1079, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addSectionScrollInAddSectionPanelParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} category - category of the add section panel
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {tool bar, handle}
* @property {string} scrollTop - where user stoped scrolling (y value)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: AddSection - scroll in add section panel. Evid: 1313.
 * Event description: send when scroll in add section panel.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * category - Type: string. Desc: category of the add section panel
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {tool bar, handle}
 *
 * scrollTop - Type: string. Desc: where user stoped scrolling (y value)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addSectionScrollInAddSectionPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addSectionScrollInAddSectionPanel = function (params) {
    return { evid: 1313, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gridTableSettingsCloseClickedParams
* @property {string} click_select - nothing, cells, items, etc...
* @property {string} component_id - comp id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} link_open - new window, current window
* @property {string} multilingual - null
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: grid - table settings close clicked. Evid: 652.
 * Event description: send the settings snapshot on closing the settings window.

 * click_select - Type: string. Desc: nothing, cells, items, etc...
 *
 * component_id - Type: string. Desc: comp id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * link_open - Type: string. Desc: new window, current window
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {gridTableSettingsCloseClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gridTableSettingsCloseClicked = function (params) {
    return { evid: 652, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsClickOnAtManageLocationsParams
* @property {string} address - {}
* @property {string} addressId - *******depricated***********
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} option - {Center,Edit,Delete}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google Maps ->click on  '...' at Manage Locations. Evid: 1216.
 * Event description: Google Maps -> click on Edit '...'  at  location at Manage Locations.

 * address - Type: string. Desc: {}
 *
 * addressId - Type: string. Desc: *******depricated***********
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * option - Type: string. Desc: {Center,Edit,Delete}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleMapsClickOnAtManageLocationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsClickOnAtManageLocations = function (params) {
    return { evid: 1216, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gridColumnManagerAddColumnClickedParams
* @property {string} component_id - comp id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: grid - column manager add column clicked. Evid: 650.
 * Event description: click on adding column to grid.

 * component_id - Type: string. Desc: comp id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {gridColumnManagerAddColumnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gridColumnManagerAddColumnClicked = function (params) {
    return { evid: 650, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionSectionRenamedParams
* @property {string} component_id - component_id of section
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of rename click
* @property {string} section_name - section_name
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section - section renamed. Evid: 1306.
 * Event description: user renamed section.

 * component_id - Type: string. Desc: component_id of section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of rename click
 *
 * section_name - Type: string. Desc: section_name
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionSectionRenamedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionSectionRenamed = function (params) {
    return { evid: 1306, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} galleryImageControlClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Left Click, Right Click, Organize Images}
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: GalleryImageControl_Click. Evid: 368.
 * Event description: GalleryImageControl_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Left Click, Right Click, Organize Images}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {galleryImageControlClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var galleryImageControlClick = function (params) {
    return { evid: 368, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuDragComponentParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} component_id - component id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} preset_id - --
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> drag component. Evid: 122.
 * Event description: add menu -> drag component.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * component_id - Type: string. Desc: component id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * preset_id - Type: string. Desc: --
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuDragComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuDragComponent = function (params) {
    return { evid: 122, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelLetterSpacingClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} how_it_was_changed - {slider, input field}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {20, 40. 60...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Letter_Spacing_Click. Evid: 246.
 * Event description: Text_Panel_Letter_Spacing_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * how_it_was_changed - Type: string. Desc: {slider, input field}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {20, 40. 60...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelLetterSpacingClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelLetterSpacingClick = function (params) {
    return { evid: 246, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelOpenedParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp, double click}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_opened. Evid: 224.
 * Event description: Text_Panel_opened **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp, double click}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelOpened = function (params) {
    return { evid: 224, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationZIndexOverlappingParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - {}
* @property {string} pageId - page id
* @property {string} section_name - name of section
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - z index overlapping. Evid: 1296.
 * Event description: z index overlapping.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: {}
 *
 * pageId - Type: string. Desc: page id
 *
 * section_name - Type: string. Desc: name of section
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationZIndexOverlappingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationZIndexOverlapping = function (params) {
    return { evid: 1296, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteAdjustShadeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - colour name
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette Adjust Shade click. Evid: 1431.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: colour name
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteAdjustShadeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteAdjustShadeClick = function (params) {
    return { evid: 1431, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openLinkPanelClickParams
* @property {string} component_id - {a,b,c...}
* @property {string} component_type - {button, image....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {fpp,settings_panel...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open_link_panel_click. Evid: 159.
 * Event description: open_link_panel_click.

 * component_id - Type: string. Desc: {a,b,c...}
 *
 * component_type - Type: string. Desc: {button, image....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {fpp,settings_panel...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openLinkPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openLinkPanelClick = function (params) {
    return { evid: 159, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sliderValueChangeParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selected_value - {value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - .
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} value_change_origin - {Slider, Input field}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Slider_ValueChange. Evid: 365.
 * Event description: Slider_ValueChange.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selected_value - Type: string. Desc: {value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * value_change_origin - Type: string. Desc: {Slider, Input field}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sliderValueChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sliderValueChange = function (params) {
    return { evid: 365, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarSiteMenuClickParams
* @property {string} category - {save, publish, site revision, manage site..}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_SITE_menu_click. Evid: 286.
 * Event description: top_bar_click.

 * category - Type: string. Desc: {save, publish, site revision, manage site..}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarSiteMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarSiteMenuClick = function (params) {
    return { evid: 286, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderFieldTitleOffsetChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} section - Circle/Square/Rectangle /Bar
* @property {string} selection - 1,2,3...
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - null
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_field_title_offset_changed. Evid: 1328.
 * Event description: range_slider_field_title_offset_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * selection - Type: string. Desc: 1,2,3...
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderFieldTitleOffsetChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderFieldTitleOffsetChanged = function (params) {
    return { evid: 1328, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarTooltipOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_published - t / f
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item - Publish/Preview/Save
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_tooltip_open. Evid: 1051.
 * Event description: Publish/Preview/Save tooltip opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_published - Type: bool. Desc: t / f
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item - Type: string. Desc: Publish/Preview/Save
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarTooltipOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarTooltipOpen = function (params) {
    return { evid: 1051, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbNumberItemsToShowChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} display_mode - wrap/ellipsis
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} section - prefix/suffix
* @property {string} selection - 1,2,3…
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_number_items_to_show_changed. Evid: 1316.
 * Event description: breadcrumb_number_items_to_show_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * display_mode - Type: string. Desc: wrap/ellipsis
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string. Desc: prefix/suffix
 *
 * selection - Type: string. Desc: 1,2,3…
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbNumberItemsToShowChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbNumberItemsToShowChanged = function (params) {
    return { evid: 1316, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardHomepagePageSelectParams
* @property {string} actionSource - page thumbnail / action link
* @property {number} curatedTemplateId - {1,2,3,....}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {number} position - 1/2/3 {which page user chose}
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Homepage - page select. Evid: 1258.


 * actionSource - Type: string. Desc: page thumbnail / action link
 *
 * curatedTemplateId - Type: numeric. Desc: {1,2,3,....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * position - Type: numeric. Desc: 1/2/3 {which page user chose}
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardHomepagePageSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardHomepagePageSelect = function (params) {
    return { evid: 1258, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateResize729Params
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_resize. Evid: 729.
 * Event description: frame view rate per resize action.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateResize729Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateResize729 = function (params) {
    return { evid: 729, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsPanelSettingsStatusParams
* @property {boolean} allow_dragging - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {boolean} show_direction_link - {}
* @property {boolean} show_map_satellite_views - {}
* @property {boolean} show_street_view - {}
* @property {boolean} show_zoom_control - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {number} zoom_value - {}
**/
/**
 * Name: Google Maps Panel Settings Status. Evid: 1212.
 * Event description: Display the panel status....

 * allow_dragging - Type: bool. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * show_direction_link - Type: bool. Desc: {}
 *
 * show_map_satellite_views - Type: bool. Desc: {}
 *
 * show_street_view - Type: bool. Desc: {}
 *
 * show_zoom_control - Type: bool. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * zoom_value - Type: numeric. Desc: {}
 * @param {googleMapsPanelSettingsStatusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsPanelSettingsStatus = function (params) {
    return { evid: 1212, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutScrollParams
* @property {string} component_id - id of selected section
* @property {string} component_type - component_type
* @property {string} correlation_id - id, which should change after layout panel was closed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - scroll. Evid: 1277.
 * Event description: on scroll.

 * component_id - Type: string. Desc: id of selected section
 *
 * component_type - Type: string. Desc: component_type
 *
 * correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutScroll = function (params) {
    return { evid: 1277, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} conflictingPagesActionsParams
* @property {string} app_id - {id of app}
* @property {string} default_page_id - {id of page that is being replaced}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {id of page that is replacing}
* @property {string} page_name - {name of page}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {cancel, replace}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Conflicting pages actions. Evid: 1445.
 * Event description: Conflicting pages actions.

 * app_id - Type: string. Desc: {id of app}
 *
 * default_page_id - Type: string. Desc: {id of page that is being replaced}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {id of page that is replacing}
 *
 * page_name - Type: string. Desc: {name of page}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {cancel, replace}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {conflictingPagesActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var conflictingPagesActions = function (params) {
    return { evid: 1445, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} cancelRotateComponentParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: cancel rotate component. Evid: 154.
 * Event description: cancel rotate component.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {cancelRotateComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cancelRotateComponent = function (params) {
    return { evid: 154, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} wixSearchAppSetAutoSuggestChangedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} isEnabled - t / f
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: wixSearch.appSet.autoSuggest.changed. Evid: 942.
 * Event description: The user changed autosuggest toggle in settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * isEnabled - Type: bool. Desc: t / f
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {wixSearchAppSetAutoSuggestChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixSearchAppSetAutoSuggestChanged = function (params) {
    return { evid: 942, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ssrCacheTimeframeDropdownOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - dynamic_page_settings_panel / pages_panel
* @property {string} pageId - xyz
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: ssr_cache_timeframe_dropdown_open. Evid: 1175.
 * Event description: ssr_cache_timeframe_dropdown_open.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: dynamic_page_settings_panel / pages_panel
 *
 * pageId - Type: string. Desc: xyz
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {ssrCacheTimeframeDropdownOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ssrCacheTimeframeDropdownOpen = function (params) {
    return { evid: 1175, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorReadyParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} isFirst - true/false
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - from where user enter mobile editor
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Mobile_Editor_Ready. Evid: 747.
 * Event description: Mobile_Editor_Ready.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isFirst - Type: bool. Desc: true/false
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: from where user enter mobile editor
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorReady = function (params) {
    return { evid: 747, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteImageQualitySettingsPanelHelpClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_image_quality_settings_panel_Help_click. Evid: 518.
 * Event description: Panel_closed_as_Cancel or X top right.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteImageQualitySettingsPanelHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteImageQualitySettingsPanelHelpClick = function (params) {
    return { evid: 518, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetLayoutDisplayInfoChangedParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} isEnabled - true / false
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {string} selection - cover / artist_name / track_name / progress_bar / time_stamp
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.layout.displayInfo.changed. Evid: 1202.
 * Event description: What info AudioPlayer_view included.

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * isEnabled - Type: bool. Desc: true / false
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: cover / artist_name / track_name / progress_bar / time_stamp
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetLayoutDisplayInfoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetLayoutDisplayInfoChanged = function (params) {
    return { evid: 1202, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkPanelRelValueClickParams
* @property {string} category - {ExternalLink, PageLink}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - panel opening origin
* @property {string} rel_name - send rel value name {noopener, noreferrer, nofollow, sponsored}
* @property {boolean} rel_status - rel value checked or unchecked (true/false)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: rel_value_select. Evid: 1346.
 * Event description: The event fires when  user clicking on rel values..

 * category - Type: string. Desc: {ExternalLink, PageLink}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * rel_name - Type: string. Desc: send rel value name {noopener, noreferrer, nofollow, sponsored}
 *
 * rel_status - Type: bool. Desc: rel value checked or unchecked (true/false)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {linkPanelRelValueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkPanelRelValueClick = function (params) {
    return { evid: 1346, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} applyOnOtherSlidesSelectionParams
* @property {boolean} all_slides_selected - 0/1
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_selected_slides - 1,2,3
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {number} total_slides - 1,2,3
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Apply on other slides selection. Evid: 540.
 * Event description: Apply on other slides selection.

 * all_slides_selected - Type: bool. Desc: 0/1
 *
 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_selected_slides - Type: numeric. Desc: 1,2,3
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * total_slides - Type: numeric. Desc: 1,2,3
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {applyOnOtherSlidesSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var applyOnOtherSlidesSelection = function (params) {
    return { evid: 540, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelSaveThemeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_panel_save_theme_Click. Evid: 268.
 * Event description: Text_panel_save_theme_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelSaveThemeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelSaveThemeClick = function (params) {
    return { evid: 268, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorTooltipTooltipOpenedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile editor tooltip --> tooltip opened. Evid: 94.
 * Event description: Mobile editor tooltip opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorTooltipTooltipOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorTooltipTooltipOpened = function (params) {
    return { evid: 94, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkPanelOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} parent_panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: LinkPanel_Open. Evid: 310.
 * Event description: LinkPanel_Open.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * parent_panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {linkPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkPanelOpen = function (params) {
    return { evid: 310, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} effectsPanelCustomizeClickParams
* @property {string} behavior_name - Grow/Shrink/Skew/Rotate/Custom
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: effects_panel_customize_click. Evid: 983.
 * Event description: Customize button click.

 * behavior_name - Type: string. Desc: Grow/Shrink/Skew/Rotate/Custom
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {effectsPanelCustomizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var effectsPanelCustomizeClick = function (params) {
    return { evid: 983, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsSeoTitleSetParams
* @property {string} category - {social,private, dynamic_page}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field - {seo title set, page URL}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_seo_title_set_or_URL_set. Evid: 433.
 * Event description: PAGES_settings_seo_title_set.

 * category - Type: string. Desc: {social,private, dynamic_page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field - Type: string. Desc: {seo title set, page URL}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsSeoTitleSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsSeoTitleSet = function (params) {
    return { evid: 433, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} autosaveErrorSaveVsUpdateParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selection - {save, update editor}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: autosave error - save vs update. Evid: 660.
 * Event description: save_error_more_than_one_window.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: {save, update editor}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {autosaveErrorSaveVsUpdateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autosaveErrorSaveVsUpdate = function (params) {
    return { evid: 660, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileInputSettingsCheckboxParams
* @property {boolean} checkbox - checkbox value
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - null
* @property {string} fieldName - fieldName
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - input settings - checkbox. Evid: 1225.
 * Event description: Form Builder - upload file - input settings - checkbox.

 * checkbox - Type: bool. Desc: checkbox value
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid.
 *
 * fieldName - Type: string. Desc: fieldName
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileInputSettingsCheckboxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileInputSettingsCheckbox = function (params) {
    return { evid: 1225, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} navigateToASlideParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - slide manager” /”slider control
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Navigate to a slide. Evid: 534.
 * Event description: Navigate to a slide.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: slide manager” /”slider control
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {navigateToASlideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var navigateToASlide = function (params) {
    return { evid: 534, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} singleVideoPlayerCoverImageAddClickParams
* @property {string} action_type - add, change
* @property {string} component_type - video
* @property {string} dm_version - dm version
* @property {string} ds_origin - editor / editor x ...
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoId - video ID
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: singleVideoPlayer.coverImage.add.click. Evid: 1509.
 * Event description: User clicked on ‘Add Image’ in thumbnail tab in Video Design panel.

 * action_type - Type: string. Desc: add, change
 *
 * component_type - Type: string. Desc: video
 *
 * dm_version - Type: string. Desc: dm version
 *
 * ds_origin - Type: string. Desc: editor / editor x ...
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoId - Type: string. Desc: video ID
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {singleVideoPlayerCoverImageAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var singleVideoPlayerCoverImageAddClick = function (params) {
    return { evid: 1509, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppPromotionalFirsttimeStep2welcomeContinueClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_promotional_firsttime_step2welcome_continue_click. Evid: 196.
 * Event description: site_app_promotional_firsttime_step2welcome_continue_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppPromotionalFirsttimeStep2welcomeContinueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppPromotionalFirsttimeStep2welcomeContinueClick = function (params) {
    return { evid: 196, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} applyThemeClickParams
* @property {string} component_id - component_id of section
* @property {string} component_type - section / header / footer
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - RCM | action_bar
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Apply theme click. Evid: 1388.
 * Event description: user clicks on Apply site theme (both from action bar or RCM).

 * component_id - Type: string. Desc: component_id of section
 *
 * component_type - Type: string. Desc: section / header / footer
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: RCM | action_bar
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {applyThemeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var applyThemeClick = function (params) {
    return { evid: 1388, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuItemActionClickParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item_id - id for the menu item
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {string} page_id - .
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} target - page / menu_set / link / dropdown
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_item_action_click. Evid: 975.
 * Event description: MENU_item_action_click.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_id - Type: string. Desc: id for the menu item
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: page / menu_set / link / dropdown
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuItemActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuItemActionClick = function (params) {
    return { evid: 975, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} effectsPanelBehaviorDeletedParams
* @property {string} deleted_behavior_name - Grow/Shrink/Skew/Rotate/Custom
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: effects_panel_behavior_deleted. Evid: 981.
 * Event description: Deleting Transform/Filters effects (selecting None).

 * deleted_behavior_name - Type: string. Desc: Grow/Shrink/Skew/Rotate/Custom
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {effectsPanelBehaviorDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var effectsPanelBehaviorDeleted = function (params) {
    return { evid: 981, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backgroundClickOnMediaItemParams
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} fileId - media file id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mediaType - image / video
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Background -> Click on media item. Evid: 93.
 * Event description: A user clicks on Image or Video preview on Background change panel (or Strip BG change, see component type) in order to change the background of a site..

 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * fileId - Type: string. Desc: media file id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mediaType - Type: string. Desc: image / video
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {backgroundClickOnMediaItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backgroundClickOnMediaItem = function (params) {
    return { evid: 93, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuInnerNavigationOpenedClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu-> inner navigation opened click. Evid: 117.
 * Event description: add menu-> inner navigation opened click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuInnerNavigationOpenedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuInnerNavigationOpenedClick = function (params) {
    return { evid: 117, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changeContactFormNameParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {name of new contact form}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: change contact form name. Evid: 645.
 * Event description: name of contact form.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {name of new contact form}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {changeContactFormNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeContactFormName = function (params) {
    return { evid: 645, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonSpaceBetweenTextAndIconChangedParams
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id
* @property {string} selection - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: StylableButton.space_between_text_and_icon_changed. Evid: 1343.


 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonSpaceBetweenTextAndIconChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonSpaceBetweenTextAndIconChanged = function (params) {
    return { evid: 1343, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerLayoutControlsShowChangedParams
* @property {string} component_id - component_id
* @property {string} componentType - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selection - hover / never
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.layout.controlsShow.changed. Evid: 830.
 * Event description: User changed 'When playing controls show'.

 * component_id - Type: string. Desc: component_id
 *
 * componentType - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: hover / never
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerLayoutControlsShowChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerLayoutControlsShowChanged = function (params) {
    return { evid: 830, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentAddedToStageParams
* @property {string} adding_method - {click,drag}
* @property {string} app_id - app id
* @property {string} app_list - null
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} component_id - component_id
* @property {string} component_name - component_name
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_target_repeated - {true,false} Is target contained in a repeater
* @property {boolean} isZoomOut - null
* @property {number} itemIndex - for ai section creator - number of section in the list
* @property {string} jsHeapSizeLimit - null
* @property {string} json_components_presets - json with component_type and component_id of all components in the section preset
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - {add panel, my uploads panel.}
* @property {string} page_id - page id where the component was added
* @property {string} preset_data_skin - skin
* @property {string} preset_data_tags - {yellow, buy, circle...}
* @property {string} preset_id - --
* @property {string} properties - properties (for Audio player)
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target_component - {compType} //will be page if add to stage
* @property {string} target_component_id - null
* @property {string} target_component_type - target component type (specific type)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - widget_id
* @property {string} workspace_mode - null
**/
/**
 * Name: component added to stage. Evid: 123.
 * Event description: component added to stage.

 * adding_method - Type: string. Desc: {click,drag}
 *
 * app_id - Type: string. Desc: app id
 *
 * app_list - Type: string.
 *
 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_name - Type: string. Desc: component_name
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_target_repeated - Type: bool. Desc: {true,false} Is target contained in a repeater
 *
 * isZoomOut - Type: bool.
 *
 * itemIndex - Type: numeric. Desc: for ai section creator - number of section in the list
 *
 * jsHeapSizeLimit - Type: string.
 *
 * json_components_presets - Type: string. Desc: json with component_type and component_id of all components in the section preset
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: {add panel, my uploads panel.}
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * preset_data_skin - Type: string. Desc: skin
 *
 * preset_data_tags - Type: string. Desc: {yellow, buy, circle...}
 *
 * preset_id - Type: string. Desc: --
 *
 * properties - Type: string. Desc: properties (for Audio player)
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target_component - Type: string. Desc: {compType} //will be page if add to stage
 *
 * target_component_id - Type: string.
 *
 * target_component_type - Type: string. Desc: target component type (specific type)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: widget_id
 *
 * workspace_mode - Type: string.
 * @param {componentAddedToStageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentAddedToStage = function (params) {
    return { evid: 123, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tabAndShiftTabNavigateBetweenComponentsOnStageParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tab and Shift Tab navigate between components on stage. Evid: 872.
 * Event description: Tab and Shift-Tab navigate between components on stage.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tabAndShiftTabNavigateBetweenComponentsOnStageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tabAndShiftTabNavigateBetweenComponentsOnStage = function (params) {
    return { evid: 872, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishViewYourSiteClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_publish - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish_view_your_site_click. Evid: 449.
 * Event description: publish_view_your_site_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_publish - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishViewYourSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishViewYourSiteClick = function (params) {
    return { evid: 449, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuThemeSectionInfoClosedParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> theme section info closed. Evid: 110.
 * Event description: add menu -> theme section info closed.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuThemeSectionInfoClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuThemeSectionInfoClosed = function (params) {
    return { evid: 110, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} strechToScreenPanelClosedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} margins_units - {pixels, percentage}
* @property {number} margins_value - {numeric value of margins set by user}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {number} viewport_height - {1,2,3...}
* @property {number} viewport_width - {1,2,3...}
* @property {string} workspace_mode - null
**/
/**
 * Name: strech_to_screen_panel closed. Evid: 507.
 * Event description: strech_to_screen_panel closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * margins_units - Type: string. Desc: {pixels, percentage}
 *
 * margins_value - Type: numeric. Desc: {numeric value of margins set by user}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * viewport_height - Type: numeric. Desc: {1,2,3...}
 *
 * viewport_width - Type: numeric. Desc: {1,2,3...}
 *
 * workspace_mode - Type: string.
 * @param {strechToScreenPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var strechToScreenPanelClosed = function (params) {
    return { evid: 507, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchTooltipClickParams
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} itemId - item name / id
* @property {number} itemIndex - item index
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.tooltip.click. Evid: 999.


 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * itemId - Type: string. Desc: item name / id
 *
 * itemIndex - Type: numeric. Desc: item index
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchTooltipClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchTooltipClick = function (params) {
    return { evid: 999, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterCreateTextClickParams
* @property {string} actionOrigin - create_text / regenerate
* @property {string} businessType - {industry:”x”; structure: “y”}
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - null
* @property {string} gptParams - e.g., ‘1.2.1’
* @property {boolean} isAiTextCreator - Smart Writer / Ai Text Creator
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} panelType - single sided / double sided
* @property {string} prompt - same as in events 38:1417, 1456
* @property {string} query - user's request in Ai Text Creator in json format
* @property {string} sessionId - .
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} subject - null
* @property {boolean} success - true = click passed the validation / false = click didn't pass the validation and error was shown
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.createText.click. Evid: 1031.
 * Event description: Smart Writer Create Text Click.

 * actionOrigin - Type: string. Desc: create_text / regenerate
 *
 * businessType - Type: string. Desc: {industry:”x”; structure: “y”}
 *
 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid.
 *
 * gptParams - Type: string. Desc: e.g., ‘1.2.1’
 *
 * isAiTextCreator - Type: bool. Desc: Smart Writer / Ai Text Creator
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * panelType - Type: string. Desc: single sided / double sided
 *
 * prompt - Type: string. Desc: same as in events 38:1417, 1456
 *
 * query - Type: string. Desc: user's request in Ai Text Creator in json format
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * subject - Type: string.
 *
 * success - Type: bool. Desc: true = click passed the validation / false = click didn't pass the validation and error was shown
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {smartWriterCreateTextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterCreateTextClick = function (params) {
    return { evid: 1031, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsLayoutChooseParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - standard / no-header-footer
* @property {boolean} toggle - standard / no-header-footer
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_layout_choose. Evid: 1078.
 * Event description: PAGES_settings_layout_choose.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: standard / no-header-footer
 *
 * toggle - Type: bool. Desc: standard / no-header-footer
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsLayoutChooseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsLayoutChoose = function (params) {
    return { evid: 1078, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardNavigateParams
* @property {string} current_step - current step while clicking skip
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} next_or_previous - {next, previous}
* @property {string} selected_value - value chosen
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_navigate. Evid: 776.
 * Event description: clicking next step in mobile wizard.

 * current_step - Type: string. Desc: current step while clicking skip
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * next_or_previous - Type: string. Desc: {next, previous}
 *
 * selected_value - Type: string. Desc: value chosen
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardNavigateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardNavigate = function (params) {
    return { evid: 776, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardErrorHidingParams
* @property {string} componentId - .
* @property {string} componentType - .
* @property {string} containerId - .
* @property {string} containerType - .
* @property {number} curatedTemplateId - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: ERROR HIDING. Evid: 1300.
 * Event description: an error BI for the site creation.

 * componentId - Type: string. Desc: .
 *
 * componentType - Type: string. Desc: .
 *
 * containerId - Type: string. Desc: .
 *
 * containerType - Type: string. Desc: .
 *
 * curatedTemplateId - Type: numeric. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardErrorHidingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardErrorHiding = function (params) {
    return { evid: 1300, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} adiToEditorPanelXButtonPressedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {esc;x button; start now}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {Url} video_url - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ADI to editor panel: X button pressed. Evid: 641.
 * Event description: Intro video for new users who migrated from ADI to editor is closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {esc;x button; start now}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_url - Type: url. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {adiToEditorPanelXButtonPressedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adiToEditorPanelXButtonPressed = function (params) {
    return { evid: 641, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} doubleSidedSliderParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} handle_ind - {left, right}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selected_value - {value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} value_change_origin - {Slider, Input field}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: double_sided_slider. Evid: 509.
 * Event description: double_sided_slider.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * handle_ind - Type: string. Desc: {left, right}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selected_value - Type: string. Desc: {value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * value_change_origin - Type: string. Desc: {Slider, Input field}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {doubleSidedSliderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var doubleSidedSlider = function (params) {
    return { evid: 509, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} removeQuickActionParams
* @property {string} action_type - action type removed
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: remove_quick_action. Evid: 725.
 * Event description: remove_quick_action.

 * action_type - Type: string. Desc: action type removed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {removeQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeQuickAction = function (params) {
    return { evid: 725, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderManageChoicesReorderChoiceCompleteParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - Manage Choices - Reorder Choice - complete. Evid: 1164.
 * Event description: Form widget --> Multiple choices field --> Manage Choices -->  Reorder Choice
Copy of event 5: 879.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderManageChoicesReorderChoiceCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderManageChoicesReorderChoiceComplete = function (params) {
    return { evid: 1164, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} showControlsTooltipAppearanceParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: show_controls_tooltip_appearance. Evid: 501.
 * Event description: show_controls_tooltip_appearance.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {showControlsTooltipAppearanceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showControlsTooltipAppearance = function (params) {
    return { evid: 501, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stripBackgroundPanelBackgroundChangedEditorxParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} fieldNames - valid values are the fields names from 487
* @property {string} fieldValues - will contain the changes similar to 487
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - panel_name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} sub_panel_name - sub_panel_name
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: strip_background_panel_background_changed_EditorX. Evid: 1319.
 * Event description: sends on panel close only if there were changes (for EditorX).

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * fieldNames - Type: string. Desc: valid values are the fields names from 487
 *
 * fieldValues - Type: string. Desc: will contain the changes similar to 487
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * sub_panel_name - Type: string. Desc: sub_panel_name
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stripBackgroundPanelBackgroundChangedEditorxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stripBackgroundPanelBackgroundChangedEditorx = function (params) {
    return { evid: 1319, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMenuPopupClickParams
* @property {string} action_type - {manage menu, learn more etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage menu popup click. Evid: 1424.
 * Event description: Click inside the manage menu modal.

 * action_type - Type: string. Desc: {manage menu, learn more etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMenuPopupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMenuPopupClick = function (params) {
    return { evid: 1424, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageSettingsPermissionsSetPermissionsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} permission_selected - {no restrictions, password protection, members only}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_settings_permissions_set_permissions. Evid: 631.
 * Event description: page_settings_permissions_set_permissions.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * permission_selected - Type: string. Desc: {no restrictions, password protection, members only}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageSettingsPermissionsSetPermissionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageSettingsPermissionsSetPermissions = function (params) {
    return { evid: 631, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} moveForwardsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: move forwards. Evid: 150.
 * Event description: move forwards.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {moveForwardsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var moveForwards = function (params) {
    return { evid: 150, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuPanelSelectParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel - {Manage,Pages,Add,LearnMore}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_panel_select. Evid: 204.
 * Event description: site_app_menu_panel_select.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel - Type: string. Desc: {Manage,Pages,Add,LearnMore}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuPanelSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuPanelSelect = function (params) {
    return { evid: 204, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishConnectDomainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_connect_domain_click. Evid: 379.
 * Event description: First_Publish_connect_domain_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstPublishConnectDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishConnectDomainClick = function (params) {
    return { evid: 379, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuInnerNavigationOpenedAutomaticallyParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu-> inner navigation opened automatically. Evid: 118.
 * Event description: add menu-> inner navigation opened automatically.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuInnerNavigationOpenedAutomaticallyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuInnerNavigationOpenedAutomatically = function (params) {
    return { evid: 118, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpPinPositionSelectedParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selected_area - {string}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_pin_position_selected. Evid: 529.
 * Event description: pop_up_pin_position_selected.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selected_area - Type: string. Desc: {string}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {popUpPinPositionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpPinPositionSelected = function (params) {
    return { evid: 529, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} themeCreatedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {duration of theme creation from origin}
* @property {GUID} esi - null
* @property {number} generationAttempt - {number of generation attempts}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {logo, image etc}
* @property {string} originValue - {image_id}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {number} themeCount - {number of themes created}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Theme Created. Evid: 1501.
 * Event description: Theme created inside Design Panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {duration of theme creation from origin}
 *
 * esi - Type: guid.
 *
 * generationAttempt - Type: numeric. Desc: {number of generation attempts}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {logo, image etc}
 *
 * originValue - Type: string. Desc: {image_id}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * themeCount - Type: numeric. Desc: {number of themes created}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {themeCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var themeCreated = function (params) {
    return { evid: 1501, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} guideDeletedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {trash_icon,drag_outside,delete_button}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: guide deleted. Evid: 524.
 * Event description: Guilde deleted.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {trash_icon,drag_outside,delete_button}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {guideDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var guideDeleted = function (params) {
    return { evid: 524, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondSavePublishNowClick339Params
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {not published not connected, not Published connected, published_connected, Published_not_connected}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Save_publish_now_click. Evid: 339.
 * Event description: Second_Save_publish_now_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {not published not connected, not Published connected, published_connected, Published_not_connected}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondSavePublishNowClick339Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondSavePublishNowClick339 = function (params) {
    return { evid: 339, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardFinishParams
* @property {string} back_to_top_button_option - BACK_TO_TOP_BUTTON chosen value
* @property {string} current_step - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} finish_method - {skip, finish}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} quick_action_bar_option - QUICK_ACTION_BAR chosen value
* @property {string} site_header_option - SITE_HEADER chosen value
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tiny_menu_option - TINY_MENU chosen value
* @property {string} totalJsHeapSize - null
* @property {string} type - **deprecated**
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_finish. Evid: 780.
 * Event description: finish mobile wizard.

 * back_to_top_button_option - Type: string. Desc: BACK_TO_TOP_BUTTON chosen value
 *
 * current_step - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * finish_method - Type: string. Desc: {skip, finish}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * quick_action_bar_option - Type: string. Desc: QUICK_ACTION_BAR chosen value
 *
 * site_header_option - Type: string. Desc: SITE_HEADER chosen value
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tiny_menu_option - Type: string. Desc: TINY_MENU chosen value
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: **deprecated**
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardFinishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardFinish = function (params) {
    return { evid: 780, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeArticleClickParams
* @property {GUID} article_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_article_click. Evid: 1092.
 * Event description: Event fires when clicking any article inside the popular articles section, under the help home panel.

 * article_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeArticleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeArticleClick = function (params) {
    return { evid: 1092, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSiteTextStylesClickParams
* @property {string} component_id - .
* @property {string} component_type - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_site_text_styles_click. Evid: 1066.
 * Event description: user clicked edit_site_text_styles in a text panel.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editSiteTextStylesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSiteTextStylesClick = function (params) {
    return { evid: 1066, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorMediaUploadStartedParams
* @property {boolean} batch - true/false several files in one import
* @property {number} batch_size - amount of files in batch
* @property {string} dm_version - dm_version
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} file_format - file extension
* @property {number} file_size - file size in KB
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - where the file was added from (desktop)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} target_component_id - target_component_id
* @property {string} target_component_type - section, repeater, e.t.c
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - workspace_mode
**/
/**
 * Name: Editor - Media upload started. Evid: 1476.
 * Event description: Editor - Media upload started.

 * batch - Type: bool. Desc: true/false several files in one import
 *
 * batch_size - Type: numeric. Desc: amount of files in batch
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * file_format - Type: string. Desc: file extension
 *
 * file_size - Type: numeric. Desc: file size in KB
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: where the file was added from (desktop)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * target_component_id - Type: string. Desc: target_component_id
 *
 * target_component_type - Type: string. Desc: section, repeater, e.t.c
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string. Desc: workspace_mode
 * @param {editorMediaUploadStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorMediaUploadStarted = function (params) {
    return { evid: 1476, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openCropOptionsMenuParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open_crop_options_menu. Evid: 511.
 * Event description: open_crop_options_menu.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openCropOptionsMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openCropOptionsMenu = function (params) {
    return { evid: 511, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpTooltipSettingsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} settings_button - {which settings button was clicked }
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_tooltip_settings_click. Evid: 567.
 * Event description: pop_up_tooltip_settings_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * settings_button - Type: string. Desc: {which settings button was clicked }
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpTooltipSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpTooltipSettingsClick = function (params) {
    return { evid: 567, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rulersTooltipAppearsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Rulers tooltip appears. Evid: 525.
 * Event description: Tooltip appears on hover.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rulersTooltipAppearsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rulersTooltipAppears = function (params) {
    return { evid: 525, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsElementsPlacedInDeadSpotParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} is_same_parent_component - element moved inside current parent component (true/false)
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_of_elements - {num}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_elements_placed_in_dead_spot. Evid: 577.
 * Event description: columns_elements_placed_in_dead_spot.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * is_same_parent_component - Type: bool. Desc: element moved inside current parent component (true/false)
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_of_elements - Type: numeric. Desc: {num}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsElementsPlacedInDeadSpotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsElementsPlacedInDeadSpot = function (params) {
    return { evid: 577, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetLayoutLayoutChangedParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.layout.layout.changed. Evid: 1201.
 * Event description: Audio Player Layout changed (classic / icon ).

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetLayoutLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetLayoutLayoutChanged = function (params) {
    return { evid: 1201, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsMoveUpDownParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {rcm, keyboard}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_move_up_down. Evid: 580.
 * Event description: columns_move_up_down.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {rcm, keyboard}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsMoveUpDownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsMoveUpDown = function (params) {
    return { evid: 580, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppPromotionalInstallCloseClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_promotional_install_close_click. Evid: 194.
 * Event description: site_app_promotional_install_close_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppPromotionalInstallCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppPromotionalInstallCloseClick = function (params) {
    return { evid: 194, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisLinkedTextChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} new_name - new name
* @property {string} old_name - old name
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Linked_text_changed. Evid: 1192.
 * Event description: TextEllipsis.Linked_text_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_name - Type: string. Desc: new name
 *
 * old_name - Type: string. Desc: old name
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisLinkedTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisLinkedTextChanged = function (params) {
    return { evid: 1192, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishPremiumPromotionPopUpLoadedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish premium promotion pop up loaded. Evid: 284.
 * Event description: publish premium promotion pop up loaded.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishPremiumPromotionPopUpLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishPremiumPromotionPopUpLoaded = function (params) {
    return { evid: 284, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thumbnailsSelectionListParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selection - {Selected Value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Thumbnails_Selection_List. Evid: 353.
 * Event description: Thumbnails_Selection_List.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selection - Type: string. Desc: {Selected Value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {thumbnailsSelectionListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thumbnailsSelectionList = function (params) {
    return { evid: 353, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} multiselectLayoutPanelMatchSizeClickedParams
* @property {string} category - type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: MULTISELECT_LAYOUT_PANEL_MATCH_SIZE_CLICKED. Evid: 496.
 * Event description: MULTISELECT_LAYOUT_PANEL_MATCH_SIZE_CLICKED.

 * category - Type: string. Desc: type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {multiselectLayoutPanelMatchSizeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var multiselectLayoutPanelMatchSizeClicked = function (params) {
    return { evid: 496, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardUserInfoAddEditRemoveInfoParams
* @property {string} action - add/edit/remove
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} fieldLength - what is the length of the content that user entered
* @property {string} fieldName - which field is updated: business logo / company name / address / email / phone / facebook / twitter / linkedin / pinterest
* @property {string} fieldType - text / social / logo
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: User Info - add/edit/remove info. Evid: 1252.
 * Event description: Site Creation Wizard: User Info - add/edit/remove info.

 * action - Type: string. Desc: add/edit/remove
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * fieldLength - Type: numeric. Desc: what is the length of the content that user entered
 *
 * fieldName - Type: string. Desc: which field is updated: business logo / company name / address / email / phone / facebook / twitter / linkedin / pinterest
 *
 * fieldType - Type: string. Desc: text / social / logo
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardUserInfoAddEditRemoveInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardUserInfoAddEditRemoveInfo = function (params) {
    return { evid: 1252, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} moveBackwardsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: move backwards. Evid: 151.
 * Event description: move backwards.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {moveBackwardsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var moveBackwards = function (params) {
    return { evid: 151, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeIconHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_icon_hover. Evid: 1090.
 * Event description: Event fires when hovering the help home icon.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeIconHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeIconHover = function (params) {
    return { evid: 1090, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesSetAsDefaultChoiceParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} choice_name - choice_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - set as default choice. Evid: 910.
 * Event description: user click on remove default/set as default choice.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * choice_name - Type: string. Desc: choice_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesSetAsDefaultChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesSetAsDefaultChoice = function (params) {
    return { evid: 910, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesPanelPageSettingsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} page_id - {guid}
* @property {string} page_ind - {}
* @property {boolean} page_on_top - {1,0}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pages_panel_page_settings_click. Evid: 607.
 * Event description: pages_panel_page_settings_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: guid. Desc: {guid}
 *
 * page_ind - Type: string. Desc: {}
 *
 * page_on_top - Type: bool. Desc: {1,0}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesPanelPageSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesPanelPageSettingsClick = function (params) {
    return { evid: 607, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} postPublishPanelOpenedWhatsNextContentParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_publish - {0,1)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - {GROW_BUSINESS, CONNECT_DOMAIN, SHOUTOUT}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - dealer content / editor content
* @property {string} usedJsHeapSize - null
* @property {string} value - {music campaign, connect domain, grow business, social, personal sale}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: post_publish_panel_opened_whats_next_content. Evid: 469.
 * Event description: post_publish_panel_opened_whats_next_content.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_publish - Type: bool. Desc: {0,1)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: {GROW_BUSINESS, CONNECT_DOMAIN, SHOUTOUT}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: dealer content / editor content
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {music campaign, connect domain, grow business, social, personal sale}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {postPublishPanelOpenedWhatsNextContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postPublishPanelOpenedWhatsNextContent = function (params) {
    return { evid: 469, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderCategoryPickerInAddPanelHoverParams
* @property {string} category - 'Contact' / 'Lightbox' / ..
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} sub_category - 'Contact' / 'Payment Form' / 'Job Application' / etc...
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Add Panel subcategory open. Evid: 955.
 * Event description: Form Builder - category picker in add panel
 (similar to 38:953) category is opened on hover - with a 3 sec delay.

 * category - Type: string. Desc: 'Contact' / 'Lightbox' / ..
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * sub_category - Type: string. Desc: 'Contact' / 'Payment Form' / 'Job Application' / etc...
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderCategoryPickerInAddPanelHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderCategoryPickerInAddPanelHover = function (params) {
    return { evid: 955, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileHintPopupPressedGotItParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_hint_popup_pressed_got_it. Evid: 610.
 * Event description: shoots when user press the got_it button after the switch to mobile popup.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileHintPopupPressedGotItParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileHintPopupPressedGotIt = function (params) {
    return { evid: 610, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contentPresentedByDealerParams
* @property {string} category - **
* @property {boolean} content_presented_by_dealer - 1 - if the content is presented by dealer, 0 - fallback to default editor content
* @property {string} description - error / no response / other
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} offeringName - name of the editor fallback
* @property {string} panel_name - panel_name that will contain dealer
* @property {string} panelProps - -
* @property {GUID} site_id - null
* @property {string} stage - {prefetch, render}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: content_presented_by_dealer. Evid: 767.
 * Event description: event for when content is presented by dealer (top bar), or there is an error and the default content if presented by editor..

 * category - Type: string. Desc: **
 *
 * content_presented_by_dealer - Type: bool. Desc: 1 - if the content is presented by dealer, 0 - fallback to default editor content
 *
 * description - Type: string. Desc: error / no response / other
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * offeringName - Type: string. Desc: name of the editor fallback
 *
 * panel_name - Type: string. Desc: panel_name that will contain dealer
 *
 * panelProps - Type: string. Desc: -
 *
 * site_id - Type: guid.
 *
 * stage - Type: string. Desc: {prefetch, render}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {contentPresentedByDealerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentPresentedByDealer = function (params) {
    return { evid: 767, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} goingBackToWixAdiPopupClickedParams
* @property {string} category - {Stay in the editor, Back to Wix ADI, Site history}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: going_back_to_wix_ADI_popup_clicked. Evid: 787.
 * Event description: going_back_to_wix_ADI_popup_clicked.

 * category - Type: string. Desc: {Stay in the editor, Back to Wix ADI, Site history}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {goingBackToWixAdiPopupClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goingBackToWixAdiPopupClicked = function (params) {
    return { evid: 787, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPublishPopOverClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - view_site / view_on_mobile
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: TopBar.Publish.popOver.click. Evid: 1131.
 * Event description: TopBar.Publish.popOver.click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: view_site / view_on_mobile
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {topBarPublishPopOverClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPublishPopOverClick = function (params) {
    return { evid: 1131, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsCustomizeProportionsClickParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - slider / text
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {50:50, 25:75, 20:80, 40:60, 33:66}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_customize_proportions_click. Evid: 576.
 * Event description: columns_customize_proportions_click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: slider / text
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {50:50, 25:75, 20:80, 40:60, 33:66}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsCustomizeProportionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsCustomizeProportionsClick = function (params) {
    return { evid: 576, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentAddInfoParams
* @property {number} amount - amount
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {boolean} email_filled - true/false
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - name field
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle - on/off
* @property {string} toggle_value - str toggle value
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Component add info. Evid: 1462.
 * Event description: When user filling data inside the component setting fields.

 * amount - Type: numeric. Desc: amount
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * email_filled - Type: bool. Desc: true/false
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: name field
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: on/off
 *
 * toggle_value - Type: string. Desc: str toggle value
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: string. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {componentAddInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentAddInfo = function (params) {
    return { evid: 1462, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} deleteInteractionParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - start interaction panel/hover mode button
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: delete_interaction. Evid: 1018.
 * Event description: Add hover interaction button click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: start interaction panel/hover mode button
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {deleteInteractionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteInteraction = function (params) {
    return { evid: 1018, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog2OkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_2_OK_click. Evid: 325.
 * Event description: First_Save_Dialog_2_OK_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog2OkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog2OkClick = function (params) {
    return { evid: 325, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} searchSiteOnGoogleClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} url - {}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Search site on google click. Evid: 630.
 * Event description: Click on "search site (domain) on google" on the get traffic frame.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * url - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {searchSiteOnGoogleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchSiteOnGoogleClick = function (params) {
    return { evid: 630, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardErrorAdjustingContentParams
* @property {string} componentId - .
* @property {string} componentType - .
* @property {number} curatedTemplateId - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} layoutToUpdate - .
* @property {string} multilingual - .
* @property {string} resultLayout - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: ERROR ADJUSTING CONTENT. Evid: 1295.
 * Event description: an error BI for the site creation.

 * componentId - Type: string. Desc: .
 *
 * componentType - Type: string. Desc: .
 *
 * curatedTemplateId - Type: numeric. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * layoutToUpdate - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * resultLayout - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardErrorAdjustingContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardErrorAdjustingContent = function (params) {
    return { evid: 1295, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textLanguagesSupportDialogSaveClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: text_languages_support_dialog_save_click. Evid: 270.
 * Event description: text_languages_support_dialog_save_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textLanguagesSupportDialogSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textLanguagesSupportDialogSaveClick = function (params) {
    return { evid: 270, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoboxDesignParams
* @property {string} border_obj - json with info about border
* @property {boolean} colorChanged - was color changed {0,1}
* @property {string} component_id - component_id
* @property {string} contour_obj - null
* @property {boolean} cover_animate - {0,1}
* @property {number} cover_index - {0,1, 2, 4...}
* @property {string} cover_media_name - image uri (+suffix)
* @property {string} currentColor - color preset name or "custom"
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_changed - true - if something was changed during panel usage
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} overlay_index - {0,1, 2, 4...}
* @property {string} overlay_media_name - image uri (+suffix)
* @property {string} shadow_obj - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videobox_design. Evid: 803.
 * Event description: sent once design panel closed.

 * border_obj - Type: string. Desc: json with info about border
 *
 * colorChanged - Type: bool. Desc: was color changed {0,1}
 *
 * component_id - Type: string. Desc: component_id
 *
 * contour_obj - Type: string.
 *
 * cover_animate - Type: bool. Desc: {0,1}
 *
 * cover_index - Type: numeric. Desc: {0,1, 2, 4...}
 *
 * cover_media_name - Type: string. Desc: image uri (+suffix)
 *
 * currentColor - Type: string. Desc: color preset name or "custom"
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_changed - Type: bool. Desc: true - if something was changed during panel usage
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * overlay_index - Type: numeric. Desc: {0,1, 2, 4...}
 *
 * overlay_media_name - Type: string. Desc: image uri (+suffix)
 *
 * shadow_obj - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoboxDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoboxDesign = function (params) {
    return { evid: 803, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderHandleSizeChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} section - Circle/Square/Rectangle /Bar
* @property {string} selection - 1,2,3...
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_handle_size_changed. Evid: 1327.
 * Event description: range_slider_handle_size_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * selection - Type: string. Desc: 1,2,3...
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderHandleSizeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderHandleSizeChanged = function (params) {
    return { evid: 1327, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} adjustColorPanelClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {boolean} isChanged - true in case color was changed
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - choose_color / apply
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: adjustColorPanel_click. Evid: 1064.
 * Event description: adjustColorPanel_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * isChanged - Type: bool. Desc: true in case color was changed
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: choose_color / apply
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {adjustColorPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adjustColorPanelClick = function (params) {
    return { evid: 1064, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityPanelLearnMoreClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} referal_info - dom/advanced- where from the user clicked learn more
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility panel ---> learn more click. Evid: 921.
 * Event description: Click on the "learn more "  in the Accessibility panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * referal_info - Type: string. Desc: dom/advanced- where from the user clicked learn more
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {accessibilityPanelLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityPanelLearnMoreClick = function (params) {
    return { evid: 921, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ratingDisplaySettingsTextChangedParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {mainpage}
* @property {string} preset_id - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Rating_display_settings_text_changed. Evid: 799.
 * Event description: Rating_display_settings_text_changed.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {mainpage}
 *
 * preset_id - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ratingDisplaySettingsTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ratingDisplaySettingsTextChanged = function (params) {
    return { evid: 799, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsPrivacyChangedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {mainpage}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} privacy - {none; password; members}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_privacy_changed. Evid: 431.
 * Event description: PAGES_settings_privacy_site_members_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {mainpage}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * privacy - Type: string. Desc: {none; password; members}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsPrivacyChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsPrivacyChanged = function (params) {
    return { evid: 431, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} exitPopUpModeClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: exit_pop_up_mode_clicked. Evid: 530.
 * Event description: exit_pop_up_mode_clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {exitPopUpModeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var exitPopUpModeClicked = function (params) {
    return { evid: 530, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceValueenteredParams
* @property {string} color_value_type - {HEX, RGB, HSB}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_valueentered. Evid: 161.
 * Event description: ColorSpace_ValueEntered.

 * color_value_type - Type: string. Desc: {HEX, RGB, HSB}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceValueenteredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceValueentered = function (params) {
    return { evid: 161, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textThemesMigratedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} status - on/off
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.enable_ellipsis_toggle_changed. Evid: 1223.
 * Event description: Text themes migration indication.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * status - Type: string. Desc: on/off
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textThemesMigratedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textThemesMigrated = function (params) {
    return { evid: 1223, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dealerUpgradeTopbarOnViewParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: dealer_upgrade_topbar_on_view. Evid: 794.
 * Event description: Dealer upgrade panel displayed (dealer arrives at on view when they finish rendering successfully).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dealerUpgradeTopbarOnViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dealerUpgradeTopbarOnView = function (params) {
    return { evid: 794, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileInputEnabledChangedNumericParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - value
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - input enabled - changed numeric. Evid: 1171.
 * Event description: Form Builder - upload file - input enabled - changed numeric.   When file limit is changed (For Images / Videos).

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: value
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileInputEnabledChangedNumericParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileInputEnabledChangedNumeric = function (params) {
    return { evid: 1171, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarSettingsMenuClickParams
* @property {string} category - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_SETTINGS_menu_click. Evid: 766.
 * Event description: top_bar_click under settings tab.

 * category - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarSettingsMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarSettingsMenuClick = function (params) {
    return { evid: 766, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleAddressApiResponseParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: google_address_api_response. Evid: 839.
 * Event description: After entering an adress in google maps setting panel, Google API returns a response and this event is shoot..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleAddressApiResponseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleAddressApiResponse = function (params) {
    return { evid: 839, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lockParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: lock. Evid: 142.
 * Event description: lock.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {lockParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lock = function (params) {
    return { evid: 142, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} numberOfLeftSideButtonsInEditorParams
* @property {boolean} ascend_bool - true if ascend panel loaded
* @property {boolean} blog_bool - {old blog}
* @property {boolean} booking_bool - {}
* @property {number} count - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {boolean} ecomm_bool - {}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {boolean} rest_bool - {}
* @property {string} shoutout_bool - {}
* @property {GUID} site_id - null
* @property {boolean} social_blog_bool - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {boolean} wix_data_bool - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: number of left side buttons in editor. Evid: 655.
 * Event description: how many left side buttons are there in the editor.

 * ascend_bool - Type: bool. Desc: true if ascend panel loaded
 *
 * blog_bool - Type: bool. Desc: {old blog}
 *
 * booking_bool - Type: bool. Desc: {}
 *
 * count - Type: numeric.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * ecomm_bool - Type: bool. Desc: {}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * rest_bool - Type: bool. Desc: {}
 *
 * shoutout_bool - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * social_blog_bool - Type: bool. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * wix_data_bool - Type: bool. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {numberOfLeftSideButtonsInEditorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var numberOfLeftSideButtonsInEditor = function (params) {
    return { evid: 655, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondSaveEditDomainCancelClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {not published not connected, not Published connected, published_connected, Published_not_connected}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Save_Edit_domain_cancel_click. Evid: 334.
 * Event description: Second_Save_Edit_domain_cancel_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {not published not connected, not Published connected, published_connected, Published_not_connected}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondSaveEditDomainCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondSaveEditDomainCancelClick = function (params) {
    return { evid: 334, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstTimeTooltipActionClickedParams
* @property {string} action - {next, got it, toggle1, toggle2..}
* @property {string} bubble_name - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} slide_location - slide name
* @property {string} stage_type - null
* @property {string} step_name - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: first_time_tooltip_action_clicked. Evid: 606.
 * Event description: first_time_tooltip_panel_closed.

 * action - Type: string. Desc: {next, got it, toggle1, toggle2..}
 *
 * bubble_name - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * slide_location - Type: string. Desc: slide name
 *
 * stage_type - Type: string.
 *
 * step_name - Type: string. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstTimeTooltipActionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstTimeTooltipActionClicked = function (params) {
    return { evid: 606, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} successUploadImagePageSettingsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: success_upload_image_page_settings. Evid: 826.
 * Event description: upload image from SEO tab in page settings succeeded.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {successUploadImagePageSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var successUploadImagePageSettings = function (params) {
    return { evid: 826, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lottiePreviewAnimationClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_pause - is playing after pause
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - play/pause
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: lottie_preview_animation_clicked. Evid: 1351.
 * Event description: lottie_preview_animation_clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_pause - Type: bool. Desc: is playing after pause
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: play/pause
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {lottiePreviewAnimationClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lottiePreviewAnimationClicked = function (params) {
    return { evid: 1351, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageBackgroundPanelApplyToOtherPagesOkParams
* @property {boolean} all_pages_selected - 1,0
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_selected_pages - 1,2,3..
* @property {number} num_unselected_pages - 1,2,3..
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_background_panel_apply_to_other_pages_ok. Evid: 377.
 * Event description: page_background_panel_apply_to_other_pages_ok.

 * all_pages_selected - Type: bool. Desc: 1,0
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_selected_pages - Type: numeric. Desc: 1,2,3..
 *
 * num_unselected_pages - Type: numeric. Desc: 1,2,3..
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageBackgroundPanelApplyToOtherPagesOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageBackgroundPanelApplyToOtherPagesOk = function (params) {
    return { evid: 377, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressUploadFontsInFontsManagerParams
* @property {number} count - {number of fonts}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {file_name}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press upload fonts in fonts manager. Evid: 594.
 * Event description: pressing upload fonts in the fonts manager.

 * count - Type: numeric. Desc: {number of fonts}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {file_name}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressUploadFontsInFontsManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressUploadFontsInFontsManager = function (params) {
    return { evid: 594, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rightClickMenuClickParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field_selected - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: right_click_menu_click. Evid: 330.
 * Event description: right_click_menu_click.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field_selected - Type: string. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rightClickMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rightClickMenuClick = function (params) {
    return { evid: 330, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} layerSpotlightParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layer_name - {}
* @property {string} multilingual - null
* @property {boolean} out_of_grid - if element currently is out of grid (true/false)
* @property {string} panel_origin - send the location from where the 'Layers panel' was opened
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - 1 - on, 0 - off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: layer_spotlight. Evid: 807.
 * Event description: click on spotlight for a specific layer in the editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layer_name - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * out_of_grid - Type: bool. Desc: if element currently is out of grid (true/false)
 *
 * panel_origin - Type: string. Desc: send the location from where the 'Layers panel' was opened
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: 1 - on, 0 - off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {layerSpotlightParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var layerSpotlight = function (params) {
    return { evid: 807, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishButtonDropdownClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Publish button dropdown clicked. Evid: 905.
 * Event description: Fires when the users clicks on the publish dropdown arrow.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishButtonDropdownClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishButtonDropdownClicked = function (params) {
    return { evid: 905, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} loginReletedErrorPopupClickParams
* @property {string} action - Save / Publish / other
* @property {string} actionType - logged out / wrong account
* @property {string} ctaName - ok / close / wix.com / contact_customer_care
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} error_code - {15, 18, ....}
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: login_releted_error_popup_click. Evid: 1136.
 * Event description: click inside error popup (event on popup show: 38:1135).

 * action - Type: string. Desc: Save / Publish / other
 *
 * actionType - Type: string. Desc: logged out / wrong account
 *
 * ctaName - Type: string. Desc: ok / close / wix.com / contact_customer_care
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * error_code - Type: string. Desc: {15, 18, ....}
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {loginReletedErrorPopupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loginReletedErrorPopupClick = function (params) {
    return { evid: 1136, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videosearchErrorMessageParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} error_message - {%keyword% , %API_error_message%}
* @property {string} errorType - {empty, API_error}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} service - {YouTube, Vimeo}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videosearch_error_message. Evid: 586.
 * Event description: videosearch_error_message.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * error_message - Type: string. Desc: {%keyword% , %API_error_message%}
 *
 * errorType - Type: string. Desc: {empty, API_error}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * service - Type: string. Desc: {YouTube, Vimeo}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videosearchErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videosearchErrorMessage = function (params) {
    return { evid: 586, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stripBackgroundScrollEffectsParams
* @property {string} bg_scroll_with_site - ‘fix’, ‘scroll’, ‘scrub’
* @property {string} close_origin - drop_down / other
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - --
* @property {GUID} esi - --
* @property {boolean} is_changed - true/false (true if users have made changes)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - --
* @property {string} multilingual - --
* @property {string} origin - close origin (drop_down / other)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - --
* @property {string} usedJsHeapSize - --
* @property {string} viewerName - --
* @property {string} viewerVersion - --
* @property {string} workspace_mode - null
**/
/**
 * Name: strip_background_scroll_effects. Evid: 1019.
 * Event description: event sent when bg  strip/col scroll effects panel closes.

 * bg_scroll_with_site - Type: string. Desc: ‘fix’, ‘scroll’, ‘scrub’
 *
 * close_origin - Type: string. Desc: drop_down / other
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: --
 *
 * esi - Type: guid. Desc: --
 *
 * is_changed - Type: bool. Desc: true/false (true if users have made changes)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: --
 *
 * multilingual - Type: string. Desc: --
 *
 * origin - Type: string. Desc: close origin (drop_down / other)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: --
 *
 * usedJsHeapSize - Type: string. Desc: --
 *
 * viewerName - Type: string. Desc: --
 *
 * viewerVersion - Type: string. Desc: --
 *
 * workspace_mode - Type: string.
 * @param {stripBackgroundScrollEffectsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stripBackgroundScrollEffects = function (params) {
    return { evid: 1019, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ecomMigrationClickOnUpgradeSiteParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top panel / manage panel / upgrade popup
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ecom migration - click on upgrade site. Evid: 506.
 * Event description: click on upgrade site.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top panel / manage panel / upgrade popup
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ecomMigrationClickOnUpgradeSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ecomMigrationClickOnUpgradeSite = function (params) {
    return { evid: 506, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverOnTheITooltipInAddPanelParams
* @property {string} category - {text;image;gallery}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {Themed_text;Titles;Paragraphs;Related_apps}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hover on the i tooltip in add panel. Evid: 674.
 * Event description: send event for 10% of the sessions. Send event if tooltip is open for > 1 sec..

 * category - Type: string. Desc: {text;image;gallery}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {Themed_text;Titles;Paragraphs;Related_apps}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverOnTheITooltipInAddPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverOnTheITooltipInAddPanel = function (params) {
    return { evid: 674, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressedChangeFieldParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field - {fields name that was changed}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pressed change field. Evid: 644.
 * Event description: new contact form press change field.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field - Type: string. Desc: {fields name that was changed}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressedChangeFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressedChangeField = function (params) {
    return { evid: 644, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationSuccessMigrationOfSiteParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {number} duration - duration of migration
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - init / tpa / navigation
* @property {string} pages_list - list of migrated pages
* @property {string} sections_on_page - sections_on_page
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - success migration of site. Evid: 1246.
 * Event description: Site Migration to sections success.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * duration - Type: numeric. Desc: duration of migration
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: init / tpa / navigation
 *
 * pages_list - Type: string. Desc: list of migrated pages
 *
 * sections_on_page - Type: string. Desc: sections_on_page
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationSuccessMigrationOfSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationSuccessMigrationOfSite = function (params) {
    return { evid: 1246, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesPageTransitionClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_page_transition_click. Evid: 414.
 * Event description: PAGES_page_transition_click - Please notice that this event won't be fired from the new Pages Panel, instead event 38:704 with category 'transitions' will be fired.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesPageTransitionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesPageTransitionClick = function (params) {
    return { evid: 414, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editsitecolorsCancelbuttonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editsitecolors_cancelbutton_click. Evid: 215.
 * Event description: editsitecolors_cancelbutton_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editsitecolorsCancelbuttonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editsitecolorsCancelbuttonClick = function (params) {
    return { evid: 215, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsSplitToColumnsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_of_columns_before - {num}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_split_to_columns_click. Evid: 571.
 * Event description: columns_split_to_columns_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_of_columns_before - Type: numeric. Desc: {num}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsSplitToColumnsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsSplitToColumnsClick = function (params) {
    return { evid: 571, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextTypeChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {string} panel_name - panel name
* @property {string} selection - link/button/show all
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.text_type_changed. Evid: 1188.
 * Event description: TextEllipsis.text_type_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * panel_name - Type: string. Desc: panel name
 *
 * selection - Type: string. Desc: link/button/show all
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextTypeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextTypeChanged = function (params) {
    return { evid: 1188, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} getRevisionOnSaveParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {number} revisionId - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: getRevision on save. Evid: 1317.
 * Event description: editorAPI.dsRead.generalInfo.getRevision() callen on silent install and save to get new revision id.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * revisionId - Type: numeric.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {getRevisionOnSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getRevisionOnSave = function (params) {
    return { evid: 1317, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoboxBehaviorParams
* @property {boolean} audio_available - {0,1}
* @property {string} audio_play - ‘on-hover’ | ‘auto’
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_changed - true - if something was changed
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} video_ends - ‘replay-auto’ | ‘replay-click’ | ‘replay-never’
* @property {string} video_onload - ‘automatically’ | ‘on-click’ | ‘on-roll-in’
* @property {string} video_pause - ‘on-click’ | ‘on-roll-out’ | ‘never’
* @property {boolean} video_slow_mo - {0,1}
* @property {boolean} video_slow_mo_available - {0,1}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videobox_behavior. Evid: 802.
 * Event description: sent once behaviors panel closed.

 * audio_available - Type: bool. Desc: {0,1}
 *
 * audio_play - Type: string. Desc: ‘on-hover’ | ‘auto’
 *
 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_changed - Type: bool. Desc: true - if something was changed
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_ends - Type: string. Desc: ‘replay-auto’ | ‘replay-click’ | ‘replay-never’
 *
 * video_onload - Type: string. Desc: ‘automatically’ | ‘on-click’ | ‘on-roll-in’
 *
 * video_pause - Type: string. Desc: ‘on-click’ | ‘on-roll-out’ | ‘never’
 *
 * video_slow_mo - Type: bool. Desc: {0,1}
 *
 * video_slow_mo_available - Type: bool. Desc: {0,1}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoboxBehaviorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoboxBehavior = function (params) {
    return { evid: 802, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} anchorNameChangedParams
* @property {string} component_id - id of component
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Anchor name changed. Evid: 1145.
 * Event description: user changed the name of anchor.

 * component_id - Type: string. Desc: id of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {anchorNameChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var anchorNameChanged = function (params) {
    return { evid: 1145, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} shapeCropSelectedParams
* @property {string} component_id - id of component
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - id of editor session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} shape_id - id of selected shape
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Shape crop selected. Evid: 1220.
 * Event description: user selected shape crop (on every select).

 * component_id - Type: string. Desc: id of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: id of editor session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * shape_id - Type: string. Desc: id of selected shape
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {shapeCropSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shapeCropSelected = function (params) {
    return { evid: 1220, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hideLablesQuickActionBarParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} hidden - are labels hidden
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hide_lables_quick_action_bar. Evid: 717.
 * Event description: hide_lables_quick_action_bar.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hidden - Type: bool. Desc: are labels hidden
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hideLablesQuickActionBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hideLablesQuickActionBar = function (params) {
    return { evid: 717, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sendToBackParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: send to back. Evid: 149.
 * Event description: send to back.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sendToBackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sendToBack = function (params) {
    return { evid: 149, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesQuickActionsMenuSelectClickParams
* @property {string} category - {settings, rename, duplicate, hide...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_opened_page - true when user applied button for currently opened page, false - for another page
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_name - new_name
* @property {string} old_name - old_name
* @property {string} page_id - page hidden
* @property {GUID} site_id - {}
* @property {string} source - {main, members, custom, blog, store, lightbox, router}
* @property {string} source_type - {double_click / quick_actions_menu}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {pages, pop ups}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_quick_actions_menu_select_click. Evid: 421.
 * Event description: PAGES_quick_actions_menu_select_click.

 * category - Type: string. Desc: {settings, rename, duplicate, hide...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_opened_page - Type: bool. Desc: true when user applied button for currently opened page, false - for another page
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_name - Type: string. Desc: new_name
 *
 * old_name - Type: string. Desc: old_name
 *
 * page_id - Type: string. Desc: page hidden
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main, members, custom, blog, store, lightbox, router}
 *
 * source_type - Type: string. Desc: {double_click / quick_actions_menu}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {pages, pop ups}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesQuickActionsMenuSelectClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesQuickActionsMenuSelectClick = function (params) {
    return { evid: 421, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} cancelClickInWelcomeScreenPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: "Cancel " click in welcome screen panel. Evid: 885.
 * Event description: "Cancel " click at the welcome screen panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {cancelClickInWelcomeScreenPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cancelClickInWelcomeScreenPanel = function (params) {
    return { evid: 885, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcCreatedSuccessculyParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor, editor1.4
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - (top_bar, publish_dropdown, top_bar_override, publish_dropdown_override)
* @property {number} revision - revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: RC created successfully. Evid: 915.
 * Event description: Fires when an RC is created.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor, editor1.4
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: (top_bar, publish_dropdown, top_bar_override, publish_dropdown_override)
 *
 * revision - Type: numeric. Desc: revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rcCreatedSuccessculyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcCreatedSuccessculy = function (params) {
    return { evid: 915, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesSettingsSetFieldAsRequiredParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - settings - set field as required. Evid: 900.
 * Event description: Manage Choices - settings - set field as required (settings is an editor panel, thus cannot use event 5:919).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesSettingsSetFieldAsRequiredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesSettingsSetFieldAsRequired = function (params) {
    return { evid: 900, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPanelSubcategoryTooltipShownParams
* @property {string} category - 'Contact' / 'Lightbox' / ..
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} sub_category - 'Contact' / 'Payment Form' / 'Job Application' / etc...
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Add Panel - subcategory tooltip shown. Evid: 1174.
 * Event description: Add Panel - subcategory tooltip shown.

 * category - Type: string. Desc: 'Contact' / 'Lightbox' / ..
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * sub_category - Type: string. Desc: 'Contact' / 'Payment Form' / 'Job Application' / etc...
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {addPanelSubcategoryTooltipShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPanelSubcategoryTooltipShown = function (params) {
    return { evid: 1174, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuCategoryClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {boolean} category_under_scroll - user click on the category that was under scroll
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isScrollable - scroll is available to the user
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {number} window_height - initial height of client window
* @property {number} window_width - initial width of client window
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu ->category click. Evid: 102.
 * Event description: add menu ->category click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * category_under_scroll - Type: bool. Desc: user click on the category that was under scroll
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isScrollable - Type: bool. Desc: scroll is available to the user
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * window_height - Type: numeric. Desc: initial height of client window
 *
 * window_width - Type: numeric. Desc: initial width of client window
 *
 * workspace_mode - Type: string.
 * @param {addMenuCategoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuCategoryClick = function (params) {
    return { evid: 102, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentAddedToRepeaterParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {add panel, my uploads panel.}
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: component_added_to_repeater. Evid: 738.
 * Event description: component added to repeater.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {add panel, my uploads panel.}
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {componentAddedToRepeaterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentAddedToRepeater = function (params) {
    return { evid: 738, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsAddLocationClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google maps -> Add Location click. Evid: 1215.
 * Event description: user click on 'Add Location'.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleMapsAddLocationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsAddLocationClick = function (params) {
    return { evid: 1215, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerBigPlayDesignOnPanelClosedParams
* @property {string} big_play_fill_color - #FFFFFF , rgb(), color_15
* @property {number} big_play_fill_color_opacity - 1-100
* @property {string} big_play_stroke_color - #FFFFFF , rgb(), color_15
* @property {number} big_play_stroke_color_opacity - 1-100
* @property {number} big_play_stroke_width - 1-15
* @property {number} color_opacity - null
* @property {number} fill_color - null
* @property {number} border_opacity - null
* @property {number} border_color - null
* @property {number} border_width - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video_player_big_play_design_on_panel_closed. Evid: 681.
 * Event description: video_player_big_play_design_on_panel_closed.

 * big_play_fill_color - Type: string. Desc: #FFFFFF , rgb(), color_15
 *
 * big_play_fill_color_opacity - Type: numeric. Desc: 1-100
 *
 * big_play_stroke_color - Type: string. Desc: #FFFFFF , rgb(), color_15
 *
 * big_play_stroke_color_opacity - Type: numeric. Desc: 1-100
 *
 * big_play_stroke_width - Type: numeric. Desc: 1-15
 *
 * color_opacity - Type: numeric.
 *
 * fill_color - Type: numeric.
 *
 * border_opacity - Type: numeric.
 *
 * border_color - Type: numeric.
 *
 * border_width - Type: numeric.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerBigPlayDesignOnPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerBigPlayDesignOnPanelClosed = function (params) {
    return { evid: 681, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorBrowserWindowNavigateAwayParams
* @property {string} dm_version - -
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {GUID} site_id - -
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - -
**/
/**
 * Name: editor_browser_window_navigate_away. Evid: 1472.
 * Event description: event is being sent in cases of navigating away from the previous tab as soon as a new editor tab is loaded with the same msid in the same browser.

 * dm_version - Type: string. Desc: -
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * site_id - Type: guid. Desc: -
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string. Desc: -
 * @param {editorBrowserWindowNavigateAwayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorBrowserWindowNavigateAway = function (params) {
    return { evid: 1472, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorBrowserWindowCloseIntentParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_browser_window_close_intent. Evid: 1139.
 * Event description: Sent when a user moves their cursor to the top bar of the browser (i.e. leaves Editor parameter).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorBrowserWindowCloseIntentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorBrowserWindowCloseIntent = function (params) {
    return { evid: 1139, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardAddPagesPageInteractionsParams
* @property {string} action - add / remove / final amount of selected pages
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} pageName - page name
* @property {number} pagesAdded - number of selected pages
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Add Pages - page interactions. Evid: 1259.
 * Event description: Site Creation Wizard: Add Pages - page interactions.

 * action - Type: string. Desc: add / remove / final amount of selected pages
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * pageName - Type: string. Desc: page name
 *
 * pagesAdded - Type: numeric. Desc: number of selected pages
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardAddPagesPageInteractionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardAddPagesPageInteractions = function (params) {
    return { evid: 1259, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyPageParams
* @property {string} copy_option - {keyboard/rcm/action_menu}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: copy_page. Evid: 948.
 * Event description: copy page.

 * copy_option - Type: string. Desc: {keyboard/rcm/action_menu}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyPage = function (params) {
    return { evid: 948, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickMoreQuickActionsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_more_quick_actions. Evid: 728.
 * Event description: click_more_quick_actions.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickMoreQuickActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickMoreQuickActions = function (params) {
    return { evid: 728, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editsitecolorsColorpaletteSelectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} index_of_selcted_palette - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editsitecolors_colorpalette_select. Evid: 213.
 * Event description: editsitecolors_colorpalette_select.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * index_of_selcted_palette - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editsitecolorsColorpaletteSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editsitecolorsColorpaletteSelect = function (params) {
    return { evid: 213, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpSettingsShowOnPagesParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} status - true/false
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_settings_show_on_pages. Evid: 1036.
 * Event description: Changing the show on pages parameter in lightbox settings.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: true/false
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpSettingsShowOnPagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpSettingsShowOnPages = function (params) {
    return { evid: 1036, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPagePhaseFinishedParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} category - about/project/contact/etc
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {number} duration - time in ms
* @property {GUID} esi - .
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} phaseName - first thumbnail ready / all thumbnails ready
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - phase finished. Evid: 1082.
 * Event description: BI event for measuring time from start loading pages, to the first thumbnail ready and to all thumbnails ready.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * category - Type: string. Desc: about/project/contact/etc
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * duration - Type: numeric. Desc: time in ms
 *
 * esi - Type: guid. Desc: .
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * phaseName - Type: string. Desc: first thumbnail ready / all thumbnails ready
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPagePhaseFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPagePhaseFinished = function (params) {
    return { evid: 1082, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesUpdateDisplayNameParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - update display name. Evid: 899.
 * Event description: When user is updating the field name (displayed question) in  'Manage Choices' Settings Pop up.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesUpdateDisplayNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesUpdateDisplayName = function (params) {
    return { evid: 899, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuInnerNavigationPopUpParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu-> inner navigation pop up. Evid: 116.
 * Event description: add menu-> inner navigation pop up.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuInnerNavigationPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuInnerNavigationPopUp = function (params) {
    return { evid: 116, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} appPresetSelectedParams
* @property {string} app_id - {id of the app: gallery and etc}
* @property {string} component_id - {id of the component selected}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of the host app id: Wix Stores, Wix Bookings etc}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {origin of selection}
* @property {string} previous_value - {previously selected preset/category}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {selected preset/category}
* @property {string} target_type - {category or preset}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: App Preset selected. Evid: 1493.
 * Event description: App preset selected.

 * app_id - Type: string. Desc: {id of the app: gallery and etc}
 *
 * component_id - Type: string. Desc: {id of the component selected}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of the host app id: Wix Stores, Wix Bookings etc}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {origin of selection}
 *
 * previous_value - Type: string. Desc: {previously selected preset/category}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {selected preset/category}
 *
 * target_type - Type: string. Desc: {category or preset}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {appPresetSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPresetSelected = function (params) {
    return { evid: 1493, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAnchorUrlUrlChangedParams
* @property {string} componentId - section/anchor component id
* @property {string} componentName - name of the section/anchor
* @property {string} componentType - section/anchor component type
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} new_url_suffix - new url suffix
* @property {string} old_url_suffix - old url suffix
* @property {string} pageId - page where section/anchor is placed
* @property {string} pageName - name of the page where section/anchor is placed
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Section/Anchor URL - URL changed. Evid: 1406.
 * Event description: User edited section url suffix in Section/Anchor URL collapsable menu in Section/Anchor Settings Panel..

 * componentId - Type: string. Desc: section/anchor component id
 *
 * componentName - Type: string. Desc: name of the section/anchor
 *
 * componentType - Type: string. Desc: section/anchor component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * new_url_suffix - Type: string. Desc: new url suffix
 *
 * old_url_suffix - Type: string. Desc: old url suffix
 *
 * pageId - Type: string. Desc: page where section/anchor is placed
 *
 * pageName - Type: string. Desc: name of the page where section/anchor is placed
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionAnchorUrlUrlChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAnchorUrlUrlChanged = function (params) {
    return { evid: 1406, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuPageSelectParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {string} page_id - .
* @property {string} page_type - main / member
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} target - show / hide
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_page_select. Evid: 971.
 * Event description: user select/unselect page in Menu Manager.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: .
 *
 * page_type - Type: string. Desc: main / member
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: show / hide
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuPageSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuPageSelect = function (params) {
    return { evid: 971, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteBackgroundChangeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mediaType - video/picture
* @property {string} multilingual - null
* @property {string} origin - page/strip
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Background - change click. Evid: 816.
 * Event description: User clicks to change background (video/picture) from page background or strip.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mediaType - Type: string. Desc: video/picture
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: page/strip
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteBackgroundChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteBackgroundChangeClick = function (params) {
    return { evid: 816, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaMessageLoadedParams
* @property {GUID} app_id - guid
* @property {string} description - {Deleting page with App on it, Trying to delete TPA page...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {delete_premium, add_page,...}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_message_loaded. Evid: 277.
 * Event description: tpa_message_loaded.

 * app_id - Type: guid. Desc: guid
 *
 * description - Type: string. Desc: {Deleting page with App on it, Trying to delete TPA page...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {delete_premium, add_page,...}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tpaMessageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaMessageLoaded = function (params) {
    return { evid: 277, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} playAnimationParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: play_animation. Evid: 783.
 * Event description: play animation.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {playAnimationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var playAnimation = function (params) {
    return { evid: 783, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} platformAppTryToRemoveParams
* @property {string} app_id - app_id
* @property {string} app_name - app name
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: platform App try to remove. Evid: 756.
 * Event description: platform App try to remove from stage.

 * app_id - Type: string. Desc: app_id
 *
 * app_name - Type: string. Desc: app name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {platformAppTryToRemoveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var platformAppTryToRemove = function (params) {
    return { evid: 756, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myElementsOpenSavePanelParams
* @property {string} content_type - type of component
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} funnel_id - synthetic variable to connect try and success events of creating my designs
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - rcm/...
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.open_save_panel. Evid: 954.
 * Event description: clicking on "save to my elements" on the right-click menu.

 * content_type - Type: string. Desc: type of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * funnel_id - Type: string. Desc: synthetic variable to connect try and success events of creating my designs
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: rcm/...
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {myElementsOpenSavePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myElementsOpenSavePanel = function (params) {
    return { evid: 954, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelStylableDesignSettingsChangedParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} fieldCategory - field category
* @property {string} fieldName - field name
* @property {string} fieldValue - field value
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - regular/hover
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel ---> stylable design settings changed. Evid: 1119.
 * Event description: This event will be sent every time a user closes the design panel after making any change in the design settings.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * fieldCategory - Type: string. Desc: field category
 *
 * fieldName - Type: string. Desc: field name
 *
 * fieldValue - Type: string. Desc: field value
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: regular/hover
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelStylableDesignSettingsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelStylableDesignSettingsChanged = function (params) {
    return { evid: 1119, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} welcomeScreenBackgroundAnimationChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} preset_id - preset_id
* @property {string} preset_name - preset_name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Welcome Screen: Background animation changed. Evid: 1160.
 * Event description: Welcome Screen: Background animation changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * preset_id - Type: string. Desc: preset_id
 *
 * preset_name - Type: string. Desc: preset_name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {welcomeScreenBackgroundAnimationChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var welcomeScreenBackgroundAnimationChanged = function (params) {
    return { evid: 1160, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonAlignChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - text/icon/text&icon
* @property {string} page_id - page id
* @property {string} selection - center/left/right
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: StylableButton.align_changed. Evid: 1341.
 * Event description: StylableButton.align_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: text/icon/text&icon
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string. Desc: center/left/right
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonAlignChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonAlignChanged = function (params) {
    return { evid: 1341, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuPagesPanelAddStorePageClickedParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_pages_panel_add_store_page_clicked. Evid: 208.
 * Event description: site_app_menu_pages_panel_add_store_page_clicked.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuPagesPanelAddStorePageClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuPagesPanelAddStorePageClicked = function (params) {
    return { evid: 208, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelThemeClickParams
* @property {string} component_id - {component_id}
* @property {string} component_type - {component_type}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {origin of change}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} theme - {theme selected}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel - theme click. Evid: 1482.
 * Event description: This event will be sent every time a user clicks on the theme in text settings.

 * component_id - Type: string. Desc: {component_id}
 *
 * component_type - Type: string. Desc: {component_type}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {origin of change}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * theme - Type: string. Desc: {theme selected}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelThemeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelThemeClick = function (params) {
    return { evid: 1482, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickOnHideHeaderAndFooterParams
* @property {string} component_id - component_id of section
* @property {string} component_type - section / header / footer
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - RCM | action_bar
* @property {string} section_name - section_name
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Click on Hide header and footer. Evid: 1369.
 * Event description: user clicks on 'Hide header and footer' on action bar or rcm.

 * component_id - Type: string. Desc: component_id of section
 *
 * component_type - Type: string. Desc: section / header / footer
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: RCM | action_bar
 *
 * section_name - Type: string. Desc: section_name
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {clickOnHideHeaderAndFooterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnHideHeaderAndFooter = function (params) {
    return { evid: 1369, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPickerOpenedFromCustomizeDesignPanelParams
* @property {string} control_name - {string}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} skin_id - {string}
* @property {string} stage_type - null
* @property {string} tab - {string}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: color_picker_opened_from_customize_design_panel. Evid: 605.
 * Event description: color_picker_opened_from_customize_design_panel.

 * control_name - Type: string. Desc: {string}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * skin_id - Type: string. Desc: {string}
 *
 * stage_type - Type: string.
 *
 * tab - Type: string. Desc: {string}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPickerOpenedFromCustomizeDesignPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPickerOpenedFromCustomizeDesignPanel = function (params) {
    return { evid: 605, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardStartParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_start. Evid: 791.
 * Event description: Mobile wizard started.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardStart = function (params) {
    return { evid: 791, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonClickOnAppActionParams
* @property {string} action_id - action id
* @property {string} action_type - main/quick/general
* @property {string} app_id - application id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tab_name - tab name
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th button -> click on app action. Evid: 1115.
 * Event description: click on action in the 6th button panel.

 * action_id - Type: string. Desc: action id
 *
 * action_type - Type: string. Desc: main/quick/general
 *
 * app_id - Type: string. Desc: application id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: tab name
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {thButtonClickOnAppActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonClickOnAppAction = function (params) {
    return { evid: 1115, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileHintPopupParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_hint_popup. Evid: 609.
 * Event description: Users that didn't switch to mobile view in the session will get a popup that direct them to switch to the mobile view..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileHintPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileHintPopup = function (params) {
    return { evid: 609, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} connectingAUserInputToAButtonParams
* @property {string} button_id - button_id
* @property {boolean} collection_defined - true,false
* @property {string} component_id - comp id
* @property {string} component_name - comp name
* @property {string} component_type - comp type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: connecting a user input to a button. Evid: 647.
 * Event description: connecting a user input to a button.

 * button_id - Type: string. Desc: button_id
 *
 * collection_defined - Type: bool. Desc: true,false
 *
 * component_id - Type: string. Desc: comp id
 *
 * component_name - Type: string. Desc: comp name
 *
 * component_type - Type: string. Desc: comp type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {connectingAUserInputToAButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectingAUserInputToAButton = function (params) {
    return { evid: 647, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPanelAddPageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {blank,admin}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ADD_PANEL_add_page_click. Evid: 796.
 * Event description: when clicking on add a page from page category in the add panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {blank,admin}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addPanelAddPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPanelAddPageClick = function (params) {
    return { evid: 796, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorRequestOutputParams
* @property {string} actionOrigin - create_text / regenerate
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - 1) AI text Creator: time in msec measured from ‘createText.click’ to shown results for user. 2) GPT injection to site: time from ‘createText.click’ to timestamp when all texts were injected
* @property {GUID} esi - session id
* @property {string} gpt3Params - set of params to know configuration of the model used
* @property {string} gptParams - e.g., ‘1.2.1’
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} pageComponents - list of pages with their components
* @property {string} pageTokens - list of pages with tokens
* @property {string} panelType - single sided / double sided
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} prompt - prompt we send to Open Ai (unified, placeholders not replaced with user input)
* @property {string} promt - “Write a tagline for an ice cream shop”
* @property {string} query - request
* @property {string} query_output - request output
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} text - “\n\nThe best ice cream in town!“
* @property {string} theme - header / paragraph
* @property {string} tokens - prompt_tokens - user query tokens; completion_tokens - output tokens
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: AI Text Generator - Request Output. Evid: 1417.
 * Event description: AI Text Generator - Returned value from AI model.

 * actionOrigin - Type: string. Desc: create_text / regenerate
 *
 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: 1) AI text Creator: time in msec measured from ‘createText.click’ to shown results for user. 2) GPT injection to site: time from ‘createText.click’ to timestamp when all texts were injected
 *
 * esi - Type: guid. Desc: session id
 *
 * gpt3Params - Type: string. Desc: set of params to know configuration of the model used
 *
 * gptParams - Type: string. Desc: e.g., ‘1.2.1’
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * pageComponents - Type: string. Desc: list of pages with their components
 *
 * pageTokens - Type: string. Desc: list of pages with tokens
 *
 * panelType - Type: string. Desc: single sided / double sided
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * prompt - Type: string. Desc: prompt we send to Open Ai (unified, placeholders not replaced with user input)
 *
 * promt - Type: string. Desc: “Write a tagline for an ice cream shop”
 *
 * query - Type: string. Desc: request
 *
 * query_output - Type: string. Desc: request output
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * text - Type: string. Desc: “\n\nThe best ice cream in town!“
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * tokens - Type: string. Desc: prompt_tokens - user query tokens; completion_tokens - output tokens
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {aiTextGeneratorRequestOutputParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorRequestOutput = function (params) {
    return { evid: 1417, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorViewModeSwitchParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mode - {desktop, mobile}
* @property {string} multilingual - null
* @property {string} origin - {top bar, site menu}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_view_mode_switch. Evid: 568.
 * Event description: editor_view_mode_switch.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mode - Type: string. Desc: {desktop, mobile}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {top bar, site menu}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorViewModeSwitchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorViewModeSwitch = function (params) {
    return { evid: 568, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchPopOverOpenParams
* @property {string} clickType - hover / click / keyboard
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.popOver.open. Evid: 989.
 * Event description: sends when Editor Search popover opens in the top bar in any method hover/click.

 * clickType - Type: string. Desc: hover / click / keyboard
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {editorSearchPopOverOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchPopOverOpen = function (params) {
    return { evid: 989, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentRemovedParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} component_id - comp-ico1n9c7
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - tpa instance id
* @property {boolean} is_component_pinned - 0,1
* @property {boolean} is_last - {0,1}
* @property {boolean} is_last_tpa - 1,0
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {boolean} last_section - true if ot was the last section on the page
* @property {string} marketVersion - if new market then 'new' else null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {boolean} out_of_grid_previously - if element was out of grid (true/false
* @property {string} page_id - page_id
* @property {string} page_or_popup - {page, popup}
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {string} removal_method - (keyboard,right_click,cut,...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} parent_component - component_type (specific type)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - [guid]
* @property {string} workspace_mode - null
**/
/**
 * Name: component_removed. Evid: 170.
 * Event description: component_removed.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: comp-ico1n9c7
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: tpa instance id
 *
 * is_component_pinned - Type: bool. Desc: 0,1
 *
 * is_last - Type: bool. Desc: {0,1}
 *
 * is_last_tpa - Type: bool. Desc: 1,0
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * last_section - Type: bool. Desc: true if ot was the last section on the page
 *
 * marketVersion - Type: string. Desc: if new market then 'new' else null
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * out_of_grid_previously - Type: bool. Desc: if element was out of grid (true/false
 *
 * page_id - Type: string. Desc: page_id
 *
 * page_or_popup - Type: string. Desc: {page, popup}
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * removal_method - Type: string. Desc: (keyboard,right_click,cut,...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * parent_component - Type: string. Desc: component_type (specific type)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: [guid]
 *
 * workspace_mode - Type: string.
 * @param {componentRemovedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentRemoved = function (params) {
    return { evid: 170, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaAddedParams
* @property {string} adding_method - {direct_add, modal, drag}
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - per site per app
* @property {string} category - {add_panel: text, image..., market: featured, new, search, pending....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} installType - What type of install? (API, App Builder, Share URL, normal, other)
* @property {string} instance_id - per site per app per component
* @property {boolean} is_first - {0,1}
* @property {number} is_permissions_app - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {number} item_position - --
* @property {string} jsHeapSizeLimit - null
* @property {string} market_version - if new = 'new' else null
* @property {string} modal_tab_name - {overview, demo...}
* @property {string} multilingual - null
* @property {string} origin - {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
* @property {string} page_id - (for template provisioning)
* @property {string} page_or_popup - {page, popup}
* @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
* @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...}
* @property {number} search_result_position - {1,2,3...}
* @property {string} search_term - {html, analytics,...}
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {GUID} template_guid - [guid]
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widget_id - (for template provisioning)
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_added. Evid: 165.
 * Event description: tpa_added.

 * adding_method - Type: string. Desc: {direct_add, modal, drag}
 *
 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: per site per app
 *
 * category - Type: string. Desc: {add_panel: text, image..., market: featured, new, search, pending....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * installType - Type: string. Desc: What type of install? (API, App Builder, Share URL, normal, other)
 *
 * instance_id - Type: string. Desc: per site per app per component
 *
 * is_first - Type: bool. Desc: {0,1}
 *
 * is_permissions_app - Type: numeric. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_position - Type: numeric. Desc: --
 *
 * jsHeapSizeLimit - Type: string.
 *
 * market_version - Type: string. Desc: if new = 'new' else null
 *
 * modal_tab_name - Type: string. Desc: {overview, demo...}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
 *
 * page_id - Type: string. Desc: (for template provisioning)
 *
 * page_or_popup - Type: string. Desc: {page, popup}
 *
 * referral_info - Type: string. Desc: {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 *
 * referral_info_category - Type: string. Desc: {[add panel 'view more apps' category], [sa category], [cart category]...}
 *
 * search_result_position - Type: numeric. Desc: {1,2,3...}
 *
 * search_term - Type: string. Desc: {html, analytics,...}
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * template_guid - Type: guid. Desc: [guid]
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: string. Desc: (for template provisioning)
 *
 * workspace_mode - Type: string.
 * @param {tpaAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaAdded = function (params) {
    return { evid: 165, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorShowComponentParams
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} component_id - guid
* @property {string} component_type - (ed_tpa, wix_component, list, blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hide_method - {right-click,...}
* @property {GUID} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile editor_show component. Evid: 283.
 * Event description: mobile editor_show component.

 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: (ed_tpa, wix_component, list, blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hide_method - Type: string. Desc: {right-click,...}
 *
 * instance_id - Type: guid. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorShowComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorShowComponent = function (params) {
    return { evid: 283, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} photographersCampaignSubmitClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {post-publish-link, submission button}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: photographers_campaign_submit_click. Evid: 628.
 * Event description: photographers_campaign_submit_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {post-publish-link, submission button}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {photographersCampaignSubmitClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var photographersCampaignSubmitClick = function (params) {
    return { evid: 628, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveErrorWorkNotSavedErrorHelpCenterLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_error_work_not_saved_error_help_center_link_click. Evid: 342.
 * Event description: First_Save_error_work_not_saved_error_help_center_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveErrorWorkNotSavedErrorHelpCenterLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveErrorWorkNotSavedErrorHelpCenterLinkClick = function (params) {
    return { evid: 342, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickSetUpQuickActionParams
* @property {string} action_type - type of action clicked on
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_set_up_quick_action. Evid: 724.
 * Event description: click_set_up_quick_action.

 * action_type - Type: string. Desc: type of action clicked on
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickSetUpQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickSetUpQuickAction = function (params) {
    return { evid: 724, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuInnerNavigationChooseSectionClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {arrows, basic shapes,decorative,animals and nature etc}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> inner navigation -> choose section click. Evid: 121.
 * Event description: add menu -> inner navigation -> choose section click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {arrows, basic shapes,decorative,animals and nature etc}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuInnerNavigationChooseSectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuInnerNavigationChooseSectionClick = function (params) {
    return { evid: 121, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} welcomeScreenBackgroundDirectionChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_direction - new_direction
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Welcome Screen: Background Direction changed. Evid: 1159.
 * Event description: Welcome Screen: Background Direction changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_direction - Type: string. Desc: new_direction
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {welcomeScreenBackgroundDirectionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var welcomeScreenBackgroundDirectionChanged = function (params) {
    return { evid: 1159, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterSuggestionClickParams
* @property {string} businessType - {industry:”x”; structure: “y”} or null
* @property {string} clickOrigin - suggestion / dropdown
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} searchTerm - what was in search placeholder when user selected from dropdown
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} step - business_type / subject
* @property {string} subject - topic as id on select topic step
* @property {string} target - suggestion
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.suggestion.click. Evid: 1028.
 * Event description: Smart Writer click on subject or business type suggestion.

 * businessType - Type: string. Desc: {industry:”x”; structure: “y”} or null
 *
 * clickOrigin - Type: string. Desc: suggestion / dropdown
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * searchTerm - Type: string. Desc: what was in search placeholder when user selected from dropdown
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * step - Type: string. Desc: business_type / subject
 *
 * subject - Type: string. Desc: topic as id on select topic step
 *
 * target - Type: string. Desc: suggestion
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterSuggestionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterSuggestionClick = function (params) {
    return { evid: 1028, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteNameValidationErrorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_save - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} save_or_publish - {save, publish}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_name_validation_error. Evid: 445.
 * Event description: Site_Name_validation_error.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_save - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * save_or_publish - Type: string. Desc: {save, publish}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteNameValidationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteNameValidationError = function (params) {
    return { evid: 445, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverHiddenElementParams
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} component_id - guid
* @property {string} component_type - {gallery, box...}
* @property {string} current_page_name - {page name}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {string} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {gfpp, delete, right click}
* @property {string} section - {all pages, current page}
* @property {GUID} site_id - {}
* @property {string} site_segment - site_header,site_footer,etc...
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: hover hidden element. Evid: 1182.
 * Event description: hover hidden element.

 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * current_page_name - Type: string. Desc: {page name}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * instance_id - Type: string. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {gfpp, delete, right click}
 *
 * section - Type: string. Desc: {all pages, current page}
 *
 * site_id - Type: guid. Desc: {}
 *
 * site_segment - Type: string. Desc: site_header,site_footer,etc...
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {hoverHiddenElementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverHiddenElement = function (params) {
    return { evid: 1182, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} anchorMenuManagerChangeComponentToggleParams
* @property {string} action - add_anchor/remove_anchor
* @property {string} anchor_name - anchor_name
* @property {string} component_id - anchor menu component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: anchor menu manager ->change component toggle. Evid: 1178.
 * Event description: input/exclude anchor from anchor menu.

 * action - Type: string. Desc: add_anchor/remove_anchor
 *
 * anchor_name - Type: string. Desc: anchor_name
 *
 * component_id - Type: string. Desc: anchor menu component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {anchorMenuManagerChangeComponentToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var anchorMenuManagerChangeComponentToggle = function (params) {
    return { evid: 1178, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} shapeDividerClickInsideDividerCustomizePanelParams
* @property {string} component_id - {}
* @property {string} component_name - {slide gallery, box...}
* @property {string} dm_version - dm_version
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {string} field_name - color / opacity/  height / e.t.c
* @property {string} field_value - field_value
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} svgId - divider's ID
* @property {string} tab - bottom / top
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Shape Divider - click inside divider customize panel. Evid: 1490.
 * Event description: Shape Divider - click inside divider customize panel.

 * component_id - Type: string. Desc: {}
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * field_name - Type: string. Desc: color / opacity/  height / e.t.c
 *
 * field_value - Type: string. Desc: field_value
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * svgId - Type: string. Desc: divider's ID
 *
 * tab - Type: string. Desc: bottom / top
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {shapeDividerClickInsideDividerCustomizePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shapeDividerClickInsideDividerCustomizePanel = function (params) {
    return { evid: 1490, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} imageControlClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Image area, Change, Effects}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Image_ControlClick. Evid: 351.
 * Event description: Image_ContolClick.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Image area, Change, Effects}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {imageControlClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var imageControlClick = function (params) {
    return { evid: 351, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} layerShowHideParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layer_name - {}
* @property {string} multilingual - null
* @property {boolean} out_of_grid - if element currently is out of grid (true/false)
* @property {string} panel_origin - send the location from where the 'Layers panel' was opened
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - 1 - show, 0 - hide
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: layer_show_hide. Evid: 806.
 * Event description: click on show or hide for a specific layer in the editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layer_name - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * out_of_grid - Type: bool. Desc: if element currently is out of grid (true/false)
 *
 * panel_origin - Type: string. Desc: send the location from where the 'Layers panel' was opened
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: 1 - show, 0 - hide
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {layerShowHideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var layerShowHide = function (params) {
    return { evid: 806, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} radioButtonsListSelectionParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selection - {Selected Value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - on/off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: RadioButtonsList_Selection. Evid: 359.
 * Event description: RadioButtonsList_Selection.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selection - Type: string. Desc: {Selected Value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: on/off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {radioButtonsListSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var radioButtonsListSelection = function (params) {
    return { evid: 359, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editsitecolorsChangemaincolorClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} index_of_selcted_color - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editsitecolors_changemaincolor_click. Evid: 212.
 * Event description: editsitecolors_changemaincolor_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * index_of_selcted_color - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editsitecolorsChangemaincolorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editsitecolorsChangemaincolorClick = function (params) {
    return { evid: 212, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickOnGoToLayoutSettingsForHideHeaderAndFooterFeatureParams
* @property {string} component_type - header / footer
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - delete notification, no header and footer notification, minimizing notification
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Click on 'Go to Layout settings' for hide header and footer feature. Evid: 1370.
 * Event description: Click on 'Go to Layout settings'.

 * component_type - Type: string. Desc: header / footer
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: delete notification, no header and footer notification, minimizing notification
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {clickOnGoToLayoutSettingsForHideHeaderAndFooterFeatureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnGoToLayoutSettingsForHideHeaderAndFooterFeature = function (params) {
    return { evid: 1370, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageBackgroundPanelApplyToOtherPagesClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_background_panel_apply_to_other_pages_click. Evid: 376.
 * Event description: page_background_panel_apply_to_other_pages_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageBackgroundPanelApplyToOtherPagesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageBackgroundPanelApplyToOtherPagesClick = function (params) {
    return { evid: 376, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} refComponentResetCustomizationParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: refComponent.resetCustomization. Evid: 88.
 * Event description: Triggered when a user resets customization of a ref component.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {refComponentResetCustomizationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var refComponentResetCustomization = function (params) {
    return { evid: 88, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextLinesNumberChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {number} new_lines_number - new_lines_number
* @property {number} old_lines_number - old_lines_number
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.text_lines_number_changed. Evid: 1198.
 * Event description: TextEllipsis.text_lines_number_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_lines_number - Type: numeric. Desc: new_lines_number
 *
 * old_lines_number - Type: numeric. Desc: old_lines_number
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextLinesNumberChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextLinesNumberChanged = function (params) {
    return { evid: 1198, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} quickNavigationClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp_Hmenu, top_bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Quick_navigation_clicked. Evid: 736.
 * Event description: Quick_navigation_opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp_Hmenu, top_bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {quickNavigationClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quickNavigationClicked = function (params) {
    return { evid: 736, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsMoveTabToPinsTabParams
* @property {string} component_id - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tab - {Map Design / Pin Design }
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google Maps -->  move tab to pins tab. Evid: 1217.
 * Event description: Move tab to pins tab click.

 * component_id - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tab - Type: string. Desc: {Map Design / Pin Design }
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleMapsMoveTabToPinsTabParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsMoveTabToPinsTab = function (params) {
    return { evid: 1217, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorInfoPopupButtonClickedParams
* @property {string} button_name - ok / close / cancel
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} message - what we are telling the user
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} source - source as in 38:1048
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_info_popup_button_clicked. Evid: 1052.
 * Event description: editor_info_popup_shown.

 * button_name - Type: string. Desc: ok / close / cancel
 *
 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * message - Type: string. Desc: what we are telling the user
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: source as in 38:1048
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editorInfoPopupButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorInfoPopupButtonClicked = function (params) {
    return { evid: 1052, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutPassUnsupportedLayoutParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} inputJson - json which include list of supported and unsupported components
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {string} section_name_personal - name of the section assigned by the user, if the user did not change the name then send a technical name)
* @property {string} section_name_technical - name of the section (welcome, about, e.t.c)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description).
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - (no description)
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - [PASS] Unsupported Layout. Evid: 1362.
 * Event description: user opened unsupported layout (PAAS family).

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * inputJson - Type: string. Desc: json which include list of supported and unsupported components
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * section_name_personal - Type: string. Desc: name of the section assigned by the user, if the user did not change the name then send a technical name)
 *
 * section_name_technical - Type: string. Desc: name of the section (welcome, about, e.t.c)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description).
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: (no description)
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutPassUnsupportedLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutPassUnsupportedLayout = function (params) {
    return { evid: 1362, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutFailureReasonsListsParams
* @property {string} component_id - id of selected section
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} errorInfo - error message (reason of failure)
* @property {GUID} esi - esi
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_list - true/false - whether the section contains lists
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_success - true/false - layout panel opened successfully
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} listType - complex/ simple - classification of lists
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - Failure reasons (Lists). Evid: 1280.


 * component_id - Type: string. Desc: id of selected section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * errorInfo - Type: string. Desc: error message (reason of failure)
 *
 * esi - Type: guid. Desc: esi
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_list - Type: bool. Desc: true/false - whether the section contains lists
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_success - Type: bool. Desc: true/false - layout panel opened successfully
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * listType - Type: string. Desc: complex/ simple - classification of lists
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutFailureReasonsListsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutFailureReasonsLists = function (params) {
    return { evid: 1280, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerSettingsAudioSourceChangedParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {string} selection - uploads / url
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.settings.audioSource.changed. Evid: 1204.
 * Event description: audio Source in Audio Player settings was changed.

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: uploads / url
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerSettingsAudioSourceChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerSettingsAudioSourceChanged = function (params) {
    return { evid: 1204, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} removeComponentClickParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - [guid]
* @property {string} component_id - comp-ico1n9c7
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_component_pinned - {0,1}
* @property {boolean} is_last - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} removal_method - (X,cut,undo...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - widget_id
* @property {string} workspace_mode - null
**/
/**
 * Name: remove_component_click. Evid: 279.
 * Event description: remove_component_click **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: [guid]
 *
 * component_id - Type: string. Desc: comp-ico1n9c7
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_component_pinned - Type: bool. Desc: {0,1}
 *
 * is_last - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * removal_method - Type: string. Desc: (X,cut,undo...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: widget_id
 *
 * workspace_mode - Type: string.
 * @param {removeComponentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeComponentClick = function (params) {
    return { evid: 279, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelUnderlineClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} panelName - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Underline_Click. Evid: 236.
 * Event description: Text_Panel_Underline_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * panelName - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelUnderlineClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelUnderlineClick = function (params) {
    return { evid: 236, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerSettingsAutoplayVideoChangedParams
* @property {string} component_id - component_id
* @property {string} componentType - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} source - panel opening origin
* @property {string} stage_type - null
* @property {boolean} toggle - true/false
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.settings.autoplayVideo.changed. Evid: 821.
 * Event description: User change autoplay video toggle.

 * component_id - Type: string. Desc: component_id
 *
 * componentType - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: panel opening origin
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: true/false
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerSettingsAutoplayVideoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerSettingsAutoplayVideoChanged = function (params) {
    return { evid: 821, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileSupportedFileTypeDropdownParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - supported file type - dropdown. Evid: 1169.
 * Event description: Form Builder - upload file - supported file type - dropdown
  (When fileType dropdown is clicked).

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileSupportedFileTypeDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileSupportedFileTypeDropdown = function (params) {
    return { evid: 1169, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextEditedParams
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {boolean} is_changed - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - null
* @property {number} new_text_length - new_text_length
* @property {number} old_text_length - null
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Text_Edited. Evid: 1187.


 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * is_changed - Type: bool.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string.
 *
 * new_text_length - Type: numeric. Desc: new_text_length
 *
 * old_text_length - Type: numeric.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextEditedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextEdited = function (params) {
    return { evid: 1187, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPagePreviewPageClickParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} category - {page, link, dropdown menu, popup, dynamic page}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_injected_content - true if content was already injected
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} name - name of the page
* @property {string} origin - From where user opened AddPage modal
* @property {string} page_id - page_id
* @property {GUID} site_id - {}
* @property {string} source - {main menu,  members menu, custom menu, store, lightbox, router, router welcome}
* @property {string} sourceName - button / link
* @property {string} stage_type - null
* @property {string} target - blank/about/project/contact/etc
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - Preview page click. Evid: 1105.
 * Event description: User chose to add new Page from templates or just click Add Blank and page was added successfully.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * category - Type: string. Desc: {page, link, dropdown menu, popup, dynamic page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * name - Type: string. Desc: name of the page
 *
 * origin - Type: string. Desc: From where user opened AddPage modal
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu,  members menu, custom menu, store, lightbox, router, router welcome}
 *
 * sourceName - Type: string. Desc: button / link
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: blank/about/project/contact/etc
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPagePreviewPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPagePreviewPageClick = function (params) {
    return { evid: 1105, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} langSelectorShowIconsToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} source - {}
* @property {string} stage_type - null
* @property {string} toggle_status - {on/off}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: lang_selector_show_icons_toggle. Evid: 788.
 * Event description: in compPanels.panels.LanguageSelector.layoutPane "show icons" toggle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle_status - Type: string. Desc: {on/off}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {langSelectorShowIconsToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var langSelectorShowIconsToggle = function (params) {
    return { evid: 788, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationPanelBehaviorClickParams
* @property {string} behavior_name - {float-in, expand...}
* @property {string} component_id - component_id
* @property {string} component_name - {slide gallery, box...}
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} trigger_type - entrance, loop, e.t.c
* @property {string} usedJsHeapSize - null
* @property {string} action_name - {screen-in, page-in...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_panel_behavior_click. Evid: 371.
 * Event description: animation_panel_behavior_click.

 * behavior_name - Type: string. Desc: {float-in, expand...}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * trigger_type - Type: string. Desc: entrance, loop, e.t.c
 *
 * usedJsHeapSize - Type: string.
 *
 * action_name - Type: string. Desc: {screen-in, page-in...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {animationPanelBehaviorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationPanelBehaviorClick = function (params) {
    return { evid: 371, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} renameQuickActionParams
* @property {string} action_type - type of action renamed
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_name - new name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: rename_quick_action. Evid: 723.
 * Event description: rename_quick_action.

 * action_type - Type: string. Desc: type of action renamed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_name - Type: string. Desc: new name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {renameQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var renameQuickAction = function (params) {
    return { evid: 723, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog1RadioButtonsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selection - {free WIX domain, connect your own domain}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_1_Radio_Buttons_click. Evid: 315.
 * Event description: First_Save_Dialog_1_Radio_Buttons_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: {free WIX domain, connect your own domain}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog1RadioButtonsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog1RadioButtonsClick = function (params) {
    return { evid: 315, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formsEngageDebugParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Forms - Engage - Debug. Evid: 1166.
 * Event description: Form widget --> submit button --> setiings.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formsEngageDebugParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formsEngageDebug = function (params) {
    return { evid: 1166, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addANewSlideClickedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Add a new slide clicked. Evid: 537.
 * Event description: Add a new slide clicked.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addANewSlideClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addANewSlideClicked = function (params) {
    return { evid: 537, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkElementClickParams
* @property {string} component_id - .
* @property {string} component_type - .
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Click on text area, Click on add button}
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: LinkElement_Click. Evid: 350.
 * Event description: LinkElement_Click.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: .
 *
 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Click on text area, Click on add button}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {linkElementClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkElementClick = function (params) {
    return { evid: 350, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dropDownSelectionParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selection - {Selected Value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: DropDown_Selection. Evid: 355.
 * Event description: DropDown_Selection.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selection - Type: string. Desc: {Selected Value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dropDownSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dropDownSelection = function (params) {
    return { evid: 355, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} bgImageSetiingsClickParams
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - image/video
* @property {string} panel_name - panel where Setting button placed
* @property {string} panelname - panelname
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: bg_image_setiings_click. Evid: 1015.
 * Event description: bg_image_setiings_click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: image/video
 *
 * panel_name - Type: string. Desc: panel where Setting button placed
 *
 * panelname - Type: string. Desc: panelname
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {bgImageSetiingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bgImageSetiingsClick = function (params) {
    return { evid: 1015, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageMinHeightTooltipAppearsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Page Min Height tooltip appears. Evid: 612.
 * Event description: Hover over the icon and tooltip appears.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageMinHeightTooltipAppearsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageMinHeightTooltipAppears = function (params) {
    return { evid: 612, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} resizeComponentFromTheToolbarParams
* @property {GUID} appId - {}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - dm_version
* @property {string} ds_origin - ds_origin
* @property {string} entry_type - manual / calculation
* @property {GUID} esi - esi
* @property {string} handle_value - {1,2,3....}
* @property {boolean} isChanged - true/false (send true when user has resized)
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - {tool bar, handle}
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - width / height
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} value - changed value
* @property {string} valueOrigin - previous value
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - workspace_mode
**/
/**
 * Name: resize component from the toolbar. Evid: 1485.
 * Event description: resize the component from the toolbar.

 * appId - Type: guid. Desc: {}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * entry_type - Type: string. Desc: manual / calculation
 *
 * esi - Type: guid. Desc: esi
 *
 * handle_value - Type: string. Desc: {1,2,3....}
 *
 * isChanged - Type: bool. Desc: true/false (send true when user has resized)
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: {tool bar, handle}
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: width / height
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * value - Type: string. Desc: changed value
 *
 * valueOrigin - Type: string. Desc: previous value
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string. Desc: workspace_mode
 * @param {resizeComponentFromTheToolbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var resizeComponentFromTheToolbar = function (params) {
    return { evid: 1485, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelTextStyleClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Text_Style_Click. Evid: 225.
 * Event description: Text_Panel_Text_Style_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelTextStyleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelTextStyleClick = function (params) {
    return { evid: 225, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hiddenElementsRefreshLayoutClickParams
* @property {string} current_page_name - {page name}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hidden_elements_refresh_layout_click. Evid: 301.
 * Event description: hidden_elements_refresh_layout_click.

 * current_page_name - Type: string. Desc: {page name}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hiddenElementsRefreshLayoutClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hiddenElementsRefreshLayoutClick = function (params) {
    return { evid: 301, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsErrorPanelLoadedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> error panel loaded. Evid: 1120.
 * Event description: Apps Manager loaded.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsErrorPanelLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsErrorPanelLoaded = function (params) {
    return { evid: 1120, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsDuplicateClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_duplicate_click. Evid: 581.
 * Event description: columns_duplicate_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsDuplicateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsDuplicateClick = function (params) {
    return { evid: 581, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} zoomModeExitParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of exit from mode
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {number} timestamp - {# in seconds}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {string} zoom_mode_type - 50% / 75%
**/
/**
 * Name: zoom_mode_exit. Evid: 549.
 * Event description: zoom_mode_exit.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of exit from mode
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * timestamp - Type: numeric. Desc: {# in seconds}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * zoom_mode_type - Type: string. Desc: 50% / 75%
 * @param {zoomModeExitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var zoomModeExit = function (params) {
    return { evid: 549, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesNavigateToPageParams
* @property {string} category - {recently,site menu ,members menu, custom menu, router,blog, tpa etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} isDynamicPage - if one of the values in this json field is not null then we define page as dynamic {hasRouterData; isMultiSectionCompOnPage}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_group_name - {depricated}
* @property {string} page_id - {}
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_navigate_to_page. Evid: 454.
 * Event description: PAGES_navigate_to_page.

 * category - Type: string. Desc: {recently,site menu ,members menu, custom menu, router,blog, tpa etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isDynamicPage - Type: string. Desc: if one of the values in this json field is not null then we define page as dynamic {hasRouterData; isMultiSectionCompOnPage}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_group_name - Type: string. Desc: {depricated}
 *
 * page_id - Type: string. Desc: {}
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesNavigateToPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesNavigateToPage = function (params) {
    return { evid: 454, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsMigrationErrorsInSiteStructureAfterMigrationParams
* @property {number} commonAmount - number of components with errors
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {string} flow - null
* @property {string} invalidData - json with detail
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {number} layoutAmount - number of layout errors
* @property {number} levelAmount - number of level errors
* @property {string} multilingual - {}
* @property {string} origin - origin
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {number} visibilityAmount - number of visibility errors
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - errors in site structure after migration. Evid: 1365.
 * Event description: Sections migration - errors in site structure after migration.

 * commonAmount - Type: numeric. Desc: number of components with errors
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string.
 *
 * invalidData - Type: string. Desc: json with detail
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * layoutAmount - Type: numeric. Desc: number of layout errors
 *
 * levelAmount - Type: numeric. Desc: number of level errors
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * visibilityAmount - Type: numeric. Desc: number of visibility errors
 *
 * workspace_mode - Type: string.
 * @param {sectionsMigrationErrorsInSiteStructureAfterMigrationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsMigrationErrorsInSiteStructureAfterMigration = function (params) {
    return { evid: 1365, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMenuItemDragParams
* @property {string} category - item_drag / subitem_drag / subitem_created / subitem_deprecated
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {string} page_id - .
* @property {string} parent_item_name - null
* @property {GUID} site_id - {}
* @property {string} source - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_menu_item_drag. Evid: 1043.
 * Event description: any menu_item_drag.

 * category - Type: string. Desc: item_drag / subitem_drag / subitem_created / subitem_deprecated
 *
 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: .
 *
 * parent_item_name - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuMenuItemDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMenuItemDrag = function (params) {
    return { evid: 1043, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsAlignmentClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - center, left, right
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_alignment_click. Evid: 572.
 * Event description: columns_alignment_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: center, left, right
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsAlignmentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsAlignmentClick = function (params) {
    return { evid: 572, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsClickOnActionInEmptyStateParams
* @property {string} action_id - action id
* @property {string} action_type - main/quick/general
* @property {string} app_id - app id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> click on app manager action. Evid: 1088.
 * Event description: Manage My App tab selected.

 * action_id - Type: string. Desc: action id
 *
 * action_type - Type: string. Desc: main/quick/general
 *
 * app_id - Type: string. Desc: app id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsClickOnActionInEmptyStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsClickOnActionInEmptyState = function (params) {
    return { evid: 1088, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorAdditionalActionsParams
* @property {string} actionName - action_name
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - session id
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - -
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} panelType - single sided / double sided
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - .
**/
/**
 * Name: AI Text Generator - additional actions. Evid: 1471.
 * Event description: AI Text Generator - additional actions.

 * actionName - Type: string. Desc: action_name
 *
 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: session id
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * panelType - Type: string. Desc: single sided / double sided
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string. Desc: .
 * @param {aiTextGeneratorAdditionalActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorAdditionalActions = function (params) {
    return { evid: 1471, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesStorePagesInfoClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_type - {product, cart, thank you}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_store_pages_info_click. Evid: 438.
 * Event description: PAGES_store_pages_info_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_type - Type: string. Desc: {product, cart, thank you}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesStorePagesInfoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesStorePagesInfoClick = function (params) {
    return { evid: 438, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorErrorEventParams
* @property {string} component_id - id of text component
* @property {string} component_type - text component
* @property {string} dm_version - -
* @property {string} ds_origin - -
* @property {number} errorCode - error code
* @property {string} errorMessage - error message
* @property {GUID} esi - session id
* @property {string} gpt3Params - set of params to know configuration of the model used
* @property {string} gptParams - e.g., ‘1.2.1’
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} panelType - .
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} prompt - prompt we send to Open Ai (unified, placeholders not replaced with user input)
* @property {string} query - user request in json format
* @property {string} query_output - request output
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tokens - prompt_tokens - user query tokens; completion_tokens - output tokens
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: AI Text Generator - Error event. Evid: 1456.
 * Event description: Details on API errors received in Ai text Generator.

 * component_id - Type: string. Desc: id of text component
 *
 * component_type - Type: string. Desc: text component
 *
 * dm_version - Type: string. Desc: -
 *
 * ds_origin - Type: string. Desc: -
 *
 * errorCode - Type: numeric. Desc: error code
 *
 * errorMessage - Type: string. Desc: error message
 *
 * esi - Type: guid. Desc: session id
 *
 * gpt3Params - Type: string. Desc: set of params to know configuration of the model used
 *
 * gptParams - Type: string. Desc: e.g., ‘1.2.1’
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * panelType - Type: string. Desc: .
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * prompt - Type: string. Desc: prompt we send to Open Ai (unified, placeholders not replaced with user input)
 *
 * query - Type: string. Desc: user request in json format
 *
 * query_output - Type: string. Desc: request output
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tokens - Type: string. Desc: prompt_tokens - user query tokens; completion_tokens - output tokens
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {aiTextGeneratorErrorEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorErrorEvent = function (params) {
    return { evid: 1456, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverSectionHandleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {string} section_size - small,medium,large
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hover_section_handle. Evid: 471.
 * Event description: hover_section_handle **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * section_size - Type: string. Desc: small,medium,large
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverSectionHandleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverSectionHandle = function (params) {
    return { evid: 471, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelFontSelectorSelectedParams
* @property {string} category - {Nimbus Cond Regular, Open Sans Light...}
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - .
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Font_Selector_selected. Evid: 228.
 * Event description: Text_Panel_Font_Selector_selected.

 * category - Type: string. Desc: {Nimbus Cond Regular, Open Sans Light...}
 *
 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelFontSelectorSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelFontSelectorSelected = function (params) {
    return { evid: 228, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeTextStyleChangingParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} parameter_name - Bold/Italic/Underline/Color/Highlight/Character spacing/Line spacing
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_text_style_changing. Evid: 1003.
 * Event description: Change text settings.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * parameter_name - Type: string. Desc: Bold/Italic/Underline/Color/Highlight/Character spacing/Line spacing
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionModeTextStyleChangingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeTextStyleChanging = function (params) {
    return { evid: 1003, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageActionClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page hidden
* @property {GUID} site_id - {}
* @property {string} source - {main menu, members menu, custom menu, blog, tpa etc, lightbox,router}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {pages, pop ups}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Page_action_click. Evid: 707.
 * Event description: Page_action_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page hidden
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu, members menu, custom menu, blog, tpa etc, lightbox,router}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {pages, pop ups}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageActionClick = function (params) {
    return { evid: 707, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcClickedWhenOneExistsPreConfirmationPanelInteractionParams
* @property {string} action_name - {create_test_site, escape, cancel}
* @property {GUID} branchId - optional
* @property {string} dm_version - null
* @property {boolean} do_not_show_again - {True, False}
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - (top_bar, publish)
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: RC clicked when one exists (pre-confirmation panel interaction). Evid: 1118.
 * Event description: Fires when a user interacts with the creation panel that appears when users tries to create RC when one already exists..

 * action_name - Type: string. Desc: {create_test_site, escape, cancel}
 *
 * branchId - Type: guid. Desc: optional
 *
 * dm_version - Type: string.
 *
 * do_not_show_again - Type: bool. Desc: {True, False}
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: (top_bar, publish)
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rcClickedWhenOneExistsPreConfirmationPanelInteractionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcClickedWhenOneExistsPreConfirmationPanelInteraction = function (params) {
    return { evid: 1118, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishGetOwnMailboxClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_get_own_Mailbox_click. Evid: 392.
 * Event description: Second_Publish_get_own_Mailbox_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishGetOwnMailboxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishGetOwnMailboxClick = function (params) {
    return { evid: 392, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} membersPanelClickOnDoneParams
* @property {string} approved_members - everyone, approved by admin
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {boolean} enable_facebook - true, false
* @property {boolean} enable_google - true, false
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} show_first - signup, login
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: members panel click on done. Evid: 666.
 * Event description: send a snap shot of the members panel after clicking the done button.

 * approved_members - Type: string. Desc: everyone, approved by admin
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * enable_facebook - Type: bool. Desc: true, false
 *
 * enable_google - Type: bool. Desc: true, false
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * show_first - Type: string. Desc: signup, login
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {membersPanelClickOnDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersPanelClickOnDone = function (params) {
    return { evid: 666, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} invertColorSchemeParams
* @property {string} component_type - component type edited
* @property {string} control_name - Control Label
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} invert - is color scheme inverted
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - Translation Key
* @property {string} section_name - Section Label
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: invert_color_scheme. Evid: 719.
 * Event description: invert_color_scheme_quick_action_bar.

 * component_type - Type: string. Desc: component type edited
 *
 * control_name - Type: string. Desc: Control Label
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * invert - Type: bool. Desc: is color scheme inverted
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: Translation Key
 *
 * section_name - Type: string. Desc: Section Label
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {invertColorSchemeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invertColorScheme = function (params) {
    return { evid: 719, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} codeEmbedOutputShownParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} vsi - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Code_embed_output_shown. Evid: 750.
 * Event description: Code embed output shown.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * vsi - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {codeEmbedOutputShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var codeEmbedOutputShown = function (params) {
    return { evid: 750, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} newFeaturesVideoPageLoadsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: New features video page loads. Evid: 590.
 * Event description: Intro video for existing users loads.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {newFeaturesVideoPageLoadsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var newFeaturesVideoPageLoads = function (params) {
    return { evid: 590, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} advancedDesignPanelScrollSkinsClickParams
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} navigation_arrow - {left, right}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: advanced_design_panel_scroll_skins_click. Evid: 255.
 * Event description: advanced_design_panel_scroll_skins_click **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * navigation_arrow - Type: string. Desc: {left, right}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {advancedDesignPanelScrollSkinsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var advancedDesignPanelScrollSkinsClick = function (params) {
    return { evid: 255, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishDonTShowAgainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - {0,1}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_don't_show_again_click. Evid: 381.
 * Event description: First_Publish_don't_show_again_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: {0,1}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstPublishDonTShowAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishDonTShowAgainClick = function (params) {
    return { evid: 381, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} imageControlStripClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Add Image, Image area, Change, Remove}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Image_Control_Strip_Click. Evid: 352.
 * Event description: Image_Control_Strip_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Add Image, Image area, Change, Remove}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {imageControlStripClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var imageControlStripClick = function (params) {
    return { evid: 352, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesReorderChoiceCompleteParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} choice_name - choice_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - Reorder Choice - complete. Evid: 914.
 * Event description: choice reorder is successfully completed.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * choice_name - Type: string. Desc: choice_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesReorderChoiceCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesReorderChoiceComplete = function (params) {
    return { evid: 914, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} removeComponent2ndStepClick280Params
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - [guid]
* @property {string} component_id - [guid]
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of host_app_id}
* @property {string} instance_id - [guid]
* @property {boolean} is_last - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {id of page}
* @property {string} page_name - {name of page}
* @property {string} removal_method - (X,cut,undo...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - {cancel, delete_and_reset}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: remove component 2nd step click. Evid: 280.
 * Event description: remove component 2nd step click.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: [guid]
 *
 * component_id - Type: string. Desc: [guid]
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of host_app_id}
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_last - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {id of page}
 *
 * page_name - Type: string. Desc: {name of page}
 *
 * removal_method - Type: string. Desc: (X,cut,undo...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {cancel, delete_and_reset}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {removeComponent2ndStepClick280Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeComponent2ndStepClick280 = function (params) {
    return { evid: 280, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishDoneClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_Done_click. Evid: 380.
 * Event description: First_Publish_Done_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstPublishDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishDoneClick = function (params) {
    return { evid: 380, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} translationKeyUsageParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} translationKeys - comma separated list of used translated keys
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: translation key usage. Evid: 1122.
 * Event description: event is sending when translation key is used.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * translationKeys - Type: string. Desc: comma separated list of used translated keys
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {translationKeyUsageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var translationKeyUsage = function (params) {
    return { evid: 1122, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesEditChoiceParams
* @property {string} builderOrigin - ADI /  Editor
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices -Edit Choice. Evid: 907.
 * Event description: Manage Choices -Edit Choice.

 * builderOrigin - Type: string. Desc: ADI /  Editor
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesEditChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesEditChoice = function (params) {
    return { evid: 907, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} presetIdParams
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} preset_id - {# of fields in the form}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: preset_id. Evid: 643.
 * Event description: preset id for contact form.

 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * preset_id - Type: string. Desc: {# of fields in the form}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {presetIdParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var presetId = function (params) {
    return { evid: 643, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorPanelOpenParams
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - session id
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} panelType - single sided / double sided
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} query - string with all values of what was prefilled in panel. similar to 38:1031 and 38:1417
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} theme - heading / paragraph
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - .
**/
/**
 * Name: AI Text Generator - panel open. Evid: 1468.
 * Event description: AI Text Generator - panel open.

 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: session id
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * panelType - Type: string. Desc: single sided / double sided
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * query - Type: string. Desc: string with all values of what was prefilled in panel. similar to 38:1031 and 38:1417
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * theme - Type: string. Desc: heading / paragraph
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string. Desc: .
 * @param {aiTextGeneratorPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorPanelOpen = function (params) {
    return { evid: 1468, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} urlTooltipOpenedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: url_tooltip_opened. Evid: 543.
 * Event description: url_tooltip_opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {urlTooltipOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var urlTooltipOpened = function (params) {
    return { evid: 543, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ppOpenedParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pp_origin - {fpp}
* @property {string} pp_type - {offering, package, cycle}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PP_opened. Evid: 185.
 * Event description: PP_opened.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pp_origin - Type: string. Desc: {fpp}
 *
 * pp_type - Type: string. Desc: {offering, package, cycle}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ppOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ppOpened = function (params) {
    return { evid: 185, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myElementsDeleteFromLibraryParams
* @property {string} content_type - content_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} element_id - id generated when adding new element to "my elements"
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.delete_from_library. Evid: 960.
 * Event description: Try to delete element from "my elements".

 * content_type - Type: string. Desc: content_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_id - Type: guid. Desc: id generated when adding new element to "my elements"
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {myElementsDeleteFromLibraryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myElementsDeleteFromLibrary = function (params) {
    return { evid: 960, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ratingDisplaySettingsWithoutReviewsStateSetParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {mainpage}
* @property {string} preset_id - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {nothing, emptyIcons.placeholderText}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Rating_display_settings_without_reviews_state_set. Evid: 800.
 * Event description: Rating_display_settings_without_reviews_state_set.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {mainpage}
 *
 * preset_id - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {nothing, emptyIcons.placeholderText}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ratingDisplaySettingsWithoutReviewsStateSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ratingDisplaySettingsWithoutReviewsStateSet = function (params) {
    return { evid: 800, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editMainColorOkParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - theme_color_picker_single_color /   theme_color_picker_column_color /
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Main_Color_OK. Evid: 411.
 * Event description: Edit_Main_Color_OK.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: theme_color_picker_single_color /   theme_color_picker_column_color /
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editMainColorOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editMainColorOk = function (params) {
    return { evid: 411, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarMenuOpenOnHoverParams
* @property {string} category - Site / Tools / Help / Upgrade
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_menu_open_on_hover. Evid: 765.
 * Event description: menu opened on hover of Site / Tools / Help / Upgrade.
Shot when the menu is opened on hover - with a 2 sec delay (similar to event 38:715)..

 * category - Type: string. Desc: Site / Tools / Help / Upgrade
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarMenuOpenOnHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarMenuOpenOnHover = function (params) {
    return { evid: 765, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteChangedColorParams
* @property {string} button_group - regular, hover and etc
* @property {string} button_type - primary button, secondary
* @property {string} color_position - color name
* @property {string} currentValue - current colour value
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - colour name of element
* @property {string} target_group - group of colours: text, button, general
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette changed color. Evid: 1430.
 * Event description: Color palette changed color.

 * button_group - Type: string. Desc: regular, hover and etc
 *
 * button_type - Type: string. Desc: primary button, secondary
 *
 * color_position - Type: string. Desc: color name
 *
 * currentValue - Type: string. Desc: current colour value
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: colour name of element
 *
 * target_group - Type: string. Desc: group of colours: text, button, general
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteChangedColorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteChangedColor = function (params) {
    return { evid: 1430, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishDoneClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_Done_click. Evid: 394.
 * Event description: Second_Publish_Done_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishDoneClick = function (params) {
    return { evid: 394, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} toggleClickParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - {On, Off}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Toggle_Click. Evid: 361.
 * Event description: Toggle_Click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {On, Off}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toggleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toggleClick = function (params) {
    return { evid: 361, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backgroundPanelApplyToOtherPageToggleChangedParams
* @property {string} action - on/off
* @property {string} category - color/image/video
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} pageId - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target_page_id - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Background Panel: Apply to other page toggle changed. Evid: 1186.


 * action - Type: string. Desc: on/off
 *
 * category - Type: string. Desc: color/image/video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * pageId - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target_page_id - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backgroundPanelApplyToOtherPageToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backgroundPanelApplyToOtherPageToggleChanged = function (params) {
    return { evid: 1186, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} showOnAllPagesParams
* @property {string} component_id - component_id (if more than 1 then comma seperated)
* @property {string} component_type - component_type (if more than 1 then comma seperated)
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_status - {on,off}
* @property {string} origin - {right click menu, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: show on all pages. Evid: 146.
 * Event description: show on all pages.

 * component_id - Type: string. Desc: component_id (if more than 1 then comma seperated)
 *
 * component_type - Type: string. Desc: component_type (if more than 1 then comma seperated)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_status - Type: string. Desc: {on,off}
 *
 * origin - Type: string. Desc: {right click menu, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {showOnAllPagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showOnAllPages = function (params) {
    return { evid: 146, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishTwitterShareClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_Twitter_share_click. Evid: 390.
 * Event description: Second_Publish_Twitter_share_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishTwitterShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishTwitterShareClick = function (params) {
    return { evid: 390, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisShowReadMoreToggleChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} status - on/off
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Show_read_more_toggle_changed. Evid: 1191.


 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: string. Desc: on/off
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisShowReadMoreToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisShowReadMoreToggleChanged = function (params) {
    return { evid: 1191, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hiddenElementsTooltipAppearParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hidden_elements_tooltip_appear. Evid: 620.
 * Event description: hidden_elements_tooltip_appear.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hiddenElementsTooltipAppearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hiddenElementsTooltipAppear = function (params) {
    return { evid: 620, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionResizeButtonHoveredParams
* @property {string} component_id - component_id of section
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section_name - section_name
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section - resize button hovered. Evid: 1304.
 * Event description: User hovers the resize button.

 * component_id - Type: string. Desc: component_id of section
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section_name - Type: string. Desc: section_name
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionResizeButtonHoveredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionResizeButtonHovered = function (params) {
    return { evid: 1304, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardProgressBarNavigationParams
* @property {string} current_step - current step while clicking skip
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} next_step - step navigated to
* @property {string} selected_value - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_progress_bar_navigation. Evid: 778.
 * Event description: navigation to the next step using progress bar.

 * current_step - Type: string. Desc: current step while clicking skip
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * next_step - Type: string. Desc: step navigated to
 *
 * selected_value - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardProgressBarNavigationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardProgressBarNavigation = function (params) {
    return { evid: 778, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} themeFromLogoErrorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} errorCode - {error code}
* @property {string} errorMessage - {error message}
* @property {string} errorTry - {number of try on error}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {origin error}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Theme from logo - error. Evid: 105.
 * Event description: Theme from logo - error.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * errorCode - Type: numeric. Desc: {error code}
 *
 * errorMessage - Type: string. Desc: {error message}
 *
 * errorTry - Type: string. Desc: {number of try on error}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {origin error}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {themeFromLogoErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var themeFromLogoError = function (params) {
    return { evid: 105, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishFlowConnectDomainNowButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_publish - {1,0}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish_flow_connect_domain_now_button_click. Evid: 297.
 * Event description: publish_connect_domain_now_button_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_publish - Type: bool. Desc: {1,0}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishFlowConnectDomainNowButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishFlowConnectDomainNowButtonClick = function (params) {
    return { evid: 297, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMenuSetChoseParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_menu_set_chose. Evid: 1045.
 * Event description: user Changed menu set  on Menu Manager.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuMenuSetChoseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMenuSetChose = function (params) {
    return { evid: 1045, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderStepsDisplayingChangedParams
* @property {string} behavior - null
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - null
* @property {string} section - Circle/Square/Rectangle /Bar
* @property {string} selection - Lines/Dots
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_steps_displaying_changed. Evid: 1334.
 * Event description: range_slider_steps_displaying_changed.

 * behavior - Type: string.
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string.
 *
 * section - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * selection - Type: string. Desc: Lines/Dots
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderStepsDisplayingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderStepsDisplayingChanged = function (params) {
    return { evid: 1334, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} zoomModeOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - desktop, mobile
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} origin - topbar etc
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {number} timestamp - {# in miliseconds}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
* @property {string} zoom_mode_type - 50% / 75%
**/
/**
 * Name: zoom_mode_open. Evid: 1085.
 * Event description: zoom_mode_open.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: desktop, mobile
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: topbar etc
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * timestamp - Type: numeric. Desc: {# in miliseconds}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 *
 * zoom_mode_type - Type: string. Desc: 50% / 75%
 * @param {zoomModeOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var zoomModeOpen = function (params) {
    return { evid: 1085, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsDeletePageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {drag, quick actions}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab - {page info, layout, privacy, SEO}
* @property {boolean} template_page - {0,1}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_delete_page_click. Evid: 428.
 * Event description: PAGES_settings_delete_page_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {drag, quick actions}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab - Type: string. Desc: {page info, layout, privacy, SEO}
 *
 * template_page - Type: bool. Desc: {0,1}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsDeletePageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsDeletePageClick = function (params) {
    return { evid: 428, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pinNotificationTooBigParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - {on resize, on pin}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pin_notification_too_big. Evid: 349.
 * Event description: pin_notification_too_big.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {on resize, on pin}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pinNotificationTooBigParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pinNotificationTooBig = function (params) {
    return { evid: 349, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderBehavierChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - Continuous/Stepped
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_behavier_changed. Evid: 1321.


 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: Continuous/Stepped
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderBehavierChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderBehavierChanged = function (params) {
    return { evid: 1321, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsTrackNameChangedParams
* @property {string} comp_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.trackName.changed. Evid: 1208.
 * Event description: track name in Audio Player settings was changed.

 * comp_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsTrackNameChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsTrackNameChanged = function (params) {
    return { evid: 1208, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} exitInteractionModeBtnClickParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - exit point name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: exit_interaction_mode. Evid: 988.
 * Event description: Click on “Exit Mode” button.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: exit point name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {exitInteractionModeBtnClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var exitInteractionModeBtnClick = function (params) {
    return { evid: 988, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarHelpMenuClickParams
* @property {string} category - {save, publish, site revision, manage site..}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_HELP_menu_click. Evid: 460.
 * Event description: top_bar_HELP_menu_click.

 * category - Type: string. Desc: {save, publish, site revision, manage site..}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarHelpMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarHelpMenuClick = function (params) {
    return { evid: 460, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} headerLabelAppearParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop zoom, mobile zoom, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: header_label_appear. Evid: 554.
 * Event description: header_label_appear **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop zoom, mobile zoom, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {headerLabelAppearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerLabelAppear = function (params) {
    return { evid: 554, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAnchorSettingsCheckTooltipContentParams
* @property {string} componentId - section/anchor component id
* @property {string} componentName - section name or anchor name
* @property {string} componentType - section/anchor component type
* @property {string} dm_version - -
* @property {string} ds_origin - -
* @property {number} duration - duration in millisec
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - from where Section/Anchor Settings panel was opened {gfpp/rcm/label/quickEditPanel}
* @property {string} pageId - page where section/anchor is placed
* @property {string} pageName - name of the page where section/anchor is placed
* @property {GUID} site_id - -
* @property {string} stage_type - null
* @property {string} topic - [Section Name; Section URL; Suffix of the URL]
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Section/Anchor Settings - Check tooltip content. Evid: 1452.
 * Event description: User checks tooltip content in Section/Anchor Settings panel.

 * componentId - Type: string. Desc: section/anchor component id
 *
 * componentName - Type: string. Desc: section name or anchor name
 *
 * componentType - Type: string. Desc: section/anchor component type
 *
 * dm_version - Type: string. Desc: -
 *
 * ds_origin - Type: string. Desc: -
 *
 * duration - Type: numeric. Desc: duration in millisec
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: from where Section/Anchor Settings panel was opened {gfpp/rcm/label/quickEditPanel}
 *
 * pageId - Type: string. Desc: page where section/anchor is placed
 *
 * pageName - Type: string. Desc: name of the page where section/anchor is placed
 *
 * site_id - Type: guid. Desc: -
 *
 * stage_type - Type: string.
 *
 * topic - Type: string. Desc: [Section Name; Section URL; Suffix of the URL]
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionAnchorSettingsCheckTooltipContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAnchorSettingsCheckTooltipContent = function (params) {
    return { evid: 1452, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMenuChangeClickParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_menu_change_click. Evid: 1044.
 * Event description: user click Change menu set  on Menu Manager.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuMenuChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMenuChangeClick = function (params) {
    return { evid: 1044, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addAppVariantPageParams
* @property {string} app_id - {id of app}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of host app id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {id of page}
* @property {string} page_name - {name of page}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {selected app page}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Add App Variant Page. Evid: 1487.
 * Event description: Adding custom app page from panel.

 * app_id - Type: string. Desc: {id of app}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of host app id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {id of page}
 *
 * page_name - Type: string. Desc: {name of page}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {selected app page}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addAppVariantPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addAppVariantPage = function (params) {
    return { evid: 1487, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputValueEnteredParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} value - what user input
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Input value entered. Evid: 1397.
 * Event description: Input value entered.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * value - Type: string. Desc: what user input
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {inputValueEnteredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputValueEntered = function (params) {
    return { evid: 1397, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} advancedDesignPanelMouseStateSelectionClickParams
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mouse_state - {active, hover, clicked}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: advanced_design_panel_mouse_state_selection_click. Evid: 259.
 * Event description: advanced_design_panel_mouse_state_selection_click.

 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mouse_state - Type: string. Desc: {active, hover, clicked}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {advancedDesignPanelMouseStateSelectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var advancedDesignPanelMouseStateSelectionClick = function (params) {
    return { evid: 259, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contentInjectionSiteBusinessTypeChangeBtClickParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - Add Section/Page panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Content Injection - Site Business Type - Change BT click. Evid: 1408.
 * Event description: User clicked Change Business Term entry point in Add Section or Add Pages panels.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: Add Section/Page panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {contentInjectionSiteBusinessTypeChangeBtClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentInjectionSiteBusinessTypeChangeBtClick = function (params) {
    return { evid: 1408, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsPlaybackOptionsChangedParams
* @property {string} comp_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {string} selection - play_once / play_in_loop
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.playbackOptions.changed. Evid: 1209.
 * Event description: payback options in Audio Player settings was changed.

 * comp_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: play_once / play_in_loop
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsPlaybackOptionsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsPlaybackOptionsChanged = function (params) {
    return { evid: 1209, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} repeaterComponentBackgroundPanelApplyToAllParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} parent_item_id - parent repeater id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: repeater component -> background panel -> apply to all. Evid: 1009.
 * Event description: Click on "Apply to all" button on repeater component background panel.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * parent_item_id - Type: string. Desc: parent repeater id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {repeaterComponentBackgroundPanelApplyToAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var repeaterComponentBackgroundPanelApplyToAll = function (params) {
    return { evid: 1009, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardBusinessNameBusinessNameSelectedParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} name - name of the business type
* @property {number} position - position of selected result
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} suggestList - from where user selected: example list / no matches list / category list
* @property {string} text - searched text
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Business Name - Business Name selected. Evid: 1270.
 * Event description: Send every time user selecting a name.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * name - Type: string. Desc: name of the business type
 *
 * position - Type: numeric. Desc: position of selected result
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * suggestList - Type: string. Desc: from where user selected: example list / no matches list / category list
 *
 * text - Type: string. Desc: searched text
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardBusinessNameBusinessNameSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardBusinessNameBusinessNameSelected = function (params) {
    return { evid: 1270, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPreviewPageBackToEditorClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {ex-button, thumb button}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Preview_Page_Back_to_Editor_click. Evid: 293.
 * Event description: top_bar_Preview_Page_Back_to_Editor_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {ex-button, thumb button}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPreviewPageBackToEditorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPreviewPageBackToEditorClick = function (params) {
    return { evid: 293, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} triggerMainPanelsOfSelectedComponentSettingsLayoutDesignParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - Settings, Layout, Design
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: trigger main panels of selected component (Settings, Layout, Design).. Evid: 875.
 * Event description: Shift+1/2/3 to trigger main panels of selected component (Settings, Layout, Design)..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: Settings, Layout, Design
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {triggerMainPanelsOfSelectedComponentSettingsLayoutDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var triggerMainPanelsOfSelectedComponentSettingsLayoutDesign = function (params) {
    return { evid: 875, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tabInsideComponentCreatedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - Add new tab btton/duplicate button/copy paste/ action menu duplicate
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_id - tab id
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Tab inside component - created. Evid: 1382.
 * Event description: Tab inside component - created.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: Add new tab btton/duplicate button/copy paste/ action menu duplicate
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_id - Type: string. Desc: tab id
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {tabInsideComponentCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tabInsideComponentCreated = function (params) {
    return { evid: 1382, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorSettingsChangedParams
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - .
* @property {string} ds_origin - null
* @property {GUID} esi - session id
* @property {string} fieldName - .
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - -
* @property {string} mandatoryField - yes / no
* @property {string} multilingual - -
* @property {string} newValue - what user chose / typed
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} panelType - single sided / double sided
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - .
**/
/**
 * Name: AI Text Generator - settings changed. Evid: 1469.
 * Event description: user changed any of the input fields.

 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: session id
 *
 * fieldName - Type: string. Desc: .
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * mandatoryField - Type: string. Desc: yes / no
 *
 * multilingual - Type: string. Desc: -
 *
 * newValue - Type: string. Desc: what user chose / typed
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * panelType - Type: string. Desc: single sided / double sided
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string. Desc: .
 * @param {aiTextGeneratorSettingsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorSettingsChanged = function (params) {
    return { evid: 1469, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishDonTShowAgainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - {0,1}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_don't_show_again_click. Evid: 395.
 * Event description: Second_Publish_don't_show_again_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: {0,1}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishDonTShowAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishDonTShowAgainClick = function (params) {
    return { evid: 395, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppTemplateFirsttimeStep2welcomeContinueClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_template_firsttime_step2welcome_continue_click. Evid: 200.
 * Event description: site_app_template_firsttime_step2welcome_continue_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppTemplateFirsttimeStep2welcomeContinueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppTemplateFirsttimeStep2welcomeContinueClick = function (params) {
    return { evid: 200, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} autowritingSuccessParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration of autowriting
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Autowiring success. Evid: 1464.
 * Event description: Autowiring success.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration of autowriting
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {autowritingSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autowritingSuccess = function (params) {
    return { evid: 1464, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsNumberOfLocationsToShowOnMapParams
* @property {string} choice - {One,Multiple}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google maps -> number of locations to show on map. Evid: 1214.
 * Event description: Google maps -> number of  locations click.

 * choice - Type: string. Desc: {One,Multiple}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleMapsNumberOfLocationsToShowOnMapParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsNumberOfLocationsToShowOnMap = function (params) {
    return { evid: 1214, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityFollowUpLinkParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility - follow up link. Evid: 925.
 * Event description: click on follow up.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {accessibilityFollowUpLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityFollowUpLink = function (params) {
    return { evid: 925, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsSeoDescriptionAddUsernameParams
* @property {string} category - {social,private}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_seo_description_add_username. Evid: 712.
 * Event description: PAGES_settings_seo_description_add_username.

 * category - Type: string. Desc: {social,private}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsSeoDescriptionAddUsernameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsSeoDescriptionAddUsername = function (params) {
    return { evid: 712, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sitePagesDetailsOpenParams
* @property {string} app_id - {id of app}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of host_app_id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {id of page}
* @property {string} page_name - {name of page}
* @property {string} page_type - {default, custom, app_replacer}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Pages details open. Evid: 1440.
 * Event description: Toggle menu details open.

 * app_id - Type: string. Desc: {id of app}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of host_app_id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {id of page}
 *
 * page_name - Type: string. Desc: {name of page}
 *
 * page_type - Type: string. Desc: {default, custom, app_replacer}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sitePagesDetailsOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sitePagesDetailsOpen = function (params) {
    return { evid: 1440, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageAddVerticalClickParams
* @property {string} app_id - vertical app_id
* @property {string} app_name - stores/ booking / etc
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Add Page - Add Vertical Click. Evid: 1129.
 * Event description: Add Page - Add Vertical Click.

 * app_id - Type: string. Desc: vertical app_id
 *
 * app_name - Type: string. Desc: stores/ booking / etc
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageAddVerticalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageAddVerticalClick = function (params) {
    return { evid: 1129, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editsitecolorsLearnmoreLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editsitecolors_learnmore_link_click. Evid: 214.
 * Event description: editsitecolors_learnmore_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editsitecolorsLearnmoreLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editsitecolorsLearnmoreLinkClick = function (params) {
    return { evid: 214, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} languageDropPanelRadioButtonParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hosting - ‘preview’,’editor’
* @property {boolean} is_primary - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_visible - the language
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} lang - {}
* @property {string} multilingual - null
* @property {string} origin - “top_ber”, “secondary_bar”
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: LANGUAGE_DROP_PANEL_radio_button. Evid: 689.
 * Event description: choose lang from LANGUAGE_DROP_PANEL.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hosting - Type: string. Desc: ‘preview’,’editor’
 *
 * is_primary - Type: bool. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_visible - Type: bool. Desc: the language
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * lang - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: “top_ber”, “secondary_bar”
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {languageDropPanelRadioButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var languageDropPanelRadioButton = function (params) {
    return { evid: 689, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lottieAnimationUrlChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} new_value - New animation link
* @property {string} old_value - Prev animation link
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: lottie_animation_url_changed. Evid: 1347.
 * Event description: lottie_animation_url_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_value - Type: string. Desc: New animation link
 *
 * old_value - Type: string. Desc: Prev animation link
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {lottieAnimationUrlChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lottieAnimationUrlChanged = function (params) {
    return { evid: 1347, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkPanelHelpClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: link_panel_help_click. Evid: 163.
 * Event description: link_panel_help_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {linkPanelHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkPanelHelpClick = function (params) {
    return { evid: 163, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_new_site - {true/false}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle - {on/off}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_toggle. Evid: 777.
 * Event description: toggle on/off animation.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_new_site - Type: bool. Desc: {true/false}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: {on/off}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {animationToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationToggle = function (params) {
    return { evid: 777, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inactiveAddPageButtonTooltipShownParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - pages_panel / add_panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: inactive add page button tooltip shown. Evid: 964.
 * Event description: inactive add page button tooltip is shown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: pages_panel / add_panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {inactiveAddPageButtonTooltipShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inactiveAddPageButtonTooltipShown = function (params) {
    return { evid: 964, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsArtistNameChangedParams
* @property {string} comp_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.artistName.changed. Evid: 1207.
 * Event description: artist name in Audio Player settings was changed.

 * comp_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsArtistNameChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsArtistNameChanged = function (params) {
    return { evid: 1207, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMainButtonClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} button_state - {installed, promotional}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_main_button_click. Evid: 169.
 * Event description: site_app_main_button_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * button_state - Type: string. Desc: {installed, promotional}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMainButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMainButtonClick = function (params) {
    return { evid: 169, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationPageMigrationErrorParams
* @property {string} components_json - null
* @property {number} components_number - number of components on migrated page
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration of migration
* @property {string} errorMessage - error message
* @property {GUID} esi - {}
* @property {string} grouping_source - prediction/labelling
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - null
* @property {string} pageId - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - page migration error. Evid: 1290.
 * Event description: Page Migration to sections error.

 * components_json - Type: string.
 *
 * components_number - Type: numeric. Desc: number of components on migrated page
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration of migration
 *
 * errorMessage - Type: string. Desc: error message
 *
 * esi - Type: guid. Desc: {}
 *
 * grouping_source - Type: string. Desc: prediction/labelling
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string.
 *
 * pageId - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationPageMigrationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationPageMigrationError = function (params) {
    return { evid: 1290, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoQuotaBannerShowParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - Editor Session Id
* @property {boolean} is_ascend - 0,1
* @property {boolean} is_premium - 0,1
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {number} video_time_quota - milliseconds
* @property {number} video_time_remaining - milliseconds
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Video.Quota.Banner.Show. Evid: 1070.
 * Event description: Event fires when video quota banner appears.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: Editor Session Id
 *
 * is_ascend - Type: bool. Desc: 0,1
 *
 * is_premium - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_time_quota - Type: numeric. Desc: milliseconds
 *
 * video_time_remaining - Type: numeric. Desc: milliseconds
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoQuotaBannerShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoQuotaBannerShow = function (params) {
    return { evid: 1070, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} xClickInWelcomeScreenPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: X click in welcome screen panel. Evid: 884.
 * Event description: X click at the welcome screen panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {xClickInWelcomeScreenPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var xClickInWelcomeScreenPanel = function (params) {
    return { evid: 884, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateSectionDragParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_SECTION_DRAG. Evid: 636.
 * Event description: frame view rate for SECTION_DRAG.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateSectionDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateSectionDrag = function (params) {
    return { evid: 636, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} layerDragParams
* @property {number} current_position_index - {1, 2, 3...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layer_name - {}
* @property {string} multilingual - null
* @property {boolean} out_of_grid - if element currently is out of grid (true/false)
* @property {string} panel_origin - send the location from where the 'Layers panel' was opened
* @property {number} previous_position_index - {1, 2, 3...}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: layer_move_up_down. Evid: 809.
 * Event description: drag a specific layer in the panel.

 * current_position_index - Type: numeric. Desc: {1, 2, 3...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layer_name - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * out_of_grid - Type: bool. Desc: if element currently is out of grid (true/false)
 *
 * panel_origin - Type: string. Desc: send the location from where the 'Layers panel' was opened
 *
 * previous_position_index - Type: numeric. Desc: {1, 2, 3...}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {layerDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var layerDrag = function (params) {
    return { evid: 809, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} urlTooltipNotificationClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: url_tooltip_notification_clicked. Evid: 546.
 * Event description: url_tooltip_notification_clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {urlTooltipNotificationClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var urlTooltipNotificationClicked = function (params) {
    return { evid: 546, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputElementsDesignableDropdownListTypeParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} value - custom / browser
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Input elements - designable dropdown - list type. Evid: 1337.
 * Event description: the user clicks on the radio button of 'list type' (custom or browser).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * value - Type: string. Desc: custom / browser
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {inputElementsDesignableDropdownListTypeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputElementsDesignableDropdownListType = function (params) {
    return { evid: 1337, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelMoveFocalPointClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->move focal point click. Evid: 940.
 * Event description: This event will be sent every time a user clicks on the move focal point option.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelMoveFocalPointClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelMoveFocalPointClick = function (params) {
    return { evid: 940, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelIndentationClickParams
* @property {string} category - {right, left}
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Indentation_Click. Evid: 238.
 * Event description: Text_Panel_Indentation_Click.

 * category - Type: string. Desc: {right, left}
 *
 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelIndentationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelIndentationClick = function (params) {
    return { evid: 238, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishConnectDomainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - user_status
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_connect_domain_click. Evid: 443.
 * Event description: Second_Publish_connect_domain_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: user_status
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishConnectDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishConnectDomainClick = function (params) {
    return { evid: 443, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} wixSearchAppSetTrendingChangedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} isEnabled - t / f
* @property {boolean} is_rollout - t / f
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: wixSearch.appSet.trending.changed. Evid: 1340.
 * Event description: The user changed the trending button toggle in settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * isEnabled - Type: bool. Desc: t / f
 *
 * is_rollout - Type: bool. Desc: t / f
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {wixSearchAppSetTrendingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixSearchAppSetTrendingChanged = function (params) {
    return { evid: 1340, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} autowritingFailedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} errorMessage - Error message
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {number} timeUntilError - time until error
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Autowiring failed. Evid: 1465.
 * Event description: Autowiring failed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * errorMessage - Type: string. Desc: Error message
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * timeUntilError - Type: numeric. Desc: time until error
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {autowritingFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autowritingFailed = function (params) {
    return { evid: 1465, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} forcePushClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} revision - revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} step - 1st, final
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Force push clicked. Evid: 903.
 * Event description: Fires when a user approves the first panel of force-pushes of an older revision to the online editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * revision - Type: numeric. Desc: revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * step - Type: string. Desc: 1st, final
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {forcePushClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forcePushClicked = function (params) {
    return { evid: 903, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hiddenElementsTooltipActionClickedParams
* @property {string} action - {settings, X}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hidden_elements_tooltip_action_clicked. Evid: 621.
 * Event description: hidden_elements_tooltip_action_clicked.

 * action - Type: string. Desc: {settings, X}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hiddenElementsTooltipActionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hiddenElementsTooltipActionClicked = function (params) {
    return { evid: 621, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} learnMoreClickWithBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Learn More click (with back option). Evid: 481.
 * Event description: With back to old editor option: Learn More click: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {learnMoreClickWithBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var learnMoreClickWithBackOption = function (params) {
    return { evid: 481, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAnchorUrlErrorDisplayedParams
* @property {string} componentId - section/anchor component id
* @property {string} componentName - name of the section/anchor
* @property {string} componentType - section/anchor component type
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {string} errorDetails - error message
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} pageId - page where section/anchor is placed
* @property {string} pageName - name of the page where section/anchor is placed
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Section/Anchor URL - Error displayed. Evid: 1407.
 * Event description: User edits section/anchor url suffix in Section/Anchor URL collapsable menu and gets exposed to one of the errors in Settings Panel..

 * componentId - Type: string. Desc: section/anchor component id
 *
 * componentName - Type: string. Desc: name of the section/anchor
 *
 * componentType - Type: string. Desc: section/anchor component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * errorDetails - Type: string. Desc: error message
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * pageId - Type: string. Desc: page where section/anchor is placed
 *
 * pageName - Type: string. Desc: name of the page where section/anchor is placed
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionAnchorUrlErrorDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAnchorUrlErrorDisplayed = function (params) {
    return { evid: 1407, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} repeaterSpacingChangedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: repeater_spacing_changed. Evid: 743.
 * Event description: repeater_spacing_changed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {repeaterSpacingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var repeaterSpacingChanged = function (params) {
    return { evid: 743, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelHeaderCloseParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} element_name - element_name
* @property {GUID} esi - null
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Esc., 'x', Click outside, background_click, section_double_click}
* @property {string} panel_correlation_id - id, which should change after panel was closed
* @property {string} panel_name - {Translation Key}
* @property {string} parent_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened
* @property {string} section_correlation_id - id, which should change after layout section panel was closed
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
* @property {number} timeSpent - time from 309 open event in ms
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} editor_working_mode - desktop, mobile
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_Header_Close. Evid: 345.
 * Event description: Panel_Header_Close.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid.
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside, background_click, section_double_click}
 *
 * panel_correlation_id - Type: string. Desc: id, which should change after panel was closed
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * parent_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout section panel was closed
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
 *
 * timeSpent - Type: numeric. Desc: time from 309 open event in ms
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * editor_working_mode - Type: string. Desc: desktop, mobile
 *
 * workspace_mode - Type: string.
 * @param {panelHeaderCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelHeaderClose = function (params) {
    return { evid: 345, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishViewSiteClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_View_Site_click. Evid: 388.
 * Event description: Second_Publish_View_Site_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishViewSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishViewSiteClick = function (params) {
    return { evid: 388, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeMoveComponentParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} parent_component_id - parent component id
* @property {string} parent_component_type - parent component type
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {string} xCoordinate_new - delta X from origin
* @property {string} xCoordinate_old - prev. delta X value
* @property {string} yCoordinate_new - delta Y from origin
* @property {string} yCoordinate_old - prev. delta Y value
**/
/**
 * Name: interaction_mode_move_component. Evid: 1001.
 * Event description: Move component in interaction mode (send an event with final coordinates).

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * parent_component_id - Type: string. Desc: parent component id
 *
 * parent_component_type - Type: string. Desc: parent component type
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * xCoordinate_new - Type: string. Desc: delta X from origin
 *
 * xCoordinate_old - Type: string. Desc: prev. delta X value
 *
 * yCoordinate_new - Type: string. Desc: delta Y from origin
 *
 * yCoordinate_old - Type: string. Desc: prev. delta Y value
 * @param {interactionModeMoveComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeMoveComponent = function (params) {
    return { evid: 1001, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityClickAriaPannelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility - click aria pannel. Evid: 928.
 * Event description: click on the arrow of aria panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {accessibilityClickAriaPannelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityClickAriaPannel = function (params) {
    return { evid: 928, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} goToReleaseManagerClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor, editor1.4
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - click origin
* @property {string} panel_name - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Go to release manager clicked. Evid: 895.
 * Event description: Fires when a user clicks on 'Go to release manager'  from the release candidate creation panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor, editor1.4
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: click origin
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {goToReleaseManagerClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goToReleaseManagerClicked = function (params) {
    return { evid: 895, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorTextPimpleParams
* @property {string} actionName - shown / hover / click
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - session id
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - quick edit / text container
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - .
**/
/**
 * Name: AI Text Generator - text pimple. Evid: 1466.
 * Event description: actions around text pimple in AI Text Generator.

 * actionName - Type: string. Desc: shown / hover / click
 *
 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: session id
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: quick edit / text container
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string. Desc: .
 * @param {aiTextGeneratorTextPimpleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorTextPimple = function (params) {
    return { evid: 1466, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dataActionClickParams
* @property {string} collection_id - {collection id}
* @property {string} collection_name - {collection name}
* @property {string} collection_type - {collection permission preset}
* @property {string} dm_version - null
* @property {string} ds_id - {ds_id}
* @property {string} ds_name - {ds_name}
* @property {string} ds_origin - null
* @property {string} ds_type - {read,write,read&write}
* @property {GUID} esi - {esi}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} source - {data_menu_panel}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {collection}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: DATA_action_click. Evid: 825.
 * Event description: DATA_action_click.

 * collection_id - Type: string. Desc: {collection id}
 *
 * collection_name - Type: string. Desc: {collection name}
 *
 * collection_type - Type: string. Desc: {collection permission preset}
 *
 * dm_version - Type: string.
 *
 * ds_id - Type: string. Desc: {ds_id}
 *
 * ds_name - Type: string. Desc: {ds_name}
 *
 * ds_origin - Type: string.
 *
 * ds_type - Type: string. Desc: {read,write,read&write}
 *
 * esi - Type: guid. Desc: {esi}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: {data_menu_panel}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {collection}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dataActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dataActionClick = function (params) {
    return { evid: 825, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspacePreviouscolorClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_previouscolor_click. Evid: 144.
 * Event description: ColorSpace_PreviousColor_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspacePreviouscolorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspacePreviouscolorClick = function (params) {
    return { evid: 144, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hideParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hide. Evid: 145.
 * Event description: hide.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hide = function (params) {
    return { evid: 145, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesCountStaticPagesCountParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {number} pages_count - 1/4/50/70/100 etc
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: pages_count -> static_pages_count. Evid: 966.
 * Event description: site menu opened, the number of static pages specified.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * pages_count - Type: numeric. Desc: 1/4/50/70/100 etc
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {pagesCountStaticPagesCountParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesCountStaticPagesCount = function (params) {
    return { evid: 966, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} megaMenuAdvancedMenuUnlockedLockedParams
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} homepage_displaying - null
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} menuId - menuId
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} source - from which entry point user added/removed advanced menu
* @property {string} stage_type - null
* @property {string} status - locked/unlocked
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Mega Menu - Advanced Menu Unlocked/Locked. Evid: 1356.
 * Event description: Mega Menu - Advanced Menu Unlocked/Locked.

 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * homepage_displaying - Type: string.
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * menuId - Type: string. Desc: menuId
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: from which entry point user added/removed advanced menu
 *
 * stage_type - Type: string.
 *
 * status - Type: string. Desc: locked/unlocked
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {megaMenuAdvancedMenuUnlockedLockedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var megaMenuAdvancedMenuUnlockedLocked = function (params) {
    return { evid: 1356, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsChangeBackgroundParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} preset_id - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_change_background. Evid: 582.
 * Event description: columns_change_background.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * preset_id - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsChangeBackgroundParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsChangeBackground = function (params) {
    return { evid: 582, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} expandOfferingParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {number} cycle_id - {3,6..}
* @property {string} cycle_name - {monthly, yearly...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pp_origin - {fpp}
* @property {string} pp_type - {offering, package, cycle}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: expand_offering. Evid: 188.
 * Event description: expand_offering.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * cycle_id - Type: numeric. Desc: {3,6..}
 *
 * cycle_name - Type: string. Desc: {monthly, yearly...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pp_origin - Type: string. Desc: {fpp}
 *
 * pp_type - Type: string. Desc: {offering, package, cycle}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {expandOfferingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var expandOffering = function (params) {
    return { evid: 188, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateResizePushParams
* @property {string} component_id - id of the component
* @property {string} component_type - type of the component
* @property {string} devMode - dev mode on/off
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_RESIZE_PUSH. Evid: 696.
 * Event description: frame view rate for RESIZE_PUSH.

 * component_id - Type: string. Desc: id of the component
 *
 * component_type - Type: string. Desc: type of the component
 *
 * devMode - Type: string. Desc: dev mode on/off
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateResizePushParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateResizePush = function (params) {
    return { evid: 696, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} finishActivatingAccessibilityKeyboardParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration from click
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: finish activating accessibility keyboard. Evid: 695.
 * Event description: finish activating keyboard accessibility.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration from click
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {finishActivatingAccessibilityKeyboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var finishActivatingAccessibilityKeyboard = function (params) {
    return { evid: 695, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelDesignTabClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} tab - Category tab index (fill, border, corners etc...)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel ---> design  tab click. Evid: 931.
 * Event description: This event will be sent every time a user clicks on the button design tabs.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * tab - Type: string. Desc: Category tab index (fill, border, corners etc...)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelDesignTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelDesignTabClick = function (params) {
    return { evid: 931, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} guideDraggedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {string} xCoordinate_new - {}
* @property {string} xCoordinate_old - {}
* @property {string} yCoordinate_new - {}
* @property {string} yCoordinate_old - {}
**/
/**
 * Name: Guide dragged. Evid: 523.
 * Event description: Guilde dragged to new position.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * xCoordinate_new - Type: string. Desc: {}
 *
 * xCoordinate_old - Type: string. Desc: {}
 *
 * yCoordinate_new - Type: string. Desc: {}
 *
 * yCoordinate_old - Type: string. Desc: {}
 * @param {guideDraggedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var guideDragged = function (params) {
    return { evid: 523, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorNotificationShownParams
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - session id
* @property {string} fieldName - .
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} message - .
* @property {string} multilingual - -
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} panelType - one sided/double sided
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} type - type of notification
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - .
**/
/**
 * Name: AI Text Generator - notification shown. Evid: 1467.
 * Event description: AI Text Generator - notification shown.

 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: session id
 *
 * fieldName - Type: string. Desc: .
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * message - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * panelType - Type: string. Desc: one sided/double sided
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * type - Type: string. Desc: type of notification
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string. Desc: .
 * @param {aiTextGeneratorNotificationShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorNotificationShown = function (params) {
    return { evid: 1467, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickUpgradeInTpaPpParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pp_origin - {fpp}
* @property {string} pp_type - {offering, package, cycle}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_upgrade_in_TPA_PP -not in use. Evid: 186.
 * Event description: click_upgrade_in_TPA_PP.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pp_origin - Type: string. Desc: {fpp}
 *
 * pp_type - Type: string. Desc: {offering, package, cycle}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickUpgradeInTpaPpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickUpgradeInTpaPp = function (params) {
    return { evid: 186, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutUnsupportedLayoutOpenParams
* @property {string} black_list - json with blacklisted components
* @property {string} component_id - null
* @property {string} component_type - component type
* @property {string} data_science_classification - field that classifies the WrichText
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {string} input_components_ids - json with component_ids inside section
* @property {string} inputJson - json with component_type and component_id of all components in the preset
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_list - whether the section contains lists (true/false)
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} panel_type - quickEditPanel / switch_layout
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {string} section_name_personal - name of the section assigned by the user, if the user did not change the name then send a technical name)
* @property {string} section_name_technical - name of the section (welcome, about, e.t.c)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - null
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - Unsupported layout open. Evid: 1301.
 * Event description: user opened unsupported layout.

 * black_list - Type: string. Desc: json with blacklisted components
 *
 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component type
 *
 * data_science_classification - Type: string. Desc: field that classifies the WrichText
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * input_components_ids - Type: string. Desc: json with component_ids inside section
 *
 * inputJson - Type: string. Desc: json with component_type and component_id of all components in the preset
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_list - Type: bool. Desc: whether the section contains lists (true/false)
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * panel_type - Type: string. Desc: quickEditPanel / switch_layout
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * section_name_personal - Type: string. Desc: name of the section assigned by the user, if the user did not change the name then send a technical name)
 *
 * section_name_technical - Type: string. Desc: name of the section (welcome, about, e.t.c)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutUnsupportedLayoutOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutUnsupportedLayoutOpen = function (params) {
    return { evid: 1301, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} toolBarMatchSizeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tool_Bar_Match_Size_click. Evid: 265.
 * Event description: Tool_Bar_Match_Size_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toolBarMatchSizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolBarMatchSizeClick = function (params) {
    return { evid: 265, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarEditMenuClickParams
* @property {string} category - {Undo, Redo , Cut, Copy...}
* @property {string} component_id - {a,b,c...}
* @property {string} component_type - {button....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_EDIT_menu_click. Evid: 288.
 * Event description: top_bar_EDIT_menu_click.

 * category - Type: string. Desc: {Undo, Redo , Cut, Copy...}
 *
 * component_id - Type: string. Desc: {a,b,c...}
 *
 * component_type - Type: string. Desc: {button....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarEditMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarEditMenuClick = function (params) {
    return { evid: 288, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myElementsConfirmDeletionFromLibraryParams
* @property {string} content_type - content_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} element_id - id generated when adding new element to "my elements"
* @property {string} error_msg - error message
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - deletion success
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.confirm_deletion_from_library. Evid: 961.
 * Event description: Deleting element from "my elements".

 * content_type - Type: string. Desc: content_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_id - Type: guid. Desc: id generated when adding new element to "my elements"
 *
 * error_msg - Type: string. Desc: error message
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: deletion success
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {myElementsConfirmDeletionFromLibraryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myElementsConfirmDeletionFromLibrary = function (params) {
    return { evid: 961, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchLinkClickParams
* @property {string} button - help / app_market etc
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.link.click. Evid: 994.
 * Event description: Click on Links in search results.

 * button - Type: string. Desc: help / app_market etc
 *
 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchLinkClick = function (params) {
    return { evid: 994, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeVideoScrollClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_video_scroll_click. Evid: 1095.
 * Event description: Event fires when scrolling videos inside the step-by-step videos section, under the help home panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeVideoScrollClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeVideoScrollClick = function (params) {
    return { evid: 1095, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardBusinessFirstSiteReadyParams
* @property {string} action - Back to Dashboard, Go to Editor, View Live Site
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Business First Site Ready. Evid: 1338.
 * Event description: Fires when clicking on one of the CTAs: Back to Dashboard, Go to Editor, View Live Site.

 * action - Type: string. Desc: Back to Dashboard, Go to Editor, View Live Site
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardBusinessFirstSiteReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardBusinessFirstSiteReady = function (params) {
    return { evid: 1338, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMigrationSuccessParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration of migration
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Menu migration success. Evid: 1422.
 * Event description: Successful migration of menu.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration of migration
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {menuMigrationSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMigrationSuccess = function (params) {
    return { evid: 1422, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} turnOnIndexingInShowPdfSearchResultPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Link panel/Document Settings panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Turn ON indexing  in "Show PDF search result" panel. Evid: 880.
 * Event description: Turn on indexing - on Show PDF search result.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Link panel/Document Settings panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {turnOnIndexingInShowPdfSearchResultPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var turnOnIndexingInShowPdfSearchResultPanel = function (params) {
    return { evid: 880, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelVerticalTextToggleParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_VerticalText_toggle. Evid: 1007.
 * Event description: Text_Panel_VerticalText_toggle.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {textPanelVerticalTextToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelVerticalTextToggle = function (params) {
    return { evid: 1007, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputElementsManageItemsPanelEditLabelEndParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Input Elements - Manage Items Panel - Edit label end. Evid: 1180.
 * Event description: Edit label end in multiple choices manage items panel
Copy of event 5:1168.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {inputElementsManageItemsPanelEditLabelEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputElementsManageItemsPanelEditLabelEnd = function (params) {
    return { evid: 1180, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPluginTryParams
* @property {string} app_def_id_plugin - {id of app in plugin}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of host_app_id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {origin of adding plugin}
* @property {string} plugin_id - {id of plugin}
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} slot_id - id of slot
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Add plugin try. Evid: 1446.
 * Event description: Add plugin try.

 * app_def_id_plugin - Type: string. Desc: {id of app in plugin}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of host_app_id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {origin of adding plugin}
 *
 * plugin_id - Type: string. Desc: {id of plugin}
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * slot_id - Type: string. Desc: id of slot
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addPluginTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPluginTry = function (params) {
    return { evid: 1446, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstTimeBubbleAppearParams
* @property {string} bubble_name - {}
* @property {number} count - {number of tooltips}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} step_name - slide name
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: first_time_bubble_appear. Evid: 608.
 * Event description: first_time_bubble_appear.

 * bubble_name - Type: string. Desc: {}
 *
 * count - Type: numeric. Desc: {number of tooltips}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * step_name - Type: string. Desc: slide name
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstTimeBubbleAppearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstTimeBubbleAppear = function (params) {
    return { evid: 608, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hintShownParams
* @property {number} count - {hint counter)
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} timestamp - {min from last hints}
* @property {string} multilingual - null
* @property {string} name - {hint_name}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {ui type}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Hint shown. Evid: 625.
 * Event description: hint was shown to user.

 * count - Type: numeric. Desc: {hint counter)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * timestamp - Type: numeric. Desc: {min from last hints}
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {hint_name}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {ui type}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hintShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hintShown = function (params) {
    return { evid: 625, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarOpenSettingsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Open-Settings_click. Evid: 289.
 * Event description: top_bar_Open-Settings_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarOpenSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarOpenSettingsClick = function (params) {
    return { evid: 289, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextTypeInfoClickedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.text_type_info_clicked. Evid: 1189.
 * Event description: TextEllipsis.text_type_info_clicked.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextTypeInfoClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextTypeInfoClicked = function (params) {
    return { evid: 1189, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} horizontalMenuScrollClickParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {string} handle_value - {1,2,3....}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {tool bar, handle}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: horizontal_menu_scroll_click. Evid: 1055.
 * Event description: send when user try to click on scroll button.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * handle_value - Type: string. Desc: {1,2,3....}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {tool bar, handle}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {horizontalMenuScrollClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var horizontalMenuScrollClick = function (params) {
    return { evid: 1055, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} removeComponent2ndStepClick217Params
* @property {string} app_id - guid
* @property {string} app_site_id - guid
* @property {string} component_id - {a,b,c...}
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_last - 0,1
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} removal_method - (X,cut,undo...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: remove component 2nd step click. Evid: 217.
 * Event description: remove component 2nd step click.

 * app_id - Type: string. Desc: guid
 *
 * app_site_id - Type: string. Desc: guid
 *
 * component_id - Type: string. Desc: {a,b,c...}
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_last - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * removal_method - Type: string. Desc: (X,cut,undo...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {removeComponent2ndStepClick217Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeComponent2ndStepClick217 = function (params) {
    return { evid: 217, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppPromotionalInstallAgreeClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog, forum, ....}
* @property {string} dm_version - null
* @property {string} ds_origin -
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_promotional_install_agree_click. Evid: 193.
 * Event description: site_app_promotional_install_agree_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog, forum, ....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppPromotionalInstallAgreeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppPromotionalInstallAgreeClick = function (params) {
    return { evid: 193, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} megaMenuMenuModeEndedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} container_id - Component id of selected container
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {number} duration - Duration of menu mode working in sec
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} item_id - The id of the mega menu item in edit mode
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} menuId - menuId
* @property {string} multilingual - multilingual
* @property {string} origin - Exit button/overlayClick
* @property {string} page_id - page id where the component was added
* @property {string} session_id - id for the edit session
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Mega Menu - Menu Mode Ended. Evid: 1392.
 * Event description: Mega Menu - Menu Mode Ended.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * container_id - Type: string. Desc: Component id of selected container
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * duration - Type: numeric. Desc: Duration of menu mode working in sec
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * item_id - Type: string. Desc: The id of the mega menu item in edit mode
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * menuId - Type: string. Desc: menuId
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: Exit button/overlayClick
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * session_id - Type: string. Desc: id for the edit session
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {megaMenuMenuModeEndedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var megaMenuMenuModeEnded = function (params) {
    return { evid: 1392, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editDomainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_save - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} save_or_publish - {save, publish}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_domain_click. Evid: 450.
 * Event description: edit_domain_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_save - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * save_or_publish - Type: string. Desc: {save, publish}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editDomainClick = function (params) {
    return { evid: 450, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterUseTextClickParams
* @property {string} actionOrigin - create_text / regenerate
* @property {string} businessType - {industry:”x”; structure: “y”} or null
* @property {string} clickOrigin - use_text / copy
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {number} duration - GPT injection to site: time from ‘createText.click’ to timestamp when all texts were injected
* @property {GUID} esi - editor session id
* @property {boolean} isAiTextCreator - Smart Writer / Ai Text Creator
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - quick edit / text container / gfpp / rcm
* @property {string} panelType - single sided / double sided
* @property {string} sectionType - topic of the test/section type in json format
* @property {string} sessionId - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} subject - subject
* @property {string} text - text itself
* @property {string} textId - text option id
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.useText.click. Evid: 1035.
 * Event description: Smart Writer click on Use text or Copy.

 * actionOrigin - Type: string. Desc: create_text / regenerate
 *
 * businessType - Type: string. Desc: {industry:”x”; structure: “y”} or null
 *
 * clickOrigin - Type: string. Desc: use_text / copy
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * duration - Type: numeric. Desc: GPT injection to site: time from ‘createText.click’ to timestamp when all texts were injected
 *
 * esi - Type: guid. Desc: editor session id
 *
 * isAiTextCreator - Type: bool. Desc: Smart Writer / Ai Text Creator
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: quick edit / text container / gfpp / rcm
 *
 * panelType - Type: string. Desc: single sided / double sided
 *
 * sectionType - Type: string. Desc: topic of the test/section type in json format
 *
 * sessionId - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * subject - Type: string. Desc: subject
 *
 * text - Type: string. Desc: text itself
 *
 * textId - Type: string. Desc: text option id
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterUseTextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterUseTextClick = function (params) {
    return { evid: 1035, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuChangeThemeFontsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> change theme fonts click. Evid: 113.
 * Event description: add menu -> change theme fonts click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuChangeThemeFontsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuChangeThemeFontsClick = function (params) {
    return { evid: 113, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuClickedAnItemAtSettingsMenuParams
* @property {string} category - {go to site members ,member sign up settings, Members URL settings etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - {main, members, custom, blog, store, lightbox,router, dynamic page}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_menu_Clicked_an_item_at_settings_menu. Evid: 706.
 * Event description: PAGES_menu_Clicked_an_item_at_settings_menu.

 * category - Type: string. Desc: {go to site members ,member sign up settings, Members URL settings etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main, members, custom, blog, store, lightbox,router, dynamic page}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuClickedAnItemAtSettingsMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuClickedAnItemAtSettingsMenu = function (params) {
    return { evid: 706, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openMarketClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_pending_apps - {0,1,2...}
* @property {string} referral_info - {market_button, add_panel...}
* @property {string} referral_info_category - {text, gallery...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open_market_click. Evid: 164.
 * Event description: open_market_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_pending_apps - Type: numeric. Desc: {0,1,2...}
 *
 * referral_info - Type: string. Desc: {market_button, add_panel...}
 *
 * referral_info_category - Type: string. Desc: {text, gallery...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openMarketClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openMarketClick = function (params) {
    return { evid: 164, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} choosingHowSsrCacheWillWorkParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pageId - xyz
* @property {string} selection - (Auto/Manual)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: choosing how  SSR cache will work. Evid: 897.
 * Event description: choosing how  SSR cache will work.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pageId - Type: string. Desc: xyz
 *
 * selection - Type: string. Desc: (Auto/Manual)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {choosingHowSsrCacheWillWorkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var choosingHowSsrCacheWillWork = function (params) {
    return { evid: 897, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsLayoutMigrationReparentParams
* @property {string} component_id - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_container_id - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {boolean} z_index_changed - {}
**/
/**
 * Name: SectionsLayoutMigration_reparent. Evid: 753.
 * Event description: Reparenting a component during SectionsLayoutMigration fixer.

 * component_id - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_container_id - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * z_index_changed - Type: bool. Desc: {}
 * @param {sectionsLayoutMigrationReparentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsLayoutMigrationReparent = function (params) {
    return { evid: 753, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pasteComponentOrTpaParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} component_id - .
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_component_pinned - 0,1
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - Keyboard
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - []
* @property {string} workspace_mode - null
**/
/**
 * Name: paste_component_or_TPA. Evid: 182.
 * Event description: paste_component_or_TPA.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_component_pinned - Type: bool. Desc: 0,1
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: Keyboard
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: []
 *
 * workspace_mode - Type: string.
 * @param {pasteComponentOrTpaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pasteComponentOrTpa = function (params) {
    return { evid: 182, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardLogoClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - add / edit / replace / delete
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - Wizard screen name
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Logo click. Evid: 1254.
 * Event description: Site Creation Wizard: Logo click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: add / edit / replace / delete
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: Wizard screen name
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardLogoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardLogoClick = function (params) {
    return { evid: 1254, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionDropDownMenuChangedParams
* @property {string} component_id - id of selected section
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} panel_name - edit_section_button_settings / edit_section_image_settings
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: drop down menu changed. Evid: 1376.
 * Event description: user changed value in drop down menu.

 * component_id - Type: string. Desc: id of selected section
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * panel_name - Type: string. Desc: edit_section_button_settings / edit_section_image_settings
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionDropDownMenuChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionDropDownMenuChanged = function (params) {
    return { evid: 1376, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changeColorSchemeParams
* @property {string} component_type - component type edited
* @property {string} control_name - Control Label
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - Translation Key
* @property {string} section_name - Section Label
* @property {string} value - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: change_color_scheme. Evid: 718.
 * Event description: change_color_scheme_quick_action_bar.

 * component_type - Type: string. Desc: component type edited
 *
 * control_name - Type: string. Desc: Control Label
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: Translation Key
 *
 * section_name - Type: string. Desc: Section Label
 *
 * value - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {changeColorSchemeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeColorScheme = function (params) {
    return { evid: 718, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} successPublishProcessParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - time
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar/dialog
* @property {string} platform - {editor/app_studio}
* @property {string} publish_type - partial/full/first
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: success_publish_process. Evid: 467.
 * Event description: success_publish_process.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: time
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar/dialog
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * publish_type - Type: string. Desc: partial/full/first
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {successPublishProcessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var successPublishProcess = function (params) {
    return { evid: 467, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myElementsSaveElementsParams
* @property {string} components - if content_type <> multiselect then  content_type else list of multiselect components
* @property {string} content_type - container/group/multiselect/text/image
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} element_id - element id
* @property {string} element_name - element name
* @property {string} element_source - saved site/unsaved site
* @property {string} error_msg - error message
* @property {GUID} esi - null
* @property {boolean} full_saved - true if component was fully saved to My design; false if it was saved partially, with come elements missed
* @property {string} funnel_id - synthetic variable to match try and success of creating my design
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - rcm/..
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - element saving success
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.save_elements. Evid: 958.
 * Event description: Saving elements to "my elements".

 * components - Type: string. Desc: if content_type <> multiselect then  content_type else list of multiselect components
 *
 * content_type - Type: string. Desc: container/group/multiselect/text/image
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_id - Type: guid. Desc: element id
 *
 * element_name - Type: string. Desc: element name
 *
 * element_source - Type: string. Desc: saved site/unsaved site
 *
 * error_msg - Type: string. Desc: error message
 *
 * esi - Type: guid.
 *
 * full_saved - Type: bool. Desc: true if component was fully saved to My design; false if it was saved partially, with come elements missed
 *
 * funnel_id - Type: string. Desc: synthetic variable to match try and success of creating my design
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: rcm/..
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: element saving success
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {myElementsSaveElementsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myElementsSaveElements = function (params) {
    return { evid: 958, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationScrollEffectPanelDropDownOpenParams
* @property {string} dm_version - dm_version
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_scroll_effect_panel_drop_down_open. Evid: 1428.
 * Event description: The event fires when clicking on the drop down menu to choose a specific panel: animation / scroll_effecrt.

 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {animationScrollEffectPanelDropDownOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationScrollEffectPanelDropDownOpen = function (params) {
    return { evid: 1428, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - done
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_close. Evid: 420.
 * Event description: PAGES_settings_back_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: done
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsClose = function (params) {
    return { evid: 420, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarCodeMenuClickParams
* @property {string} category - {dev_mode}
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {string} editor_view_mode - -
* @property {GUID} esi - {Editor session id}
* @property {string} initiator_name - {manual, auto-acquisition, auto-intro funnel}
* @property {boolean} is_data_on - {true, false}
* @property {boolean} is_first - true = first time dev mode was turned on. (first per msid and logged in uuid}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {auto,manual}
* @property {GUID} site_id - {msid}
* @property {string} stage_type - null
* @property {boolean} status - {true, false}
* @property {string} sub_origin - {exposure, query}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_CODE_menu_click. Evid: 790.
 * Event description: (top_bar_CODE_menu_click) user changes his dev mode on/off.

 * category - Type: string. Desc: {dev_mode}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * editor_view_mode - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: {Editor session id}
 *
 * initiator_name - Type: string. Desc: {manual, auto-acquisition, auto-intro funnel}
 *
 * is_data_on - Type: bool. Desc: {true, false}
 *
 * is_first - Type: bool. Desc: true = first time dev mode was turned on. (first per msid and logged in uuid}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {auto,manual}
 *
 * site_id - Type: guid. Desc: {msid}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {true, false}
 *
 * sub_origin - Type: string. Desc: {exposure, query}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarCodeMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarCodeMenuClick = function (params) {
    return { evid: 790, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editDomainSaveClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_save - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} save_or_publish - {save, publish}
* @property {string} siteDisplayName - site_display_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_domain_save_click. Evid: 446.
 * Event description: Edit_domain_save_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_save - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * save_or_publish - Type: string. Desc: {save, publish}
 *
 * siteDisplayName - Type: string. Desc: site_display_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editDomainSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editDomainSaveClick = function (params) {
    return { evid: 446, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardNotificationParams
* @property {string} action - shown / hover / click
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} key - key for the message
* @property {string} message - enter valid email / wrong url format / ...
* @property {string} multilingual - .
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - Wizard screen name
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Notification. Evid: 1255.
 * Event description: Site Creation Wizard: Notification.

 * action - Type: string. Desc: shown / hover / click
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * key - Type: string. Desc: key for the message
 *
 * message - Type: string. Desc: enter valid email / wrong url format / ...
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: Wizard screen name
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardNotification = function (params) {
    return { evid: 1255, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} musicCampaignDonTShowThisAgainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - {0,1}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: music_campaign_don't_show_this_again_click. Evid: 307.
 * Event description: music_campaign_don't_show_this_again_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {0,1}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {musicCampaignDonTShowThisAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var musicCampaignDonTShowThisAgainClick = function (params) {
    return { evid: 307, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelToggleParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {}
* @property {boolean} toggle - {}
* @property {string} toggleName - {}
* @property {string} toggle_name - toggle_name
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel ---> toggle. Evid: 937.
 * Event description: This event will be sent every time a user touch the toggle.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {}
 *
 * toggle - Type: bool. Desc: {}
 *
 * toggleName - Type: string. Desc: {}
 *
 * toggle_name - Type: string. Desc: toggle_name
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelToggle = function (params) {
    return { evid: 937, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPreviewPageEditorViewModeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop, mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Preview_Page_Editor_View_Mode_click. Evid: 295.
 * Event description: top_bar_Preview_Page_Editor_View_Mode_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop, mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPreviewPageEditorViewModeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPreviewPageEditorViewModeClick = function (params) {
    return { evid: 295, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageAddNewPageClick1072Params
* @property {string} app_list - list of the apps
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} button - dd_page_modal / preview / add_shop_page
* @property {string} category - {page, link, dropdown menu, popup, dynamic page}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_injected_content - true if content was already injected
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - name of the page
* @property {string} origin - From where user opened pages panel
* @property {string} page_id - page_id
* @property {GUID} site_id - {}
* @property {string} source - {main menu,  members menu, custom menu, store, lightbox, router, router welcome}
* @property {string} stage_type - null
* @property {string} target - blank/about/project/contact/stores/etc
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - new page added successfully. Evid: 1072.
 * Event description: User chose to add new Page from templates or just click Add Blank and page was added successfully.                                        NOTE!!! when Wix Forms (app_list =14ce1214-b278-a7e4-1373-00cebd1bef7c) wasn't added this event is still comping but without page_id.

 * app_list - Type: string. Desc: list of the apps
 *
 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * button - Type: string. Desc: dd_page_modal / preview / add_shop_page
 *
 * category - Type: string. Desc: {page, link, dropdown menu, popup, dynamic page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: name of the page
 *
 * origin - Type: string. Desc: From where user opened pages panel
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu,  members menu, custom menu, store, lightbox, router, router welcome}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: blank/about/project/contact/stores/etc
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageAddNewPageClick1072Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageAddNewPageClick1072 = function (params) {
    return { evid: 1072, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pluginMovedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - parent_app_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} plugin_id - plugin_id
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} slot_id_current - slot_id_current
* @property {string} slot_id_previous - slot_id_previous
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Plugin moved. Evid: 1451.
 * Event description: Plugin moved.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: parent_app_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * plugin_id - Type: string. Desc: plugin_id
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * slot_id_current - Type: string. Desc: slot_id_current
 *
 * slot_id_previous - Type: string. Desc: slot_id_previous
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pluginMovedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginMoved = function (params) {
    return { evid: 1451, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonManageContentTabClickedSettingsParams
* @property {string} actionName - settings/view_all_collections/advanced_settings
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} isEmptyState - T/F
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button > Manage Content Tab > Clicked settings. Evid: 1266.
 * Event description: 6th Button > Manage Content Tab > Clicked settings. there are 3 types of settings clicks.

 * actionName - Type: string. Desc: settings/view_all_collections/advanced_settings
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * isEmptyState - Type: bool. Desc: T/F
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonManageContentTabClickedSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonManageContentTabClickedSettings = function (params) {
    return { evid: 1266, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rightClickMenuCategoryOpenParams
* @property {string} category - "Overlapping Items" / "Arrange"
* @property {string} component - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: right click menu --> category open. Evid: 967.
 * Event description: open category "Overlapping Items" / "Arrange" in right-click menu.

 * category - Type: string. Desc: "Overlapping Items" / "Arrange"
 *
 * component - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rightClickMenuCategoryOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rightClickMenuCategoryOpen = function (params) {
    return { evid: 967, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} donTShowAgainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - panel name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle - on/off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: don't_show_again_click. Evid: 798.
 * Event description: don't_show_again_click for pop-ups in the editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: panel name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: on/off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {donTShowAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var donTShowAgainClick = function (params) {
    return { evid: 798, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorIntendToOpenPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_intend - {true/false}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_type - {panel type that is intended to open}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: AI Text Generator - intend to open panel. Evid: 1494.
 * Event description: AI Text Generator - intend to open panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_intend - Type: bool. Desc: {true/false}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_type - Type: string. Desc: {panel type that is intended to open}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {aiTextGeneratorIntendToOpenPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorIntendToOpenPanel = function (params) {
    return { evid: 1494, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} blogLeftPanelOpenBlogManagerClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {open blog manager, add new post}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: blog_left_panel_open_blog_manager_click. Evid: 423.
 * Event description: blog_left_panel_open_blog_manager_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {open blog manager, add new post}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {blogLeftPanelOpenBlogManagerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var blogLeftPanelOpenBlogManagerClick = function (params) {
    return { evid: 423, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} previewClick250Params
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_dev_mode - online indication of Dev mode on/off
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - test_site/ preview
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: preview_click. Evid: 250.
 * Event description: preview_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_dev_mode - Type: bool. Desc: online indication of Dev mode on/off
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: test_site/ preview
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {previewClick250Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewClick250 = function (params) {
    return { evid: 250, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonManageContentClickedCreateAPresetParams
* @property {string} dm_version - dm_version
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - isZoomout
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - mode
**/
/**
 * Name: 6th Button > Manage Content > Clicked Create a Preset. Evid: 1486.
 * Event description: click the create a preset button on 6th button not empty state.

 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: isZoomout
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string. Desc: mode
 * @param {thButtonManageContentClickedCreateAPresetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonManageContentClickedCreateAPreset = function (params) {
    return { evid: 1486, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} reorderPanelClickedParams
* @property {string} action_clicked - {move up, move down, delete section, delete space, hide section}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop zoom, mobile zoom, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: reorder_panel_clicked. Evid: 551.
 * Event description: reorder_panel_clicked.

 * action_clicked - Type: string. Desc: {move up, move down, delete section, delete space, hide section}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop zoom, mobile zoom, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {reorderPanelClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reorderPanelClicked = function (params) {
    return { evid: 551, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerSettingsSearchPanelClickParams
* @property {string} component_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoSource - facebook / youtube / vimeo etc
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.settings.searchPanel.click. Evid: 890.
 * Event description: User clicked on Search for Videos button / link in settings.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoSource - Type: string. Desc: facebook / youtube / vimeo etc
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerSettingsSearchPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerSettingsSearchPanelClick = function (params) {
    return { evid: 890, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} horizontalScrollParams
* @property {string} dm_version - .
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - desktop, mobile
* @property {GUID} esi - esi
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - multilingual
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - horizontal_scroll_on / horizontal_scroll_off
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - .
**/
/**
 * Name: Horizontal scroll. Evid: 1492.
 * Event description: the event indicates when the horizontal scroll was applied to user's site & when it stopped.

 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: desktop, mobile
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: horizontal_scroll_on / horizontal_scroll_off
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string. Desc: .
 * @param {horizontalScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var horizontalScroll = function (params) {
    return { evid: 1492, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} imageOrBgReplacedOnStageParams
* @property {string} addingMethod - color / image / video /ai image
* @property {string} component_id - component_id
* @property {string} component_name - component_name
* @property {string} component_type - component_type
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} is_target_repeated - {true, false} Is target contained in a repeater
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} json_components_presets - json with component_type and component_id of all components in the section preset
* @property {string} multilingual - .
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - add_panel / gfpp / image_settings / section_background_settings / column_background_settings / page_background / quick_edit
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - {}
* @property {string} stage_type - .
* @property {string} target_component - {compType} //will be page if add to stage
* @property {string} target_component_id - .
* @property {string} target_component_type - target component type (specific type)
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: image or bg replaced on stage. Evid: 1506.
 * Event description: image/bg replaced on stage.

 * addingMethod - Type: string. Desc: color / image / video /ai image
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_name - Type: string. Desc: component_name
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * is_target_repeated - Type: bool. Desc: {true, false} Is target contained in a repeater
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * json_components_presets - Type: string. Desc: json with component_type and component_id of all components in the section preset
 *
 * multilingual - Type: string. Desc: .
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: add_panel / gfpp / image_settings / section_background_settings / column_background_settings / page_background / quick_edit
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string. Desc: .
 *
 * target_component - Type: string. Desc: {compType} //will be page if add to stage
 *
 * target_component_id - Type: string. Desc: .
 *
 * target_component_type - Type: string. Desc: target component type (specific type)
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {imageOrBgReplacedOnStageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var imageOrBgReplacedOnStage = function (params) {
    return { evid: 1506, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} reorderRepeaterItemParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: reorder_repeater_item. Evid: 740.
 * Event description: reorder repeater item.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {reorderRepeaterItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reorderRepeaterItem = function (params) {
    return { evid: 740, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardPageLoadingSuccessParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {number} durationToAction - ime (in ms) spent between same event from previous view and current event
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} loadTime - time (in ms) elapsed since loading started
* @property {string} multilingual - .
* @property {number} pageCount - count of pages suggested in a "add pages" screen
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - null
* @property {string} viewerName - .
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: page loading success. Evid: 1251.
 * Event description: Site Creation Wizard: page loading success.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * durationToAction - Type: numeric. Desc: ime (in ms) spent between same event from previous view and current event
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * loadTime - Type: numeric. Desc: time (in ms) elapsed since loading started
 *
 * multilingual - Type: string. Desc: .
 *
 * pageCount - Type: numeric. Desc: count of pages suggested in a "add pages" screen
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardPageLoadingSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardPageLoadingSuccess = function (params) {
    return { evid: 1251, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} enableSsrCacheForAPageToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - dynamic_page_settings_panel / pages_panel
* @property {string} pageId - xyz
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle - (TRUE,FALSE)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: enable_ssr_cache_for_a_page_toggle. Evid: 836.
 * Event description: enable_ssr_cache_for_a_page_toggle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: dynamic_page_settings_panel / pages_panel
 *
 * pageId - Type: string. Desc: xyz
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: (TRUE,FALSE)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {enableSsrCacheForAPageToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var enableSsrCacheForAPageToggle = function (params) {
    return { evid: 836, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationStopMigrationDueToUserChoiceParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor / heavySite
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Section migration - Stop migration due to user choice. Evid: 1484.
 * Event description: stop migration because user skipped migration for 3 times.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor / heavySite
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {sectionMigrationStopMigrationDueToUserChoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationStopMigrationDueToUserChoice = function (params) {
    return { evid: 1484, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} multiselectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_of_elements_selected - {num}
* @property {string} selection_method - {keyboard, lasso}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: multiselect. Evid: 127.
 * Event description: multiselect.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_of_elements_selected - Type: numeric. Desc: {num}
 *
 * selection_method - Type: string. Desc: {keyboard, lasso}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {multiselectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var multiselect = function (params) {
    return { evid: 127, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerBigPlayChangeOnPanelClosedParams
* @property {string} big_play_symbol_colors - ‘rrggbb_rrggbb’ <bg color>_<foreground color>
* @property {string} big_play_symbol_id - ‘yyy-xxxx.svg’
* @property {number} big_play_symbol_index - (1-100)
* @property {number} big_play_symbol_opacity - 0-100 (percent)
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_changed - true - if something was changed during panel usage
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video_player_big_play_change_on_panel_closed. Evid: 688.
 * Event description: sent when big play change panel closed.

 * big_play_symbol_colors - Type: string. Desc: ‘rrggbb_rrggbb’ <bg color>_<foreground color>
 *
 * big_play_symbol_id - Type: string. Desc: ‘yyy-xxxx.svg’
 *
 * big_play_symbol_index - Type: numeric. Desc: (1-100)
 *
 * big_play_symbol_opacity - Type: numeric. Desc: 0-100 (percent)
 *
 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_changed - Type: bool. Desc: true - if something was changed during panel usage
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerBigPlayChangeOnPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerBigPlayChangeOnPanelClosed = function (params) {
    return { evid: 688, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} urlTooltipNotificationDisappearedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: url_tooltip_notification_disappeared. Evid: 547.
 * Event description: url_tooltip_notification_disappeared.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {urlTooltipNotificationDisappearedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var urlTooltipNotificationDisappeared = function (params) {
    return { evid: 547, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} membersSignupSettingsSocialGoogleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} googlePlus - {true to allow}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: members signup settings social google. Evid: 639.
 * Event description: under the members signup settings panel, allow social login using google.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * googlePlus - Type: bool. Desc: {true to allow}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {membersSignupSettingsSocialGoogleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersSignupSettingsSocialGoogle = function (params) {
    return { evid: 639, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} exitLightboxModeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - from where lightbox mode was closed (gfpp \ mode_bar)
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Exit lightbox mode click. Evid: 1144.
 * Event description: Exit lightbox mode click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: from where lightbox mode was closed (gfpp \ mode_bar)
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {exitLightboxModeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var exitLightboxModeClick = function (params) {
    return { evid: 1144, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} anchorMenuManagerAddNewAnchorParams
* @property {string} component_id - anchor menu component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - type of component added (anchor / section)
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: anchor menu manager -> add new component. Evid: 1006.
 * Event description: add new anchor.

 * component_id - Type: string. Desc: anchor menu component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: type of component added (anchor / section)
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {anchorMenuManagerAddNewAnchorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var anchorMenuManagerAddNewAnchor = function (params) {
    return { evid: 1006, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editClickOnWelcomeScreenInMobileToolsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mobile_tool - {welcome screen, browser theme}
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_mobile_tool. Evid: 888.
 * Event description: In mobile tools panel, clicking on edit in three dots menu..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mobile_tool - Type: string. Desc: {welcome screen, browser theme}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editClickOnWelcomeScreenInMobileToolsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editClickOnWelcomeScreenInMobileTools = function (params) {
    return { evid: 888, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteImageQualitySettingsPanelApplyParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {site_setting}
* @property {string} preset_id - {‘custom’, ‘regular’, ‘text’, ‘nature’, ‘landscape’, ‘portrait’, ‘illustration’ }
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {number} unsharp_amount - {number}
* @property {number} unsharp_radius - {number}
* @property {number} unsharp_threshold - {number}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_image_quality_settings_panel_Apply. Evid: 516.
 * Event description: Panel_closed_as_DONE.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {site_setting}
 *
 * preset_id - Type: string. Desc: {‘custom’, ‘regular’, ‘text’, ‘nature’, ‘landscape’, ‘portrait’, ‘illustration’ }
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * unsharp_amount - Type: numeric. Desc: {number}
 *
 * unsharp_radius - Type: numeric. Desc: {number}
 *
 * unsharp_threshold - Type: numeric. Desc: {number}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteImageQualitySettingsPanelApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteImageQualitySettingsPanelApply = function (params) {
    return { evid: 516, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbTrailChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - null
* @property {string} homepage_displaying - text/icon
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - homepage>item>current page/homepage>item/item>current page
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_trail_changed. Evid: 1235.
 * Event description: breadcrumb_trail_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid.
 *
 * homepage_displaying - Type: string. Desc: text/icon
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: homepage>item>current page/homepage>item/item>current page
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbTrailChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbTrailChanged = function (params) {
    return { evid: 1235, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPopUpOpensWithBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video pop up opens (with back option). Evid: 478.
 * Event description: With back to old editor option: Intro video for existing users loads.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPopUpOpensWithBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPopUpOpensWithBackOption = function (params) {
    return { evid: 478, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisTextAppearChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {string} selection - multi-line / single-line
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.text_appear_changed. Evid: 1197.
 * Event description: TextEllipsis.text_appear_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string. Desc: multi-line / single-line
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisTextAppearChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisTextAppearChanged = function (params) {
    return { evid: 1197, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverSectionActionBarParams
* @property {string} component_id - component_id
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} firstTimeSectionFocus - true if user clicked on section once
* @property {boolean} isGfppVisible - true if section gfpp is visible
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} is_section_selected - is_section_selected
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - t/f
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - null
* @property {string} workspace_mode - .
**/
/**
 * Name: Hover section action bar. Evid: 1480.
 * Event description: hover section action bar.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * firstTimeSectionFocus - Type: bool. Desc: true if user clicked on section once
 *
 * isGfppVisible - Type: bool. Desc: true if section gfpp is visible
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * is_section_selected - Type: bool. Desc: is_section_selected
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: t/f
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string. Desc: .
 * @param {hoverSectionActionBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverSectionActionBar = function (params) {
    return { evid: 1480, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} bgImageSetiingsBackClickParams
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - video/image
* @property {string} panel_name - .
* @property {string} panelname - panelname
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: bg_image_setiings_back_click. Evid: 1016.
 * Event description: bg_image_setiings_back_click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: video/image
 *
 * panel_name - Type: string. Desc: .
 *
 * panelname - Type: string. Desc: panelname
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {bgImageSetiingsBackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bgImageSetiingsBackClick = function (params) {
    return { evid: 1016, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentAddedFromMarketParams
* @property {string} adding_method - {direct_add, modal, drag}
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - per app per site
* @property {string} category - {add_panel: text, image..., market: featured, new, search, pending....}
* @property {string} component_id - [guid]
* @property {string} component_type - (wix_component, list, blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} installType - What type of install? (API, App Builder, Share URL, normal, other)
* @property {string} instance_id - per app per site per component
* @property {boolean} is_first - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {number} item_position - --
* @property {string} jsHeapSizeLimit - null
* @property {string} marketVersion - new market = 'new' old is 'null'
* @property {string} modal_tab_name - {overview, demo...}
* @property {string} multilingual - null
* @property {string} origin - {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
* @property {string} page_or_popup - {page, popup}
* @property {string} referral_info - {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
* @property {string} referral_info_category - {[add panel 'view more apps' category], [sa category], [cart category]...}
* @property {number} search_result_position - {0,1,2...}
* @property {string} search_term - {html, analytics,...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Component_added_from market. Evid: 168.
 * Event description: Component_added_from market.

 * adding_method - Type: string. Desc: {direct_add, modal, drag}
 *
 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: per app per site
 *
 * category - Type: string. Desc: {add_panel: text, image..., market: featured, new, search, pending....}
 *
 * component_id - Type: string. Desc: [guid]
 *
 * component_type - Type: string. Desc: (wix_component, list, blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * installType - Type: string. Desc: What type of install? (API, App Builder, Share URL, normal, other)
 *
 * instance_id - Type: string. Desc: per app per site per component
 *
 * is_first - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_position - Type: numeric. Desc: --
 *
 * jsHeapSizeLimit - Type: string.
 *
 * marketVersion - Type: string. Desc: new market = 'new' old is 'null'
 *
 * modal_tab_name - Type: string. Desc: {overview, demo...}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
 *
 * page_or_popup - Type: string. Desc: {page, popup}
 *
 * referral_info - Type: string. Desc: {email_1, email_2, google, ed_market_button, ed_add_panel, da_NF, da_market, da_widget, da_in_app, sa_explore, sa_footer, premium_cart.}
 *
 * referral_info_category - Type: string. Desc: {[add panel 'view more apps' category], [sa category], [cart category]...}
 *
 * search_result_position - Type: numeric. Desc: {0,1,2...}
 *
 * search_term - Type: string. Desc: {html, analytics,...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {componentAddedFromMarketParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentAddedFromMarket = function (params) {
    return { evid: 168, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} deleteImagePageSettingsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Delete_image_page_settings. Evid: 815.
 * Event description: Delete_upload_from_page_settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {deleteImagePageSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteImagePageSettings = function (params) {
    return { evid: 815, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaCloseSettingsParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} seconds_opened - {}
* @property {number} session_time - 1,2,3
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_close_settings. Evid: 191.
 * Event description: tpa_close_settings.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * seconds_opened - Type: numeric. Desc: {}
 *
 * session_time - Type: numeric. Desc: 1,2,3
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tpaCloseSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaCloseSettings = function (params) {
    return { evid: 191, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchToNewEditorLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: switch_to_new_editor_link_click. Evid: 488.
 * Event description: switch_to_new_editor_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {switchToNewEditorLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchToNewEditorLinkClick = function (params) {
    return { evid: 488, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisAddLinkButtonClickedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Add_link_button_clicked. Evid: 1190.


 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisAddLinkButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisAddLinkButtonClicked = function (params) {
    return { evid: 1190, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} htmlLoadingStepAppsInstallerStartParams
* @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
* @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
* @property {number} base_version - X.Y.Z
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id
* @property {string} experiments - the open experiments (from the editorModel) which are turned ON for the user
* @property {number} height - {}
* @property {boolean} is_premium - 0,1
* @property {boolean} is_rollout - (1,0)
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_template - {0,1}
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {boolean} onboarding_in_use - onboarding_in_use (ADI or Editor)
* @property {boolean} prefetch - Prefetched resources
* @property {string} ref - indicates the page the user came from (document.referrer)
* @property {boolean} request_from_adi - {1,0}
* @property {number} screen_height - Height of client device screen
* @property {number} screen_width - Width of client device screen
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} version_hash - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {number} width - {}
* @property {number} window_height - Initial height of client window
* @property {number} window_width - Initial width of client window
* @property {string} wixsession - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: html loading step - apps_installer_start. Evid: 841.
 * Event description: html loading step - apps_installer_start.

 * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
 *
 * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
 *
 * base_version - Type: numeric. Desc: X.Y.Z
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id
 *
 * experiments - Type: string. Desc: the open experiments (from the editorModel) which are turned ON for the user
 *
 * height - Type: numeric. Desc: {}
 *
 * is_premium - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool. Desc: (1,0)
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_template - Type: bool. Desc: {0,1}
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * onboarding_in_use - Type: bool. Desc: onboarding_in_use (ADI or Editor)
 *
 * prefetch - Type: bool. Desc: Prefetched resources
 *
 * ref - Type: string. Desc: indicates the page the user came from (document.referrer)
 *
 * request_from_adi - Type: bool. Desc: {1,0}
 *
 * screen_height - Type: numeric. Desc: Height of client device screen
 *
 * screen_width - Type: numeric. Desc: Width of client device screen
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * version_hash - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * width - Type: numeric. Desc: {}
 *
 * window_height - Type: numeric. Desc: Initial height of client window
 *
 * window_width - Type: numeric. Desc: Initial width of client window
 *
 * wixsession - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {htmlLoadingStepAppsInstallerStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var htmlLoadingStepAppsInstallerStart = function (params) {
    return { evid: 841, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} advancedDesignPanelCloseParams
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: advanced_design_panel_close. Evid: 322.
 * Event description: advanced_design_panel_close.

 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {advancedDesignPanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var advancedDesignPanelClose = function (params) {
    return { evid: 322, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelAlignmentSelectedParams
* @property {string} category - {Right, Left, Center, justified}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Alignment_Selected. Evid: 234.
 * Event description: Text_Panel_Alignment_Selected.

 * category - Type: string. Desc: {Right, Left, Center, justified}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelAlignmentSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelAlignmentSelected = function (params) {
    return { evid: 234, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutClickOnLayoutParams
* @property {string} component_id - id of selected section
* @property {number} componentsAmount - amount of components in the selected section
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} layout_id - id of layout
* @property {string} layout_index - order in which layout was suggested in the panel
* @property {string} layout_type - layout_type (original_layout, optional)
* @property {string} multilingual - multilingual
* @property {string} origin - null
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - click on layout. Evid: 1273.
 * Event description: user clicks on layout in Layout panel.

 * component_id - Type: string. Desc: id of selected section
 *
 * componentsAmount - Type: numeric. Desc: amount of components in the selected section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * layout_id - Type: string. Desc: id of layout
 *
 * layout_index - Type: string. Desc: order in which layout was suggested in the panel
 *
 * layout_type - Type: string. Desc: layout_type (original_layout, optional)
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string.
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutClickOnLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutClickOnLayout = function (params) {
    return { evid: 1273, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} musicCampaignLearnMoreClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: music_campaign_learn_more_click. Evid: 313.
 * Event description: music_campaign_learn_more_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {musicCampaignLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var musicCampaignLearnMoreClick = function (params) {
    return { evid: 313, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationComponentMigrationErrorParams
* @property {string} component_id - id of component with error
* @property {string} component_type - type of component that cant be migrated
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {string} errorMessage - error message
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} pageId - id of the page where component is located
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - component migration error. Evid: 1248.
 * Event description: Component can't be migrated to sections.

 * component_id - Type: string. Desc: id of component with error
 *
 * component_type - Type: string. Desc: type of component that cant be migrated
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * errorMessage - Type: string. Desc: error message
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * pageId - Type: string. Desc: id of the page where component is located
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationComponentMigrationErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationComponentMigrationError = function (params) {
    return { evid: 1248, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationAnchorsInSiteStructureParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {string} flow - editor / editor2Anchors
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - {}
* @property {number} revision - revision of site
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - anchors in site structure. Evid: 1396.
 * Event description: events indicates anchors in site structure.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: editor / editor2Anchors
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: {}
 *
 * revision - Type: numeric. Desc: revision of site
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationAnchorsInSiteStructureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationAnchorsInSiteStructure = function (params) {
    return { evid: 1396, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceHueSelectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_hue_select. Evid: 137.
 * Event description: ColorSpace_Hue_Select.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceHueSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceHueSelect = function (params) {
    return { evid: 137, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPagesSpecialPagesBackClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_PAGES_special_pages_back_click. Evid: 453.
 * Event description: top_bar_PAGES_special_pages_back_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPagesSpecialPagesBackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPagesSpecialPagesBackClick = function (params) {
    return { evid: 453, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickSaveUpgradeTooltipTopbarParams
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: click_save_upgrade_tooltip_topbar. Evid: 1389.
 * Event description: clicking save from top bar tooltip (in editor draft mode).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {clickSaveUpgradeTooltipTopbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickSaveUpgradeTooltipTopbar = function (params) {
    return { evid: 1389, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishSeoWizClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_SEO_WIZ_click. Evid: 684.
 * Event description: Second_Publish_SEO_WIZ_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishSeoWizClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishSeoWizClick = function (params) {
    return { evid: 684, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPagesSpecialPagesIconClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {tpa,blog}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_PAGES_special_pages_icon_click. Evid: 452.
 * Event description: top_bar_PAGES_special_pages_icon_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {tpa,blog}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPagesSpecialPagesIconClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPagesSpecialPagesIconClick = function (params) {
    return { evid: 452, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteImageQualitySettingsPanelCancelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {site_setting}
* @property {string} preset - {‘nonr’, ‘strong’, ‘maximum’, ‘regular’, ‘moderate’, ‘mild’}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {number} unsharp_amount - {number}
* @property {number} unsharp_radius - {number}
* @property {number} unsharp_threshold - {number}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_image_quality_settings_panel_Cancel. Evid: 517.
 * Event description: Panel_closed_as_Cancel or X top right.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {site_setting}
 *
 * preset - Type: string. Desc: {‘nonr’, ‘strong’, ‘maximum’, ‘regular’, ‘moderate’, ‘mild’}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * unsharp_amount - Type: numeric. Desc: {number}
 *
 * unsharp_radius - Type: numeric. Desc: {number}
 *
 * unsharp_threshold - Type: numeric. Desc: {number}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteImageQualitySettingsPanelCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteImageQualitySettingsPanelCancel = function (params) {
    return { evid: 517, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputFiledwithValidationButtonClickParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} validation_type - {URL, email, url, Youtube, etc...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: InputFiledwithValidationButton_Click. Evid: 360.
 * Event description: InputFiledwithButton_Click.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * validation_type - Type: string. Desc: {URL, email, url, Youtube, etc...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {inputFiledwithValidationButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputFiledwithValidationButtonClick = function (params) {
    return { evid: 360, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} timingPanelChangeSettingsParams
* @property {string} behavior_name - Ease Both/Ease In/Ease Out/Elastic/Linear
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_value - new value
* @property {string} old_value - old value
* @property {string} parameter_name - duration/delay
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: timing_panel_change_settings. Evid: 84.
 * Event description: Changing settings.

 * behavior_name - Type: string. Desc: Ease Both/Ease In/Ease Out/Elastic/Linear
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_value - Type: string. Desc: new value
 *
 * old_value - Type: string. Desc: old value
 *
 * parameter_name - Type: string. Desc: duration/delay
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {timingPanelChangeSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var timingPanelChangeSettings = function (params) {
    return { evid: 84, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contactFormChangedParams
* @property {boolean} address_mandatory - {mandatory address}
* @property {boolean} address_ok - {1=address appears on form}
* @property {boolean} dateChanged - {1=date appears on form}
* @property {boolean} date_mandatory - {mandatory date}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {boolean} emailChanged - {1=email appears on form}
* @property {boolean} email_mandatory - {mandatory email}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {boolean} messageChanged - {1=message appears on form}
* @property {boolean} message_mandatory - {mandatory message}
* @property {string} multilingual - null
* @property {boolean} nameChanged - {1=name appears on form}
* @property {boolean} name_mandatory - {mandatory name}
* @property {number} number_of_items - {# of fields in the form}
* @property {boolean} phoneChanged - {1=phone appears on form}
* @property {boolean} phone_mandatory - {mandatory phone}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} subjectChanged - {1=text appears on form}
* @property {boolean} subject_mandatory - {mandatory subject}
* @property {string} text - {value of text input}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Contact form changed. Evid: 642.
 * Event description: new contact form changed (event generated when panel closes only).

 * address_mandatory - Type: bool. Desc: {mandatory address}
 *
 * address_ok - Type: bool. Desc: {1=address appears on form}
 *
 * dateChanged - Type: bool. Desc: {1=date appears on form}
 *
 * date_mandatory - Type: bool. Desc: {mandatory date}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * emailChanged - Type: bool. Desc: {1=email appears on form}
 *
 * email_mandatory - Type: bool. Desc: {mandatory email}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * messageChanged - Type: bool. Desc: {1=message appears on form}
 *
 * message_mandatory - Type: bool. Desc: {mandatory message}
 *
 * multilingual - Type: string.
 *
 * nameChanged - Type: bool. Desc: {1=name appears on form}
 *
 * name_mandatory - Type: bool. Desc: {mandatory name}
 *
 * number_of_items - Type: numeric. Desc: {# of fields in the form}
 *
 * phoneChanged - Type: bool. Desc: {1=phone appears on form}
 *
 * phone_mandatory - Type: bool. Desc: {mandatory phone}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * subjectChanged - Type: bool. Desc: {1=text appears on form}
 *
 * subject_mandatory - Type: bool. Desc: {mandatory subject}
 *
 * text - Type: string. Desc: {value of text input}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {contactFormChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contactFormChanged = function (params) {
    return { evid: 642, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickedEnableVisualIndicatorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {ON/OFF}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: clicked enable visual indicator. Evid: 731.
 * Event description: Clicked enable visual indicator.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {ON/OFF}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickedEnableVisualIndicatorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickedEnableVisualIndicator = function (params) {
    return { evid: 731, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderSpaceBetweenFieldAndFieldTitleChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} section - Circle/Square/Rectangle /Bar
* @property {string} selection - 1,2,3...
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_space_between_field_and_field_title_changed. Evid: 1329.


 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * selection - Type: string. Desc: 1,2,3...
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderSpaceBetweenFieldAndFieldTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderSpaceBetweenFieldAndFieldTitleChanged = function (params) {
    return { evid: 1329, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppAddedByUserFirsttimeStep1welcomeCloseClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {app market,template,promotional button...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_added_by_user_firsttime_step1welcome_close_click. Evid: 203.
 * Event description: site_app_added_by_user_firsttime_step1welcome_close_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {app market,template,promotional button...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppAddedByUserFirsttimeStep1welcomeCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppAddedByUserFirsttimeStep1welcomeCloseClick = function (params) {
    return { evid: 203, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyComponentOrTpaParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} component_id - .
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_component_pinned - 0,1
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - Keyboard
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - []
* @property {string} workspace_mode - null
**/
/**
 * Name: copy_component_or_TPA. Evid: 181.
 * Event description: copy_component_or_TPA.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_component_pinned - Type: bool. Desc: 0,1
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: Keyboard
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: []
 *
 * workspace_mode - Type: string.
 * @param {copyComponentOrTpaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyComponentOrTpa = function (params) {
    return { evid: 181, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickedHelpParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Clicked Help. Evid: 692.
 * Event description: Clicked "Help' from opened panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickedHelpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickedHelp = function (params) {
    return { evid: 692, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelSpacingClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Spacing_Click. Evid: 245.
 * Event description: Text_Panel_Spacing_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelSpacingClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelSpacingClick = function (params) {
    return { evid: 245, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} multiselectLayoutPanelDistributionClickedParams
* @property {string} category - type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: MULTISELECT_LAYOUT_PANEL_DISTRIBUTION_CLICKED. Evid: 495.
 * Event description: MULTISELECT_LAYOUT_PANEL_DISTRIBUTION_CLICKED.

 * category - Type: string. Desc: type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {multiselectLayoutPanelDistributionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var multiselectLayoutPanelDistributionClicked = function (params) {
    return { evid: 495, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterBackClickParams
* @property {string} businessType - null
* @property {string} clickOrigin - back_button / tag
* @property {string} component_id - component_id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} step - subject_selection / texts_business_type / texts_subject
* @property {string} subject - subject or null
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.back.click. Evid: 1030.
 * Event description: Smart Writer click on subject or business type selection to change it.

 * businessType - Type: string.
 *
 * clickOrigin - Type: string. Desc: back_button / tag
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * step - Type: string. Desc: subject_selection / texts_business_type / texts_subject
 *
 * subject - Type: string. Desc: subject or null
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterBackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterBackClick = function (params) {
    return { evid: 1030, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} htmlLoadingStepEditorReadyParams
* @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
* @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
* @property {number} base_version - X.Y.Z
* @property {boolean} contentEditingOnly - t / f
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editorLanguage - field for comparison with Petri’s language detection heuristic is based on multiple params: headers, domain, ip, etc
* @property {GUID} esi - null
* @property {string} experiments - the open experiments (from the editorModel) which are turned ON for the user
* @property {number} height - {}
* @property {boolean} is_premium - 0,1
* @property {boolean} is_rollout - (1,0)
* @property {boolean} isSection - null
* @property {boolean} is_section_component - true if there is section component in the site structure
* @property {boolean} is_section_migration - true if we migrating site/template to sections during the session
* @property {boolean} isSiteCreation - null
* @property {boolean} is_template - {0,1}
* @property {boolean} isWelcomeScreen - isWelcomeScreen shown
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {boolean} onboarding_in_use - onboarding_in_use (ADI or Editor)
* @property {string} open_method - editor 2.0 wizard / templates
* @property {string} permission_status - .
* @property {boolean} prefetch - Prefetched resources
* @property {string} ref - indicates the page the user came from (document.referrer)
* @property {boolean} request_from_adi - {1,0}
* @property {number} screen_height - Height of client device screen
* @property {number} screen_width - Width of client device screen
* @property {boolean} sectionsEnabled - true if site was opened with sections
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} theme - browser theme - dark, light or an empty string for users without theme.
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} version_hash - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {number} width - {}
* @property {number} window_height - Initial height of client window
* @property {number} window_width - Initial width of client window
* @property {string} wixsession - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: html loading step - editor_ready. Evid: 429.
 * Event description: html loading step - editor_ready.

 * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
 *
 * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
 *
 * base_version - Type: numeric. Desc: X.Y.Z
 *
 * contentEditingOnly - Type: bool. Desc: t / f
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editorLanguage - Type: string. Desc: field for comparison with Petri’s language detection heuristic is based on multiple params: headers, domain, ip, etc
 *
 * esi - Type: guid.
 *
 * experiments - Type: string. Desc: the open experiments (from the editorModel) which are turned ON for the user
 *
 * height - Type: numeric. Desc: {}
 *
 * is_premium - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool. Desc: (1,0)
 *
 * isSection - Type: bool.
 *
 * is_section_component - Type: bool. Desc: true if there is section component in the site structure
 *
 * is_section_migration - Type: bool. Desc: true if we migrating site/template to sections during the session
 *
 * isSiteCreation - Type: bool.
 *
 * is_template - Type: bool. Desc: {0,1}
 *
 * isWelcomeScreen - Type: bool. Desc: isWelcomeScreen shown
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * onboarding_in_use - Type: bool. Desc: onboarding_in_use (ADI or Editor)
 *
 * open_method - Type: string. Desc: editor 2.0 wizard / templates
 *
 * permission_status - Type: string. Desc: .
 *
 * prefetch - Type: bool. Desc: Prefetched resources
 *
 * ref - Type: string. Desc: indicates the page the user came from (document.referrer)
 *
 * request_from_adi - Type: bool. Desc: {1,0}
 *
 * screen_height - Type: numeric. Desc: Height of client device screen
 *
 * screen_width - Type: numeric. Desc: Width of client device screen
 *
 * sectionsEnabled - Type: bool. Desc: true if site was opened with sections
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * theme - Type: string. Desc: browser theme - dark, light or an empty string for users without theme.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * version_hash - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * width - Type: numeric. Desc: {}
 *
 * window_height - Type: numeric. Desc: Initial height of client window
 *
 * window_width - Type: numeric. Desc: Initial width of client window
 *
 * wixsession - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {htmlLoadingStepEditorReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var htmlLoadingStepEditorReady = function (params) {
    return { evid: 429, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hideThisPageFromSearchResultsParams
* @property {string} category - {social,private, dynamic_page}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} title - {page title}
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - {true;false}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hide this page from search results. Evid: 662.
 * Event description: toggle allowing user to hide page from search results.

 * category - Type: string. Desc: {social,private, dynamic_page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * title - Type: string. Desc: {page title}
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: {true;false}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hideThisPageFromSearchResultsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hideThisPageFromSearchResults = function (params) {
    return { evid: 662, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutLayoutApplyParams
* @property {string} component_id - id of selected section
* @property {number} componentsAmount - amount of components in the selected section
* @property {string} correlation_id - id, which should change after layout panel was closed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - null
* @property {string} layout_id - null
* @property {string} layout_index - order in which layout was suggested in the panel
* @property {string} layout_type - layout_type (original_layout, optional)
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - layout apply. Evid: 1274.


 * component_id - Type: string. Desc: id of selected section
 *
 * componentsAmount - Type: numeric. Desc: amount of components in the selected section
 *
 * correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout_id - Type: string.
 *
 * layout_index - Type: string. Desc: order in which layout was suggested in the panel
 *
 * layout_type - Type: string. Desc: layout_type (original_layout, optional)
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutLayoutApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutLayoutApply = function (params) {
    return { evid: 1274, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} languageSupportHelpClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} open_close - {open, close}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Language_Support_Help_Click. Evid: 218.
 * Event description: Language_Support_Help_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * open_close - Type: string. Desc: {open, close}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {languageSupportHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var languageSupportHelpClick = function (params) {
    return { evid: 218, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorBrowserWindowFocusParams
* @property {string} actionName - suspend, activate
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_browser_window_focus. Evid: 1140.
 * Event description: Sent:
When the user moves to another tab ("suspend")
When the user comes back the tab of the Editor ("activate").

 * actionName - Type: string. Desc: suspend, activate
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorBrowserWindowFocusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorBrowserWindowFocus = function (params) {
    return { evid: 1140, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} petriBugJsonAnchorsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} label_id - 1/2
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: petri_bug_json_anchors. Evid: 640.
 * Event description: petri_bug_json_anchor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * label_id - Type: string. Desc: 1/2
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {petriBugJsonAnchorsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var petriBugJsonAnchors = function (params) {
    return { evid: 640, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMenuPopupShowParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - name of the popup
* @property {string} origin - {pages panel, manage menu etc}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage menu popup show. Evid: 1423.
 * Event description: Modal for manage menus shown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: name of the popup
 *
 * origin - Type: string. Desc: {pages panel, manage menu etc}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMenuPopupShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMenuPopupShow = function (params) {
    return { evid: 1423, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveErrorWorkNotSavedErrorCloseClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_error_work_not_saved_error_close_click. Evid: 340.
 * Event description: First_Save_error_work_not_saved_error_close_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveErrorWorkNotSavedErrorCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveErrorWorkNotSavedErrorCloseClick = function (params) {
    return { evid: 340, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressDeleteFontFromFontsManagerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {file_name}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} text - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press delete font from fonts manager. Evid: 599.
 * Event description: press delete font from fonts manager.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {file_name}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * text - Type: string. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressDeleteFontFromFontsManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressDeleteFontFromFontsManager = function (params) {
    return { evid: 599, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSiteColorsEditMainColorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {index of main color clicked on}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Site_Colors_EditMainColor. Evid: 406.
 * Event description: Edit_Site_Colors_EditMainColor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {index of main color clicked on}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editSiteColorsEditMainColorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSiteColorsEditMainColor = function (params) {
    return { evid: 406, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityAddAttributeClickParams
* @property {string} componentId - .
* @property {string} componentName - button/text_input/dropdown/radio/checkbox/date_picker/range/lightbox/text/box/strip/repeater
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility - Add Attribute Click. Evid: 1229.
 * Event description: Accessibility - Add Attribute Click.

 * componentId - Type: string. Desc: .
 *
 * componentName - Type: string. Desc: button/text_input/dropdown/radio/checkbox/date_picker/range/lightbox/text/box/strip/repeater
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {accessibilityAddAttributeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityAddAttributeClick = function (params) {
    return { evid: 1229, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteAccessibilityIndicatorShownParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of accessibility
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette accessibility indicator shown. Evid: 1437.
 * Event description: Color palette accessibility indicator shown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of accessibility
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteAccessibilityIndicatorShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteAccessibilityIndicatorShown = function (params) {
    return { evid: 1437, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcmMovePluginSelectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {application_id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} plugin_id - {id of plugin}
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} slot_id - slot_id highlighted
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: RCM Move Plugin select. Evid: 1449.
 * Event description: RCM Move Plugin select.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {application_id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * plugin_id - Type: string. Desc: {id of plugin}
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * slot_id - Type: string. Desc: slot_id highlighted
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rcmMovePluginSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcmMovePluginSelect = function (params) {
    return { evid: 1449, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} loadingPhaseInInitCompleteParams
* @property {string} app_name - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {number} intervalLoadTime - load time of this phase in ms
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_template - new / existing
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} loadTime - total load time till this phase in ms
* @property {string} multilingual - null
* @property {string} phaseName - phase name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} subPhaseName - {}
* @property {string} subphase - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: loading - phase in init - complete. Evid: 78.
 * Event description: Module: builder. Flow: a phase in the init has been completed.

 * app_name - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * intervalLoadTime - Type: numeric. Desc: load time of this phase in ms
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_template - Type: bool. Desc: new / existing
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * loadTime - Type: numeric. Desc: total load time till this phase in ms
 *
 * multilingual - Type: string.
 *
 * phaseName - Type: string. Desc: phase name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * subPhaseName - Type: string. Desc: {}
 *
 * subphase - Type: string. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {loadingPhaseInInitCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loadingPhaseInInitComplete = function (params) {
    return { evid: 78, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstTimeTooltipPanelClosedParams
* @property {string} bubble_name - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {X, 'got it', click on stage}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} step_name - {}
* @property {number} timestamp - how long the panel was opend
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: first_time_tooltip_panel_closed. Evid: 587.
 * Event description: first_time_tooltip_panel_closed.

 * bubble_name - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {X, 'got it', click on stage}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * step_name - Type: string. Desc: {}
 *
 * timestamp - Type: numeric. Desc: how long the panel was opend
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstTimeTooltipPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstTimeTooltipPanelClosed = function (params) {
    return { evid: 587, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stripBackgroundPanelBackgroundChangedParams
* @property {string} bg_color - --
* @property {string} bg_color_opacity - bg_color_opacity
* @property {string} bg_fitting - 'full_screen', 'fit', 'tile', 'tile_vert'...
* @property {string} bg_image_opacity - --
* @property {string} bg_image_scaling - --
* @property {string} bg_media_name - --
* @property {string} bg_media_type - --
* @property {boolean} bg_mobile_detached - true or false
* @property {number} bg_opacity - 0-1
* @property {string} bg_overlay_color - #FFFFFF , rgb(), color_15
* @property {number} bg_overlay_color_opacity - 0-1
* @property {string} bg_page_id - --
* @property {string} bg_positioning - 'top', 'bottom', 'left', 'right', 'top-left'..
* @property {string} bg_preset_index - --
* @property {string} bg_scroll_with_site - ‘fix’, ‘scroll’, ‘scrub’
* @property {string} bg_slideshow_image_scaling - --
* @property {string} bg_slideshow_pausebetweenimages - --
* @property {string} bg_slideshow_transition_direction - --
* @property {string} bg_slideshow_transition_duration - --
* @property {string} bg_slideshow_transition_type - --
* @property {string} bg_vendor_media_id - --
* @property {string} bg_vendor_name - --
* @property {string} bg_video_loop - --
* @property {number} bg_video_opacity - 0-100
* @property {string} bg_video_overlay_pattern - --
* @property {string} bg_video_speed - 1.25/1.5/..
* @property {string} component_id - --
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} isAiGenerator - t/f
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - 'bg_presets', 'bg_remove', 'bg_color_picker', 'bg_media_manager_video', 'bg_media_manager_image', 'bg_image_settings', 'bg_video_settings',
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} source - panel opening source
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: strip_background_panel_background_changed. Evid: 487.
 * Event description: event sent when new strip background has changed.

 * bg_color - Type: string. Desc: --
 *
 * bg_color_opacity - Type: string. Desc: bg_color_opacity
 *
 * bg_fitting - Type: string. Desc: 'full_screen', 'fit', 'tile', 'tile_vert'...
 *
 * bg_image_opacity - Type: string. Desc: --
 *
 * bg_image_scaling - Type: string. Desc: --
 *
 * bg_media_name - Type: string. Desc: --
 *
 * bg_media_type - Type: string. Desc: --
 *
 * bg_mobile_detached - Type: bool. Desc: true or false
 *
 * bg_opacity - Type: numeric. Desc: 0-1
 *
 * bg_overlay_color - Type: string. Desc: #FFFFFF , rgb(), color_15
 *
 * bg_overlay_color_opacity - Type: numeric. Desc: 0-1
 *
 * bg_page_id - Type: string. Desc: --
 *
 * bg_positioning - Type: string. Desc: 'top', 'bottom', 'left', 'right', 'top-left'..
 *
 * bg_preset_index - Type: string. Desc: --
 *
 * bg_scroll_with_site - Type: string. Desc: ‘fix’, ‘scroll’, ‘scrub’
 *
 * bg_slideshow_image_scaling - Type: string. Desc: --
 *
 * bg_slideshow_pausebetweenimages - Type: string. Desc: --
 *
 * bg_slideshow_transition_direction - Type: string. Desc: --
 *
 * bg_slideshow_transition_duration - Type: string. Desc: --
 *
 * bg_slideshow_transition_type - Type: string. Desc: --
 *
 * bg_vendor_media_id - Type: string. Desc: --
 *
 * bg_vendor_name - Type: string. Desc: --
 *
 * bg_video_loop - Type: string. Desc: --
 *
 * bg_video_opacity - Type: numeric. Desc: 0-100
 *
 * bg_video_overlay_pattern - Type: string. Desc: --
 *
 * bg_video_speed - Type: string. Desc: 1.25/1.5/..
 *
 * component_id - Type: string. Desc: --
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isAiGenerator - Type: bool. Desc: t/f
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: 'bg_presets', 'bg_remove', 'bg_color_picker', 'bg_media_manager_video', 'bg_media_manager_image', 'bg_image_settings', 'bg_video_settings',
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: panel opening source
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stripBackgroundPanelBackgroundChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stripBackgroundPanelBackgroundChanged = function (params) {
    return { evid: 487, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonAnyTabClickedAVideoParams
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} isEmptyState - T/F
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} tabName - main/content_manager, the tab name in 6th bitton of content manager
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} videoUrl - the url of the video
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button > any Tab > clicked a video. Evid: 1268.
 * Event description: 6th Button > Tab > clicked a video.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * isEmptyState - Type: bool. Desc: T/F
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * tabName - Type: string. Desc: main/content_manager, the tab name in 6th bitton of content manager
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * videoUrl - Type: string. Desc: the url of the video
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonAnyTabClickedAVideoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonAnyTabClickedAVideo = function (params) {
    return { evid: 1268, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbDisplayingItemsThatDontFitChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - wrap/ellipsis
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_displaying_items_that_dont_fit_changed. Evid: 1238.
 * Event description: breadcrumb_displaying_items_that_dont_fit_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: wrap/ellipsis
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbDisplayingItemsThatDontFitChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbDisplayingItemsThatDontFitChanged = function (params) {
    return { evid: 1238, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeTourClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_tour_click. Evid: 1096.
 * Event description: Event fires when clicking the Welcome Tour section, under the help home panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeTourClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeTourClick = function (params) {
    return { evid: 1096, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} devModeOnOffParams
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {string} editor_view_mode - -
* @property {GUID} esi - {Editor session id}
* @property {boolean} is_data_on - {true, false}
* @property {boolean} is_first - true = first time dev mode was turned on. (first per msid and logged in uuid}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - add_panel_manual
* @property {GUID} site_id - {msid}
* @property {string} stage_type - null
* @property {boolean} status - {true, false}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Dev Mode On/Off. Evid: 1075.
 * Event description: Dev Mode On/Off.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * editor_view_mode - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: {Editor session id}
 *
 * is_data_on - Type: bool. Desc: {true, false}
 *
 * is_first - Type: bool. Desc: true = first time dev mode was turned on. (first per msid and logged in uuid}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: add_panel_manual
 *
 * site_id - Type: guid. Desc: {msid}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {true, false}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {devModeOnOffParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var devModeOnOff = function (params) {
    return { evid: 1075, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} deleteRepeaterItemParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: delete_repeater_item. Evid: 741.
 * Event description: delete repeater item.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {deleteRepeaterItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteRepeaterItem = function (params) {
    return { evid: 741, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pluginRemovedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {application_id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} method - {method of removing: click, keyboard etc}
* @property {string} multilingual - null
* @property {string} origin - {origin of removing}
* @property {string} plugin_id - {id of plugin}
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} slot_id - {slot_id from which plugin was removed}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Plugin removed. Evid: 1448.
 * Event description: Plugin removed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {application_id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * method - Type: string. Desc: {method of removing: click, keyboard etc}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {origin of removing}
 *
 * plugin_id - Type: string. Desc: {id of plugin}
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * slot_id - Type: string. Desc: {slot_id from which plugin was removed}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pluginRemovedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginRemoved = function (params) {
    return { evid: 1448, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tooltipOpenCloseParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - {Open, Close on mouse out}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tooltip_OpenClose. Evid: 343.
 * Event description: Tooltip_OpenClose.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {Open, Close on mouse out}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tooltipOpenCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tooltipOpenClose = function (params) {
    return { evid: 343, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsPageInfoHomePageChangeSetClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_page_info_home_page_change_set_click. Evid: 426.
 * Event description: PAGES_settings_page_info_home_page_change_set_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsPageInfoHomePageChangeSetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsPageInfoHomePageChangeSetClick = function (params) {
    return { evid: 426, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} codeEmbedInvalidCodeErrorParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} vsi - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Code_embed_invalid_code_error. Evid: 751.
 * Event description: Code embed invalid code error.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * vsi - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {codeEmbedInvalidCodeErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var codeEmbedInvalidCodeError = function (params) {
    return { evid: 751, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openModalClickParams
* @property {GUID} app_id - [guid]
* @property {string} category - {add_panel: text, image..., market: featured, new, search, pending....}
* @property {GUID} componant_id - [guid]
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open_modal_click. Evid: 173.
 * Event description: open_modal_click.

 * app_id - Type: guid. Desc: [guid]
 *
 * category - Type: string. Desc: {add_panel: text, image..., market: featured, new, search, pending....}
 *
 * componant_id - Type: guid. Desc: [guid]
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {ed_add_panel, ed_market, template_provision, gt_market, sa_market, da_market, da_widget)
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openModalClick = function (params) {
    return { evid: 173, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuInfoPresetClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} preset_label - {anchor, subscribe form etc}
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> info preset click. Evid: 124.
 * Event description: add menu -> info preset click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * preset_label - Type: string. Desc: {anchor, subscribe form etc}
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuInfoPresetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuInfoPresetClick = function (params) {
    return { evid: 124, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} connetingAUserInputToADatasetParams
* @property {boolean} collection_defined - true,false
* @property {string} component_id - comp id
* @property {string} component_name - comp name
* @property {string} component_type - comp type
* @property {string} data_set_name - data_set_name
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: conneting a user input to a dataset. Evid: 648.
 * Event description: conneting a user input to a dataset.

 * collection_defined - Type: bool. Desc: true,false
 *
 * component_id - Type: string. Desc: comp id
 *
 * component_name - Type: string. Desc: comp name
 *
 * component_type - Type: string. Desc: comp type
 *
 * data_set_name - Type: string. Desc: data_set_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {connetingAUserInputToADatasetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connetingAUserInputToADataset = function (params) {
    return { evid: 648, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarComparePlansClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Compare-Plans_click. Evid: 290.
 * Event description: top_bar_Compare-Plans_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarComparePlansClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarComparePlansClick = function (params) {
    return { evid: 290, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myDesignsRenamePresetClickParams
* @property {string} content_type - type of component
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} element_id - element_id
* @property {string} element_name - element_name
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.rename_preset_click. Evid: 1386.
 * Event description: clicking on "rename" on the context menu.

 * content_type - Type: string. Desc: type of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * element_id - Type: string. Desc: element_id
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {myDesignsRenamePresetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myDesignsRenamePresetClick = function (params) {
    return { evid: 1386, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} footerTooltipHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop zoom, mobile zoom, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: footer_tooltip_hover. Evid: 553.
 * Event description: footer_tooltip_hover.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop zoom, mobile zoom, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {footerTooltipHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var footerTooltipHover = function (params) {
    return { evid: 553, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} multiselectLayoutPanelAlignmentClickedParams
* @property {string} category - type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: MULTISELECT_LAYOUT_PANEL_ALIGNMENT_CLICKED. Evid: 493.
 * Event description: MULTISELECT_LAYOUT_PANEL_ALIGNMENT_CLICKED.

 * category - Type: string. Desc: type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {multiselectLayoutPanelAlignmentClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var multiselectLayoutPanelAlignmentClicked = function (params) {
    return { evid: 493, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressRetryAfterFontDidnTUploadParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {file_name}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press retry after font didn't upload. Evid: 601.
 * Event description: press retry after font didn't upload.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {file_name}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressRetryAfterFontDidnTUploadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressRetryAfterFontDidnTUpload = function (params) {
    return { evid: 601, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hiddenElementsShowParams
* @property {string} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} component_id - guid
* @property {string} component_type - {gallery, box...}
* @property {string} current_page_name - {page name}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hide_method - {}
* @property {string} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {all pages, current page}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hidden_elements_show. Evid: 300.
 * Event description: hidden_elements_show.

 * app_id - Type: string. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * current_page_name - Type: string. Desc: {page name}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hide_method - Type: string. Desc: {}
 *
 * instance_id - Type: string. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {all pages, current page}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hiddenElementsShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hiddenElementsShow = function (params) {
    return { evid: 300, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backgroundPanelCustomizeButtonsClickedParams
* @property {string} button_name - color/image/video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} pageId - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Background Panel: Customize buttons clicked. Evid: 1184.
 * Event description: when user clicked in Color/Image/video in Background Panel.

 * button_name - Type: string. Desc: color/image/video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * pageId - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {backgroundPanelCustomizeButtonsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backgroundPanelCustomizeButtonsClicked = function (params) {
    return { evid: 1184, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dynamicPagesPageInfoParams
* @property {string} collection_name - {connected_data_collection_name}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {esi}
* @property {string} field - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {msid}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: DYNAMIC_PAGES_page_info. Evid: 817.
 * Event description: DYNAMIC_PAGES_page_info.

 * collection_name - Type: string. Desc: {connected_data_collection_name}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {esi}
 *
 * field - Type: string. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {msid}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dynamicPagesPageInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dynamicPagesPageInfo = function (params) {
    return { evid: 817, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} timeoutAfterViewerStartsLoadingParams
* @property {string} autosave_on - was autosave enabled in the last editor session
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {number} time_seconds - time in seconds from the moment the editor starts loading the viewer  [40,45,50,55,60]
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {DateTime} viewer_start_loading_timestamp - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: timeout_after_viewer_starts_loading. Evid: 735.
 * Event description: event will be sent when a timeout of [40,45,50,55,60] seconds passed from the moment the editor starts loading the viewer if there was no event of "preview loaded successfully" (BI 429).

 * autosave_on - Type: string. Desc: was autosave enabled in the last editor session
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * time_seconds - Type: numeric. Desc: time in seconds from the moment the editor starts loading the viewer  [40,45,50,55,60]
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewer_start_loading_timestamp - Type: datetime. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {timeoutAfterViewerStartsLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var timeoutAfterViewerStartsLoading = function (params) {
    return { evid: 735, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesDuplicateChoiceCompleteParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} choice_name - choice_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - Duplicate Choice - complete. Evid: 912.
 * Event description: choice duplication is successfully added.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * choice_name - Type: string. Desc: choice_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesDuplicateChoiceCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesDuplicateChoiceComplete = function (params) {
    return { evid: 912, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationStartMigrationOfSiteParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_anchor_in_structure - true if we have an anchor in site structure
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} is_section_in_structure - true if we have a section in site structure
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - init / tpa / navigation
* @property {number} revision - revision of site
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - start migration of site. Evid: 1307.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_anchor_in_structure - Type: bool. Desc: true if we have an anchor in site structure
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * is_section_in_structure - Type: bool. Desc: true if we have a section in site structure
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: init / tpa / navigation
 *
 * revision - Type: numeric. Desc: revision of site
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationStartMigrationOfSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationStartMigrationOfSite = function (params) {
    return { evid: 1307, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsHideFromMobileDoneClickParams
* @property {string} category - {hide, show}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {}
* @property {GUID} site_id - {}
* @property {string} source - {main menu,members menu, custom menu}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_hide_from_mobile_done_click. Evid: 436.
 * Event description: PAGES_settings_hide_from_mobile_done_click.

 * category - Type: string. Desc: {hide, show}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {main menu,members menu, custom menu}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsHideFromMobileDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsHideFromMobileDoneClick = function (params) {
    return { evid: 436, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} embedHtmlClickedFromDevModePopWindoweParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {dev_mode,help_home}
* @property {GUID} site_id - {site guid}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: embed HTML clicked from dev mode pop window. Evid: 1401.
 * Event description: when a user clicks on embed HTML on the dev mode pop window (test).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {dev_mode,help_home}
 *
 * site_id - Type: guid. Desc: {site guid}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {embedHtmlClickedFromDevModePopWindoweParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var embedHtmlClickedFromDevModePopWindowe = function (params) {
    return { evid: 1401, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textMaskChangesParams
* @property {string} actionName - ‘change text’
* @property {string} ancestors - list of the component_Ids of the parents | ‘none’
* @property {string} brandId - ‘classic editor’
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - dm_version
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} fieldName - ‘text box’
* @property {string} fieldType - ‘text’
* @property {string} fieldValue - The new text
* @property {boolean} isContainer - true / false
* @property {boolean} isOrganizerItem - true / false
* @property {boolean} isRepeaterItem - true / false
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} origin - ‘GFPP’
* @property {string} panelName - ‘text mask settings’
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} subPanelName - ‘text edit’
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - workspace_mode
**/
/**
 * Name: text_mask_changes. Evid: 1474.
 * Event description: BI for 'Text Mask' text changes - choosing an effect type (for EditorX)
components - closing the text panel.

 * actionName - Type: string. Desc: ‘change text’
 *
 * ancestors - Type: string. Desc: list of the component_Ids of the parents | ‘none’
 *
 * brandId - Type: string. Desc: ‘classic editor’
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * fieldName - Type: string. Desc: ‘text box’
 *
 * fieldType - Type: string. Desc: ‘text’
 *
 * fieldValue - Type: string. Desc: The new text
 *
 * isContainer - Type: bool. Desc: true / false
 *
 * isOrganizerItem - Type: bool. Desc: true / false
 *
 * isRepeaterItem - Type: bool. Desc: true / false
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: ‘GFPP’
 *
 * panelName - Type: string. Desc: ‘text mask settings’
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * subPanelName - Type: string. Desc: ‘text edit’
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string. Desc: workspace_mode
 * @param {textMaskChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textMaskChanges = function (params) {
    return { evid: 1474, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageMinHeightDoubleClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Page Min Height double click. Evid: 613.
 * Event description: double click - back to minimum position.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageMinHeightDoubleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageMinHeightDoubleClick = function (params) {
    return { evid: 613, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} arenaPopoverOpenParams
* @property {string} clickType - Hover, click
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Arena --> Popover open. Evid: 80.
 * Event description: sends when Arena popover opens in the top bar in any method hover/click.

 * clickType - Type: string. Desc: Hover, click
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {arenaPopoverOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var arenaPopoverOpen = function (params) {
    return { evid: 80, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} effectsPanelChangeSettingsParams
* @property {string} behavior_name - Grow/Shrink/Skew/Rotate/Custom
* @property {string} component_id - null
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_value - null
* @property {string} old_value - old value
* @property {string} parameter_name - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: effects_panel_change_settings. Evid: 984.
 * Event description: Changing settings.

 * behavior_name - Type: string. Desc: Grow/Shrink/Skew/Rotate/Custom
 *
 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_value - Type: string.
 *
 * old_value - Type: string. Desc: old value
 *
 * parameter_name - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {effectsPanelChangeSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var effectsPanelChangeSettings = function (params) {
    return { evid: 984, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} undoRedoComponentChangeParams
* @property {string} actionName - action_name
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} component_id - guid
* @property {string} component_type - (ed_tpa, wix_component, list, blog...}
* @property {string} date_of_action - date_of_action
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Keyboard
* @property {string} pageId - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} status_change - {add, remove...}
* @property {string} totalJsHeapSize - null
* @property {string} type - {undo, redo}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: undo_redo_component_change. Evid: 281.
 * Event description: undo_redo_component_change.

 * actionName - Type: string. Desc: action_name
 *
 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: (ed_tpa, wix_component, list, blog...}
 *
 * date_of_action - Type: string. Desc: date_of_action
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Keyboard
 *
 * pageId - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status_change - Type: string. Desc: {add, remove...}
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {undo, redo}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {undoRedoComponentChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var undoRedoComponentChange = function (params) {
    return { evid: 281, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hiddenElementsRefreshLayoutTooltipOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hidden elements_refresh_layout_tooltip_open. Evid: 302.
 * Event description: hidden elements_refresh_layout_tooltip_open.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hiddenElementsRefreshLayoutTooltipOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hiddenElementsRefreshLayoutTooltipOpen = function (params) {
    return { evid: 302, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googlePreviewTooltipHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google preview tooltip hover. Evid: 771.
 * Event description: hover on "Google preview" tooltip on the new SEO tab in the pages panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googlePreviewTooltipHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googlePreviewTooltipHover = function (params) {
    return { evid: 771, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} oldNotToUseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pageId - xyz
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle - (1,0)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: old not to use. Evid: 847.
 * Event description: video background on/off toggle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pageId - Type: string. Desc: xyz
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: (1,0)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {oldNotToUseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oldNotToUse = function (params) {
    return { evid: 847, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} customElementContentChangedParams
* @property {string} component_id - component_id
* @property {string} content - Fixed field for server url/corvid file
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {number} input - server url/corvid file
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} source - server/corvid
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: customElement.content.changed. Evid: 985.
 * Event description: Server URL or Corvid file changed in a custom element component.

 * component_id - Type: string. Desc: component_id
 *
 * content - Type: string. Desc: Fixed field for server url/corvid file
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * input - Type: numeric. Desc: server url/corvid file
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: server/corvid
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {customElementContentChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customElementContentChanged = function (params) {
    return { evid: 985, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tabsChangeParams
* @property {string} component_id - .
* @property {string} component_type - component_TYPE
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} isEmptyState - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} panel_name - panel_name
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - menu / submenu
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: tabs_change. Evid: 1053.
 * Event description: user click on the tab in component layout settings.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_TYPE
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * isEmptyState - Type: bool. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: menu / submenu
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {tabsChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tabsChange = function (params) {
    return { evid: 1053, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonImageReplacedParams
* @property {string} button_type - Icon only/text&icon
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} homepage_displaying - text/icon
* @property {string} imageUrl - image_url
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Button - Image replaced. Evid: 1368.
 * Event description: Stylable Button - Image replaced.

 * button_type - Type: string. Desc: Icon only/text&icon
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * homepage_displaying - Type: string. Desc: text/icon
 *
 * imageUrl - Type: string. Desc: image_url
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonImageReplacedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonImageReplaced = function (params) {
    return { evid: 1368, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderReadOnlyToggleChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - null
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_read_only_toggle_changed. Evid: 1325.
 * Event description: range_slider_read_only_toggle_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderReadOnlyToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderReadOnlyToggleChanged = function (params) {
    return { evid: 1325, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tabInsideComponentRenamedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} new_value - new_value
* @property {string} old_value - old value
* @property {string} origin - action menu/ double click
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_id - tab id
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Tab inside component - renamed. Evid: 1383.
 * Event description: Tab inside component - renamed.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_value - Type: string. Desc: new_value
 *
 * old_value - Type: string. Desc: old value
 *
 * origin - Type: string. Desc: action menu/ double click
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_id - Type: string. Desc: tab id
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {tabInsideComponentRenamedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tabInsideComponentRenamed = function (params) {
    return { evid: 1383, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changesMayNotBeSavedBrowserPopupOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: changes_may_not_be_saved_browser_popup_open. Evid: 1142.
 * Event description: Sent when a user want to quit editor by closing browser but Browser (Do you really want to leave / Changes may not be saved) pop up appears.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {changesMayNotBeSavedBrowserPopupOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changesMayNotBeSavedBrowserPopupOpen = function (params) {
    return { evid: 1142, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionEmptyStateClickParams
* @property {string} component_id - component_id of section
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - stage, layers_panel (from what place click was made )
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - what user clicks (choose layout / add element)
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section - empty state click. Evid: 1309.


 * component_id - Type: string. Desc: component_id of section
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: stage, layers_panel (from what place click was made )
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: what user clicks (choose layout / add element)
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionEmptyStateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionEmptyStateClick = function (params) {
    return { evid: 1309, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationNoMigrationPossibleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} reason - reason why site is not eligible for migration
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - null
* @property {boolean} was_migration_started - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - no migration possible. Evid: 1291.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * reason - Type: string. Desc: reason why site is not eligible for migration
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * was_migration_started - Type: bool.
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationNoMigrationPossibleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationNoMigrationPossible = function (params) {
    return { evid: 1291, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuFirstTimeGotItClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {arrows, basic shapes,decorative,animals and nature etc}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> first time 'got it' click. Evid: 128.
 * Event description: add menu -> first time 'got it' click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {arrows, basic shapes,decorative,animals and nature etc}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuFirstTimeGotItClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuFirstTimeGotItClick = function (params) {
    return { evid: 128, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPagesNavigateToPopUpParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} pop_up_id - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_navigate_to_pop_up. Evid: 559.
 * Event description: top_bar_PAGES_navigate_to_pop_up.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * pop_up_id - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPagesNavigateToPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPagesNavigateToPopUp = function (params) {
    return { evid: 559, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAnchorUrlCloseCollapsableMenuParams
* @property {string} componentId - section/anchor component id
* @property {string} componentName - section name or anchor name
* @property {string} componentType - section/anchor component type
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} pageId - page where section/anchor is placed
* @property {string} pageName - name of the page where section/anchor is placed
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Section/Anchor URL - Close Collapsable Menu. Evid: 1403.
 * Event description: User closes Section/Anchor URL collapsable menu in Section/Anchor Settings panel..

 * componentId - Type: string. Desc: section/anchor component id
 *
 * componentName - Type: string. Desc: section name or anchor name
 *
 * componentType - Type: string. Desc: section/anchor component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * pageId - Type: string. Desc: page where section/anchor is placed
 *
 * pageName - Type: string. Desc: name of the page where section/anchor is placed
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionAnchorUrlCloseCollapsableMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAnchorUrlCloseCollapsableMenu = function (params) {
    return { evid: 1403, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tryItNowClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Try.It.Now.Click. Evid: 1067.
 * Event description: Try.It.Now.Click.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {tryItNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tryItNowClick = function (params) {
    return { evid: 1067, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} showControlsTooltipCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: show_controls_tooltip_close. Evid: 502.
 * Event description: show_controls_tooltip_close.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {showControlsTooltipCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showControlsTooltipClose = function (params) {
    return { evid: 502, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsLayoutsChangeLayoutParams
* @property {string} category - {standard, no header and footer}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pageId - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_layouts_change_layout. Evid: 92.
 * Event description: Changing the page layout in the layout tab of pages settings.

 * category - Type: string. Desc: {standard, no header and footer}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pageId - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsLayoutsChangeLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsLayoutsChangeLayout = function (params) {
    return { evid: 92, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rulersTooltipInEditModeParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {click_on_tooltip,click_on_guid}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} valid_value - {accepted/denied}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: rulers tooltip in edit mode. Evid: 526.
 * Event description: Full edit mode (with delete icon and focus).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {click_on_tooltip,click_on_guid}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * valid_value - Type: string. Desc: {accepted/denied}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rulersTooltipInEditModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rulersTooltipInEditMode = function (params) {
    return { evid: 526, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} successSaveProcessParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - time
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar/dialog
* @property {string} platform - {editor/app_studio}
* @property {number} revisionId - revision_id
* @property {string} save_type - partial/full/first
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: success_save_process. Evid: 462.
 * Event description: success_save_process.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: time
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar/dialog
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * revisionId - Type: numeric. Desc: revision_id
 *
 * save_type - Type: string. Desc: partial/full/first
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {successSaveProcessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var successSaveProcess = function (params) {
    return { evid: 462, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsSeoDescriptionSetParams
* @property {string} category - {social,private, dynamic_page}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_seo_description_set. Evid: 434.
 * Event description: PAGES_settings_seo_description_set.

 * category - Type: string. Desc: {social,private, dynamic_page}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsSeoDescriptionSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsSeoDescriptionSet = function (params) {
    return { evid: 434, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerSettingsPlayOnLoopChangedParams
* @property {string} component_id - component_id
* @property {string} componentType - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section_correlation_id - id that indicates edit section session
* @property {GUID} site_id - site_id
* @property {string} source - panel opening origin
* @property {string} stage_type - null
* @property {boolean} toggle - true/false
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.settings.playOnLoop.changed. Evid: 822.
 * Event description: User change "Play video on loop" toggle.

 * component_id - Type: string. Desc: component_id
 *
 * componentType - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section_correlation_id - Type: string. Desc: id that indicates edit section session
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: panel opening origin
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: true/false
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerSettingsPlayOnLoopChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerSettingsPlayOnLoopChanged = function (params) {
    return { evid: 822, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileInputDisabledRequestFeatureParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - input disabled - request feature. Evid: 1172.
 * Event description: Form Builder - upload file - input disabled - request feature. When 'Let us know' link is clicked for Document / Audio.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileInputDisabledRequestFeatureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileInputDisabledRequestFeature = function (params) {
    return { evid: 1172, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionShowEmptyStateParams
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section - show empty state. Evid: 1308.


 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionShowEmptyStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionShowEmptyState = function (params) {
    return { evid: 1308, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceColorvaluetabClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value_tab_selected - HEX, RGB, HSB
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_colorvaluetab_click. Evid: 138.
 * Event description: ColorSpace_ColorValueTab_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value_tab_selected - Type: string. Desc: HEX, RGB, HSB
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceColorvaluetabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceColorvaluetabClick = function (params) {
    return { evid: 138, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} chromeThemeColorChooseColorClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Chrome Theme Color: Choose color clicked. Evid: 1162.
 * Event description: Chrome Theme Color: Choose color clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {chromeThemeColorChooseColorClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var chromeThemeColorChooseColorClicked = function (params) {
    return { evid: 1162, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPreviewPageSaveClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Preview_Page_Save_click. Evid: 294.
 * Event description: top_bar_Preview_Page_Save_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPreviewPageSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPreviewPageSaveClick = function (params) {
    return { evid: 294, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageBackgroundPanelBackgroundChangedParams
* @property {string} bg_color - --
* @property {string} bg_fitting - 'full_screen', 'fit', 'tile', 'tile_vert'...
* @property {string} bg_image_opacity - --
* @property {string} bg_image_scaling - --
* @property {string} bg_media_name - --
* @property {string} bg_media_type - --
* @property {boolean} bg_mobile_detached - true or false
* @property {number} bg_opacity - 0-1
* @property {string} bg_overlay_color - #FFFFFF , rgb(), color_15
* @property {number} bg_overlay_color_opacity - 0-1
* @property {string} bg_page_id - --
* @property {string} bg_positioning - 'top', 'bottom', 'left', 'right', 'top-left'..
* @property {string} bg_preset_index - --
* @property {string} bg_scroll_with_site - ‘fix’, ‘scroll’, ‘scrub’
* @property {string} bg_slideshow_image_scaling - --
* @property {string} bg_slideshow_pausebetweenimages - --
* @property {string} bg_slideshow_transition_direction - --
* @property {string} bg_slideshow_transition_duration - --
* @property {string} bg_slideshow_transition_type - --
* @property {string} bg_vendor_media_id - --
* @property {string} bg_vendor_name - --
* @property {string} bg_video_loop - --
* @property {string} bg_video_overlay_pattern - --
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} isAiGenerator - t/f
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - --
* @property {string} pageId - current page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target_page_id - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_background_panel_background_changed. Evid: 375.
 * Event description: page_background_panel_background_changed.

 * bg_color - Type: string. Desc: --
 *
 * bg_fitting - Type: string. Desc: 'full_screen', 'fit', 'tile', 'tile_vert'...
 *
 * bg_image_opacity - Type: string. Desc: --
 *
 * bg_image_scaling - Type: string. Desc: --
 *
 * bg_media_name - Type: string. Desc: --
 *
 * bg_media_type - Type: string. Desc: --
 *
 * bg_mobile_detached - Type: bool. Desc: true or false
 *
 * bg_opacity - Type: numeric. Desc: 0-1
 *
 * bg_overlay_color - Type: string. Desc: #FFFFFF , rgb(), color_15
 *
 * bg_overlay_color_opacity - Type: numeric. Desc: 0-1
 *
 * bg_page_id - Type: string. Desc: --
 *
 * bg_positioning - Type: string. Desc: 'top', 'bottom', 'left', 'right', 'top-left'..
 *
 * bg_preset_index - Type: string. Desc: --
 *
 * bg_scroll_with_site - Type: string. Desc: ‘fix’, ‘scroll’, ‘scrub’
 *
 * bg_slideshow_image_scaling - Type: string. Desc: --
 *
 * bg_slideshow_pausebetweenimages - Type: string. Desc: --
 *
 * bg_slideshow_transition_direction - Type: string. Desc: --
 *
 * bg_slideshow_transition_duration - Type: string. Desc: --
 *
 * bg_slideshow_transition_type - Type: string. Desc: --
 *
 * bg_vendor_media_id - Type: string. Desc: --
 *
 * bg_vendor_name - Type: string. Desc: --
 *
 * bg_video_loop - Type: string. Desc: --
 *
 * bg_video_overlay_pattern - Type: string. Desc: --
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isAiGenerator - Type: bool. Desc: t/f
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: --
 *
 * pageId - Type: string. Desc: current page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target_page_id - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageBackgroundPanelBackgroundChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageBackgroundPanelBackgroundChanged = function (params) {
    return { evid: 375, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} effectsPanelBehaviorSavedParams
* @property {string} behavior_name - Grow/Shrink/Skew/Rotate/Custom
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} effect_origin - position
* @property {GUID} esi - null
* @property {number} hor_skew - horizontal skew value
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} rotation_value - rotation value
* @property {number} scale - scale value
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {number} ver_skew - vertical skew value
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: effects_panel_behavior_saved. Evid: 986.
 * Event description: Closing the Effects panel, if the behaviour was changed.

 * behavior_name - Type: string. Desc: Grow/Shrink/Skew/Rotate/Custom
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * effect_origin - Type: string. Desc: position
 *
 * esi - Type: guid.
 *
 * hor_skew - Type: numeric. Desc: horizontal skew value
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * rotation_value - Type: numeric. Desc: rotation value
 *
 * scale - Type: numeric. Desc: scale value
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * ver_skew - Type: numeric. Desc: vertical skew value
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {effectsPanelBehaviorSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var effectsPanelBehaviorSaved = function (params) {
    return { evid: 986, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contentInjectionSiteBusinessTypeBtSelectedParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {string} fieldName - business type/business name
* @property {boolean} is_changed - true if user chose another bt
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} newValue - what user selected
* @property {string} origin - Add Section/Page panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Content Injection - Site Business Type - BT Selected. Evid: 1411.
 * Event description: User chose business type in search drop down and clicked save.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * fieldName - Type: string. Desc: business type/business name
 *
 * is_changed - Type: bool. Desc: true if user chose another bt
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * newValue - Type: string. Desc: what user selected
 *
 * origin - Type: string. Desc: Add Section/Page panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {contentInjectionSiteBusinessTypeBtSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentInjectionSiteBusinessTypeBtSelected = function (params) {
    return { evid: 1411, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backToTopButtonIconChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {number} iconId - icon_id
* @property {string} icon_name - icon_name
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Back to top button icon changed. Evid: 1154.
 * Event description: Back to top button icon changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * iconId - Type: numeric. Desc: icon_id
 *
 * icon_name - Type: string. Desc: icon_name
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backToTopButtonIconChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backToTopButtonIconChanged = function (params) {
    return { evid: 1154, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} containerBoxBoxDesignSettingsParams
* @property {string} component_id - {}
* @property {string} component_type - component_type
* @property {string} dm_version - dm_version
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {string} field_name - field name
* @property {string} field_type - field type
* @property {string} field_value - value
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {boolean} keep_proportions - true / false
* @property {string} multilingual - .
* @property {string} panel_name - panel name
* @property {GUID} site_id - {}
* @property {string} stage_type - .
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Container Box  -  box design settings. Evid: 1512.
 * Event description: Container Box  -  box design settings (event for Studio / Edix bridge only.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: field type
 *
 * field_value - Type: string. Desc: value
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * keep_proportions - Type: bool. Desc: true / false
 *
 * multilingual - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: panel name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {containerBoxBoxDesignSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var containerBoxBoxDesignSettings = function (params) {
    return { evid: 1512, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hintDismissedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {hint_name}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {number} timestamp_ms - {milliseconds since hints was shown}
* @property {string} totalJsHeapSize - null
* @property {string} type - {got_it; click_overlay; on_target; esc}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Hint dismissed. Evid: 626.
 * Event description: hits was dismissed by user.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {hint_name}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * timestamp_ms - Type: numeric. Desc: {milliseconds since hints was shown}
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {got_it; click_overlay; on_target; esc}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hintDismissedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hintDismissed = function (params) {
    return { evid: 626, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} previewClick464Params
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {keyboard, top bar...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: preview_click. Evid: 464.
 * Event description: preview_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {keyboard, top bar...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {previewClick464Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewClick464 = function (params) {
    return { evid: 464, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lassoParams
* @property {number} num_of_elements_selected - num of selected elements {0, 1, 2...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {boolean} special_key - {0,1}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: lasso. Evid: 498.
 * Event description: selection.lasso.

 * num_of_elements_selected - Type: numeric. Desc: num of selected elements {0, 1, 2...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * special_key - Type: bool. Desc: {0,1}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {lassoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lasso = function (params) {
    return { evid: 498, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarClickParams
* @property {string} category - {wix_logo, pages, Menu, site, edit, view...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} isPreview - is_preview
* @property {boolean} is_published - {true, false}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {editor,preview}
* @property {string} platform - {editor/app_studio}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - standart / only_icons_search_tools_multilingual / fb_shrink
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_click. Evid: 285.
 * Event description: top_bar_click.

 * category - Type: string. Desc: {wix_logo, pages, Menu, site, edit, view...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * isPreview - Type: bool. Desc: is_preview
 *
 * is_published - Type: bool. Desc: {true, false}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {editor,preview}
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: standart / only_icons_search_tools_multilingual / fb_shrink
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarClick = function (params) {
    return { evid: 285, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeTooltipsInAddPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tooltipname - {key}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Close tooltips in add panel. Evid: 669.
 * Event description: pressing the (x) on tooltips in add panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tooltipname - Type: string. Desc: {key}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeTooltipsInAddPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeTooltipsInAddPanel = function (params) {
    return { evid: 669, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationComponentIsNotContainableParams
* @property {string} component_id - id of component with error
* @property {string} component_type - type of component that cant be migrated
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} pageId - id of the page where component is located
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - .
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - component is not containable. Evid: 1297.
 * Event description: component is not containable.

 * component_id - Type: string. Desc: id of component with error
 *
 * component_type - Type: string. Desc: type of component that cant be migrated
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * pageId - Type: string. Desc: id of the page where component is located
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationComponentIsNotContainableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationComponentIsNotContainable = function (params) {
    return { evid: 1297, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetIconLayoutDesignChangedParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - layout
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} target - design preset id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.iconLayout.design.changed. Evid: 1200.
 * Event description: Audio Player Icon Layout design changed.

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: layout
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: design preset id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetIconLayoutDesignChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetIconLayoutDesignChanged = function (params) {
    return { evid: 1200, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardEditorFullyInteractiveParams
* @property {string} appsToInstall - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} pageId - all page id’s comma separated
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {number} timeout - timeout for apps installation progress bar
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Editor Fully Interactive. Evid: 1261.
 * Event description: event for the final Editor opening -
Editor is ready for editing and user can work. Between these steps we’re waiting to the sooner between:
1) apps installation finished
2) timeout for apps installation progress bar (60s for up to 2 apps, 80s for 3-5 apps, 100s for 5+ apps)
After the first of these two happened, we’re closing the progress bar, and the user can work on the site (as the event of fully interactive).

 * appsToInstall - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * pageId - Type: string. Desc: all page id’s comma separated
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * timeout - Type: numeric. Desc: timeout for apps installation progress bar
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardEditorFullyInteractiveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardEditorFullyInteractive = function (params) {
    return { evid: 1261, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} getAddonsSelectedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel_name or tools/RCM
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Get Addons selected. Evid: 1458.
 * Event description: Get Addons selected from tolls or RCM.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel_name or tools/RCM
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {getAddonsSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var getAddonsSelected = function (params) {
    return { evid: 1458, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dropDownFontLanguageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} language_click - {Language Selected}
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: DropDownFont_LanguageClick. Evid: 356.
 * Event description: DropDownFont_LanguageClick.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * language_click - Type: string. Desc: {Language Selected}
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dropDownFontLanguageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dropDownFontLanguageClick = function (params) {
    return { evid: 356, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateDrag730Params
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_drag. Evid: 730.
 * Event description: frame view rate per drag action.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateDrag730Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateDrag730 = function (params) {
    return { evid: 730, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} strechToScreenLockedMarginsClickParams
* @property {GUID} appId - app_id
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - on, off
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: strech_to_screen_locked_margins_click. Evid: 508.
 * Event description: strech_to_screen_locked_margins_click.

 * appId - Type: guid. Desc: app_id
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: on, off
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {strechToScreenLockedMarginsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var strechToScreenLockedMarginsClick = function (params) {
    return { evid: 508, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuImageSearchParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} jsonData - search results
* @property {string} multilingual - multilingual
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} success - if anything found
* @property {string} target - search term
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> image-> search. Evid: 1059.
 * Event description: add panel -> image-> search.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * jsonData - Type: string. Desc: search results
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: if anything found
 *
 * target - Type: string. Desc: search term
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {addMenuImageSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuImageSearch = function (params) {
    return { evid: 1059, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverSeoSettingsTooltipInDocumentSettingsPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hover SEO settings Tooltip in document settings panel. Evid: 879.
 * Event description: hover SEO settings Tooltip in document settings - After 3 seconds.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverSeoSettingsTooltipInDocumentSettingsPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverSeoSettingsTooltipInDocumentSettingsPanel = function (params) {
    return { evid: 879, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutExploreMoreDesignsParams
* @property {string} component_id - id of selected section
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - Explore More Designs. Evid: 1276.
 * Event description: when user click 'Explore More Designs' and open add section panel.

 * component_id - Type: string. Desc: id of selected section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutExploreMoreDesignsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutExploreMoreDesigns = function (params) {
    return { evid: 1276, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelFontSelectorClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - .
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Font_Selector_click. Evid: 227.
 * Event description: Text_Panel_Font_Selector_click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelFontSelectorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelFontSelectorClick = function (params) {
    return { evid: 227, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardErrorParentingParams
* @property {string} componentId - .
* @property {string} componentType - .
* @property {number} curatedTemplateId - .
* @property {string} currentParentId - null
* @property {string} currentParentType - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - null
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} newParentId - null
* @property {string} newParentType - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: ERROR PARENTING. Evid: 1299.
 * Event description: an error BI for the site creation.

 * componentId - Type: string. Desc: .
 *
 * componentType - Type: string. Desc: .
 *
 * curatedTemplateId - Type: numeric. Desc: .
 *
 * currentParentId - Type: string.
 *
 * currentParentType - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * newParentId - Type: string.
 *
 * newParentType - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardErrorParentingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardErrorParenting = function (params) {
    return { evid: 1299, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchHotkeyOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.hotkey.open. Evid: 1037.
 * Event description: User opened Editor Search panel via command+/ hotkey.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {editorSearchHotkeyOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchHotkeyOpen = function (params) {
    return { evid: 1037, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} learnMoreClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: LearnMore_Click. Evid: 308.
 * Event description: LearnMore_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {learnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var learnMoreClick = function (params) {
    return { evid: 308, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuLearnMorePanelCategoryClickedParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} category - {HelpCenter, Forums, FromTheWixBlog, Videos}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_learn_more_panel_category_clicked. Evid: 209.
 * Event description: site_app_menu_learn_more_panel_category_clicked.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * category - Type: string. Desc: {HelpCenter, Forums, FromTheWixBlog, Videos}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuLearnMorePanelCategoryClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuLearnMorePanelCategoryClicked = function (params) {
    return { evid: 209, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorLoadingStepEditorFullyReadyParams
* @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
* @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
* @property {string} devmod_type - {data,devmode,none}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {number} height - {}
* @property {boolean} is_premium - 0,1
* @property {boolean} is_rollout - (1,0)
* @property {boolean} isSection - null
* @property {boolean} is_section_migration - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_template - {0,1}
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} open_method - null
* @property {boolean} prefetch - Prefetched resources
* @property {string} ref - indicates the page the user came from (document.referrer)
* @property {boolean} request_from_adi - {1,0}
* @property {number} screen_height - Height of client device screen
* @property {number} screen_width - Width of client device screen
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {number} width - {}
* @property {number} window_height - Initial height of client window
* @property {number} window_width - Initial width of client window
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor loading step - Editor fully ready. Evid: 951.
 * Event description: HTML loading step - editor_fully_ready.

 * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
 *
 * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
 *
 * devmod_type - Type: string. Desc: {data,devmode,none}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * height - Type: numeric. Desc: {}
 *
 * is_premium - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool. Desc: (1,0)
 *
 * isSection - Type: bool.
 *
 * is_section_migration - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_template - Type: bool. Desc: {0,1}
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * open_method - Type: string.
 *
 * prefetch - Type: bool. Desc: Prefetched resources
 *
 * ref - Type: string. Desc: indicates the page the user came from (document.referrer)
 *
 * request_from_adi - Type: bool. Desc: {1,0}
 *
 * screen_height - Type: numeric. Desc: Height of client device screen
 *
 * screen_width - Type: numeric. Desc: Width of client device screen
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * width - Type: numeric. Desc: {}
 *
 * window_height - Type: numeric. Desc: Initial height of client window
 *
 * window_width - Type: numeric. Desc: Initial width of client window
 *
 * workspace_mode - Type: string.
 * @param {editorLoadingStepEditorFullyReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorLoadingStepEditorFullyReady = function (params) {
    return { evid: 951, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondPublishFacebookShareClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {Free and or Not Connected Premium, Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Publish_facebook_Share_click. Evid: 389.
 * Event description: Second_Publish_facebook_Share_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {Free and or Not Connected Premium, Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondPublishFacebookShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondPublishFacebookShareClick = function (params) {
    return { evid: 389, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardChooseOptionParams
* @property {string} current_step - current step while clicking skip
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selectedValue - value chosen
* @property {string} selected_value - value chosen
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - - does not exist!
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_choose_option. Evid: 779.
 * Event description: choosing options in current step of mobile wizard.

 * current_step - Type: string. Desc: current step while clicking skip
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selectedValue - Type: string. Desc: value chosen
 *
 * selected_value - Type: string. Desc: value chosen
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: - does not exist!
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardChooseOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardChooseOption = function (params) {
    return { evid: 779, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openSiteHistoryFromPushPanelClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Open site history from push panel clicked. Evid: 906.
 * Event description: Fires when a user clicks on the 'site history' text in the 'version pushed' dialog panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openSiteHistoryFromPushPanelClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openSiteHistoryFromPushPanelClicked = function (params) {
    return { evid: 906, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dragHandleParams
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - drag button/indicator line
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: drag handle. Evid: 155.
 * Event description: drag handle.

 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: drag button/indicator line
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dragHandleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dragHandle = function (params) {
    return { evid: 155, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} upgradeToMenuAsContainerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {settings,help_gpp,pinned_teaser}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Upgrade to Menu as Container. Evid: 883.
 * Event description: Upgrade to Menu as Container.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {settings,help_gpp,pinned_teaser}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {upgradeToMenuAsContainerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeToMenuAsContainer = function (params) {
    return { evid: 883, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuCategoryClickParams
* @property {string} category - {main,  members, custom, blog, tpa etc, lightbox, router }
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pages menu-> category click. Evid: 704.
 * Event description: pages menu ->category click.

 * category - Type: string. Desc: {main,  members, custom, blog, tpa etc, lightbox, router }
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuCategoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuCategoryClick = function (params) {
    return { evid: 704, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} codePackageGoToBlocksParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} source - velo_left_tree
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Code Package - Go to Blocks. Evid: 1135.
 * Event description: Panel_Opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: velo_left_tree
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {codePackageGoToBlocksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var codePackageGoToBlocks = function (params) {
    return { evid: 1135, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchClearClickParams
* @property {string} clickOrigin - click / keyboard
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.clear.click. Evid: 992.
 * Event description: Click on X to clear search bar.

 * clickOrigin - Type: string. Desc: click / keyboard
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchClearClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchClearClick = function (params) {
    return { evid: 992, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} removeClickOnWelcomeScreenInMobileToolsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mobile_tool - {welcome screen, browser theme}
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: remove_mobile_tool. Evid: 887.
 * Event description: In mobile tools panel, clicking on remove in three dots menu..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mobile_tool - Type: string. Desc: {welcome screen, browser theme}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {removeClickOnWelcomeScreenInMobileToolsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeClickOnWelcomeScreenInMobileTools = function (params) {
    return { evid: 887, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionZoomOutParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {number} scale - 10,15
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: section_zoom_out. Evid: 476.
 * Event description: section_zoom_out.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * scale - Type: numeric. Desc: 10,15
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionZoomOutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionZoomOut = function (params) {
    return { evid: 476, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelOpenedParams
* @property {string} apps_array - comma separated list of all Application tabs
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} element_name - element_name
* @property {GUID} esi - null
* @property {string} funnel_id - id generated when adding new element to "my elements"
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin -
* @property {string} panel_correlation_id - id, which should change after panel was closed
* @property {string} panel_name - {Translation Key}
* @property {string} panelProps - json with additional info about panel (for error panels - which error opened it)
* @property {string} panelname - panelname
* @property {string} section_correlation_id - id, which should change after layout section panel was closed
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_name - app id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_Opened. Evid: 309.
 * Event description: Panel_Opened.

 * apps_array - Type: string. Desc: comma separated list of all Application tabs
 *
 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid.
 *
 * funnel_id - Type: string. Desc: id generated when adding new element to "my elements"
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string.
 *
 * panel_correlation_id - Type: string. Desc: id, which should change after panel was closed
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * panelProps - Type: string. Desc: json with additional info about panel (for error panels - which error opened it)
 *
 * panelname - Type: string. Desc: panelname
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout section panel was closed
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: app id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelOpened = function (params) {
    return { evid: 309, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcmScrollButtonHoveredParams
* @property {string} component_type - text, image, etc
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} scroll_direction - up / down
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: RCM scroll button hovered. Evid: 1071.
 * Event description: Right Click Menu scroll button hovered.

 * component_type - Type: string. Desc: text, image, etc
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * scroll_direction - Type: string. Desc: up / down
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {rcmScrollButtonHoveredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcmScrollButtonHovered = function (params) {
    return { evid: 1071, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} blogFeedDesignCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_default - 1 - if the user changed anything in the feed design, 0 - if the design is equal to template
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {GUID} metasiteid - msid
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: blog feed design - close. Evid: 658.
 * Event description: Fired when a user close the blog feed design panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_default - Type: bool. Desc: 1 - if the user changed anything in the feed design, 0 - if the design is equal to template
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * metasiteid - Type: guid. Desc: msid
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {blogFeedDesignCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var blogFeedDesignClose = function (params) {
    return { evid: 658, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startSaveProcessParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar/dialog
* @property {string} platform - {editor/app_studio}
* @property {string} save_type - partial/full/first
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: start_save_process. Evid: 461.
 * Event description: start_save_process.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar/dialog
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * save_type - Type: string. Desc: partial/full/first
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startSaveProcessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startSaveProcess = function (params) {
    return { evid: 461, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonClickedCreateACollectionEmptyStateParams
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button - Clicked Create a collection empty state. Evid: 1262.
 * Event description: click the create a c collection blue button on 6th button empty state.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonClickedCreateACollectionEmptyStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonClickedCreateACollectionEmptyState = function (params) {
    return { evid: 1262, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startNowClickExistingUsersVideoParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Start now click existing users video. Evid: 591.
 * Event description: Intro video for existing users: Start now click: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startNowClickExistingUsersVideoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startNowClickExistingUsersVideo = function (params) {
    return { evid: 591, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorStuckParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {number} timeout - timeout
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor stuck. Evid: 1292.
 * Event description: Editor stuck (no actions can be done).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * timeout - Type: numeric. Desc: timeout
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorStuckParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorStuck = function (params) {
    return { evid: 1292, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} duplicateComponentOrTpaParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} component_id - .
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_component_pinned - 0,1
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - Keyboard
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: duplicate_component_or_TPA. Evid: 183.
 * Event description: duplicate_component_or_TPA.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_component_pinned - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: Keyboard
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {duplicateComponentOrTpaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var duplicateComponentOrTpa = function (params) {
    return { evid: 183, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} escButtonClickedWithoutBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ESC button clicked (without back option). Evid: 484.
 * Event description: Without back to old editor option: ESC button clicked: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {escButtonClickedWithoutBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var escButtonClickedWithoutBackOption = function (params) {
    return { evid: 484, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileViewIsOffMessageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_view_is_off_message_click. Evid: 569.
 * Event description: mobile_view_is_off_message_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileViewIsOffMessageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileViewIsOffMessageClick = function (params) {
    return { evid: 569, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} designPanelClosePanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Close button, Esc}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Design_Panel_Close_Panel. Evid: 274.
 * Event description: Design_Panel_Close_Panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Close button, Esc}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {designPanelClosePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var designPanelClosePanel = function (params) {
    return { evid: 274, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rulerClickedGuideAddedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {string} xCoordinate - {}
* @property {string} yCoordinate - {}
**/
/**
 * Name: Ruler clicked_guide_added. Evid: 521.
 * Event description: ruler clicked and guide added.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * xCoordinate - Type: string. Desc: {}
 *
 * yCoordinate - Type: string. Desc: {}
 * @param {rulerClickedGuideAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rulerClickedGuideAdded = function (params) {
    return { evid: 521, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startNowClickWithBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Start now click (with back option). Evid: 482.
 * Event description: With back to old editor option: Start now click: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startNowClickWithBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startNowClickWithBackOption = function (params) {
    return { evid: 482, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} infoIconTooltipOpenParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_name - control_name
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Info.Icon.Tooltip.Open. Evid: 1069.
 * Event description: Event fires when hovering the information icon and the tooltip is opened.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_name - Type: string. Desc: control_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {infoIconTooltipOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var infoIconTooltipOpen = function (params) {
    return { evid: 1069, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} themeTextStylePanelClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {boolean} isChanged - true in case any text design settings  was changed
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - cancel / done
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: ThemeTextStylePanel_click. Evid: 1065.
 * Event description: ThemeTextStylePanel_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * isChanged - Type: bool. Desc: true in case any text design settings  was changed
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: cancel / done
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {themeTextStylePanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var themeTextStylePanelClick = function (params) {
    return { evid: 1065, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} previewPrefetchComparisonParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} devMode - dev mode on/off
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} frames_per_second - null
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_DRAG_PUSH. Evid: 733.
 * Event description: frame_view_rate_DRAG_PUSH.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * devMode - Type: string. Desc: dev mode on/off
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * frames_per_second - Type: numeric.
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {previewPrefetchComparisonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewPrefetchComparison = function (params) {
    return { evid: 733, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverContainerComponentParams
* @property {string} app_id - which app is placed in a container
* @property {string} compName - name, for example, section name
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} component_value - which component_type is placed in a container
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t/f
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} openedPanels - list of panel_names opened on component selection
* @property {string} origin - from where comp was selected
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - Repeater/Strip/Container box
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: hover_container_component. Evid: 1361.
 * Event description: hover container component on the stage (container, repeater, section, strip) - similar to 38:1040, but on hover.

 * app_id - Type: string. Desc: which app is placed in a container
 *
 * compName - Type: string. Desc: name, for example, section name
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * component_value - Type: string. Desc: which component_type is placed in a container
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t/f
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * openedPanels - Type: string. Desc: list of panel_names opened on component selection
 *
 * origin - Type: string. Desc: from where comp was selected
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: Repeater/Strip/Container box
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {hoverContainerComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverContainerComponent = function (params) {
    return { evid: 1361, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishDialogClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} selectedValue - get_free_domain / connect_own_domain
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} step - 1 / 2
* @property {string} target - radio_button / publish_and_continue
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_Dialog_click. Evid: 1385.
 * Event description: First_Publish_Dialog_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * selectedValue - Type: string. Desc: get_free_domain / connect_own_domain
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * step - Type: string. Desc: 1 / 2
 *
 * target - Type: string. Desc: radio_button / publish_and_continue
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {firstPublishDialogClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishDialogClick = function (params) {
    return { evid: 1385, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} submitUrlToGoogleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} video_url - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Submit url to google. Evid: 629.
 * Event description: Click on "Submit url to google" on the get traffic frame.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_url - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {submitUrlToGoogleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var submitUrlToGoogle = function (params) {
    return { evid: 629, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelPanelCloseParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - time spent on panel
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} jsonData - {}
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->Panel Close. Evid: 938.
 * Event description: This event will be sent every time a user closes the Panel.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: time spent on panel
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * jsonData - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelPanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelPanelClose = function (params) {
    return { evid: 938, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickToOpenLayersPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Click to Open Layers Panel. Evid: 1181.
 * Event description: Click to Open Layers Panel inside Hidden Elements Panel in Mobile Editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {clickToOpenLayersPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToOpenLayersPanel = function (params) {
    return { evid: 1181, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteHoverOverColorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - color name
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette Hover over color. Evid: 1429.
 * Event description: Color palette Hover over color.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: color name
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteHoverOverColorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteHoverOverColor = function (params) {
    return { evid: 1429, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuUserRevertedToMainPageParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {drag, quick actions}
* @property {GUID} site_id - {}
* @property {string} source - {site menu ,members menu, custom menu}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_menu_user_reverted_to_main_page. Evid: 418.
 * Event description: PAGES_menu_user_reverted_to_main_page.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {drag, quick actions}
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {site menu ,members menu, custom menu}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuUserRevertedToMainPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuUserRevertedToMainPage = function (params) {
    return { evid: 418, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuDragParams
* @property {string} category - {item_drag / subitem_drag / subitem_created / subitem_deprecated}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} number_of_sub_pages - {0,1,2..}
* @property {string} parent_item_name - page / folder
* @property {boolean} rearrange_order - {1,0}
* @property {GUID} site_id - {}
* @property {string} source - {site menu ,members menu, custom menu}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_menu_drag. Evid: 416.
 * Event description: PAGES_menu_drag.

 * category - Type: string. Desc: {item_drag / subitem_drag / subitem_created / subitem_deprecated}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * number_of_sub_pages - Type: numeric. Desc: {0,1,2..}
 *
 * parent_item_name - Type: string. Desc: page / folder
 *
 * rearrange_order - Type: bool. Desc: {1,0}
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: {site menu ,members menu, custom menu}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuDrag = function (params) {
    return { evid: 416, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} draggingFontsIntoTheFontsManagerParams
* @property {number} count - {number of fonts}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {file_name}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Dragging fonts into the fonts manager. Evid: 595.
 * Event description: Dragging fonts into the fonts manager.

 * count - Type: numeric. Desc: {number of fonts}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {file_name}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {draggingFontsIntoTheFontsManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var draggingFontsIntoTheFontsManager = function (params) {
    return { evid: 595, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputElementsAppointmentFieldSettingsClickOnButtonParams
* @property {string} buttonName - buttonName
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} fieldName - null
* @property {string} inputType - inputType
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Input elements - appointment field settings - click on button. Evid: 1247.
 * Event description: the user clicks on a button/ link in the settings of the appointment (and time zone) field in the editor.

 * buttonName - Type: string. Desc: buttonName
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * fieldName - Type: string.
 *
 * inputType - Type: string. Desc: inputType
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {inputElementsAppointmentFieldSettingsClickOnButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputElementsAppointmentFieldSettingsClickOnButton = function (params) {
    return { evid: 1247, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchAddPanelClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.addPanel.click. Evid: 1026.
 * Event description: user clicked on Search in Add Panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {editorSearchAddPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchAddPanelClick = function (params) {
    return { evid: 1026, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} imageFilterPanelClosedParams
* @property {string} component_name - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} filter_name - {sand, blue-ray,none,...}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp,...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Image_filter_panel_closed. Evid: 556.
 * Event description: Image filter panel closed.

 * component_name - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * filter_name - Type: string. Desc: {sand, blue-ray,none,...}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp,...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {imageFilterPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var imageFilterPanelClosed = function (params) {
    return { evid: 556, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textTextChangedParams
* @property {string} actionOrigin - create_text / regenerate
* @property {string} component_id - for text
* @property {string} component_type - wysiwyg.viewer.components.WRichText
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} origin - .
* @property {string} pageId - page_id
* @property {string} parentComponentId - for component than contain textt box
* @property {string} parentComponentType - for component than contain textt box
* @property {string} sectionType - section_type
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} text - edited text
* @property {string} textOrigin - previous text
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_text_changed. Evid: 979.
 * Event description: text in text box was changed.

 * actionOrigin - Type: string. Desc: create_text / regenerate
 *
 * component_id - Type: string. Desc: for text
 *
 * component_type - Type: string. Desc: wysiwyg.viewer.components.WRichText
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: .
 *
 * pageId - Type: string. Desc: page_id
 *
 * parentComponentId - Type: string. Desc: for component than contain textt box
 *
 * parentComponentType - Type: string. Desc: for component than contain textt box
 *
 * sectionType - Type: string. Desc: section_type
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * text - Type: string. Desc: edited text
 *
 * textOrigin - Type: string. Desc: previous text
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {textTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textTextChanged = function (params) {
    return { evid: 979, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} codeEmbedApplyClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} errorReason - no https / embed_restricted / null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isSuccess - true/false
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} vsi - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Code_embed_apply_clicked. Evid: 749.
 * Event description: Code embed apply clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * errorReason - Type: string. Desc: no https / embed_restricted / null
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isSuccess - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * vsi - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {codeEmbedApplyClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var codeEmbedApplyClicked = function (params) {
    return { evid: 749, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} fontsUploadFailedIndicatorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} file_size - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - null
* @property {string} multilingual - null
* @property {string} name - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: fonts upload failed indicator. Evid: 603.
 * Event description: fonts upload failed indicator.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * file_size - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {fontsUploadFailedIndicatorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fontsUploadFailedIndicator = function (params) {
    return { evid: 603, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} approveStoppingWhileUploadingFontsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} text - {cancel / delete}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Approve stopping while uploading fonts. Evid: 611.
 * Event description: approving the 'are you sure' dialog when stopping the upload in the middle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * text - Type: string. Desc: {cancel / delete}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {approveStoppingWhileUploadingFontsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var approveStoppingWhileUploadingFonts = function (params) {
    return { evid: 611, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addSectionPhaseFinishedParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} category - category of the add section panel
* @property {string} correlation_id - correlation_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {number} duration - duration
* @property {GUID} esi - esi
* @property {boolean} is_injected_content - true if content was already injected
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} phaseName - first thumbnail ready / all thumbnails ready
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: AddSection - phase finished. Evid: 1311.
 * Event description: BI event for measuring time from start loading sections, to the first thumbnail ready and to all thumbnails ready.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * category - Type: string. Desc: category of the add section panel
 *
 * correlation_id - Type: string. Desc: correlation_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * duration - Type: numeric. Desc: duration
 *
 * esi - Type: guid. Desc: esi
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * phaseName - Type: string. Desc: first thumbnail ready / all thumbnails ready
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addSectionPhaseFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addSectionPhaseFinished = function (params) {
    return { evid: 1311, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorComponentsComponentEditedParams
* @property {string} action_type - edit/duplicate/drag/delete
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} control_id - setting name (as example we can use 38:365): it should be some identifier of control (setting), example: Social_Bar_Layout__Icon_Size
* @property {string} control_type - dropdown/checkbox/slider/toggle/thumbnail/text input
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} is_valid - false - if user get validation error
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} measure - null
* @property {string} multilingual - multilingual
* @property {string} new_value - which value user selected (if it numeric -> cast to str), if it check box we will send set of selected values *specifically for text input - debounce
* @property {string} page_id - page_id
* @property {string} panel_type - layout/settings/manage/behaviors/..
* @property {string} prev_value - which value were selected
* @property {GUID} site_id - {site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor Components: Component Edited. Evid: 1399.
 * Event description: Editor Components: Component Edited.

 * action_type - Type: string. Desc: edit/duplicate/drag/delete
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * control_id - Type: string. Desc: setting name (as example we can use 38:365): it should be some identifier of control (setting), example: Social_Bar_Layout__Icon_Size
 *
 * control_type - Type: string. Desc: dropdown/checkbox/slider/toggle/thumbnail/text input
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * is_valid - Type: bool. Desc: false - if user get validation error
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * measure - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_value - Type: string. Desc: which value user selected (if it numeric -> cast to str), if it check box we will send set of selected values *specifically for text input - debounce
 *
 * page_id - Type: string. Desc: page_id
 *
 * panel_type - Type: string. Desc: layout/settings/manage/behaviors/..
 *
 * prev_value - Type: string. Desc: which value were selected
 *
 * site_id - Type: guid. Desc: {site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editorComponentsComponentEditedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorComponentsComponentEdited = function (params) {
    return { evid: 1399, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyStyleCancelParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: copy_style_cancel. Evid: 320.
 * Event description: copy_style_cancel.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyStyleCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyStyleCancel = function (params) {
    return { evid: 320, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardWixLogoClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {regular_wizard, landing_page_wizard}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_Wix_logo_click. Evid: 782.
 * Event description: logo click inside the mobile wizard.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {regular_wizard, landing_page_wizard}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardWixLogoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardWixLogoClick = function (params) {
    return { evid: 782, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaOpenSettingsParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp,double_click...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_open_settings. Evid: 179.
 * Event description: tpa_open_settings.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp,double_click...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tpaOpenSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaOpenSettings = function (params) {
    return { evid: 179, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} layerHierarchyClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} layer_name - {}
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - open / close
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: layer hierarchy click. Evid: 1185.
 * Event description: click layer hierarchy to open or close it.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * layer_name - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: open / close
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {layerHierarchyClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var layerHierarchyClick = function (params) {
    return { evid: 1185, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} megaMenuMenuModeStartedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} container_id - Component id of selected container
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} item_id - The id of the mega menu item in edit mode
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} menuId - menuId
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} session_id - id for the edit session. not logged_session_uuid!
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Mega Menu - Menu Mode Started. Evid: 1391.
 * Event description: Mega Menu - Menu Mode Started.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * container_id - Type: string. Desc: Component id of selected container
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * item_id - Type: string. Desc: The id of the mega menu item in edit mode
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * menuId - Type: string. Desc: menuId
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * session_id - Type: string. Desc: id for the edit session. not logged_session_uuid!
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {megaMenuMenuModeStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var megaMenuMenuModeStarted = function (params) {
    return { evid: 1391, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageOrPopUpDeletedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_or_popup - {page, pop up,members page,members area}
* @property {number} page_popup_id - {}
* @property {string} page_popup_name - {}
* @property {string} page_popup_string_id - {mainPage,zxc5v,...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_or_pop_up _deleted. Evid: 564.
 * Event description: page_or_pop_up _deleted.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_or_popup - Type: string. Desc: {page, pop up,members page,members area}
 *
 * page_popup_id - Type: numeric. Desc: {}
 *
 * page_popup_name - Type: string. Desc: {}
 *
 * page_popup_string_id - Type: string. Desc: {mainPage,zxc5v,...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageOrPopUpDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageOrPopUpDeleted = function (params) {
    return { evid: 564, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog2ConnectExistingDomainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_2_connect_existing_domain_click. Evid: 328.
 * Event description: First_Save_Dialog_2_connect_existing_domain_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog2ConnectExistingDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog2ConnectExistingDomainClick = function (params) {
    return { evid: 328, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sitePagesActionsParams
* @property {string} app_id - {id of app}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of host app id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {id of page}
* @property {string} page_name - {name of page}
* @property {string} page_type - {default, custom, app_replacer}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {rename,settings, hide, delete and reset, custom action, etc any action inside context menu, custom_action}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Pages Actions. Evid: 1441.
 * Event description: Context menu in Site pages click.

 * app_id - Type: string. Desc: {id of app}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of host app id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {id of page}
 *
 * page_name - Type: string. Desc: {name of page}
 *
 * page_type - Type: string. Desc: {default, custom, app_replacer}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {rename,settings, hide, delete and reset, custom action, etc any action inside context menu, custom_action}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sitePagesActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sitePagesActions = function (params) {
    return { evid: 1441, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ratingInputSettingsShowLabelsToggleChangedParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {mainpage}
* @property {string} panel_name - {}
* @property {string} preset_id - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {on,off}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Rating_input_settings_show_labels_toggle_changed. Evid: 801.
 * Event description: Rating_input_settings_show_labels_toggle_changed.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {mainpage}
 *
 * panel_name - Type: string. Desc: {}
 *
 * preset_id - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {on,off}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ratingInputSettingsShowLabelsToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ratingInputSettingsShowLabelsToggleChanged = function (params) {
    return { evid: 801, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuOpenParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} app_state - {first-time, return to first-time, steady-state}
* @property {string} button_state - {installed, promotional}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first - {true,false}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {app market install app,add menu install app,template first-time,promotional button first-time}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_open. Evid: 192.
 * Event description: site_app_menu_open.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * app_state - Type: string. Desc: {first-time, return to first-time, steady-state}
 *
 * button_state - Type: string. Desc: {installed, promotional}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first - Type: bool. Desc: {true,false}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {app market install app,add menu install app,template first-time,promotional button first-time}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuOpen = function (params) {
    return { evid: 192, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelAlignmentClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - click_to_open / left / right / center / wide
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Alignment_Click. Evid: 233.
 * Event description: Text_Panel_Alignment_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: click_to_open / left / right / center / wide
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelAlignmentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelAlignmentClick = function (params) {
    return { evid: 233, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderManageChoicesUpdateChoiceNameParams
* @property {string} component_id - component_id
* @property {string} component_type - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - Manage Choices - update choice name. Evid: 1168.
 * Event description: Form widget --> Multiple choices field --> Manage Choices --> update Choice name.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderManageChoicesUpdateChoiceNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderManageChoicesUpdateChoiceName = function (params) {
    return { evid: 1168, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} changeInFeedDesignParams
* @property {string} cardId - post body, image, etc...
* @property {string} control_name - control_name
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {GUID} metasiteid - msid
* @property {string} multilingual - null
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - 1 - on, 0 - off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - value
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: change in feed design. Evid: 656.
 * Event description: Fired when user turn on/off changes in the blog feed design.

 * cardId - Type: string. Desc: post body, image, etc...
 *
 * control_name - Type: string. Desc: control_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * metasiteid - Type: guid. Desc: msid
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: 1 - on, 0 - off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: value
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {changeInFeedDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeInFeedDesign = function (params) {
    return { evid: 656, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpLayoutChangedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {top, bottom, right, left}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_layout_changed. Evid: 565.
 * Event description: pop_up_layout_changed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {top, bottom, right, left}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpLayoutChanged = function (params) {
    return { evid: 565, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppTemplateFirsttimeStep1introContinueClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_template_firsttime_step1intro_continue_click. Evid: 198.
 * Event description: site_app_template_firsttime_step1intro_continue_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppTemplateFirsttimeStep1introContinueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppTemplateFirsttimeStep1introContinueClick = function (params) {
    return { evid: 198, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesPageTransitionSelectedClickParams
* @property {string} category - {none, swipe horizontal, swipe vertical...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_page_transition_selected_click. Evid: 415.
 * Event description: PAGES_page_transition_selected_click.

 * category - Type: string. Desc: {none, swipe horizontal, swipe vertical...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesPageTransitionSelectedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesPageTransitionSelectedClick = function (params) {
    return { evid: 415, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuMenuSetDeletedParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {number} deletedActiveMenuSetCount - how many components currently used this deleted menu set
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_menu_set_deleted. Evid: 1046.
 * Event description: MENU_menu_set_deleted.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * deletedActiveMenuSetCount - Type: numeric. Desc: how many components currently used this deleted menu set
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuMenuSetDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuMenuSetDeleted = function (params) {
    return { evid: 1046, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} documentSettingsShowTheTitleToggleOnOffParams
* @property {string} component_id - {}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - (true,false)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Document Settings show the title toggle on/off. Evid: 878.
 * Event description: Document Settings show the title toggle on/off.

 * component_id - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: (true,false)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {documentSettingsShowTheTitleToggleOnOffParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var documentSettingsShowTheTitleToggleOnOff = function (params) {
    return { evid: 878, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsTabClickParams
* @property {string} category - {page info, layout, privacy, SEO}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - { main, members, custom, blog, store, lightbox, router, dynamic page}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_tab_click. Evid: 422.
 * Event description: PAGES_settings_tab_click.

 * category - Type: string. Desc: {page info, layout, privacy, SEO}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: { main, members, custom, blog, store, lightbox, router, dynamic page}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsTabClick = function (params) {
    return { evid: 422, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardBusinessNameTypingParams
* @property {string} contentLanguage - The content Language used for the intro
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {number} returnedResults - how many resuslts the user sees, 0 for zero matches
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} text - searched text
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Business Name - typing. Evid: 1269.
 * Event description: user typed text, Send every time we showing result to user based on a typed text.

 * contentLanguage - Type: string. Desc: The content Language used for the intro
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * returnedResults - Type: numeric. Desc: how many resuslts the user sees, 0 for zero matches
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * text - Type: string. Desc: searched text
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardBusinessNameTypingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardBusinessNameTyping = function (params) {
    return { evid: 1269, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} showControlsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - handle,shortcut
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: show_controls. Evid: 500.
 * Event description: show_controls.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: handle,shortcut
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {showControlsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showControls = function (params) {
    return { evid: 500, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} designPanelSelectPresetClickParams
* @property {string} component_id - {a,b,c...}
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} preset_data_skin - {}
* @property {string} preset_data_tags - {yellow, buy, circle...}
* @property {string} preset_id - --
* @property {string} section - {My buttons, themes...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} style_id - {a,b,c...}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: Design_Panel_Select_Preset_Click. Evid: 275.
 * Event description: Design_Panel_Select_Preset_Click.

 * component_id - Type: string. Desc: {a,b,c...}
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * preset_data_skin - Type: string. Desc: {}
 *
 * preset_data_tags - Type: string. Desc: {yellow, buy, circle...}
 *
 * preset_id - Type: string. Desc: --
 *
 * section - Type: string. Desc: {My buttons, themes...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * style_id - Type: string. Desc: {a,b,c...}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {designPanelSelectPresetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var designPanelSelectPresetClick = function (params) {
    return { evid: 275, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} loginRelatedErrorMessageShowParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: login_related_error_message_show. Evid: 1149.
 * Event description: iframe error message that user sees when he can't perform the action while he logged out or logged in to another account.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {loginRelatedErrorMessageShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var loginRelatedErrorMessageShow = function (params) {
    return { evid: 1149, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickOnPagesPanelOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {top bar/ left tree/ gfpp  Hmenu}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Click_on_pages_panel_open. Evid: 703.
 * Event description: Click_on_pages_panel_open.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {top bar/ left tree/ gfpp  Hmenu}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickOnPagesPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnPagesPanelOpen = function (params) {
    return { evid: 703, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesQuickActionsMenuClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_quick_actions_menu_click. Evid: 419.
 * Event description: PAGES_quick_actions_menu_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesQuickActionsMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesQuickActionsMenuClick = function (params) {
    return { evid: 419, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsTrackAddedParams
* @property {string} comp_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} source - upload / soundcloud / spotify / other_url
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} track_id - track_id
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.track.added. Evid: 1210.
 * Event description: successful track set up in Audio Player settings.

 * comp_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: upload / soundcloud / spotify / other_url
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * track_id - Type: string. Desc: track_id
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsTrackAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsTrackAdded = function (params) {
    return { evid: 1210, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clipboardErrorParams
* @property {string} action - {set/get}
* @property {string} copy_option - {keyboard/rcm/toolbar}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} error_type - {local storage is full/local storage is not accessible}
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item_type - {page/TPA/container/group/multiselect/text}
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Clipboard Error. Evid: 90.
 * Event description: Clipboard Error when "Local storage is full" or "Local storage is not accessible".

 * action - Type: string. Desc: {set/get}
 *
 * copy_option - Type: string. Desc: {keyboard/rcm/toolbar}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * error_type - Type: string. Desc: {local storage is full/local storage is not accessible}
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_type - Type: string. Desc: {page/TPA/container/group/multiselect/text}
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clipboardErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clipboardError = function (params) {
    return { evid: 90, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} unpinFromScreenParams
* @property {string} component_id - component_id
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {rcm, panel}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: dummy-name. Evid: 333.
 * Event description: unpin_from _screen.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {rcm, panel}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {unpinFromScreenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var unpinFromScreen = function (params) {
    return { evid: 333, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} autoSaveDiffSavedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} success - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {idle, num of actions}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: auto_save_diff_saved. Evid: 622.
 * Event description: auto_save_diff_saved (deprecated from code on 2023-07-18).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * success - Type: bool.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {idle, num of actions}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {autoSaveDiffSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autoSaveDiffSaved = function (params) {
    return { evid: 622, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationPredictionErrorParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} errorMessage - errorMessage
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - {}
* @property {number} revision - site revision
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - PREDICTION_ERROR. Evid: 1380.
 * Event description: PREDICTION_ERROR - if Editor didn't get info from prediction model OR got not full info.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * errorMessage - Type: string. Desc: errorMessage
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: {}
 *
 * revision - Type: numeric. Desc: site revision
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationPredictionErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationPredictionError = function (params) {
    return { evid: 1380, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelTextClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} font - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->  text click. Evid: 939.
 * Event description: This event will be sent every time a user choose font type.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * font - Type: string. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelTextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelTextClick = function (params) {
    return { evid: 939, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateParams
* @property {string} action_name - type of action done by user
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate. Evid: 713.
 * Event description: frame view rate.

 * action_name - Type: string. Desc: type of action done by user
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRate = function (params) {
    return { evid: 713, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelTextOrientationClickParams
* @property {string} category - {RTL, LTR}
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Text_Orientation_Click. Evid: 239.
 * Event description: Text_Panel_Text_Orientation_Click.

 * category - Type: string. Desc: {RTL, LTR}
 *
 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelTextOrientationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelTextOrientationClick = function (params) {
    return { evid: 239, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelRenderedParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} isMultiColumns - flag for cases when panel was opened from multi-column strip component
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - -
* @property {string} panel_name - {Translation Key}
* @property {string} panelProps - json with additional info about panel (for error panels - which error opened it)
* @property {string} panelname - panelname
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_name - app id
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_Rendered. Evid: 1395.
 * Event description: panel is rendered (will fire only for strip-related gfpp panels as for now).

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * isMultiColumns - Type: bool. Desc: flag for cases when panel was opened from multi-column strip component
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: -
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * panelProps - Type: string. Desc: json with additional info about panel (for error panels - which error opened it)
 *
 * panelname - Type: string. Desc: panelname
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: app id
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {panelRenderedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelRendered = function (params) {
    return { evid: 1395, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuHelpCategoryClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> help category click. Evid: 104.
 * Event description: add menu -> help category click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuHelpCategoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuHelpCategoryClick = function (params) {
    return { evid: 104, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesAddDynamicPageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_Add_dynamic_page_click. Evid: 699.
 * Event description: PAGES_Add_dynamic_page_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesAddDynamicPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesAddDynamicPageClick = function (params) {
    return { evid: 699, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} designPanelCustomizeButtonClickParams
* @property {string} chosen_style_id - {a,b,c...}
* @property {string} component_id - {a,b,c...}
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {boolean} was_preset_clicked_current_session - {0,1}
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: Design_Panel_Customize_Button_Click. Evid: 276.
 * Event description: Design_Panel_Customize_Button_Click.

 * chosen_style_id - Type: string. Desc: {a,b,c...}
 *
 * component_id - Type: string. Desc: {a,b,c...}
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * was_preset_clicked_current_session - Type: bool. Desc: {0,1}
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {designPanelCustomizeButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var designPanelCustomizeButtonClick = function (params) {
    return { evid: 276, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationUpdateLaterButtonInHeavyMigrationParams
* @property {string} action_type - show/click
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - {}
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Section migration - Update later button in Heavy migration. Evid: 1483.
 * Event description: Actions with Update later button in Heavy migration flow.

 * action_type - Type: string. Desc: show/click
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {sectionMigrationUpdateLaterButtonInHeavyMigrationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationUpdateLaterButtonInHeavyMigration = function (params) {
    return { evid: 1483, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rememberToSaveActiveSaveParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: remember_to_save_active_save. Evid: 457.
 * Event description: remember_to_save_active_save.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rememberToSaveActiveSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rememberToSaveActiveSave = function (params) {
    return { evid: 457, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} choseCachingAtutomaticManualInDropdownParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} selection - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: chose_caching_atutomatic_manual_in_dropdown. Evid: 838.
 * Event description: chose_caching_atutomatic_manual_in_dropdown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * selection - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {choseCachingAtutomaticManualInDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var choseCachingAtutomaticManualInDropdown = function (params) {
    return { evid: 838, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageScrollInAddPagePanelParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_injected_content - true if content was already injected version_of_content
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {tool bar, handle}
* @property {string} scrollTop - where user stoped scrolling (y value)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - blank/about/project/contact/etc
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - scroll in add page panel. Evid: 1080.
 * Event description: send when scroll in add page panel.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected version_of_content
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {tool bar, handle}
 *
 * scrollTop - Type: string. Desc: where user stoped scrolling (y value)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: blank/about/project/contact/etc
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageScrollInAddPagePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageScrollInAddPagePanel = function (params) {
    return { evid: 1080, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeUnhideComponentParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} parent_component_id - parent component id
* @property {string} parent_component_type - parent component type
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_unhide_component. Evid: 1012.
 * Event description: Unhide component in interaction mode.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * parent_component_id - Type: string. Desc: parent component id
 *
 * parent_component_type - Type: string. Desc: parent component type
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionModeUnhideComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeUnhideComponent = function (params) {
    return { evid: 1012, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickOnCreateNewElementFromLinkPanelParams
* @property {string} category - category of element was clicked to add (lightbox | page | anchor)
* @property {string} component_id - id of component
* @property {string} component_type - type of component
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: click on create new element from link panel. Evid: 1221.
 * Event description: user click on creating new element in link panel.

 * category - Type: string. Desc: category of element was clicked to add (lightbox | page | anchor)
 *
 * component_id - Type: string. Desc: id of component
 *
 * component_type - Type: string. Desc: type of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {clickOnCreateNewElementFromLinkPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnCreateNewElementFromLinkPanel = function (params) {
    return { evid: 1221, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutGetResultLayoutIdeasParams
* @property {string} black_list - json with blacklisted components
* @property {string} component_id - id of selected section
* @property {number} components_amount - number of components in the selected section
* @property {string} correlation_id - id, which should change after layout panel was closed
* @property {string} data_science_classification - WrichText classification
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {number} duration - time in ms that took to load layout panel
* @property {string} edit_section_result - json with results
* @property {string} engine_type - paas or bruteforce
* @property {GUID} esi - esi
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_list - whether the section contains lists (true/false)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} result - json with component_type and component_id of all components of returned layouts
* @property {number} resultCount - amount of layouts that were returned (if there is no result - no layout - send 0)
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {string} section_name_personal - name of the section assigned by the user, if the user did not change the name then send a technical name)
* @property {string} section_name_technical - name of the section (welcome, about, e.t.c)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - get result (layout ideas). Evid: 1272.
 * Event description: Panel open or click on other section to see another layouts (Finish event).

 * black_list - Type: string. Desc: json with blacklisted components
 *
 * component_id - Type: string. Desc: id of selected section
 *
 * components_amount - Type: numeric. Desc: number of components in the selected section
 *
 * correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * data_science_classification - Type: string. Desc: WrichText classification
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * duration - Type: numeric. Desc: time in ms that took to load layout panel
 *
 * edit_section_result - Type: string. Desc: json with results
 *
 * engine_type - Type: string. Desc: paas or bruteforce
 *
 * esi - Type: guid. Desc: esi
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_list - Type: bool. Desc: whether the section contains lists (true/false)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * result - Type: string. Desc: json with component_type and component_id of all components of returned layouts
 *
 * resultCount - Type: numeric. Desc: amount of layouts that were returned (if there is no result - no layout - send 0)
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * section_name_personal - Type: string. Desc: name of the section assigned by the user, if the user did not change the name then send a technical name)
 *
 * section_name_technical - Type: string. Desc: name of the section (welcome, about, e.t.c)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutGetResultLayoutIdeasParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutGetResultLayoutIdeas = function (params) {
    return { evid: 1272, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchRequestResultParams
* @property {string} correlationId - one search intent id
* @property {number} itemsCount - # of received results
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {string} errorMessage - error_message
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} loadingDuration - loading time in ms
* @property {string} multilingual - {}
* @property {string} origin - shortcut / settings / top_bar / add_panel
* @property {string} requestId - id for each target search
* @property {string} result - json with results
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - t / f
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.request.result. Evid: 991.
 * Event description: Search request results were received from the server.

 * correlationId - Type: string. Desc: one search intent id
 *
 * itemsCount - Type: numeric. Desc: # of received results
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * errorMessage - Type: string. Desc: error_message
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * loadingDuration - Type: numeric. Desc: loading time in ms
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: shortcut / settings / top_bar / add_panel
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * result - Type: string. Desc: json with results
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: t / f
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchRequestResultParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchRequestResult = function (params) {
    return { evid: 991, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} autowritingStartParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Autowiring start. Evid: 1463.
 * Event description: Autowiring start.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {autowritingStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autowritingStart = function (params) {
    return { evid: 1463, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dontShowAgainClickParams
* @property {string} component_id - .
* @property {string} component_type - component_TYPE
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} panelName - panel_name
* @property {string} popupType - first_time / last_time
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: dontShowAgain_click. Evid: 1057.
 * Event description: user click 'Don't Show this AGain' on FirstTime PopUps.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_TYPE
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * panelName - Type: string. Desc: panel_name
 *
 * popupType - Type: string. Desc: first_time / last_time
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {dontShowAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dontShowAgainClick = function (params) {
    return { evid: 1057, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesUpdateChoiceNameParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - update choice name. Evid: 909.
 * Event description: user updating choice name.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesUpdateChoiceNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesUpdateChoiceName = function (params) {
    return { evid: 909, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} applyOnOtherSlidesParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Apply on other slides. Evid: 539.
 * Event description: Apply on other slides.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {applyOnOtherSlidesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var applyOnOtherSlides = function (params) {
    return { evid: 539, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorSpaceAddNewColorPreviousColorClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color_Space_Add_New_Color_PreviousColorClick. Evid: 400.
 * Event description: Color_Space_Add_New_Color_PreviousColorClick.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorSpaceAddNewColorPreviousColorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorSpaceAddNewColorPreviousColorClick = function (params) {
    return { evid: 400, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderStepValueChangedParams
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - 1,2,3..
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} type - Value/Number
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_step_value_changed. Evid: 1323.
 * Event description: range_slider_step_value_changed.

 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: 1,2,3..
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * type - Type: string. Desc: Value/Number
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderStepValueChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderStepValueChanged = function (params) {
    return { evid: 1323, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationScrollEffectPanelDropDownChooseDistanationParams
* @property {string} dm_version - dm_version
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - the name of the panel that the user clicked on
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_scroll_effect_panel_drop_down_choose_distanation. Evid: 1439.
 * Event description: The event fires when users choose a specific panel: animation / scroll_effecrt from drop downd menu.

 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: the name of the panel that the user clicked on
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {animationScrollEffectPanelDropDownChooseDistanationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationScrollEffectPanelDropDownChooseDistanation = function (params) {
    return { evid: 1439, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} appMarketIconExpandedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: app_market_icon_expanded. Evid: 675.
 * Event description: sent on appmarket icon expanded in the Editor (currently happens after site publish event).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {appMarketIconExpandedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appMarketIconExpanded = function (params) {
    return { evid: 675, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} wixSearchAppSetPlaceholderTextChangedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - placeholder text instead of default 'Search'
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: wixSearch.appSet.placeholderText.changed. Evid: 919.
 * Event description: User changed placeholder text in Search Box Settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: placeholder text instead of default 'Search'
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {wixSearchAppSetPlaceholderTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixSearchAppSetPlaceholderTextChanged = function (params) {
    return { evid: 919, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} permissionModalClosedParams
* @property {GUID} app_id - [guid]
* @property {string} closing_method - {X, cancel}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: permission_modal_closed. Evid: 189.
 * Event description: permission_modal_closed.

 * app_id - Type: guid. Desc: [guid]
 *
 * closing_method - Type: string. Desc: {X, cancel}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {permissionModalClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var permissionModalClosed = function (params) {
    return { evid: 189, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeTextStyleChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_text_style_changed. Evid: 1004.
 * Event description: Closing the text settings panel, if settings were changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionModeTextStyleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeTextStyleChanged = function (params) {
    return { evid: 1004, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageReplacePageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - name of the page
* @property {string} origin - thumbnail / replace_popup / preview
* @property {string} page_id - page_id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - replace page click. Evid: 1143.
 * Event description: AddPage - replace page click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: name of the page
 *
 * origin - Type: string. Desc: thumbnail / replace_popup / preview
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageReplacePageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageReplacePageClick = function (params) {
    return { evid: 1143, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} escButtonClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mode - Which mode the user exit by pressing ESC button
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ESC button clicked. Evid: 1284.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mode - Type: string. Desc: Which mode the user exit by pressing ESC button
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {escButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var escButtonClicked = function (params) {
    return { evid: 1284, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityAriaLabelsParams
* @property {string} aria_prop - activedescendant,atomic,autocomplete,busy,checked,colcount,colindex,colspan,controls,current,describedby,details,disabled,dragged,dropeffect,errormessage,expanded,flowto,haspopup,hidden,invalid,label,labelledby,level,live,modal,multiline,multiselectable,orientation,owns,placeholder,posinset,pressed,readonly,relevant,required,rowcount,rowindex,rowspan,selected,setsize,sort,valuemax,valuemin,valuenow,valuetext,tabindex,role
* @property {string} componentName - button/text_input/dropdown/radio/checkbox/date_picker/range/lightbox/text/box/strip/repeater
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} prop_token - depends on the aria_prop
* @property {string} prop_category - relationships,live,description,state,DND
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - add / save
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility - aria labels. Evid: 927.
 * Event description: the "Add attribute" properties aria label per component and aria.

 * aria_prop - Type: string. Desc: activedescendant,atomic,autocomplete,busy,checked,colcount,colindex,colspan,controls,current,describedby,details,disabled,dragged,dropeffect,errormessage,expanded,flowto,haspopup,hidden,invalid,label,labelledby,level,live,modal,multiline,multiselectable,orientation,owns,placeholder,posinset,pressed,readonly,relevant,required,rowcount,rowindex,rowspan,selected,setsize,sort,valuemax,valuemin,valuenow,valuetext,tabindex,role
 *
 * componentName - Type: string. Desc: button/text_input/dropdown/radio/checkbox/date_picker/range/lightbox/text/box/strip/repeater
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * prop_token - Type: string. Desc: depends on the aria_prop
 *
 * prop_category - Type: string. Desc: relationships,live,description,state,DND
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: add / save
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {accessibilityAriaLabelsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityAriaLabels = function (params) {
    return { evid: 927, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuCreateNewMenuSetClickParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_create_new_menu_set_click. Evid: 973.
 * Event description: MENU_create_new_menu_set_click.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuCreateNewMenuSetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuCreateNewMenuSetClick = function (params) {
    return { evid: 973, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hideControlsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - handle,tooltip,shortcut
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hide_controls. Evid: 499.
 * Event description: hide_controls.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: handle,tooltip,shortcut
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hideControlsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hideControls = function (params) {
    return { evid: 499, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} timingPanelBehaviorSavedParams
* @property {string} behavior_name - Ease Both/Ease In/Ease Out/Elastic/Linear
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {number} delay - delay value
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration value
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: timing_panel_behavior_saved. Evid: 85.
 * Event description: Closing the Timing panel, if behaviour was changed.

 * behavior_name - Type: string. Desc: Ease Both/Ease In/Ease Out/Elastic/Linear
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * delay - Type: numeric. Desc: delay value
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration value
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {timingPanelBehaviorSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var timingPanelBehaviorSaved = function (params) {
    return { evid: 85, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsMoveLeftRightParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {rcm, keyboard}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_move_left_right. Evid: 579.
 * Event description: columns_move_left_right.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {rcm, keyboard}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsMoveLeftRightParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsMoveLeftRight = function (params) {
    return { evid: 579, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelAddShadowClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - Regular/Hover
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel ---> Add shadow click. Evid: 934.
 * Event description: This event will be sent every time a user clicks on the Add shadow  button.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: Regular/Hover
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelAddShadowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelAddShadowClick = function (params) {
    return { evid: 934, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickChangeIconQuickActionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_change_icon_quick_action. Evid: 727.
 * Event description: click_change_icon_quick_action.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickChangeIconQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickChangeIconQuickAction = function (params) {
    return { evid: 727, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPopUpOpensWithoutBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video pop up opens (without back option). Evid: 479.
 * Event description: Without back to old editor option: Intro video for existing users loads.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPopUpOpensWithoutBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPopUpOpensWithoutBackOption = function (params) {
    return { evid: 479, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} multilingualDonTShowAgainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle_state - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Multilingual_don't_show_again_click. Evid: 770.
 * Event description: Multilingual_don't_show_again_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle_state - Type: bool. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {multilingualDonTShowAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var multilingualDonTShowAgainClick = function (params) {
    return { evid: 770, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardNavigatePageParams
* @property {string} current_page_id - ID of current page
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} next_page_id - ID of page navigated to
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_navigate_page. Evid: 792.
 * Event description: Mobile wizard navigate to non-landing page.

 * current_page_id - Type: string. Desc: ID of current page
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * next_page_id - Type: string. Desc: ID of page navigated to
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardNavigatePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardNavigatePage = function (params) {
    return { evid: 792, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lottiePlayInLoopToggleChangedParams
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - on/off
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: lottie_play_in_loop_toggle_changed. Evid: 1350.
 * Event description: lottie_play_in_loop_toggle_changed.

 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: on/off
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {lottiePlayInLoopToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lottiePlayInLoopToggleChanged = function (params) {
    return { evid: 1350, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} outOfGridLinesParams
* @property {string} component_id - component_id
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} is_same_parent_component - element moved inside current parent component (true/false)
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - null
* @property {string} source_name - source container
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: out_of_grid_lines. Evid: 814.
 * Event description: when placing component out of grid lines.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * is_same_parent_component - Type: bool. Desc: element moved inside current parent component (true/false)
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid.
 *
 * source_name - Type: string. Desc: source container
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {outOfGridLinesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var outOfGridLines = function (params) {
    return { evid: 814, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerChangeVideoSourceParsingDoneParams
* @property {string} component_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {boolean} success - is url valid
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoUrl - parsing url
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.changeVideoSource.parsing.done. Evid: 863.
 * Event description: User clicked on 'Select video from' on socials -> paste url to add video.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: is url valid
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoUrl - Type: string. Desc: parsing url
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerChangeVideoSourceParsingDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerChangeVideoSourceParsingDone = function (params) {
    return { evid: 863, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} selectiveTextInputFieldSelectedParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field_selected - {field id or label}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - {Checked, Unchecked}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: SelectiveTextInput_FieldSelected. Evid: 363.
 * Event description: SelectiveTextInput_FieldSelected.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field_selected - Type: string. Desc: {field id or label}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {Checked, Unchecked}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {selectiveTextInputFieldSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectiveTextInputFieldSelected = function (params) {
    return { evid: 363, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lightboxAddedToStageFromLinkPanelParams
* @property {string} category - {boxSlideShow}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_target_repeated - {true,false} Is target contained in a repeater
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - {link panel}
* @property {string} page_id - page id where the lightbox was added
* @property {string} preset_data_skin - skin
* @property {string} preset_data_tags - {yellow, buy, circle...}
* @property {string} preset_id - --
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target_component - {compType} //will be page if add to stage
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Lightbox added to stage from link panel. Evid: 1234.
 * Event description: The event fires when a lightbox is added to stage from link panel.

 * category - Type: string. Desc: {boxSlideShow}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_target_repeated - Type: bool. Desc: {true,false} Is target contained in a repeater
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: {link panel}
 *
 * page_id - Type: string. Desc: page id where the lightbox was added
 *
 * preset_data_skin - Type: string. Desc: skin
 *
 * preset_data_tags - Type: string. Desc: {yellow, buy, circle...}
 *
 * preset_id - Type: string. Desc: --
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target_component - Type: string. Desc: {compType} //will be page if add to stage
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {lightboxAddedToStageFromLinkPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lightboxAddedToStageFromLinkPanel = function (params) {
    return { evid: 1234, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsUploadTrackClickParams
* @property {string} comp_id - component_id
* @property {string} component_type - wixui.VideoPlayer / wysiwyg.viewer.components.Video
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.uploadTrack.click. Evid: 1205.
 * Event description: upload Track clicked in Audio Player settings.

 * comp_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: wixui.VideoPlayer / wysiwyg.viewer.components.Video
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsUploadTrackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsUploadTrackClick = function (params) {
    return { evid: 1205, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelResetToThemeClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Reset_to_theme_Click. Evid: 249.
 * Event description: Text_Panel_Reset_to_theme_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelResetToThemeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelResetToThemeClick = function (params) {
    return { evid: 249, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverboxChangeTabParams
* @property {string} component_id - component_id
* @property {string} componentType - component_type
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tabName - regular/hover
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hoverbox_change_tab. Evid: 1074.
 * Event description: Switch to another tab in hoverbox (regular, hover).

 * component_id - Type: string. Desc: component_id
 *
 * componentType - Type: string. Desc: component_type
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tabName - Type: string. Desc: regular/hover
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverboxChangeTabParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverboxChangeTab = function (params) {
    return { evid: 1074, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarWixCodeResourcesClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item_name - {Forum , API Reference, Documentation}
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {dev_mode,help_home}
* @property {GUID} site_id - {site guid}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: wix code resources clicked. Evid: 785.
 * Event description: top bar Wix code resources clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_name - Type: string. Desc: {Forum , API Reference, Documentation}
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {dev_mode,help_home}
 *
 * site_id - Type: guid. Desc: {site guid}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarWixCodeResourcesClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarWixCodeResourcesClicked = function (params) {
    return { evid: 785, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonButtonTextChangedParams
* @property {string} button_type - Text only/text&icon
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} homepage_displaying - text/icon
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} new_value - new_value
* @property {string} old_value - old_value
* @property {string} origin - .
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Button - Button text changed. Evid: 1366.
 * Event description: Stylable Button - Button text changed.

 * button_type - Type: string. Desc: Text only/text&icon
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * homepage_displaying - Type: string. Desc: text/icon
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_value - Type: string. Desc: new_value
 *
 * old_value - Type: string. Desc: old_value
 *
 * origin - Type: string. Desc: .
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonButtonTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonButtonTextChanged = function (params) {
    return { evid: 1366, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeSearchClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_search_click. Evid: 1097.
 * Event description: Event fires when clicking the Search the Editor section, under the help home panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeSearchClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeSearchClick = function (params) {
    return { evid: 1097, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rightClickChangeBackgroundParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: right_click_change_background. Evid: 267.
 * Event description: Panel_Opened_from_right_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rightClickChangeBackgroundParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rightClickChangeBackground = function (params) {
    return { evid: 267, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} escDuringDragResizeOrRotateToCancelTheActionParams
* @property {string} action - the name of the action that user cancel (drag resize or rotate)
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - panel_name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ESC during drag ,resize or rotate to cancel the action. Evid: 871.
 * Event description: use of keyboard shortcuts (ESC) to cancel drag resize or rotate.

 * action - Type: string. Desc: the name of the action that user cancel (drag resize or rotate)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {escDuringDragResizeOrRotateToCancelTheActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var escDuringDragResizeOrRotateToCancelTheAction = function (params) {
    return { evid: 871, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutRequestSendResultLayoutIdeasParams
* @property {string} black_list - json with blacklisted components
* @property {string} component_id - id of selected section
* @property {number} components_amount - number of components in the selected section
* @property {string} data_science_classification - field that classifies the WrichText
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} input_components_ids - json with component_ids inside section
* @property {string} inputJson - json with component_type and component_id of all components in the preset
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_list - whether the section contains lists (true/false)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} parent_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {string} section_name_personal - name of the section assigned by the user, if the user did not change the name then send a technical name)
* @property {string} section_name_technical - name of the section (welcome, about, e.t.c)
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - request send result (layout ideas). Evid: 1271.
 * Event description: Panel open or click on other section to see another layouts (Start event).

 * black_list - Type: string. Desc: json with blacklisted components
 *
 * component_id - Type: string. Desc: id of selected section
 *
 * components_amount - Type: numeric. Desc: number of components in the selected section
 *
 * data_science_classification - Type: string. Desc: field that classifies the WrichText
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * input_components_ids - Type: string. Desc: json with component_ids inside section
 *
 * inputJson - Type: string. Desc: json with component_type and component_id of all components in the preset
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_list - Type: bool. Desc: whether the section contains lists (true/false)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * parent_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * section_name_personal - Type: string. Desc: name of the section assigned by the user, if the user did not change the name then send a technical name)
 *
 * section_name_technical - Type: string. Desc: name of the section (welcome, about, e.t.c)
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutRequestSendResultLayoutIdeasParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutRequestSendResultLayoutIdeas = function (params) {
    return { evid: 1271, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backToTopButtonCustomizeButtonClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Back to top button: Customize button clicked. Evid: 1155.
 * Event description: Back to top button: Customize button clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backToTopButtonCustomizeButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backToTopButtonCustomizeButtonClicked = function (params) {
    return { evid: 1155, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerVideoChangedParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - 'video_player_settings_panel', 'video_player_gfpp', 'my_uploads'
* @property {GUID} site_id - null
* @property {string} source - quickEditPanel
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} video_aspect_ratio - ‘16:9’
* @property {string} video_format - ‘hls’,’webm’,’mp4’,’dash’
* @property {string} video_fps - ‘29.97’
* @property {boolean} video_has_alpha - (1,0)
* @property {boolean} video_has_audio - {1,0}
* @property {boolean} video_has_mask - {1,0}
* @property {number} video_height - {}
* @property {string} video_id - null
* @property {string} video_quality - ‘1080p’
* @property {number} video_width - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video_player_video_changed. Evid: 687.
 * Event description: sent when the video content has been changed or added.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: 'video_player_settings_panel', 'video_player_gfpp', 'my_uploads'
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: quickEditPanel
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_aspect_ratio - Type: string. Desc: ‘16:9’
 *
 * video_format - Type: string. Desc: ‘hls’,’webm’,’mp4’,’dash’
 *
 * video_fps - Type: string. Desc: ‘29.97’
 *
 * video_has_alpha - Type: bool. Desc: (1,0)
 *
 * video_has_audio - Type: bool. Desc: {1,0}
 *
 * video_has_mask - Type: bool. Desc: {1,0}
 *
 * video_height - Type: numeric. Desc: {}
 *
 * video_id - Type: string.
 *
 * video_quality - Type: string. Desc: ‘1080p’
 *
 * video_width - Type: numeric. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerVideoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerVideoChanged = function (params) {
    return { evid: 687, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} fontsSuccessfullyLoadedParams
* @property {number} count - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} file_size - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: fonts successfully loaded. Evid: 597.
 * Event description: fonts successfully loaded on fonts manager.

 * count - Type: numeric.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * file_size - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {fontsSuccessfullyLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fontsSuccessfullyLoaded = function (params) {
    return { evid: 597, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoBackgroundOffOnToggleParams
* @property {string} component_id - {}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - (true,false)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video background OFF/ ON toggle. Evid: 870.
 * Event description: video background on/off toggle.

 * component_id - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: (true,false)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoBackgroundOffOnToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoBackgroundOffOnToggle = function (params) {
    return { evid: 870, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickUploadImagePageSettingsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_upload_image_page_settings. Evid: 824.
 * Event description: clicking on upload image from SEO tab in Page Settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickUploadImagePageSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickUploadImagePageSettings = function (params) {
    return { evid: 824, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationErrorOfMigrationOfSiteParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {string} errorMessage - errorMessage
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - null
* @property {string} origin - init / tpa / navigation
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} template_id - template_id
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - error of migration of site. Evid: 1318.
 * Event description: Section migration - error of migration of site.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * errorMessage - Type: string. Desc: errorMessage
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: init / tpa / navigation
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * template_id - Type: string. Desc: template_id
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationErrorOfMigrationOfSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationErrorOfMigrationOfSite = function (params) {
    return { evid: 1318, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardWidgetInstallEndParams
* @property {string} appId - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {number} duration - .
* @property {GUID} esi - null
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} screenResolution - height x width
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} viewerName - null
* @property {string} viewerVersion - .
* @property {string} widgetName - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Widget Install End. Evid: 1335.
 * Event description: Site Creation Wizard: Widget Install End.

 * appId - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * duration - Type: numeric. Desc: .
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string. Desc: .
 *
 * widgetName - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardWidgetInstallEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardWidgetInstallEnd = function (params) {
    return { evid: 1335, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisCollapseModeTextChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} new_name - null
* @property {string} old_name - old name
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Collapse_mode_text_changed. Evid: 1194.


 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_name - Type: string.
 *
 * old_name - Type: string. Desc: old name
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisCollapseModeTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisCollapseModeTextChanged = function (params) {
    return { evid: 1194, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} replacementPageSucceededParams
* @property {string} app_id - {app id added if applicable}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {id of host app id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} original_page - {original page id}
* @property {string} replacement_page - {replaced page id}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Replacement page succeeded. Evid: 1443.
 * Event description: Replacement page succeeded - send after page was successfully replaced by custom/default page.

 * app_id - Type: string. Desc: {app id added if applicable}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {id of host app id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * original_page - Type: string. Desc: {original page id}
 *
 * replacement_page - Type: string. Desc: {replaced page id}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {replacementPageSucceededParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var replacementPageSucceeded = function (params) {
    return { evid: 1443, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} selectiveTextInputFieldMarkedMandatoryParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} field_selected - {field id or label}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - {Checked, Unchecked}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: SelectiveTextInput_FieldMarkedMandatory. Evid: 364.
 * Event description: SelectiveTextInput_FieldMarkedMandatory.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * field_selected - Type: string. Desc: {field id or label}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {Checked, Unchecked}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {selectiveTextInputFieldMarkedMandatoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectiveTextInputFieldMarkedMandatory = function (params) {
    return { evid: 364, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rememberToSaveNotificationParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {save tool-tip, pop up message}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: remember_to_save_notification. Evid: 456.
 * Event description: remember_to_save_notification.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {save tool-tip, pop up message}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rememberToSaveNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rememberToSaveNotification = function (params) {
    return { evid: 456, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutInfoButtonParams
* @property {string} action - hover / click
* @property {string} component_id - id of selected section
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} layout_type - at what type of layout user hover or click info (original_layout, optional, no_results)
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - info button. Evid: 1275.
 * Event description: user hover or clicked on info button at layout panel.

 * action - Type: string. Desc: hover / click
 *
 * component_id - Type: string. Desc: id of selected section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * layout_type - Type: string. Desc: at what type of layout user hover or click info (original_layout, optional, no_results)
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened:  (action_bar, gfpp, rcm, section_click)
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutInfoButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutInfoButton = function (params) {
    return { evid: 1275, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} contentInjectionContentVersionChangedParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} triggerName - new wix ui lang/change business type/cash cleaned/another browser/initial version of the content
* @property {string} usedJsHeapSize - -
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Content Injection - Content Version Changed. Evid: 1421.
 * Event description: Version of the injected content was changed by CaaS in the Editor.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * triggerName - Type: string. Desc: new wix ui lang/change business type/cash cleaned/another browser/initial version of the content
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {contentInjectionContentVersionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentInjectionContentVersionChanged = function (params) {
    return { evid: 1421, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} zoomModeSpacerDragParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: zoom_mode_spacer_drag. Evid: 550.
 * Event description: zoom_mode_spacer_drag.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {zoomModeSpacerDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var zoomModeSpacerDrag = function (params) {
    return { evid: 550, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuShapesMoreClickParams
* @property {string} category - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {arrows, basic shapes,decorative,animals and nature etc}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> more click. Evid: 112.
 * Event description: add menu -> more click, on components in Add Panel.

 * category - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {arrows, basic shapes,decorative,animals and nature etc}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuShapesMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuShapesMoreClick = function (params) {
    return { evid: 112, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsSeoTitleAddUsernameParams
* @property {string} category - {social,private}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_seo_title_add_username. Evid: 711.
 * Event description: PAGES_settings_seo_title_add_username.

 * category - Type: string. Desc: {social,private}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsSeoTitleAddUsernameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsSeoTitleAddUsername = function (params) {
    return { evid: 711, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationLoaderOnMigratedSiteParams
* @property {string} dm_version - dm version
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {string} flow - template / adi / editor
* @property {boolean} is_rollout - .
* @property {boolean} isSection - is section
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - init / tpa / navigation
* @property {number} revision - revision
* @property {number} sections_number - sections_number
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} undo_label - undo_label
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - {}
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - loader on migrated site. Evid: 1455.
 * Event description: migration loader appeared on migrated site.

 * dm_version - Type: string. Desc: dm version
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * flow - Type: string. Desc: template / adi / editor
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: is section
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: init / tpa / navigation
 *
 * revision - Type: numeric. Desc: revision
 *
 * sections_number - Type: numeric. Desc: sections_number
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * undo_label - Type: string. Desc: undo_label
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationLoaderOnMigratedSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationLoaderOnMigratedSite = function (params) {
    return { evid: 1455, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pinToScreenPanelOpenParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {rcm, gfpp}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pin_to _screen_panel_open. Evid: 332.
 * Event description: pin_to _screen_panel_open.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {rcm, gfpp}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pinToScreenPanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pinToScreenPanelOpen = function (params) {
    return { evid: 332, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} cancelUploadWhileUploadingParams
* @property {number} count - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} file_size - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: cancel upload while uploading. Evid: 602.
 * Event description: Cancel while spinning (uploading). press X.

 * count - Type: numeric.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * file_size - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {cancelUploadWhileUploadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cancelUploadWhileUploading = function (params) {
    return { evid: 602, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gridSelectionParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selection - {Selected Value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: 9Grid_Selection. Evid: 367.
 * Event description: 9Grid_Selection.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selection - Type: string. Desc: {Selected Value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {gridSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gridSelection = function (params) {
    return { evid: 367, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} devModePanelOpenedTopBarParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menu_name - menu_name
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Dev_Mode_Panel_Opened_top_bar. Evid: 1010.
 * Event description: Panel_Opened_top_bar
fires any time the panel is loaded.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menu_name - Type: string. Desc: menu_name
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {devModePanelOpenedTopBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var devModePanelOpenedTopBar = function (params) {
    return { evid: 1010, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuCategoryHoverParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> category hover. Evid: 103.
 * Event description: add menu -> category hover **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuCategoryHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuCategoryHover = function (params) {
    return { evid: 103, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionGoToPreviewParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_go_to_preview. Evid: 1077.
 * Event description: Click on “Go to preview” button.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionGoToPreviewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionGoToPreview = function (params) {
    return { evid: 1077, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuMySectionInfoOpenedParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> my section info opened. Evid: 107.
 * Event description: add menu -> my section info opened.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuMySectionInfoOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuMySectionInfoOpened = function (params) {
    return { evid: 107, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} approveDeleteFontsSecondDialogParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} text - {cancel / delete}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: approve delete fonts second dialog. Evid: 600.
 * Event description: pressing delete fonts on the second dialog approving the delete.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * text - Type: string. Desc: {cancel / delete}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {approveDeleteFontsSecondDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var approveDeleteFontsSecondDialog = function (params) {
    return { evid: 600, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsFitToSizeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - screen, page
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_fit_to_size_click. Evid: 570.
 * Event description: columns_fit_to_size_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: screen, page
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsFitToSizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsFitToSizeClick = function (params) {
    return { evid: 570, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelLineHeightCustomClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} how_it_was_changed - {slider, input field}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {20, 40. 60...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Line_Height_Custom_Click. Evid: 248.
 * Event description: Text_Panel_Line_Height_Custom_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * how_it_was_changed - Type: string. Desc: {slider, input field}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {20, 40. 60...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelLineHeightCustomClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelLineHeightCustomClick = function (params) {
    return { evid: 248, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openTooltipParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tooltipname - {key}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open tooltip. Evid: 671.
 * Event description: send event for 10% of the sessions. Send event if tooltip is open for > 1 sec..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tooltipname - Type: string. Desc: {key}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openTooltip = function (params) {
    return { evid: 671, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textMinHeightHandleDragParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - Increase/decrease
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_min-height_handle_drag. Evid: 683.
 * Event description: Text component bottom min-height handle is dragged. Can be used to solve alignment problems..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: Increase/decrease
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textMinHeightHandleDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textMinHeightHandleDrag = function (params) {
    return { evid: 683, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog2HelpConnectingDomainLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_2_help_connecting_domain_link_click. Evid: 326.
 * Event description: First_Save_Dialog_2_help_connecting_domain_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog2HelpConnectingDomainLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog2HelpConnectingDomainLinkClick = function (params) {
    return { evid: 326, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} vnBusinessNumberFromEditorLink1061Params
* @property {GUID} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - get,use
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: VN- business number from editor link. Evid: 1061.
 * Event description: VN- business number from editor link.

 * component_id - Type: guid. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: get,use
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {vnBusinessNumberFromEditorLink1061Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var vnBusinessNumberFromEditorLink1061 = function (params) {
    return { evid: 1061, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonMainClickedActionParams
* @property {string} actionName - add_preset/ create_collection/manage_dynamic_pages/manage_content/add_content_element
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} isEmptyState - T/F
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button > Main > Clicked Action. Evid: 1264.
 * Event description: on 6th button main tab - user clicking any action(can differentiate between empty state or non empty state).

 * actionName - Type: string. Desc: add_preset/ create_collection/manage_dynamic_pages/manage_content/add_content_element
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * isEmptyState - Type: bool. Desc: T/F
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonMainClickedActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonMainClickedAction = function (params) {
    return { evid: 1264, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} widgetInstalledAfterItsComponentAddedToStageParams
* @property {string} adding_method - {click,drag}
* @property {GUID} appId - app_id
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} is_target_repeated - {true,false} Is target contained in a repeater
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {add panel, my uploads panel.}
* @property {string} page_id - page id where the component was added
* @property {string} preset_data_skin - skin
* @property {string} preset_data_tags - {yellow, buy, circle...}
* @property {string} preset_id - --
* @property {string} properties - properties (for Audio player)
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target_component - {compType} //will be page if add to stage
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: widget installed after its component added to stage. Evid: 1114.
 * Event description: sending after component added to stage and content for the app was fully downloaded (right after 38:123).

 * adding_method - Type: string. Desc: {click,drag}
 *
 * appId - Type: guid. Desc: app_id
 *
 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * is_target_repeated - Type: bool. Desc: {true,false} Is target contained in a repeater
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {add panel, my uploads panel.}
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * preset_data_skin - Type: string. Desc: skin
 *
 * preset_data_tags - Type: string. Desc: {yellow, buy, circle...}
 *
 * preset_id - Type: string. Desc: --
 *
 * properties - Type: string. Desc: properties (for Audio player)
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target_component - Type: string. Desc: {compType} //will be page if add to stage
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {widgetInstalledAfterItsComponentAddedToStageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetInstalledAfterItsComponentAddedToStage = function (params) {
    return { evid: 1114, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeMarketClickParams
* @property {string} closing_method - {Close button, Esc, Click outside}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} open_origin - {add_panel...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: close_market_click. Evid: 171.
 * Event description: close_market_click.

 * closing_method - Type: string. Desc: {Close button, Esc, Click outside}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * open_origin - Type: string. Desc: {add_panel...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeMarketClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeMarketClick = function (params) {
    return { evid: 171, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} heavySitesPagesPanelBannerShownParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {number} pages_count - 50/70/100
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: heavy sites pages panel banner shown. Evid: 963.
 * Event description: heavy sites pages panel banner shown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * pages_count - Type: numeric. Desc: 50/70/100
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {heavySitesPagesPanelBannerShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var heavySitesPagesPanelBannerShown = function (params) {
    return { evid: 963, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelFontSizeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} how_it_was_changed - {slider, input field}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {20, 40. 60...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Font_Size_Click. Evid: 230.
 * Event description: Text_Panel_Font_Size_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * how_it_was_changed - Type: string. Desc: {slider, input field}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {20, 40. 60...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelFontSizeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelFontSizeClick = function (params) {
    return { evid: 230, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} membersSignupSettingsSocialFacebookParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} facebook - {true to allow}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: members signup settings social facebook. Evid: 298.
 * Event description: under the members signup settings panel, allow social login using facebook.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * facebook - Type: bool. Desc: {true to allow}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {membersSignupSettingsSocialFacebookParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersSignupSettingsSocialFacebook = function (params) {
    return { evid: 298, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} advancedDesignPanelBackClickParams
* @property {string} component_id - .
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: advanced_design_panel_back_click. Evid: 323.
 * Event description: advanced_design_panel_back_click.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {advancedDesignPanelBackClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var advancedDesignPanelBackClick = function (params) {
    return { evid: 323, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} extensionAddedParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - add_page_panel / 6th_button_store_panel (from where shop page was added)
* @property {string} page_id - [guid]
* @property {string} preset_id - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - [guid]
* @property {string} workspace_mode - null
**/
/**
 * Name: extension_added. Evid: 177.
 * Event description: extension_added.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: add_page_panel / 6th_button_store_panel (from where shop page was added)
 *
 * page_id - Type: string. Desc: [guid]
 *
 * preset_id - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: [guid]
 *
 * workspace_mode - Type: string.
 * @param {extensionAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var extensionAdded = function (params) {
    return { evid: 177, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbItemSpacingChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} display_mode - wrap/ellipsis
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - 0px/1px/..
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - vertical/horizontal
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_item_spacing_changed. Evid: 1240.


 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * display_mode - Type: string. Desc: wrap/ellipsis
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: 0px/1px/..
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: vertical/horizontal
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbItemSpacingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbItemSpacingChanged = function (params) {
    return { evid: 1240, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} deleteSpaceInMobileEditorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page_id
* @property {GUID} site_id - site id
* @property {number} space_size - deleted space between components in pixels
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Delete space in mobile editor. Evid: 677.
 * Event description: Delete space  between components in mobile editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: site id
 *
 * space_size - Type: numeric. Desc: deleted space between components in pixels
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {deleteSpaceInMobileEditorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteSpaceInMobileEditor = function (params) {
    return { evid: 677, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsPageInfoHomePageChangeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_page_info_home_page_change_click. Evid: 425.
 * Event description: PAGES_settings_page_info_home_page_change_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsPageInfoHomePageChangeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsPageInfoHomePageChangeClick = function (params) {
    return { evid: 425, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pinDragAttemptParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pin_drag_attempt. Evid: 386.
 * Event description: pin_drag_attempt.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pinDragAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pinDragAttempt = function (params) {
    return { evid: 386, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} upgradeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {top_bar, gfpp...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: upgrade_click. Evid: 519.
 * Event description: upgrade_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {top_bar, gfpp...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {upgradeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeClick = function (params) {
    return { evid: 519, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbItemDirectionChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} display_mode - wrap/ellipsis
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - LtR/RtL
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_item_direction_changed. Evid: 1242.
 * Event description: breadcrumb_item_direction_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * display_mode - Type: string. Desc: wrap/ellipsis
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: LtR/RtL
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbItemDirectionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbItemDirectionChanged = function (params) {
    return { evid: 1242, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} megaMenuPopupShownParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} homepage_displaying - text/icon
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} menuId - menuId
* @property {string} multilingual - multilingual
* @property {string} name - popup name
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Mega Menu - Popup Shown. Evid: 1357.
 * Event description: Mega Menu - Popup Shown.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * homepage_displaying - Type: string. Desc: text/icon
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * menuId - Type: string. Desc: menuId
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * name - Type: string. Desc: popup name
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {megaMenuPopupShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var megaMenuPopupShown = function (params) {
    return { evid: 1357, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dmoActivationClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} entry_point - {add_panel, too_many_pages_suggestion, etc}
* @property {GUID} esi - {}
* @property {string} initiator_name - {manual, auto-acquisition, auto-intro funnel}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {auto,manual}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - {true,false}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Wix Data toggle. Evid: 818.
 * Event description: DMO activation click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * entry_point - Type: string. Desc: {add_panel, too_many_pages_suggestion, etc}
 *
 * esi - Type: guid. Desc: {}
 *
 * initiator_name - Type: string. Desc: {manual, auto-acquisition, auto-intro funnel}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {auto,manual}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {true,false}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dmoActivationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dmoActivationClick = function (params) {
    return { evid: 818, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuSectionInfoClosedParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> section info closed. Evid: 106.
 * Event description: add menu -> section info closed.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuSectionInfoClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuSectionInfoClosed = function (params) {
    return { evid: 106, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkPanelDoneClickParams
* @property {string} anchor_where_on_page - {top, bottom, anchor}
* @property {string} appDefinitionId - appDefinitionId of the app that managed Linked Dynamic Page
* @property {string} category - {email,document....}
* @property {string} component_id - id of component
* @property {string} component_type - type of component
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} inner_selection - {}
* @property {boolean} is_changed - send if changes have been made to the link panel
* @property {boolean} isMobileOnlyComponentSelected - mobile only component
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} open_method - new window / current window
* @property {string} origin - panel opening origin
* @property {boolean} rel_is_changed - send if rel values were changed (true/ false)
* @property {string} rel_value - {noopener, noreferrer, nofollow, sponsored}. If previously there were rel values and user unchecked all of them, then send NULL.
* @property {string} selection - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target_component_id - target component_id to which we linked a component (in a Link Panel)
* @property {string} target_component_type - target component_type to which we linked a component (in a Link Panel)
* @property {string} targetPage - target page_id to which we linked a component (in a Link Panel)
* @property {string} totalJsHeapSize - null
* @property {string} urlAddress - web adress
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: link_panel_done_click. Evid: 160.
 * Event description: link_panel_done_click.

 * anchor_where_on_page - Type: string. Desc: {top, bottom, anchor}
 *
 * appDefinitionId - Type: string. Desc: appDefinitionId of the app that managed Linked Dynamic Page
 *
 * category - Type: string. Desc: {email,document....}
 *
 * component_id - Type: string. Desc: id of component
 *
 * component_type - Type: string. Desc: type of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * inner_selection - Type: string. Desc: {}
 *
 * is_changed - Type: bool. Desc: send if changes have been made to the link panel
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: mobile only component
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * open_method - Type: string. Desc: new window / current window
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * rel_is_changed - Type: bool. Desc: send if rel values were changed (true/ false)
 *
 * rel_value - Type: string. Desc: {noopener, noreferrer, nofollow, sponsored}. If previously there were rel values and user unchecked all of them, then send NULL.
 *
 * selection - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target_component_id - Type: string. Desc: target component_id to which we linked a component (in a Link Panel)
 *
 * target_component_type - Type: string. Desc: target component_type to which we linked a component (in a Link Panel)
 *
 * targetPage - Type: string. Desc: target page_id to which we linked a component (in a Link Panel)
 *
 * totalJsHeapSize - Type: string.
 *
 * urlAddress - Type: string. Desc: web adress
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {linkPanelDoneClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkPanelDoneClick = function (params) {
    return { evid: 160, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} accessibilityPanelClosedParams
* @property {string} advanced_settings_toggle - on,off
* @property {string} automatically_order_dom_toggle - on,off
* @property {string} closeType - close or X or out_of_focus
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {boolean} ischanged - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} skip_to_content_toggle - on,off
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} visual_ind_toggle - on,off
* @property {string} workspace_mode - null
**/
/**
 * Name: Accessibility panel closed. Evid: 693.
 * Event description: the panel closed by X button, close button or click on panel's overlay.

 * advanced_settings_toggle - Type: string. Desc: on,off
 *
 * automatically_order_dom_toggle - Type: string. Desc: on,off
 *
 * closeType - Type: string. Desc: close or X or out_of_focus
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * ischanged - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * skip_to_content_toggle - Type: string. Desc: on,off
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * visual_ind_toggle - Type: string. Desc: on,off
 *
 * workspace_mode - Type: string.
 * @param {accessibilityPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accessibilityPanelClosed = function (params) {
    return { evid: 693, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsReverseLayoutClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_reverse_layout_click. Evid: 575.
 * Event description: columns_reverse_layout_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsReverseLayoutClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsReverseLayoutClick = function (params) {
    return { evid: 575, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} resizeParams
* @property {GUID} appId - {}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} entry_type - manual / calculation
* @property {GUID} esi - null
* @property {string} handle_value - {1,2,3....}
* @property {boolean} isChanged - true/false (send true when user has resized)
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - {tool bar, handle}
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - width / height
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - changed value
* @property {string} valueOrigin - previous value
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: resize. Evid: 157.
 * Event description: resize **EVENT REDUCED TO 10% FROM TRAFFIC**.

 * appId - Type: guid. Desc: {}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * entry_type - Type: string. Desc: manual / calculation
 *
 * esi - Type: guid.
 *
 * handle_value - Type: string. Desc: {1,2,3....}
 *
 * isChanged - Type: bool. Desc: true/false (send true when user has resized)
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: {tool bar, handle}
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: width / height
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: changed value
 *
 * valueOrigin - Type: string. Desc: previous value
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {resizeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var resize = function (params) {
    return { evid: 157, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} headerBackgroundChangeScrollEffectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {number} header_height - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} scroll_type - stays_on_top, freezes, disappears, fade_out
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Header Background - change scroll effect. Evid: 732.
 * Event description: Header Background - change scroll effect - Will be sent only when user changes the scroll effect.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * header_height - Type: numeric.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * scroll_type - Type: string. Desc: stays_on_top, freezes, disappears, fade_out
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {headerBackgroundChangeScrollEffectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerBackgroundChangeScrollEffect = function (params) {
    return { evid: 732, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverElementInLayersPanelParams
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_landing_page - true, false (header - footer shown)
* @property {boolean} is_popup - true, false (header - footer shown - lightbox)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} layer_name - {}
* @property {string} multilingual - .
* @property {string} parent_component_type - header, page, overlay, footer
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: hover element in layers panel. Evid: 1183.
 * Event description: hover specific layer.

 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_landing_page - Type: bool. Desc: true, false (header - footer shown)
 *
 * is_popup - Type: bool. Desc: true, false (header - footer shown - lightbox)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * layer_name - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: .
 *
 * parent_component_type - Type: string. Desc: header, page, overlay, footer
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {hoverElementInLayersPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverElementInLayersPanel = function (params) {
    return { evid: 1183, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuAddMenuNewPageDoneParams
* @property {string} category - category
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - null
* @property {string} source - source
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_add_menu_new_page_done. Evid: 1360.
 * Event description: Done new page add from Manage menu.

 * category - Type: string. Desc: category
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: source
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {menuAddMenuNewPageDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuAddMenuNewPageDone = function (params) {
    return { evid: 1360, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} welcomeScreenAddYourLogoClickedParams
* @property {string} button_name - button_name
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Welcome Screen: Add your logo clicked. Evid: 1157.
 * Event description: Welcome Screen: Add your logo clicked.

 * button_name - Type: string. Desc: button_name
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {welcomeScreenAddYourLogoClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var welcomeScreenAddYourLogoClicked = function (params) {
    return { evid: 1157, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondSaveOkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {not published not connected, not Published connected, published_connected, Published_not_connected}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Save_OK_click. Evid: 337.
 * Event description: Second_Save_OK_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {not published not connected, not Published connected, published_connected, Published_not_connected}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondSaveOkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondSaveOkClick = function (params) {
    return { evid: 337, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetIconLayoutCustomizeDesignClickParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - layout
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.iconLayout.customizeDesign.click. Evid: 1199.
 * Event description: Audio Player Icon Layout Design -> click on customize design.

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: layout
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetIconLayoutCustomizeDesignClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetIconLayoutCustomizeDesignClick = function (params) {
    return { evid: 1199, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rightClickActionParams
* @property {string} action_name - pin to screen, undo, redo, etc...
* @property {string} app_id - app id from clientSpecMap
* @property {string} component_id - comp id
* @property {string} component_type - comp type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {GUID} instance_id - unique instance id related to the app id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} toggle_status - on, off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: right click action. Evid: 697.
 * Event description: report on click type in tight click menu.

 * action_name - Type: string. Desc: pin to screen, undo, redo, etc...
 *
 * app_id - Type: string. Desc: app id from clientSpecMap
 *
 * component_id - Type: string. Desc: comp id
 *
 * component_type - Type: string. Desc: comp type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * instance_id - Type: guid. Desc: unique instance id related to the app id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * toggle_status - Type: string. Desc: on, off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rightClickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rightClickAction = function (params) {
    return { evid: 697, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAnchorUrlOpenCollapsableMenuParams
* @property {string} componentId - section/anchor component id
* @property {string} componentName - section name or anchor name
* @property {string} componentType - section/anchor component type
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - from where Section/Anchor Settings panel was opened {gfpp/rcm/label/quickEditPanel}
* @property {string} pageId - page where section/anchor is placed
* @property {string} pageName - name of the page where section/anchor is placed
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Section/Anchor URL - Open Collapsable Menu. Evid: 1402.
 * Event description: User opens Section/Anchor URL collapsable menu in Section/Anchor Settings panel..

 * componentId - Type: string. Desc: section/anchor component id
 *
 * componentName - Type: string. Desc: section name or anchor name
 *
 * componentType - Type: string. Desc: section/anchor component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: from where Section/Anchor Settings panel was opened {gfpp/rcm/label/quickEditPanel}
 *
 * pageId - Type: string. Desc: page where section/anchor is placed
 *
 * pageName - Type: string. Desc: name of the page where section/anchor is placed
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionAnchorUrlOpenCollapsableMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAnchorUrlOpenCollapsableMenu = function (params) {
    return { evid: 1402, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkPanelDropDownOpenParams
* @property {string} category - {nolink,email,document....}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} subcategory - {seo_settings, rel_values}, send which subcategory user expand
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: link_panel_drop_down_open. Evid: 1232.
 * Event description: The event fires when clicking on the drop down menu to choose a specific element to link to.

 * category - Type: string. Desc: {nolink,email,document....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * subcategory - Type: string. Desc: {seo_settings, rel_values}, send which subcategory user expand
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {linkPanelDropDownOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkPanelDropDownOpen = function (params) {
    return { evid: 1232, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerChangeFileClickParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} source - panel opening origin
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.changeFile.click. Evid: 862.
 * Event description: User clicked on Change File to open Media Manager.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: panel opening origin
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerChangeFileClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerChangeFileClick = function (params) {
    return { evid: 862, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageOrPopUpDeletedSelectClickParams
* @property {string} category - {cancel,delete}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_or_popup - {page, pop up,members page}
* @property {number} page_popup_id - {}
* @property {string} page_popup_name - {}
* @property {string} page_popup_string_id - {mainPage,zxc5v,...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: page_or_pop_up _deleted_select_click. Evid: 708.
 * Event description: page_or_pop_up _deleted_select_click.

 * category - Type: string. Desc: {cancel,delete}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_or_popup - Type: string. Desc: {page, pop up,members page}
 *
 * page_popup_id - Type: numeric. Desc: {}
 *
 * page_popup_name - Type: string. Desc: {}
 *
 * page_popup_string_id - Type: string. Desc: {mainPage,zxc5v,...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pageOrPopUpDeletedSelectClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageOrPopUpDeletedSelectClick = function (params) {
    return { evid: 708, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationStartMigrationOfPageParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} origin - init/shadow/navigation
* @property {string} pageId - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - start migration of page. Evid: 1244.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: init/shadow/navigation
 *
 * pageId - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationStartMigrationOfPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationStartMigrationOfPage = function (params) {
    return { evid: 1244, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} themeDataMigrationParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} errorReason - why migration failed
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} mp_styles_after - number of styles in master page after migration
* @property {number} mp_styles_before - number of styles in master page before migration
* @property {string} multilingual - null
* @property {string} page_styles_after - list of dictionaries with key = page_id and value = number of styles in page after migration. always no style so will be null
* @property {string} page_styles_before - list of dictionaries with key = page_id and value = number of styles in page before migration
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} status - true = success, false = fail
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: theme_data_migration. Evid: 805.
 * Event description: Sent once per site - when theme data migration fixer runs. Moves styles from Master Page to the pages..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * errorReason - Type: string. Desc: why migration failed
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mp_styles_after - Type: numeric. Desc: number of styles in master page after migration
 *
 * mp_styles_before - Type: numeric. Desc: number of styles in master page before migration
 *
 * multilingual - Type: string.
 *
 * page_styles_after - Type: string. Desc: list of dictionaries with key = page_id and value = number of styles in page after migration. always no style so will be null
 *
 * page_styles_before - Type: string. Desc: list of dictionaries with key = page_id and value = number of styles in page before migration
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: true = success, false = fail
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {themeDataMigrationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var themeDataMigration = function (params) {
    return { evid: 805, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} saveClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {top_bar, top_bar_site_menu, top_bar_preview_page, keyboard, remember_to_save_active_save_popup}
* @property {string} platform - {editor/app_studio}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: save_click. Evid: 260.
 * Event description: save_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {top_bar, top_bar_site_menu, top_bar_preview_page, keyboard, remember_to_save_active_save_popup}
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {saveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveClick = function (params) {
    return { evid: 260, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} disabledEnabledAutoSaveParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Keyboard
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {enable,disable}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: disabled_enabled_auto_save. Evid: 764.
 * Event description: disabled_enabled_auto_save.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Keyboard
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {enable,disable}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {disabledEnabledAutoSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var disabledEnabledAutoSave = function (params) {
    return { evid: 764, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} connectDomainClickOnTopPanelParams
* @property {string} dm_version - null
* @property {string} domain_type - general/suggested
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Connect domain click on Top panel. Evid: 1146.
 * Event description: User clicks on Connect domain / get it on Top bar in Editor.

 * dm_version - Type: string.
 *
 * domain_type - Type: string. Desc: general/suggested
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {connectDomainClickOnTopPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectDomainClickOnTopPanel = function (params) {
    return { evid: 1146, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchRequestSentParams
* @property {string} component_type - from which link Panel was opened
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: link_panel_pageName_type_start. Evid: 990.
 * Event description: This event will be sent every time a user start to fill page name in a LinkPanel (Page section).

 * component_type - Type: string. Desc: from which link Panel was opened
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editorSearchRequestSentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchRequestSent = function (params) {
    return { evid: 990, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterBusinessTypeSelectedParams
* @property {string} businessType - {industry:”x”; structure: “y”}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} oldBusinessType - {industry:”x”; structure: “y”} or null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - BType in user language
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.businessType.selected. Evid: 1029.
 * Event description: Smart Writer click on Next to select / change business type.

 * businessType - Type: string. Desc: {industry:”x”; structure: “y”}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * oldBusinessType - Type: string. Desc: {industry:”x”; structure: “y”} or null
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: BType in user language
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterBusinessTypeSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterBusinessTypeSelected = function (params) {
    return { evid: 1029, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} marginsControlVisibleParams
* @property {GUID} appId - app_id
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: margins_control_visible. Evid: 1121.
 * Event description: User saw slider with Margins in Stretch Panel.

 * appId - Type: guid. Desc: app_id
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {marginsControlVisibleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marginsControlVisible = function (params) {
    return { evid: 1121, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} escButtonClickedWithBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ESC button clicked (with back option). Evid: 485.
 * Event description: With back to old editor option: ESC button clicked: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {escButtonClickedWithBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var escButtonClickedWithBackOption = function (params) {
    return { evid: 485, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} saveErrorMoreThanOneWindowParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selection - {save, don't save}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: save_error_more_than_one_window. Evid: 447.
 * Event description: save_error_more_than_one_window.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: {save, don't save}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {saveErrorMoreThanOneWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveErrorMoreThanOneWindow = function (params) {
    return { evid: 447, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} inputElementsAppointmentFieldSettingsChangeValueParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} fieldName - null
* @property {string} fieldType - fieldType
* @property {string} inputType - inputType
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} previousValue - previousValue
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: dummy-name. Evid: 1281.
 * Event description: the user change value in the settings of the appointment (and time zone) field in the editor. include chequebook, radio button, text input etc.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * fieldName - Type: string.
 *
 * fieldType - Type: string. Desc: fieldType
 *
 * inputType - Type: string. Desc: inputType
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * previousValue - Type: string. Desc: previousValue
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {inputElementsAppointmentFieldSettingsChangeValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inputElementsAppointmentFieldSettingsChangeValue = function (params) {
    return { evid: 1281, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openCropModeParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} fixed_layout - 0/1
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Open_crop_mode. Evid: 510.
 * Event description: Open_crop_mode.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * fixed_layout - Type: bool. Desc: 0/1
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openCropModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openCropMode = function (params) {
    return { evid: 510, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishWorkNotPublishedErrorHelpCenterLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Publish_Work_not_Published_Error_Help_Center_Link_Click. Evid: 397.
 * Event description: Publish_Work_not_Published_Error_Help_Center_Link_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishWorkNotPublishedErrorHelpCenterLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishWorkNotPublishedErrorHelpCenterLinkClick = function (params) {
    return { evid: 397, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} marketClosedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} open_origin - {add_panel...}
* @property {number} seconds_opened - {1,2...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: market_closed. Evid: 172.
 * Event description: market_closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * open_origin - Type: string. Desc: {add_panel...}
 *
 * seconds_opened - Type: numeric. Desc: {1,2...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {marketClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketClosed = function (params) {
    return { evid: 172, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyStyleChooseStylesToReplaceClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - {}
* @property {string} style_id - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: copy_style_choose_styles_to_replace_click. Evid: 319.
 * Event description: copy_style_choose_styles_to_replace_click.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {}
 *
 * style_id - Type: string. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyStyleChooseStylesToReplaceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyStyleChooseStylesToReplaceClick = function (params) {
    return { evid: 319, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesReorderChoiceClickParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} choice_name - choice_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - Reorder Choice - click. Evid: 913.
 * Event description: user click on reorder choice.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * choice_name - Type: string. Desc: choice_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesReorderChoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesReorderChoiceClick = function (params) {
    return { evid: 913, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuMySectionInfoClosedParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> my section info closed. Evid: 108.
 * Event description: add menu -> my section info closed.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuMySectionInfoClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuMySectionInfoClosed = function (params) {
    return { evid: 108, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuUpgradeClickedParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {SidebarUpgradeLink, TooltipUpgradeLink}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_upgrade_clicked. Evid: 207.
 * Event description: site_app_menu_upgrade_clicked.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {SidebarUpgradeLink, TooltipUpgradeLink}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuUpgradeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuUpgradeClicked = function (params) {
    return { evid: 207, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarEditorViewModeClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop, mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {editor,preview}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_Editor_View_Mode_click. Evid: 291.
 * Event description: top_bar_Editor_View_Mode_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop, mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {editor,preview}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarEditorViewModeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarEditorViewModeClick = function (params) {
    return { evid: 291, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardPageStartLoadingParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {number} pageCount - count of pages suggested in a "add pages" screen
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - Wizard screen name
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: page start loading. Evid: 1250.
 * Event description: Site Creation Wizard: page start loading.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * pageCount - Type: numeric. Desc: count of pages suggested in a "add pages" screen
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: Wizard screen name
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardPageStartLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardPageStartLoading = function (params) {
    return { evid: 1250, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickOnMovePluginHoverOnSlotParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {application_id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} plugin_id - plugin_id
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} slot_id_current - slot_id_current
* @property {string} slot_id_highlighted - slot_id_highlighted
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Click on move plugin + hover on slot. Evid: 1450.
 * Event description: Click on move plugin +hover on slot.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {application_id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * plugin_id - Type: string. Desc: plugin_id
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * slot_id_current - Type: string. Desc: slot_id_current
 *
 * slot_id_highlighted - Type: string. Desc: slot_id_highlighted
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickOnMovePluginHoverOnSlotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnMovePluginHoverOnSlot = function (params) {
    return { evid: 1450, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editDomainCancelClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_save - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {}
* @property {string} save_or_publish - {save, publish}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_domain_cancel_click. Evid: 448.
 * Event description: edit_domain_cancel_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_save - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {}
 *
 * save_or_publish - Type: string. Desc: {save, publish}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editDomainCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editDomainCancelClick = function (params) {
    return { evid: 448, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} refComponentChangesParams
* @property {string} changeType - data (on data changed (when for ex user modifies label of a button), style (style changed (when changing button color), props
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: refComponent.changes. Evid: 87.
 * Event description: Triggered when user modified data or style of components in refComponent:
- data changed (when for example user modifies label of a button)
- style changed (when changing button color)
- props changed.

 * changeType - Type: string. Desc: data (on data changed (when for ex user modifies label of a button), style (style changed (when changing button color), props
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {refComponentChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var refComponentChanges = function (params) {
    return { evid: 87, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} transitionSelectedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} transition - horizontal,vertical
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Transition selected. Evid: 541.
 * Event description: Transition selected.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * transition - Type: string. Desc: horizontal,vertical
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {transitionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transitionSelected = function (params) {
    return { evid: 541, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisHtmlTagChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} old_value - old value that user used (p/h1/h2/..)
* @property {string} origin - Main GFPP button/Seo settings button
* @property {string} page_id - page id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - new value that user chosen (p/h1/..)
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.html_tag_changed. Evid: 1283.


 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * old_value - Type: string. Desc: old value that user used (p/h1/h2/..)
 *
 * origin - Type: string. Desc: Main GFPP button/Seo settings button
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: new value that user chosen (p/h1/..)
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisHtmlTagChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisHtmlTagChanged = function (params) {
    return { evid: 1283, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonTextAndIconPositionChangedParams
* @property {string} component_id - component id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id
* @property {string} selection - chosen position
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: StylableButton.text_and_icon_position_changed. Evid: 1342.
 * Event description: StylableButton.text_and_icon_position_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id
 *
 * selection - Type: string. Desc: chosen position
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonTextAndIconPositionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonTextAndIconPositionChanged = function (params) {
    return { evid: 1342, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageDeletedParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} page_id - page_id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Page Deleted. Evid: 97.
 * Event description: Static Page deleted.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {pageDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageDeleted = function (params) {
    return { evid: 97, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} overlappingItemsHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - rcm
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: overlapping items hover. Evid: 140.
 * Event description: overlapping items hover (1 sec delay).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: rcm
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {overlappingItemsHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var overlappingItemsHover = function (params) {
    return { evid: 140, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationPanelBehaviorSavedParams
* @property {boolean} animate_once - 1,0
* @property {string} behavior_name - {float-in, expand...}
* @property {string} close_origin - drop_down / other
* @property {string} component_id - {}
* @property {string} component_name - {slide gallery, box...}
* @property {number} cycle - 1,2,3
* @property {number} delay - 1,2,3
* @property {string} direction - --
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - 1,2,3
* @property {GUID} esi - null
* @property {string} field_name - direction, duration, e.t.c
* @property {string} field_value - {from_top} or {0,1,2,3,.... }
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - from where the animation panel was opened
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} trigger_type - entrance, loop, e.t.c
* @property {string} usedJsHeapSize - null
* @property {string} action_name - {screen-in, page-in...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_panel_behavior_saved. Evid: 373.
 * Event description: animation_panel_behavior_saved.

 * animate_once - Type: bool. Desc: 1,0
 *
 * behavior_name - Type: string. Desc: {float-in, expand...}
 *
 * close_origin - Type: string. Desc: drop_down / other
 *
 * component_id - Type: string. Desc: {}
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * cycle - Type: numeric. Desc: 1,2,3
 *
 * delay - Type: numeric. Desc: 1,2,3
 *
 * direction - Type: string. Desc: --
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: 1,2,3
 *
 * esi - Type: guid.
 *
 * field_name - Type: string. Desc: direction, duration, e.t.c
 *
 * field_value - Type: string. Desc: {from_top} or {0,1,2,3,.... }
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: from where the animation panel was opened
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * trigger_type - Type: string. Desc: entrance, loop, e.t.c
 *
 * usedJsHeapSize - Type: string.
 *
 * action_name - Type: string. Desc: {screen-in, page-in...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {animationPanelBehaviorSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationPanelBehaviorSaved = function (params) {
    return { evid: 373, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceCancelbuttonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_cancelbutton_click. Evid: 162.
 * Event description: ColorSpace_CancelButton_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceCancelbuttonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceCancelbuttonClick = function (params) {
    return { evid: 162, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} saveErrorPopupParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} error_code - {15, 18, ....}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: save_error_popup. Evid: 686.
 * Event description: will shoot when save error pop up appears in editor with error code.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * error_code - Type: string. Desc: {15, 18, ....}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {saveErrorPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveErrorPopup = function (params) {
    return { evid: 686, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeContactUsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_contact_us_click. Evid: 1091.
 * Event description: Event fires when clicking the contact us section under the help home panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeContactUsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeContactUsClick = function (params) {
    return { evid: 1091, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} actionBarComponentToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} toggle_name - email/phone/etc...
* @property {string} toggle_status - on/off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Action bar component toggle. Evid: 616.
 * Event description: toggle state of the component in the action bar (site menu/phone/emal etc...).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle_name - Type: string. Desc: email/phone/etc...
 *
 * toggle_status - Type: string. Desc: on/off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {actionBarComponentToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionBarComponentToggle = function (params) {
    return { evid: 616, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startUploadFontParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: start_upload_font. Evid: 682.
 * Event description: start_upload_font.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startUploadFontParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startUploadFont = function (params) {
    return { evid: 682, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterOpenParams
* @property {string} businessType - {industry:”x”; structure: “y”}  or null
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} pageId - page_id
* @property {string} pageUrl - page_url
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} step - business_type / subject / text
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.open. Evid: 1027.
 * Event description: Smart Writer Open.

 * businessType - Type: string. Desc: {industry:”x”; structure: “y”}  or null
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * pageId - Type: string. Desc: page_id
 *
 * pageUrl - Type: string. Desc: page_url
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * step - Type: string. Desc: business_type / subject / text
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterOpen = function (params) {
    return { evid: 1027, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pinToScreenParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - rcm/...
* @property {string} selected_area - area pined to screen
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - **allways auto
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pin_to _screen. Evid: 810.
 * Event description: component pined to screen.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: rcm/...
 *
 * selected_area - Type: string. Desc: area pined to screen
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: **allways auto
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pinToScreenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pinToScreen = function (params) {
    return { evid: 810, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startPublishProcessParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar/dialog
* @property {string} platform - {editor/app_studio}
* @property {string} publish_type - partial/full/first
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: start_publish_process. Evid: 466.
 * Event description: start_publish_process.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar/dialog
 *
 * platform - Type: string. Desc: {editor/app_studio}
 *
 * publish_type - Type: string. Desc: partial/full/first
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startPublishProcessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startPublishProcess = function (params) {
    return { evid: 466, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} effectsPanelBehaviorClickParams
* @property {string} behavior_name - Grow/Shrink/Skew/Rotate/Custom
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: effects_panel_behavior_click. Evid: 980.
 * Event description: Selecting Transform/Filters effects.

 * behavior_name - Type: string. Desc: Grow/Shrink/Skew/Rotate/Custom
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {effectsPanelBehaviorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var effectsPanelBehaviorClick = function (params) {
    return { evid: 980, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} concurrentUsersPopupOkClickParams
* @property {number} count - num users logged in editor {1,2,3,4..}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - time passed until message {1,2,3,4..}
* @property {GUID} esi - null
* @property {boolean} is_first - first time message shown? {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user - {first user, second user}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: concurrent_users_popup_OK_click. Evid: 494.
 * Event description: concurrent_users_popup_OK_click.

 * count - Type: numeric. Desc: num users logged in editor {1,2,3,4..}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: time passed until message {1,2,3,4..}
 *
 * esi - Type: guid.
 *
 * is_first - Type: bool. Desc: first time message shown? {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user - Type: string. Desc: {first user, second user}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {concurrentUsersPopupOkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var concurrentUsersPopupOkClick = function (params) {
    return { evid: 494, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardNavigationClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} navButton - next / skip / ...
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - Wizard screen name
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: navigation click. Evid: 1253.
 * Event description: Site Creation Wizard: navigation click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * navButton - Type: string. Desc: next / skip / ...
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: Wizard screen name
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardNavigationClick = function (params) {
    return { evid: 1253, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppAddedByUserFirsttimeStep1welcomeContinueClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_added_by_user_firsttime_step1welcome_continue_click. Evid: 202.
 * Event description: site_app_added_by_user_firsttime_step1welcome_continue_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppAddedByUserFirsttimeStep1welcomeContinueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppAddedByUserFirsttimeStep1welcomeContinueClick = function (params) {
    return { evid: 202, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorModeClickToChangeParams
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} mode - liteEditor/ fullExperience (which mode user selected)
* @property {string} multilingual - .
* @property {string} origin - top bar / three dots / drag …  (from which entry point LiteEditor panel was opened)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor Mode: click to change. Evid: 1453.
 * Event description: top_bar_click.

 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * mode - Type: string. Desc: liteEditor/ fullExperience (which mode user selected)
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: top bar / three dots / drag …  (from which entry point LiteEditor panel was opened)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editorModeClickToChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorModeClickToChange = function (params) {
    return { evid: 1453, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addAltTextParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} imageType - image / background
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - value user added
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Add alt text. Evid: 929.
 * Event description: Add alt text to an image or background..

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * imageType - Type: string. Desc: image / background
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: value user added
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addAltTextParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addAltText = function (params) {
    return { evid: 929, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelBulletsClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - click_to_open / bullet / number / none
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Bullets_Click. Evid: 235.
 * Event description: Text_Panel_Bullets_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: click_to_open / bullet / number / none
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelBulletsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelBulletsClick = function (params) {
    return { evid: 235, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} adiToEditorWarningBeforeSavePanelClosedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: adi_to_editor_warning_before_save_panel_closed. Evid: 618.
 * Event description: adi_to_editor_warning_before_save_panel_closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {adiToEditorWarningBeforeSavePanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adiToEditorWarningBeforeSavePanelClosed = function (params) {
    return { evid: 618, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} platformAppTryToAddParams
* @property {string} adding_method - {click,drag}
* @property {string} allAppsToInstall - array of all the apps on this session
* @property {string} app_id - app_id
* @property {string} app_name - app name
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {GUID} flowId - Silent install flow id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {add panel, my uploads panel.}
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: platform App try to Add. Evid: 755.
 * Event description: platform App try to add to stage.

 * adding_method - Type: string. Desc: {click,drag}
 *
 * allAppsToInstall - Type: string. Desc: array of all the apps on this session
 *
 * app_id - Type: string. Desc: app_id
 *
 * app_name - Type: string. Desc: app name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * flowId - Type: guid. Desc: Silent install flow id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {add panel, my uploads panel.}
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {platformAppTryToAddParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var platformAppTryToAdd = function (params) {
    return { evid: 755, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbHomepageDisplayingChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - text/icon
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_homepage_displaying_changed. Evid: 1236.
 * Event description: breadcrumb_homepage_displaying_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: text/icon
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbHomepageDisplayingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbHomepageDisplayingChanged = function (params) {
    return { evid: 1236, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcmFlipClickParams
* @property {string} actionName - flip_hor / flip_vert
* @property {string} component_type - text, image, etc
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} scroll_direction - up / down
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: RCM Flip Click. Evid: 1060.
 * Event description: Right Click Menu flip click for Vector Art and Video Box Components.

 * actionName - Type: string. Desc: flip_hor / flip_vert
 *
 * component_type - Type: string. Desc: text, image, etc
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * scroll_direction - Type: string. Desc: up / down
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {rcmFlipClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcmFlipClick = function (params) {
    return { evid: 1060, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dynamicPagesOptimizedSolutionClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - pages_panel / add_page_tooltip / add_panel
* @property {number} pages_count - 50/70/90
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: dynamic pages optimized solution click. Evid: 962.
 * Event description: Click on a banner with heavy site notification on Pages Panel or on enabled Add page tooltip.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: pages_panel / add_page_tooltip / add_panel
 *
 * pages_count - Type: numeric. Desc: 50/70/90
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {dynamicPagesOptimizedSolutionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dynamicPagesOptimizedSolutionClick = function (params) {
    return { evid: 962, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dynamicPageDatasetAddClickParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {add panel}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: dynamic_page_dataset_add_click. Evid: 702.
 * Event description: Dynamic_page_dataset_Add_click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {add panel}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dynamicPageDatasetAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dynamicPageDatasetAddClick = function (params) {
    return { evid: 702, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuQuickActionsMenuSelectClickParams
* @property {string} category - rename / unlink / settings / remove / duplicate / delete
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item_id - id of the menu item clicked on from menu
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {string} origin - drag/manage item
* @property {string} page_id - .
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} target - page / menu_set / link / dropdown
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_quick_actions_menu_select_click. Evid: 974.
 * Event description: MENU_quick_actions_menu_select_click.

 * category - Type: string. Desc: rename / unlink / settings / remove / duplicate / delete
 *
 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_id - Type: string. Desc: id of the menu item clicked on from menu
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: drag/manage item
 *
 * page_id - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: page / menu_set / link / dropdown
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuQuickActionsMenuSelectClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuQuickActionsMenuSelectClick = function (params) {
    return { evid: 974, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} timingPanelBehaviorDeletedParams
* @property {string} deleted_behavior_name - Ease Both/Ease In/Ease Out/Elastic/Linear
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: timing_panel_behavior_deleted. Evid: 83.
 * Event description: Deleting acceleration (selecting None).

 * deleted_behavior_name - Type: string. Desc: Ease Both/Ease In/Ease Out/Elastic/Linear
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {timingPanelBehaviorDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var timingPanelBehaviorDeleted = function (params) {
    return { evid: 83, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateDrag638Params
* @property {GUID} appId - {}
* @property {string} component_id - component_id
* @property {string} component_type - {}
* @property {string} devMode - dev mode on/off
* @property {number} distance - distance that component pass
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - Time to complete action in ms
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} is_same_parent_component - element moved inside current parent component (true/false)
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {boolean} out_of_grid - if element currently is out of grid (true/false)
* @property {boolean} out_of_grid_previously - if element was out of grid (true/false)
* @property {string} pageContext - page context
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_DRAG. Evid: 638.
 * Event description: frame view rate for DRAG.

 * appId - Type: guid. Desc: {}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {}
 *
 * devMode - Type: string. Desc: dev mode on/off
 *
 * distance - Type: numeric. Desc: distance that component pass
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: Time to complete action in ms
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * is_same_parent_component - Type: bool. Desc: element moved inside current parent component (true/false)
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * out_of_grid - Type: bool. Desc: if element currently is out of grid (true/false)
 *
 * out_of_grid_previously - Type: bool. Desc: if element was out of grid (true/false)
 *
 * pageContext - Type: string. Desc: page context
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateDrag638Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateDrag638 = function (params) {
    return { evid: 638, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileElementClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} element_name - element clicked on
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_element_click. Evid: 714.
 * Event description: mobile_element_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_name - Type: string. Desc: element clicked on
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileElementClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileElementClick = function (params) {
    return { evid: 714, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelAddGradientClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {layers ,border}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel ---> Add Gradient Click. Evid: 936.
 * Event description: This event will be sent every time a user clicks on the Add  Add Gradient Click.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {layers ,border}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelAddGradientClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelAddGradientClick = function (params) {
    return { evid: 936, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pinPositionSelectedParams
* @property {string} component_id - component_id
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selected_area - {string}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: dummy-name. Evid: 382.
 * Event description: pin_notification_too_big.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selected_area - Type: string. Desc: {string}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pinPositionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pinPositionSelected = function (params) {
    return { evid: 382, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textFontThemeHoverParams
* @property {string} category - {hovering over font style or theme: rubik-light, font_7 and etc}
* @property {string} component_id - {component_id}
* @property {string} component_type - {type of the component}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {origin of hover: mouse, up/down}
* @property {string} panel_name - {name of the text panle}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {font or theme}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text Font/Theme Hover. Evid: 1481.
 * Event description: Hover over Text Fonts or Theme.

 * category - Type: string. Desc: {hovering over font style or theme: rubik-light, font_7 and etc}
 *
 * component_id - Type: string. Desc: {component_id}
 *
 * component_type - Type: string. Desc: {type of the component}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {origin of hover: mouse, up/down}
 *
 * panel_name - Type: string. Desc: {name of the text panle}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {font or theme}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textFontThemeHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textFontThemeHover = function (params) {
    return { evid: 1481, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} postPublishMusicCampaignSubmitYourVideoClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} first_publish - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: post_publish_music_campaign_submit_your_video_click. Evid: 477.
 * Event description: post_publish_music_campaign_submit_your_video_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * first_publish - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {postPublishMusicCampaignSubmitYourVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postPublishMusicCampaignSubmitYourVideoClick = function (params) {
    return { evid: 477, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} checkBoxSelectionParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {string} selection - {Selected Value}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} state - {Checked, Unchecked}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: CheckBox_Selection. Evid: 357.
 * Event description: CheckBox_Selection.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * selection - Type: string. Desc: {Selected Value}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {Checked, Unchecked}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {checkBoxSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkBoxSelection = function (params) {
    return { evid: 357, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppPromotionalInstallFindoutMoreClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_promotional_install_findout_more_click. Evid: 195.
 * Event description: site_app_promotional_install_findout_more_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppPromotionalInstallFindoutMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppPromotionalInstallFindoutMoreClick = function (params) {
    return { evid: 195, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterPlaceholderHoverParams
* @property {string} businessType - {industry:”x”; structure: “y”}
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} subject - subject
* @property {string} textId - text option id
* @property {number} textLength - textLength of origin text in text comp
* @property {string} theme - header / paragraph
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.placeholder.hover. Evid: 1034.
 * Event description: Hover on placeholder in the generated text.

 * businessType - Type: string. Desc: {industry:”x”; structure: “y”}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * subject - Type: string. Desc: subject
 *
 * textId - Type: string. Desc: text option id
 *
 * textLength - Type: numeric. Desc: textLength of origin text in text comp
 *
 * theme - Type: string. Desc: header / paragraph
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterPlaceholderHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterPlaceholderHover = function (params) {
    return { evid: 1034, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dragComponentParams
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {tool bar, selected, on hover}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: drag component. Evid: 152.
 * Event description: drag component.

 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {tool bar, selected, on hover}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dragComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dragComponent = function (params) {
    return { evid: 152, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gfppClickParams
* @property {string} action_name - {change image, edit text...} includes if the action is main action, secondary action or tooltip.
* @property {string} all_gfpp_actions - all available gfpp actions
* @property {GUID} app_id - -
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} icon - {}
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWithinBlocksWidget - true - if the component contained inside a blocks widget or if that's the widget itself
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - {RCM,GFPP_button,top_bar}
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} editor_working_mode - desktop, mobile
* @property {string} workspace_mode - null
**/
/**
 * Name: gfpp -> click. Evid: 100.
 * Event description: gfpp -> click.

 * action_name - Type: string. Desc: {change image, edit text...} includes if the action is main action, secondary action or tooltip.
 *
 * all_gfpp_actions - Type: string. Desc: all available gfpp actions
 *
 * app_id - Type: guid. Desc: -
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * icon - Type: string. Desc: {}
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWithinBlocksWidget - Type: bool. Desc: true - if the component contained inside a blocks widget or if that's the widget itself
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: {RCM,GFPP_button,top_bar}
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * editor_working_mode - Type: string. Desc: desktop, mobile
 *
 * workspace_mode - Type: string.
 * @param {gfppClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gfppClick = function (params) {
    return { evid: 100, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyStyleApplyParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_of_styles_chosen - {0,1,2,3..}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: copy_style_apply. Evid: 321.
 * Event description: copy_style_apply.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_of_styles_chosen - Type: numeric. Desc: {0,1,2,3..}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyStyleApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyStyleApply = function (params) {
    return { evid: 321, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dataQuickActionsMenuSelectClickParams
* @property {string} category - {add dynamic page, edit permissions, remove collection,...}
* @property {string} collection_id - {collection id}
* @property {string} collection_name - {collection name}
* @property {string} collection_type - {permission preset}
* @property {string} dm_version - null
* @property {string} ds_id - {ds_id}
* @property {string} ds_name - {ds_name}
* @property {string} ds_origin - null
* @property {string} ds_type - {read,write,read&write}
* @property {GUID} esi - {esi}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} source - {data_menu_panel}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {collection}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: DATA_quick_actions_menu_select_click. Evid: 823.
 * Event description: DATA_quick_actions_menu_select_click.

 * category - Type: string. Desc: {add dynamic page, edit permissions, remove collection,...}
 *
 * collection_id - Type: string. Desc: {collection id}
 *
 * collection_name - Type: string. Desc: {collection name}
 *
 * collection_type - Type: string. Desc: {permission preset}
 *
 * dm_version - Type: string.
 *
 * ds_id - Type: string. Desc: {ds_id}
 *
 * ds_name - Type: string. Desc: {ds_name}
 *
 * ds_origin - Type: string.
 *
 * ds_type - Type: string. Desc: {read,write,read&write}
 *
 * esi - Type: guid. Desc: {esi}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: {data_menu_panel}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {collection}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dataQuickActionsMenuSelectClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dataQuickActionsMenuSelectClick = function (params) {
    return { evid: 823, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsPrivacyLanguageSelectedClickParams
* @property {string} category - {password, members}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} language_selected - {en, es, pt, ru...}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_privacy_language_selected_click. Evid: 430.
 * Event description: PAGES_settings_privacy_language_selected_click.

 * category - Type: string. Desc: {password, members}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * language_selected - Type: string. Desc: {en, es, pt, ru...}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsPrivacyLanguageSelectedClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsPrivacyLanguageSelectedClick = function (params) {
    return { evid: 430, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsSectionAddingProcessStartedAfterAppInstallationParams
* @property {string} adding_method - click or drag
* @property {string} app_list - app id of the app
* @property {string} category - sections category (Stores, Bookings etc.)
* @property {string} component_type - section
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - esi
* @property {boolean} is_rollout - -
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} origin - from where the add section panel was opened or paste / duplicate
* @property {string} presetId - id of preset
* @property {GUID} site_id - -
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Sections - section adding process started after app installation. Evid: 1359.
 * Event description: Event triggers upon adding section after app installation succeeded and section adding process has started.

 * adding_method - Type: string. Desc: click or drag
 *
 * app_list - Type: string. Desc: app id of the app
 *
 * category - Type: string. Desc: sections category (Stores, Bookings etc.)
 *
 * component_type - Type: string. Desc: section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * origin - Type: string. Desc: from where the add section panel was opened or paste / duplicate
 *
 * presetId - Type: string. Desc: id of preset
 *
 * site_id - Type: guid. Desc: -
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionsSectionAddingProcessStartedAfterAppInstallationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsSectionAddingProcessStartedAfterAppInstallation = function (params) {
    return { evid: 1359, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionAnchorUrlCopyGoToUrlParams
* @property {string} actionName - Copy URL/Go to URL
* @property {string} componentId - section/anchor component id
* @property {string} componentName - section name or anchor name
* @property {string} componentType - section/anchor component type
* @property {string} dm_version - null
* @property {string} ds_origin - -
* @property {GUID} esi - -
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} pageId - page where section/anchor is placed
* @property {string} pageName - name of the page where section is placed
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - -
* @property {string} urlSuffix - url suffix
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: Section/Anchor URL - Copy/Go to URL. Evid: 1405.
 * Event description: User copied URL or went to URL through Section/Anchor URL collapsable menu in Section/Anchor Settings Panel..

 * actionName - Type: string. Desc: Copy URL/Go to URL
 *
 * componentId - Type: string. Desc: section/anchor component id
 *
 * componentName - Type: string. Desc: section name or anchor name
 *
 * componentType - Type: string. Desc: section/anchor component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: -
 *
 * esi - Type: guid. Desc: -
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * pageId - Type: string. Desc: page where section/anchor is placed
 *
 * pageName - Type: string. Desc: name of the page where section is placed
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * urlSuffix - Type: string. Desc: url suffix
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {sectionAnchorUrlCopyGoToUrlParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionAnchorUrlCopyGoToUrl = function (params) {
    return { evid: 1405, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarViewMenuClickParams
* @property {string} category - {toolbar, rulers, guidelines, snap}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {string} initiator_name - {manual, auto-acquisition, auto-intro funnel}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {auto,manual,Keyboardshortcut}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - {1,0}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_TOOLS_menu_click. Evid: 287.
 * Event description: top_bar_click.

 * category - Type: string. Desc: {toolbar, rulers, guidelines, snap}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * initiator_name - Type: string. Desc: {manual, auto-acquisition, auto-intro funnel}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {auto,manual,Keyboardshortcut}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {1,0}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarViewMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarViewMenuClick = function (params) {
    return { evid: 287, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myDesignsRenamePresetSaveParams
* @property {string} content_type - type of component
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} element_id - element_id
* @property {string} element_name - element_name
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.rename_preset_save. Evid: 1387.
 * Event description: user renamed saved preset.

 * content_type - Type: string. Desc: type of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * element_id - Type: string. Desc: element_id
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {myDesignsRenamePresetSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myDesignsRenamePresetSave = function (params) {
    return { evid: 1387, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelTextStyleSelectedParams
* @property {string} category - {Heading L...}
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Text_Style_Selected. Evid: 226.
 * Event description: Text_Panel_Text_Style_Selected.

 * category - Type: string. Desc: {Heading L...}
 *
 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelTextStyleSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelTextStyleSelected = function (params) {
    return { evid: 226, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} crossSitePasteComponentOrTpaParams
* @property {string} component_id - component_id created by paste
* @property {string} component_type - {page/TPA/container/group/multiselect/text...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} error_type - error type
* @property {GUID} esi - editor session id
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} media_content - {yes/no/NULL} null - no media content, yes - upload media content, no - don't upload media content
* @property {string} multilingual - null
* @property {string} origin_component_id - component_id
* @property {GUID} origin_msid - msid of a site from which the component was copied
* @property {string} paste_option - {keyboard/rcm/toolbar}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - paste success
* @property {string} theme - {target/origin}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: paste_component. Evid: 943.
 * Event description: paste component or TPA.

 * component_id - Type: string. Desc: component_id created by paste
 *
 * component_type - Type: string. Desc: {page/TPA/container/group/multiselect/text...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * error_type - Type: string. Desc: error type
 *
 * esi - Type: guid. Desc: editor session id
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * media_content - Type: string. Desc: {yes/no/NULL} null - no media content, yes - upload media content, no - don't upload media content
 *
 * multilingual - Type: string.
 *
 * origin_component_id - Type: string. Desc: component_id
 *
 * origin_msid - Type: guid. Desc: msid of a site from which the component was copied
 *
 * paste_option - Type: string. Desc: {keyboard/rcm/toolbar}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: paste success
 *
 * theme - Type: string. Desc: {target/origin}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {crossSitePasteComponentOrTpaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crossSitePasteComponentOrTpa = function (params) {
    return { evid: 943, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuManagePagesApplyParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {number} pages_count - how many pages currently in menu set
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_manage_pages_apply. Evid: 972.
 * Event description: user click Apply after selcet/unselect pages in Menu Manager.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * pages_count - Type: numeric. Desc: how many pages currently in menu set
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuManagePagesApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuManagePagesApply = function (params) {
    return { evid: 972, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarMenuItemHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menu_item_name - menu item name
* @property {string} multilingual - null
* @property {string} menu_name - Site/Settings/Help
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_menu_item_hover. Evid: 987.
 * Event description: Hovering menu items of the top bar menus.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menu_item_name - Type: string. Desc: menu item name
 *
 * multilingual - Type: string.
 *
 * menu_name - Type: string. Desc: Site/Settings/Help
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarMenuItemHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarMenuItemHover = function (params) {
    return { evid: 987, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} cutComponentOrTpaParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} component_id - id of component
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} instance_id - [guid]
* @property {boolean} is_component_pinned - {0,1}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} non_page_top_parent_component_id - id of top level component's parent that is not a page
* @property {string} non_page_top_parent_component_type - type of top level component's parent that is not a page
* @property {string} origin - Keyboard
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - []
* @property {string} workspace_mode - null
**/
/**
 * Name: cut_component_or_TPA. Evid: 180.
 * Event description: cut_component_or_TPA.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: id of component
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: string. Desc: [guid]
 *
 * is_component_pinned - Type: bool. Desc: {0,1}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * non_page_top_parent_component_id - Type: string. Desc: id of top level component's parent that is not a page
 *
 * non_page_top_parent_component_type - Type: string. Desc: type of top level component's parent that is not a page
 *
 * origin - Type: string. Desc: Keyboard
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: []
 *
 * workspace_mode - Type: string.
 * @param {cutComponentOrTpaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cutComponentOrTpa = function (params) {
    return { evid: 180, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} createRcClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor, editor1.4
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar/publish
* @property {string} panel_name - {}
* @property {number} revision - revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: RC created panel - Done clicked. Evid: 894.
 * Event description: Fires when a user clicks on 'done'  from the release candidate creation panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor, editor1.4
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar/publish
 *
 * panel_name - Type: string. Desc: {}
 *
 * revision - Type: numeric. Desc: revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {createRcClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var createRcClicked = function (params) {
    return { evid: 894, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpTooltipClosedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {x, auto closed}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_tooltip_closed. Evid: 566.
 * Event description: pop_up_tooltip_closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {x, auto closed}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpTooltipClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpTooltipClosed = function (params) {
    return { evid: 566, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} themeManagerCategoryClickParams
* @property {string} category - colors / text
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: theme manager -> category click. Evid: 1062.
 * Event description: theme manager ->category click.

 * category - Type: string. Desc: colors / text
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {themeManagerCategoryClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var themeManagerCategoryClick = function (params) {
    return { evid: 1062, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveErrorWorkNotSavedErrorOkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_error_work_not_saved_error_ok_click. Evid: 341.
 * Event description: First_Save_error_work_not_saved_error_ok_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveErrorWorkNotSavedErrorOkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveErrorWorkNotSavedErrorOkClick = function (params) {
    return { evid: 341, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsAddSectionPanelCategoryOpenParams
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} category - category of the add section panel
* @property {string} correlation_id - correlation_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_injected_content - true if content was already loaded
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - if category was opened from notification
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Sections - Add section panel - category open. Evid: 1310.
 * Event description: User see category of the add section panel.

 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * category - Type: string. Desc: category of the add section panel
 *
 * correlation_id - Type: string. Desc: correlation_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_injected_content - Type: bool. Desc: true if content was already loaded
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: if category was opened from notification
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionsAddSectionPanelCategoryOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsAddSectionPanelCategoryOpen = function (params) {
    return { evid: 1310, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteRemoveColorPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - color name changed: none, theme color values
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette remove color panel. Evid: 1434.
 * Event description: Color palette remove colour change & accept colour.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: color name changed: none, theme color values
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteRemoveColorPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteRemoveColorPanel = function (params) {
    return { evid: 1434, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pluginAddedParams
* @property {string} app_def_id_plugin - app_def_id_plugin
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} host_app_id - {application_id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of install
* @property {string} plugin_id - {id of plugin installed}
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} slot_id - {slot_id where plugin installed}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Plugin added. Evid: 1447.
 * Event description: Plugin added.

 * app_def_id_plugin - Type: string. Desc: app_def_id_plugin
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * host_app_id - Type: string. Desc: {application_id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of install
 *
 * plugin_id - Type: string. Desc: {id of plugin installed}
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * slot_id - Type: string. Desc: {slot_id where plugin installed}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pluginAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginAdded = function (params) {
    return { evid: 1447, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeResetButtonClickParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} origin - rcm \ button
* @property {string} parent_component_id - parent component id
* @property {string} parent_component_type - parent component type
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_reset_button_click. Evid: 1151.
 * Event description: interaction_mode_reset_button_click.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: rcm \ button
 *
 * parent_component_id - Type: string. Desc: parent component id
 *
 * parent_component_type - Type: string. Desc: parent component type
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {interactionModeResetButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeResetButtonClick = function (params) {
    return { evid: 1151, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelHighlightClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - click_to_open / color / none
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Highlight_Click. Evid: 242.
 * Event description: Text_Panel_Highlight_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: click_to_open / color / none
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelHighlightClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelHighlightClick = function (params) {
    return { evid: 242, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuImageSectionButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {my images/wix free images/bigstock/facebook/instagram etc}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} sub_section - {free wix images, cliparts, illustrations...}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> image-> section button click. Evid: 125.
 * Event description: add menu -> image-> section button click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {my images/wix free images/bigstock/facebook/instagram etc}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * sub_section - Type: string. Desc: {free wix images, cliparts, illustrations...}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuImageSectionButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuImageSectionButtonClick = function (params) {
    return { evid: 125, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} applyToRegularClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Apply to regular clicked. Evid: 635.
 * Event description: apply from hover to regular.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {applyToRegularClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var applyToRegularClicked = function (params) {
    return { evid: 635, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} customMobilePresetAppliedParams
* @property {string} component_id - component id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page_id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: custom mobile preset applied. Evid: 664.
 * Event description: custom mobile preset applied.

 * component_id - Type: string. Desc: component id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {customMobilePresetAppliedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customMobilePresetApplied = function (params) {
    return { evid: 664, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorHideComponentParams
* @property {GUID} app_id - guid
* @property {GUID} app_site_id - guid
* @property {string} component_id - guid
* @property {string} component_type - (ed_tpa, wix_component, list, blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hide_method - {right-click,...}
* @property {GUID} instance_id - guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile editor_hide component. Evid: 282.
 * Event description: mobile editor_hide component.

 * app_id - Type: guid. Desc: guid
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_id - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: (ed_tpa, wix_component, list, blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hide_method - Type: string. Desc: {right-click,...}
 *
 * instance_id - Type: guid. Desc: guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorHideComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorHideComponent = function (params) {
    return { evid: 282, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonContentManagerClickedAnyCollectionCmsOpensParams
* @property {string} collectionId - the original collection_id
* @property {string} collection_name - the name of the collection that was clicked
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button > Content Manager > Clicked any collection(cms opens). Evid: 1265.
 * Event description: on 6th button content manager tab, user clicks a collection. after the click the cms is opened!.

 * collectionId - Type: string. Desc: the original collection_id
 *
 * collection_name - Type: string. Desc: the name of the collection that was clicked
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonContentManagerClickedAnyCollectionCmsOpensParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonContentManagerClickedAnyCollectionCmsOpens = function (params) {
    return { evid: 1265, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpChoosePagesClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_choose_pages_clicked. Evid: 528.
 * Event description: pop_up_choose_pages_clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpChoosePagesClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpChoosePagesClicked = function (params) {
    return { evid: 528, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rightClickMenuCloseParams
* @property {string} category - {selected, on hover}
* @property {string} component - {text,image,gallery,button,shape,music,video,social,box,menu,contact}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {esc button, outside click}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: right_click_menu_close. Evid: 331.
 * Event description: right click menu open.

 * category - Type: string. Desc: {selected, on hover}
 *
 * component - Type: string. Desc: {text,image,gallery,button,shape,music,video,social,box,menu,contact}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {esc button, outside click}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rightClickMenuCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rightClickMenuClose = function (params) {
    return { evid: 331, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteMenusContentParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_advanced_menu - True/false exposed to advanced menu experience
* @property {boolean} is_advanced_menu_in_use - True/false when advanced menu is in use on site
* @property {boolean} is_custom_menu_exposed - True/false for exposed to custom menu experience
* @property {boolean} is_custom_menu_in_use - True/false when custom menu is in use on site
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menusetsComponents - json with menu sets by components
* @property {string} multilingual - null
* @property {number} numFolder - Number of folders in pages panel
* @property {number} numMenus - Number of menu components in site (exclude members, login, mobile menu, tiny menu (old mobile))
* @property {number} numMenusetsUnique - Number of unique menu sets on site
* @property {number} numPages - number of pages on site
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} siteType - site type based on custom menu/advanced menu/old custom menu logic
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Site_menus_content. Evid: 1393.
 * Event description: Menus on site information: number of menus, sets, custom, advanced types, number of folders.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_advanced_menu - Type: bool. Desc: True/false exposed to advanced menu experience
 *
 * is_advanced_menu_in_use - Type: bool. Desc: True/false when advanced menu is in use on site
 *
 * is_custom_menu_exposed - Type: bool. Desc: True/false for exposed to custom menu experience
 *
 * is_custom_menu_in_use - Type: bool. Desc: True/false when custom menu is in use on site
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menusetsComponents - Type: string. Desc: json with menu sets by components
 *
 * multilingual - Type: string.
 *
 * numFolder - Type: numeric. Desc: Number of folders in pages panel
 *
 * numMenus - Type: numeric. Desc: Number of menu components in site (exclude members, login, mobile menu, tiny menu (old mobile))
 *
 * numMenusetsUnique - Type: numeric. Desc: Number of unique menu sets on site
 *
 * numPages - Type: numeric. Desc: number of pages on site
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * siteType - Type: string. Desc: site type based on custom menu/advanced menu/old custom menu logic
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteMenusContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteMenusContent = function (params) {
    return { evid: 1393, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageAddedParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Page Added. Evid: 1076.
 * Event description: Static Page Added - duplication of 38:1072, will be deprecated soon.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {pageAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageAdded = function (params) {
    return { evid: 1076, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lottieAltTextChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} new_value - new alt value
* @property {string} old_value - prev alt
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: lottie_alt_text_changed. Evid: 1349.
 * Event description: lottie_alt_text_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_value - Type: string. Desc: new alt value
 *
 * old_value - Type: string. Desc: prev alt
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {lottieAltTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lottieAltTextChanged = function (params) {
    return { evid: 1349, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} setupOverlayClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: setup_overlay_clicked. Evid: 532.
 * Event description: setup_overlay_clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {setupOverlayClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var setupOverlayClicked = function (params) {
    return { evid: 532, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeVideosInEditorParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {time in milli seconds}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {ESC;X button}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoID - {}
* @property {string} video_name - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Close videos in editor. Evid: 668.
 * Event description: step by step videos close.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {time in milli seconds}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {ESC;X button}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoID - Type: string. Desc: {}
 *
 * video_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeVideosInEditorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeVideosInEditor = function (params) {
    return { evid: 668, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpSettingsPageSelectorOkParams
* @property {boolean} all_pages_selected - 1,0
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_selected_pages - 1,2,3..
* @property {number} num_unselected_pages - 1,2,3..
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_settings_page_selector_ok. Evid: 560.
 * Event description: pop_up_settings_page_selector_ok.

 * all_pages_selected - Type: bool. Desc: 1,0
 *
 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_selected_pages - Type: numeric. Desc: 1,2,3..
 *
 * num_unselected_pages - Type: numeric. Desc: 1,2,3..
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpSettingsPageSelectorOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpSettingsPageSelectorOk = function (params) {
    return { evid: 560, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} headerTooltipHoverParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop zoom, mobile zoom, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: header_tooltip_hover. Evid: 552.
 * Event description: header_tooltip_hover.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop zoom, mobile zoom, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {headerTooltipHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerTooltipHover = function (params) {
    return { evid: 552, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbBackToHomepageToggleChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} selection - on/off
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_back_to_homepage_toggle_changed. Evid: 1243.
 * Event description: breadcrumb_back_to_homepage_toggle_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: on/off
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbBackToHomepageToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbBackToHomepageToggleChanged = function (params) {
    return { evid: 1243, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} bizManagerTrackAndAnalyzeEnableDisableToolParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Auto / ByUserRequest}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} toggle - {true/false}
* @property {string} totalJsHeapSize - null
* @property {string} tool_type - {Google Analytics, Facebook Pixel, Yandex Metrica, Google AdWords, Verification Code, Custom}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Biz Manager - Track and Analyze - enable disable tool. Evid: 763.
 * Event description: enable disable tool Track and Analyze tool {Google Analytics, Facebook Pixel, Yandex Metrica, Google AdWords, Verification Code, Custom}.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Auto / ByUserRequest}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: {true/false}
 *
 * totalJsHeapSize - Type: string.
 *
 * tool_type - Type: string. Desc: {Google Analytics, Facebook Pixel, Yandex Metrica, Google AdWords, Verification Code, Custom}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {bizManagerTrackAndAnalyzeEnableDisableToolParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerTrackAndAnalyzeEnableDisableTool = function (params) {
    return { evid: 763, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppTemplateFirsttimeStep2welcomeCloseClickParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_template_firsttime_step2welcome_close_click. Evid: 201.
 * Event description: site_app_template_firsttime_step2welcome_close_click.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppTemplateFirsttimeStep2welcomeCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppTemplateFirsttimeStep2welcomeCloseClick = function (params) {
    return { evid: 201, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceTintSelectParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} index_of_tint - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_tint_select. Evid: 139.
 * Event description: ColorSpace_Tint_Select.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * index_of_tint - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceTintSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceTintSelect = function (params) {
    return { evid: 139, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageCarouselClicksInAddPagePanelParams
* @property {string} direction - left / right
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - stores / bookings / blog / pricing plan
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: AddPage - carousel clicks in add page panel. Evid: 1137.
 * Event description: send when user clicks on carousel in add page panel.

 * direction - Type: string. Desc: left / right
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: stores / bookings / blog / pricing plan
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageCarouselClicksInAddPagePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageCarouselClicksInAddPagePanel = function (params) {
    return { evid: 1137, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} duplicateCurrentSlideClickedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Duplicate current slide clicked. Evid: 538.
 * Event description: Duplicate current slide clicked.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {duplicateCurrentSlideClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var duplicateCurrentSlideClicked = function (params) {
    return { evid: 538, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionComponentSettingsPanelOpenedParams
* @property {string} component_id - id of selected component
* @property {string} component_type - type of the component that was changed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} panel_name - image_settings, edit_section_settings)
* @property {string} parent_component_id - id of selected section
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: Component Settings Panel Opened. Evid: 1377.
 * Event description: Edit Section Settings Panel Opened inside the "Edit Section" panel.

 * component_id - Type: string. Desc: id of selected component
 *
 * component_type - Type: string. Desc: type of the component that was changed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * panel_name - Type: string. Desc: image_settings, edit_section_settings)
 *
 * parent_component_id - Type: string. Desc: id of selected section
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionComponentSettingsPanelOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionComponentSettingsPanelOpened = function (params) {
    return { evid: 1377, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rcmResetElementToRegularClickParams
* @property {string} component_type - text, image, etc
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} scroll_direction - up / down
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: RCM Reset Element to Regular Click. Evid: 1099.
 * Event description: Right Click Menu  Reset Element to Regular for Hover Mode.

 * component_type - Type: string. Desc: text, image, etc
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * scroll_direction - Type: string. Desc: up / down
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {rcmResetElementToRegularClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rcmResetElementToRegularClick = function (params) {
    return { evid: 1099, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionClickOnComponentParams
* @property {string} action_origin - origin of the click: edit_section / <name>_settings (e.g. section_background_settings, button_settings e.t.c)
* @property {string} component_id - id of selected component
* @property {string} component_parent_id - id of component that contain element
* @property {string} component_parent_type - for component that contain element (example: BoxSlideShowSlide)
* @property {string} component_type - type of the component that was clicked
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} parent_component_id - id of selected section
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} target - section_background, section_background_change_ button, title, paragraph, settings_button, settings_link_button, more, rename_section, help, e.t.c
* @property {string} totalJsHeapSize - (no description)
* @property {boolean} unsupported_edit_section - true/false
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: Click on Component. Evid: 1373.
 * Event description: user clicks on component inside Edit Section panel.

 * action_origin - Type: string. Desc: origin of the click: edit_section / <name>_settings (e.g. section_background_settings, button_settings e.t.c)
 *
 * component_id - Type: string. Desc: id of selected component
 *
 * component_parent_id - Type: string. Desc: id of component that contain element
 *
 * component_parent_type - Type: string. Desc: for component that contain element (example: BoxSlideShowSlide)
 *
 * component_type - Type: string. Desc: type of the component that was clicked
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * parent_component_id - Type: string. Desc: id of selected section
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: section_background, section_background_change_ button, title, paragraph, settings_button, settings_link_button, more, rename_section, help, e.t.c
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * unsupported_edit_section - Type: bool. Desc: true/false
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionClickOnComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionClickOnComponent = function (params) {
    return { evid: 1373, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderTrackSizeChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {string} section - Circle/Square/Rectangle /Bar
* @property {string} selection - 1,2,3...
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: dummy-name. Evid: 1330.
 * Event description: range_slider_track_size_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * selection - Type: string. Desc: 1,2,3...
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderTrackSizeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderTrackSizeChanged = function (params) {
    return { evid: 1330, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuShowAllPagesClickParams
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} target - show / hide
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_show_all_pages_click. Evid: 970.
 * Event description: user click Show All Pages in Menu Manager.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: show / hide
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuShowAllPagesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuShowAllPagesClick = function (params) {
    return { evid: 970, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} fullSaveAttemptedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} endpoint - {full, partial}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Full_save_attempted. Evid: 632.
 * Event description: Full save attempted in order to fix partial save validation failure.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * endpoint - Type: string. Desc: {full, partial}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {fullSaveAttemptedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fullSaveAttempted = function (params) {
    return { evid: 632, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSiteColorsClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - single_color / column_color
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - number (0-24 for color or 0-4 for whole column)
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Site_Colors_Click. Evid: 403.
 * Event description: Edit_Site_Colors_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: single_color / column_color
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: number (0-24 for color or 0-4 for whole column)
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editSiteColorsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSiteColorsClick = function (params) {
    return { evid: 403, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesStorePagesSettingsTabClickParams
* @property {string} category - {page info, layout, privacy, SEO}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_type - {product, cart, thank you}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_store_pages_settings_tab_click. Evid: 441.
 * Event description: PAGES_store_pages_settings_tab_click.

 * category - Type: string. Desc: {page info, layout, privacy, SEO}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_type - Type: string. Desc: {product, cart, thank you}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesStorePagesSettingsTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesStorePagesSettingsTabClick = function (params) {
    return { evid: 441, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} marketHelpSupportLinkParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: market_help_support_link. Evid: 176.
 * Event description: market_help_support_link.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {marketHelpSupportLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketHelpSupportLink = function (params) {
    return { evid: 176, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} bringToFrontParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {right click menu, keyboard sc, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: bring to front. Evid: 148.
 * Event description: bring to front.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {right click menu, keyboard sc, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {bringToFrontParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bringToFront = function (params) {
    return { evid: 148, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonTextButtonShowParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {string} origin - null
* @property {string} page_id - null
* @property {string} selection - text/ellipsis
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: StylableButton.text_button_show. Evid: 1344.
 * Event description: StylableButton.text_button_show.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string.
 *
 * page_id - Type: string.
 *
 * selection - Type: string. Desc: text/ellipsis
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonTextButtonShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonTextButtonShow = function (params) {
    return { evid: 1344, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageChoicesDuplicateChoiceClickParams
* @property {string} builderOrigin - ADI / Editor
* @property {string} choice_name - choice_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} field_name - field_name
* @property {string} field_type - field_type
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Manage Choices - Duplicate Choice - click. Evid: 911.
 * Event description: user click on duplicate choice.

 * builderOrigin - Type: string. Desc: ADI / Editor
 *
 * choice_name - Type: string. Desc: choice_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * field_name - Type: string. Desc: field_name
 *
 * field_type - Type: string. Desc: field_type
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageChoicesDuplicateChoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageChoicesDuplicateChoiceClick = function (params) {
    return { evid: 911, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickedActivateKeyboardAccessibilityParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: clicked activate keyboard accessibility. Evid: 694.
 * Event description: Clicked activate keyboard accessibility  button.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickedActivateKeyboardAccessibilityParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickedActivateKeyboardAccessibility = function (params) {
    return { evid: 694, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateRotateParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_ROTATE. Evid: 734.
 * Event description: frame view rate for ROTATE.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateRotateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateRotate = function (params) {
    return { evid: 734, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} openPushedVersionInEditorClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} revision - revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: open pushed version in editor clicked. Evid: 902.
 * Event description: Fires when a user clicks on the 'open version' button in the 'version pushed' dialog.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * revision - Type: numeric. Desc: revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {openPushedVersionInEditorClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openPushedVersionInEditorClicked = function (params) {
    return { evid: 902, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderDirectionChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - component_id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} section - null
* @property {string} selection - RtL/LtR
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_direction_changed. Evid: 1331.
 * Event description: range_slider_direction_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * section - Type: string.
 *
 * selection - Type: string. Desc: RtL/LtR
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderDirectionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderDirectionChanged = function (params) {
    return { evid: 1331, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} saveGarbageCollectionParams
* @property {string} client_items_to_delete - list of items to delete according to client
* @property {string} difference - list of diff items
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} server_items_to_delete - list of items to delete according to server
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: save_garbage_collection. Evid: 889.
 * Event description: For each save in the editor sends the difference in garbage collection list according to client and server..

 * client_items_to_delete - Type: string. Desc: list of items to delete according to client
 *
 * difference - Type: string. Desc: list of diff items
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * server_items_to_delete - Type: string. Desc: list of items to delete according to server
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {saveGarbageCollectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveGarbageCollection = function (params) {
    return { evid: 889, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} layerClickParams
* @property {string} component_type - component type which was clicked
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_landing_page - true, false (header - footer shown)
* @property {boolean} is_popup - true, false (header - footer shown - lightbox)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layer_name - {}
* @property {string} multilingual - null
* @property {boolean} out_of_grid - if element currently is out of grid (true/false)
* @property {string} panel_origin - send the location from where the 'Layers panel' was opened
* @property {string} parent_component_type - header, page, overlay, footer
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: layer_click. Evid: 808.
 * Event description: click on a specific layer to highlight it on stage.

 * component_type - Type: string. Desc: component type which was clicked
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_landing_page - Type: bool. Desc: true, false (header - footer shown)
 *
 * is_popup - Type: bool. Desc: true, false (header - footer shown - lightbox)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layer_name - Type: string. Desc: {}
 *
 * multilingual - Type: string.
 *
 * out_of_grid - Type: bool. Desc: if element currently is out of grid (true/false)
 *
 * panel_origin - Type: string. Desc: send the location from where the 'Layers panel' was opened
 *
 * parent_component_type - Type: string. Desc: header, page, overlay, footer
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {layerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var layerClick = function (params) {
    return { evid: 808, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} wixEditor14DummyUserEventParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} ticket_id - add ticket_id to users_38
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: wix editor 1.4 - dummy user event. Evid: 99.


 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * ticket_id - Type: string. Desc: add ticket_id to users_38
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {wixEditor14DummyUserEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixEditor14DummyUserEvent = function (params) {
    return { evid: 99, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteHas100PagesParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: site has 100+ pages. Evid: 969.
 * Event description: Event is being sent on check if a site has 100+ pages to be excluded from AB test.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {siteHas100PagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteHas100Pages = function (params) {
    return { evid: 969, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsAudioPreviewClickParams
* @property {string} button - play / pause
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.audioPreview.click. Evid: 1203.
 * Event description: Audio Player Settings button clicked.

 * button - Type: string. Desc: play / pause
 *
 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsAudioPreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsAudioPreviewClick = function (params) {
    return { evid: 1203, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondSaveDonTShowAgainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} toggle - {0,1}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {not published not connected, not Published connected, published_connected, Published_not_connected}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Save_don't_show_again_click. Evid: 336.
 * Event description: Second_Save_don't_show_again_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle - Type: bool. Desc: {0,1}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {not published not connected, not Published connected, published_connected, Published_not_connected}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondSaveDonTShowAgainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondSaveDonTShowAgainClick = function (params) {
    return { evid: 336, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} previewButtonDropdownClickedParams
* @property {string} dm_version - dm_version
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - preview/ test_site
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - workspace_mode
**/
/**
 * Name: test_site button dropdown clicked. Evid: 1473.
 * Event description: Fires when the user clicks on the preview/test_site dropdown arrow.

 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: preview/ test_site
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string. Desc: workspace_mode
 * @param {previewButtonDropdownClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewButtonDropdownClicked = function (params) {
    return { evid: 1473, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelHeaderCloseMaxScrollParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - ()
* @property {boolean} has_scroll - {1,0}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} max_scroll - (0% - 100%)
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {number} panel_total_scroll_px - total scrolling area pixels in panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: panel_header_close_max_scroll. Evid: 795.
 * Event description: panel_header_close_max_scroll.
reports the max scroll the users saw in a specific panel.
If a user didn't scroll at all -> 0%
If a user scrolled all the way to the bottom -> 100%.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: ()
 *
 * has_scroll - Type: bool. Desc: {1,0}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * max_scroll - Type: numeric. Desc: (0% - 100%)
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * panel_total_scroll_px - Type: numeric. Desc: total scrolling area pixels in panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelHeaderCloseMaxScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelHeaderCloseMaxScroll = function (params) {
    return { evid: 795, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} interactionModeStartedParams
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: interaction_mode_started. Evid: 977.
 * Event description: Interaction mode started.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {interactionModeStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var interactionModeStarted = function (params) {
    return { evid: 977, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} smartWriterSearchDropDownOpenParams
* @property {string} businessType - {industry:”x”; structure: “y”} or null
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isWixData - content manager connected componetns
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: smartWriter.searchDropDown.open. Evid: 1058.
 * Event description: After user typed in at least 1 symbol in Search - Search drop down with suggestions opened.

 * businessType - Type: string. Desc: {industry:”x”; structure: “y”} or null
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isWixData - Type: bool. Desc: content manager connected componetns
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {smartWriterSearchDropDownOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var smartWriterSearchDropDownOpen = function (params) {
    return { evid: 1058, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} breadcrumbHomepageIconReplaceClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_homepage_icon_replace_clicked. Evid: 1237.
 * Event description: breadcrumb_homepage_icon_replace_clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {breadcrumbHomepageIconReplaceClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var breadcrumbHomepageIconReplaceClicked = function (params) {
    return { evid: 1237, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} frameViewRateDragPanelsParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - esi
* @property {number} frames_per_second - number of frames  viewed by user per second
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: frame_view_rate_DRAG Panels. Evid: 956.
 * Event description: frame view rate for DRAG panels.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: esi
 *
 * frames_per_second - Type: numeric. Desc: number of frames  viewed by user per second
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {frameViewRateDragPanelsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var frameViewRateDragPanels = function (params) {
    return { evid: 956, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tourEndedParams
* @property {string} dm_version - null
* @property {string} ds_origin - generic field
* @property {GUID} esi - generic field
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - generic field
* @property {string} multilingual - generic field
* @property {string} name - tour name
* @property {string} panel_name - Last opened panel after which tour was ended
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - generic field
* @property {string} usedJsHeapSize - generic field
* @property {string} viewerName - generic field
* @property {string} viewerVersion - generic field
* @property {string} workspace_mode - null
**/
/**
 * Name: tour.ended. Evid: 1081.
 * Event description: Sends when tour is over (by clicking X (close), skip on any stage or finished till the end).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: generic field
 *
 * esi - Type: guid. Desc: generic field
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: generic field
 *
 * multilingual - Type: string. Desc: generic field
 *
 * name - Type: string. Desc: tour name
 *
 * panel_name - Type: string. Desc: Last opened panel after which tour was ended
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: generic field
 *
 * usedJsHeapSize - Type: string. Desc: generic field
 *
 * viewerName - Type: string. Desc: generic field
 *
 * viewerVersion - Type: string. Desc: generic field
 *
 * workspace_mode - Type: string.
 * @param {tourEndedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tourEnded = function (params) {
    return { evid: 1081, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} formBuilderUploadFileInputSettingsClickOnButtonParams
* @property {string} button_name - button_name
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - null
* @property {string} form_comp_id - form_comp_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Form Builder - upload file - input settings - click on button. Evid: 1227.
 * Event description: Form Builder - upload file - input settings - click on button.

 * button_name - Type: string. Desc: button_name
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid.
 *
 * form_comp_id - Type: string. Desc: form_comp_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {formBuilderUploadFileInputSettingsClickOnButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var formBuilderUploadFileInputSettingsClickOnButton = function (params) {
    return { evid: 1227, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorNotificationMediaUploadParams
* @property {boolean} batch - true/false several files in one import
* @property {number} batch_size - amount of files in batch
* @property {string} dm_version - dm_version
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} file_format - file extension
* @property {number} file_size - file size in KB
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} message - Upload stopped due to …
* @property {string} multilingual - multilingual
* @property {string} origin - editor_drag_and_drop_on_stage / editor_shortcut_paste_on_stage
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} type - type of notification (incorrect_file_type / intrenet_connection e.t.c)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - workspace_mode
**/
/**
 * Name: Editor - Notification media upload. Evid: 1488.
 * Event description: Editor - Notification media upload.

 * batch - Type: bool. Desc: true/false several files in one import
 *
 * batch_size - Type: numeric. Desc: amount of files in batch
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * file_format - Type: string. Desc: file extension
 *
 * file_size - Type: numeric. Desc: file size in KB
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * message - Type: string. Desc: Upload stopped due to …
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: editor_drag_and_drop_on_stage / editor_shortcut_paste_on_stage
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * type - Type: string. Desc: type of notification (incorrect_file_type / intrenet_connection e.t.c)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string. Desc: workspace_mode
 * @param {editorNotificationMediaUploadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorNotificationMediaUpload = function (params) {
    return { evid: 1488, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstSaveDialog1SaveAndContinueClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value_selected - {free WIX domain, connect your own domain}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Save_Dialog_1_save_and_continue_click. Evid: 317.
 * Event description: First_Save_Dialog_1_save_and_continue_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value_selected - Type: string. Desc: {free WIX domain, connect your own domain}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstSaveDialog1SaveAndContinueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstSaveDialog1SaveAndContinueClick = function (params) {
    return { evid: 317, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} cropOptionSelectedParams
* @property {string} action_name - size,square
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: crop_option_selected. Evid: 512.
 * Event description: crop_option_selected.

 * action_name - Type: string. Desc: size,square
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {cropOptionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cropOptionSelected = function (params) {
    return { evid: 512, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelLeftTreeClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {string} selection - choosen breakdown value
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->  left tree click. Evid: 930.
 * Event description: This event will be sent every time a user clicks on the left tree panel tabs.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * selection - Type: string. Desc: choosen breakdown value
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelLeftTreeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelLeftTreeClick = function (params) {
    return { evid: 930, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsClickOnActionParams
* @property {string} action_id - openPostPanel/addProductPage/openPagesPanelOnStores/etc.
* @property {string} action_type - main/quick actions/general actions/other
* @property {string} deep_link - deep link in case of dealer primary/secondary buttons click
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tab_name - app_id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> click on app action. Evid: 1087.
 * Event description: Manage My App tab selected.

 * action_id - Type: string. Desc: openPostPanel/addProductPage/openPagesPanelOnStores/etc.
 *
 * action_type - Type: string. Desc: main/quick actions/general actions/other
 *
 * deep_link - Type: string. Desc: deep link in case of dealer primary/secondary buttons click
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: app_id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsClickOnActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsClickOnAction = function (params) {
    return { evid: 1087, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} imageMaskClickInsidePanelParams
* @property {string} component_id - {}
* @property {string} component_type - component_type
* @property {string} dm_version - dm_version
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {string} field_name - field name
* @property {string} field_type - field type
* @property {string} field_value - value
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {boolean} keep_proportions - true / false
* @property {string} multilingual - .
* @property {string} panel_name - text_panel, text_design_panel
* @property {GUID} site_id - {}
* @property {string} stage_type - .
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Image Mask  -  click inside panel. Evid: 1495.
 * Event description: Image Mask -  click inside panel.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: field type
 *
 * field_value - Type: string. Desc: value
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * keep_proportions - Type: bool. Desc: true / false
 *
 * multilingual - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: text_panel, text_design_panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {imageMaskClickInsidePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var imageMaskClickInsidePanel = function (params) {
    return { evid: 1495, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorpickerMainpanelAddcolorButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorpicker_mainpanel_addcolor_button_click. Evid: 133.
 * Event description: ColorPicker_MainPanel_AddColor_Button_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorpickerMainpanelAddcolorButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorpickerMainpanelAddcolorButtonClick = function (params) {
    return { evid: 133, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} selectOverlappingItemParams
* @property {string} component - {selected, other}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - rcm etc
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: select overlapping item. Evid: 141.
 * Event description: select overlapping item.

 * component - Type: string. Desc: {selected, other}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: rcm etc
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {selectOverlappingItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectOverlappingItem = function (params) {
    return { evid: 141, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickUpgradeAppParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pp_origin - {fpp}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_upgrade_app. Evid: 184.
 * Event description: click_upgrade_app.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pp_origin - Type: string. Desc: {fpp}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickUpgradeAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickUpgradeApp = function (params) {
    return { evid: 184, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pinPositionOffsetSelectedParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} modified - {horizontal, vertical}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pin_position_offset_selected. Evid: 387.
 * Event description: pin_position_offset_selected.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * modified - Type: string. Desc: {horizontal, vertical}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pinPositionOffsetSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pinPositionOffsetSelected = function (params) {
    return { evid: 387, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionRenameSectionClickParams
* @property {string} component_id - component_id of section
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of click
* @property {string} section_name - section_name
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section - rename section click. Evid: 1305.
 * Event description: user clicked on rename section.

 * component_id - Type: string. Desc: component_id of section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of click
 *
 * section_name - Type: string. Desc: section_name
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionRenameSectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionRenameSectionClick = function (params) {
    return { evid: 1305, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videosInEditorLoadParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {add_panel;video_library}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoID - {}
* @property {string} video_name - {key}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videos in editor load. Evid: 667.
 * Event description: step by step videos load and play.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {add_panel;video_library}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoID - Type: string. Desc: {}
 *
 * video_name - Type: string. Desc: {key}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videosInEditorLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videosInEditorLoad = function (params) {
    return { evid: 667, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editDesignRceParams
* @property {string} category - the main category of the change
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
* @property {string} subcategory - the sub category of the change
* @property {number} timeSpent - time from 309 open event in ms
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} value - the value has change
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Design_RCE. Evid: 1125.
 * Event description: user edit the design inside the panel of RCE.

 * category - Type: string. Desc: the main category of the change
 *
 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
 *
 * subcategory - Type: string. Desc: the sub category of the change
 *
 * timeSpent - Type: numeric. Desc: time from 309 open event in ms
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * value - Type: string. Desc: the value has change
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editDesignRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editDesignRce = function (params) {
    return { evid: 1125, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editInteractionParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit_interaction. Evid: 1014.
 * Event description: Add hover interaction button click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editInteractionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editInteraction = function (params) {
    return { evid: 1014, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileWizardFirstStepSkipParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_wizard_first_step_skip. Evid: 775.
 * Event description: skip mobile wizard in first step.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileWizardFirstStepSkipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileWizardFirstStepSkip = function (params) {
    return { evid: 775, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backToOldEditorClickedWithBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Back to old editor clicked (with back option). Evid: 486.
 * Event description: With back to old editor option: Back to old editor : pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backToOldEditorClickedWithBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backToOldEditorClickedWithBackOption = function (params) {
    return { evid: 486, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardWidgetInstallStartParams
* @property {string} appId - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} screenResolution - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - .
* @property {GUID} uuid - user id
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} widgetName - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: Widget Install Start. Evid: 1333.
 * Event description: Site Creation Wizard: Widget Install Start.

 * appId - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * uuid - Type: guid. Desc: user id
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * widgetName - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardWidgetInstallStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardWidgetInstallStart = function (params) {
    return { evid: 1333, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchLayoutSwitchBetweenSectionsParams
* @property {string} component_id - id of selected section
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} is_list - whether the section contains lists (true/false)
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} layout_type - layout_type (original_layout, optional)
* @property {string} multilingual - multilingual
* @property {string} origin - from where the layout panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: SwitchLayout - switch between sections. Evid: 1293.
 * Event description: user switch between sections.

 * component_id - Type: string. Desc: id of selected section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * is_list - Type: bool. Desc: whether the section contains lists (true/false)
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * layout_type - Type: string. Desc: layout_type (original_layout, optional)
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the layout panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {switchLayoutSwitchBetweenSectionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchLayoutSwitchBetweenSections = function (params) {
    return { evid: 1293, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} advancedDesignPanelSelectSkinClickParams
* @property {string} component_id - component id
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} skin_id - {1,2,3...}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: advanced_design_panel_select_skin_click. Evid: 256.
 * Event description: advanced_design_panel_select_skin_click.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * skin_id - Type: string. Desc: {1,2,3...}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {advancedDesignPanelSelectSkinClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var advancedDesignPanelSelectSkinClick = function (params) {
    return { evid: 256, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} welcomeScreenAnimationDirectionChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_direction - new_direction
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Welcome Screen: Animation Direction changed. Evid: 1158.
 * Event description: Welcome Screen: Animation Direction changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_direction - Type: string. Desc: new_direction
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {welcomeScreenAnimationDirectionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var welcomeScreenAnimationDirectionChanged = function (params) {
    return { evid: 1158, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} linkPanelRadioButtonClickParams
* @property {string} category - {nolink,email,document....}
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - panel opening origin
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: link_panel_radio_button_click. Evid: 1231.
 * Event description: The event fires when clicking the radio button link option in the link panel.

 * category - Type: string. Desc: {nolink,email,document....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {linkPanelRadioButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var linkPanelRadioButtonClick = function (params) {
    return { evid: 1231, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuAddMenuItemClickParams
* @property {string} category - show_page, add_link, add_dropdown, add_page
* @property {string} component_id - .
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} item_id - id for the menu item added
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_add_menu_item_click. Evid: 1047.
 * Event description: MENU_Add_menu_item_click.

 * category - Type: string. Desc: show_page, add_link, add_dropdown, add_page
 *
 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * item_id - Type: string. Desc: id for the menu item added
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {menuAddMenuItemClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuAddMenuItemClick = function (params) {
    return { evid: 1047, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelFillPickerTabClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} tab - color, image,gradient,pattern
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->  Fill picker  tab click. Evid: 935.
 * Event description: This event will be sent every time a user clicks on the Fill picker tabs.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * tab - Type: string. Desc: color, image,gradient,pattern
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelFillPickerTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelFillPickerTabClick = function (params) {
    return { evid: 935, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} animationPanelBehaviorDeletedParams
* @property {string} deleted_behavior_name - {float-in, expand...}
* @property {string} behavior_name - {float-in, expand...}
* @property {string} component_id - component_id
* @property {string} component_name - {slide gallery, box...}
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} action_name - {screen-in, page-in...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: animation_panel_behavior_deleted. Evid: 374.
 * Event description: animation_panel_behavior_deleted.

 * deleted_behavior_name - Type: string. Desc: {float-in, expand...}
 *
 * behavior_name - Type: string. Desc: {float-in, expand...}
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * action_name - Type: string. Desc: {screen-in, page-in...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {animationPanelBehaviorDeletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var animationPanelBehaviorDeleted = function (params) {
    return { evid: 374, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} audioPlayerAppSetSettingsTrackUrlParsedParams
* @property {string} comp_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} layout - classic / icon
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} source - spotify / soundcloud
* @property {string} stage_type - null
* @property {boolean} success - mandatory
* @property {string} totalJsHeapSize - null
* @property {string} url - mandatory
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: audioPlayer.appSet.settings.trackUrl.parsed. Evid: 1211.
 * Event description: result of trackUrl parsing in Audio Player settings.

 * comp_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * layout - Type: string. Desc: classic / icon
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * source - Type: string. Desc: spotify / soundcloud
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: mandatory
 *
 * totalJsHeapSize - Type: string.
 *
 * url - Type: string. Desc: mandatory
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {audioPlayerAppSetSettingsTrackUrlParsedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPlayerAppSetSettingsTrackUrlParsed = function (params) {
    return { evid: 1211, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} langSelectorReorderLangsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} lang - lang moved
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: lang_selector_reorder_langs. Evid: 768.
 * Event description: reorder_langs.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * lang - Type: string. Desc: lang moved
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {langSelectorReorderLangsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var langSelectorReorderLangs = function (params) {
    return { evid: 768, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} welcomeScreenClosedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - X,exit
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: welcome_screen_closed. Evid: 497.
 * Event description: welcome_screen_closed.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: X,exit
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {welcomeScreenClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var welcomeScreenClosed = function (params) {
    return { evid: 497, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsSetUpActionShownParams
* @property {string} app_id - app_id
* @property {GUID} assetCampaignGuid - similar to 5:590
* @property {number} asset_location_from_group_list - 0/1/2/.../N
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} targetName - add product / set up payment method / set up shipping regions / etc
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> set up action shown. Evid: 1289.
 * Event description: manage my apps -> set up action shown.

 * app_id - Type: string. Desc: app_id
 *
 * assetCampaignGuid - Type: guid. Desc: similar to 5:590
 *
 * asset_location_from_group_list - Type: numeric. Desc: 0/1/2/.../N
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * targetName - Type: string. Desc: add product / set up payment method / set up shipping regions / etc
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsSetUpActionShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsSetUpActionShown = function (params) {
    return { evid: 1289, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelOpenedTopBarParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_published - {true, false}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menu_name - menu_name
* @property {string} multilingual - null
* @property {string} origin - not empty if event was triggered by tour
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_Opened_top_bar. Evid: 745.
 * Event description: Panel_Opened_top_bar
fire only if hovering for 3 sec.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_published - Type: bool. Desc: {true, false}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menu_name - Type: string. Desc: menu_name
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: not empty if event was triggered by tour
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelOpenedTopBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelOpenedTopBar = function (params) {
    return { evid: 745, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyOfGridLayoutSettingsColumnWidthParams
* @property {string} column_width_data - JSON with column_name,coulmn_width
* @property {string} component_id - comp id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} has_data_changed - 1 if any of the column width has changes else 0
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Copy of grid - layout settings column width. Evid: 654.
 * Event description: send the settings snapshot on closing column width window.

 * column_width_data - Type: string. Desc: JSON with column_name,coulmn_width
 *
 * component_id - Type: string. Desc: comp id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * has_data_changed - Type: bool. Desc: 1 if any of the column width has changes else 0
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyOfGridLayoutSettingsColumnWidthParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyOfGridLayoutSettingsColumnWidth = function (params) {
    return { evid: 654, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerPlayPreviewClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video_player_play_preview_click. Evid: 676.
 * Event description: sent when a user clicks play in setting panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerPlayPreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerPlayPreviewClick = function (params) {
    return { evid: 676, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderLabelChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} new_value - new value
* @property {string} old_value - old value
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_label_changed. Evid: 1320.
 * Event description: range_slider_label_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_value - Type: string. Desc: new value
 *
 * old_value - Type: string. Desc: old value
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderLabelChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderLabelChanged = function (params) {
    return { evid: 1320, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonAnyTabHoverAVideoParams
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} isEmptyState - T/F
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} tabName - main/content_manager, the tab name in 6th bitton of content manager
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} videoUrl - the url of the video
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button > any Tab > Hover a video. Evid: 1267.
 * Event description: 6th Button > Manage Content Tab > Hover a video (hover preview is openend).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * isEmptyState - Type: bool. Desc: T/F
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * tabName - Type: string. Desc: main/content_manager, the tab name in 6th bitton of content manager
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * videoUrl - Type: string. Desc: the url of the video
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonAnyTabHoverAVideoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonAnyTabHoverAVideo = function (params) {
    return { evid: 1267, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeCodeVideoPanelParams
* @property {string} action - {close, getStarted, help}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - duration panel was open
* @property {GUID} esi - {esi}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {data,add_code,data&code}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Close code video panel. Evid: 819.
 * Event description: Close code video panel.

 * action - Type: string. Desc: {close, getStarted, help}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: duration panel was open
 *
 * esi - Type: guid. Desc: {esi}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {data,add_code,data&code}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeCodeVideoPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeCodeVideoPanel = function (params) {
    return { evid: 819, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} themeManagerClickInsideAddPanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} positionNumber - 1 - 25
* @property {string} selection - bg_and_text / action / additional_1 / additional_2 / additional_3
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} target - edit_color / adjust_color / change_theme / back
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: theme manager -> click inside add panel. Evid: 1063.
 * Event description: user click on edit colors in ColorsCategory of ThemeManager.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * positionNumber - Type: numeric. Desc: 1 - 25
 *
 * selection - Type: string. Desc: bg_and_text / action / additional_1 / additional_2 / additional_3
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: edit_color / adjust_color / change_theme / back
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {themeManagerClickInsideAddPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var themeManagerClickInsideAddPanel = function (params) {
    return { evid: 1063, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} urlTooltipActionClickedParams
* @property {string} action - don't_change, change_url
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} value - {string}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} mode - translated, direct, no result
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: url_tooltip_action_clicked. Evid: 544.
 * Event description: url_tooltip_action_clicked.

 * action - Type: string. Desc: don't_change, change_url
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * value - Type: string. Desc: {string}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * mode - Type: string. Desc: translated, direct, no result
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {urlTooltipActionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var urlTooltipActionClicked = function (params) {
    return { evid: 544, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} repeaterStretchToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} toggle_status - {on/off}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: repeater_stretch_toggle. Evid: 742.
 * Event description: toggle state of stretch to full width toggle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * toggle_status - Type: string. Desc: {on/off}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {repeaterStretchToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var repeaterStretchToggle = function (params) {
    return { evid: 742, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ecomMigrationClickOnCtaInModalParams
* @property {string} button_type - got it / upgrade site / close / i'm not ready yet
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - modal type - welcome / migrate / error
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ecom migration - click on CTA in modal. Evid: 505.
 * Event description: click on CTA in ecom migration modal.

 * button_type - Type: string. Desc: got it / upgrade site / close / i'm not ready yet
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: modal type - welcome / migrate / error
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ecomMigrationClickOnCtaInModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ecomMigrationClickOnCtaInModal = function (params) {
    return { evid: 505, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsRecommendedToolsClickParams
* @property {string} app_id - app_id
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} tool - tool name (in english)
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> Recommended Tools Click. Evid: 1288.
 * Event description: manage my apps -> Recommended Tools Click.

 * app_id - Type: string. Desc: app_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * tool - Type: string. Desc: tool name (in english)
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsRecommendedToolsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsRecommendedToolsClick = function (params) {
    return { evid: 1288, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} toolBarDistributionMenuClickParams
* @property {string} category - {Vertical, Horizontal, Both}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tool_Bar_Distribution_menu_click. Evid: 264.
 * Event description: Tool_Bar_Distribution_menu_click.

 * category - Type: string. Desc: {Vertical, Horizontal, Both}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toolBarDistributionMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolBarDistributionMenuClick = function (params) {
    return { evid: 264, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishTrafficAppsLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_Traffic_Apps_link_click. Evid: 385.
 * Event description: First_Publish_Traffic_Apps_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstPublishTrafficAppsLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishTrafficAppsLinkClick = function (params) {
    return { evid: 385, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} backToTopPreviewClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: back_to_top_preview_click. Evid: 304.
 * Event description: back_to_top_preview_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {backToTopPreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var backToTopPreviewClick = function (params) {
    return { evid: 304, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} timingPanelBehaviorClickParams
* @property {string} behavior_name - Ease Both/Ease In/Ease Out/Elastic/Linear
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: timing_panel_behavior_click. Evid: 81.
 * Event description: Changing acceleration.

 * behavior_name - Type: string. Desc: Ease Both/Ease In/Ease Out/Elastic/Linear
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {timingPanelBehaviorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var timingPanelBehaviorClick = function (params) {
    return { evid: 81, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickedAutomaticallyOrderDomParams
* @property {string} dm_version - null
* @property {string} ds_origin - {]
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {ON/OFF}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: clicked Automatically order Dom. Evid: 922.
 * Event description: Clicked enable visual indicator.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {]
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {ON/OFF}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickedAutomaticallyOrderDomParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickedAutomaticallyOrderDom = function (params) {
    return { evid: 922, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishFlowUpgradeNowButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_publish - {1,0}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish_flow_upgrade_now_button_click. Evid: 272.
 * Event description: publish_upgrade_now_button_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_publish - Type: bool. Desc: {1,0}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishFlowUpgradeNowButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishFlowUpgradeNowButtonClick = function (params) {
    return { evid: 272, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} nameOfTryToUploadFontsToFontManagerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {number} file_size - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} name - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: name of try to upload fonts to font manager. Evid: 665.
 * Event description: full name of the file being tried to upload as a font.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * file_size - Type: numeric. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * name - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {nameOfTryToUploadFontsToFontManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var nameOfTryToUploadFontsToFontManager = function (params) {
    return { evid: 665, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lottieChangeAnimationClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: lottie_change_animation_clicked. Evid: 1348.
 * Event description: lottie_change_animation_clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {lottieChangeAnimationClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lottieChangeAnimationClicked = function (params) {
    return { evid: 1348, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelFirstTimeCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_FirstTime_Close. Evid: 348.
 * Event description: Panel_FirstTime_Close.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelFirstTimeCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelFirstTimeClose = function (params) {
    return { evid: 348, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} repeaterDuplicateItemParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {item,panel}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: repeater_duplicate_item. Evid: 739.
 * Event description: duplicate item in repeater.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {item,panel}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {repeaterDuplicateItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var repeaterDuplicateItem = function (params) {
    return { evid: 739, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} actionBarToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} toggle_status - on/off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Action bar toggle. Evid: 615.
 * Event description: toggle state of the action bar.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * toggle_status - Type: string. Desc: on/off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {actionBarToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var actionBarToggle = function (params) {
    return { evid: 615, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} qrCodeScannedParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - view_published_version_on_mobile
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: QR code Scanned. Evid: 1133.
 * Event description: QR code Scanned.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: view_published_version_on_mobile
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {qrCodeScannedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var qrCodeScanned = function (params) {
    return { evid: 1133, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thumbnailsValueChangeParams
* @property {string} component_id - .
* @property {string} component_type - component_TYPE
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} panel_name - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - what user chose
* @property {string} totalJsHeapSize - .
* @property {string} type - type of alignment
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Thumbnails_ValueChange. Evid: 1054.
 * Event description: change layout event.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: component_TYPE
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what user chose
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * type - Type: string. Desc: type of alignment
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {thumbnailsValueChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thumbnailsValueChange = function (params) {
    return { evid: 1054, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorpickerMainPanelCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorpicker_main_panel_close. Evid: 251.
 * Event description: ColorPicker_MainPanel_Close.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorpickerMainPanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorpickerMainPanelClose = function (params) {
    return { evid: 251, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsProportionClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {50:50, 25:75, 20:80, 40:60, 33:66}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_proportion_click. Evid: 574.
 * Event description: columns_proportion_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {50:50, 25:75, 20:80, 40:60, 33:66}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsProportionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsProportionClick = function (params) {
    return { evid: 574, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tabInsideComponentRemovedParams
* @property {string} component_id - guid
* @property {string} componentType - guid
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - action menu/delete button
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_id - tab id
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Tab inside component - removed. Evid: 1381.
 * Event description: Tab inside component - removed.

 * component_id - Type: string. Desc: guid
 *
 * componentType - Type: string. Desc: guid
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: action menu/delete button
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_id - Type: string. Desc: tab id
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {tabInsideComponentRemovedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tabInsideComponentRemoved = function (params) {
    return { evid: 1381, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myUploadsPanelSectionClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} section - {images, music,docs...}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: my_uploads_panel_section_click. Evid: 370.
 * Event description: my_uploads_panel_section_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {images, music,docs...}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {myUploadsPanelSectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myUploadsPanelSectionClick = function (params) {
    return { evid: 370, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsPanelLoadedParams
* @property {string} apps_array - comma separated list of all apps installed
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSegment - true/false
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} recommendedApps - comma separated list of all recommended apps
* @property {string} segment_info - comma separated installed apps which user can manage in My Business panel
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} tab_name - app_id
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> panel loaded. Evid: 1098.
 * Event description: Apps Manager loaded.

 * apps_array - Type: string. Desc: comma separated list of all apps installed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSegment - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * recommendedApps - Type: string. Desc: comma separated list of all recommended apps
 *
 * segment_info - Type: string. Desc: comma separated installed apps which user can manage in My Business panel
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: app_id
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsPanelLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsPanelLoaded = function (params) {
    return { evid: 1098, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressTheVideoImageInTheTooltipParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tooltipname - {key}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoID - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press the video image in the tooltip. Evid: 670.
 * Event description: pressing the image to play the video.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tooltipname - Type: string. Desc: {key}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoID - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressTheVideoImageInTheTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressTheVideoImageInTheTooltip = function (params) {
    return { evid: 670, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} startNowClickWithoutBackOptionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Start now click (without back option). Evid: 483.
 * Event description: Without back to old editor option: Start now click: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {startNowClickWithoutBackOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var startNowClickWithoutBackOption = function (params) {
    return { evid: 483, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} hoverSocialSharePreviewPageSettingsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - +
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: hover_social_share_preview_page_settings. Evid: 827.
 * Event description: hover social share preview on page settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: +
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {hoverSocialSharePreviewPageSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hoverSocialSharePreviewPageSettings = function (params) {
    return { evid: 827, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorIntroVideoXButtonPressedNewUsersParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {duration the window was open in milliseconds )
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {esc;x button; start now} - how the user closed the video panel
* @property {string} panel_name - what is the name of the video panel
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {Url} video_url - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_video_close. Evid: 492.
 * Event description: Intro video for new users: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {duration the window was open in milliseconds )
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {esc;x button; start now} - how the user closed the video panel
 *
 * panel_name - Type: string. Desc: what is the name of the video panel
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_url - Type: url. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorIntroVideoXButtonPressedNewUsersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorIntroVideoXButtonPressedNewUsers = function (params) {
    return { evid: 492, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsSetUpActionClickParams
* @property {string} app_id - app_id
* @property {GUID} assetCampaignGuid - similar to 5:590
* @property {number} asset_location_from_group_list - 0/1/2/.../N
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - main action / skip / undo
* @property {string} targetName - add product / set up payment method / set up shipping regions / etc
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> set up action click. Evid: 1285.
 * Event description: manage my apps -> set up action click.

 * app_id - Type: string. Desc: app_id
 *
 * assetCampaignGuid - Type: guid. Desc: similar to 5:590
 *
 * asset_location_from_group_list - Type: numeric. Desc: 0/1/2/.../N
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: main action / skip / undo
 *
 * targetName - Type: string. Desc: add product / set up payment method / set up shipping regions / etc
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsSetUpActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsSetUpActionClick = function (params) {
    return { evid: 1285, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} thButtonManageContentClickedCreateACollectionNotEmptyStateParams
* @property {string} dm_version - null
* @property {string} ds_origin - implicit for source 38
* @property {GUID} esi - implicit for source 38
* @property {boolean} is_rollout - implicit for source 38
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - implicit for source 38
* @property {string} multilingual - implicit for source 38
* @property {GUID} site_id - implicit for source 38
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - implicit for source 38
* @property {string} usedJsHeapSize - implicit for source 38
* @property {string} viewerName - implicit for source 38
* @property {string} viewerVersion - implicit for source 38
* @property {string} workspace_mode - null
**/
/**
 * Name: 6th Button > Manage Content > Clicked Create a collection(not empty state). Evid: 1263.
 * Event description: click the create a c collection blue button on 6th button not empty state.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: implicit for source 38
 *
 * esi - Type: guid. Desc: implicit for source 38
 *
 * is_rollout - Type: bool. Desc: implicit for source 38
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: implicit for source 38
 *
 * multilingual - Type: string. Desc: implicit for source 38
 *
 * site_id - Type: guid. Desc: implicit for source 38
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * usedJsHeapSize - Type: string. Desc: implicit for source 38
 *
 * viewerName - Type: string. Desc: implicit for source 38
 *
 * viewerVersion - Type: string. Desc: implicit for source 38
 *
 * workspace_mode - Type: string.
 * @param {thButtonManageContentClickedCreateACollectionNotEmptyStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thButtonManageContentClickedCreateACollectionNotEmptyState = function (params) {
    return { evid: 1263, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rightClickMenuOpenParams
* @property {string} category - {selected, on hover}
* @property {string} component - {text,image,gallery,button,shape,music,video,social,box,menu,contact}
* @property {string} component_id - id of component
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isScrollable - true - if scroll-down button at the bottom appeared
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin of context menu opening (rcm/sections panel)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: right click menu open. Evid: 130.
 * Event description: right click menu open.

 * category - Type: string. Desc: {selected, on hover}
 *
 * component - Type: string. Desc: {text,image,gallery,button,shape,music,video,social,box,menu,contact}
 *
 * component_id - Type: string. Desc: id of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isScrollable - Type: bool. Desc: true - if scroll-down button at the bottom appeared
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin of context menu opening (rcm/sections panel)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rightClickMenuOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rightClickMenuOpen = function (params) {
    return { evid: 130, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPanelDataLoadedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {boolean} prefetch - Resources prefetched
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: addPanelData_loaded. Evid: 465.
 * Event description: addPanelData_loaded.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * prefetch - Type: bool. Desc: Resources prefetched
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addPanelDataLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPanelDataLoaded = function (params) {
    return { evid: 465, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageLanuagesClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hosting - ‘preview’,’editor’
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} source - {Add_Language, Manage_Languages}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: manage_lanuages_click. Evid: 769.
 * Event description: manage_lanuages_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hosting - Type: string. Desc: ‘preview’,’editor’
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: {Add_Language, Manage_Languages}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {manageLanuagesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageLanuagesClick = function (params) {
    return { evid: 769, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} boundingBoxIssuesParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} layout_dom - layout_dom
* @property {string} layout_structure - layout_structure
* @property {string} methodName - method_name
* @property {string} multilingual - multilingual
* @property {string} page_id - page_id
* @property {GUID} site_id - site_id
* @property {string} site_url - site_url
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - (no description)
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Bounding box issues. Evid: 1303.
 * Event description: when user faces bounding box issues.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * layout_dom - Type: string. Desc: layout_dom
 *
 * layout_structure - Type: string. Desc: layout_structure
 *
 * methodName - Type: string. Desc: method_name
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page_id
 *
 * site_id - Type: guid. Desc: site_id
 *
 * site_url - Type: string. Desc: site_url
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: (no description)
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {boundingBoxIssuesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boundingBoxIssues = function (params) {
    return { evid: 1303, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} urlTooltipNotificationAppearedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: url_tooltip_notification_appeared. Evid: 545.
 * Event description: url_tooltip_notification_appeared.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {urlTooltipNotificationAppearedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var urlTooltipNotificationAppeared = function (params) {
    return { evid: 545, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderFieldTitleAlignmentChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - null
* @property {string} section - Circle/Square/Rectangle /Bar
* @property {string} selection - left/right/center
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: range_slider_field_title_alignment_changed. Evid: 1332.
 * Event description: range_slider_field_title_alignment_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string.
 *
 * section - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * selection - Type: string. Desc: left/right/center
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderFieldTitleAlignmentChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderFieldTitleAlignmentChanged = function (params) {
    return { evid: 1332, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} languageSupportSetClickParams
* @property {string} category - {Eastern Europe, Cyrillic...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Language_Support_Set_click. Evid: 221.
 * Event description: Language_Support_Set_click.

 * category - Type: string. Desc: {Eastern Europe, Cyrillic...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {languageSupportSetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var languageSupportSetClick = function (params) {
    return { evid: 221, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorModeChangedSuccessfullyParams
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} mode - which mode user is using from now on = category value from 38:1453
* @property {string} multilingual - .
* @property {string} origin - top bar / three dots / drag …  (from which entry point LiteEditor panel was opened)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor mode changed successfully. Evid: 1454.
 * Event description: user switch from Lite to Full or vise versa.

 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * mode - Type: string. Desc: which mode user is using from now on = category value from 38:1453
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: top bar / three dots / drag …  (from which entry point LiteEditor panel was opened)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editorModeChangedSuccessfullyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorModeChangedSuccessfully = function (params) {
    return { evid: 1454, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionComponentSettingsClosedParams
* @property {string} component_id - id of selected component
* @property {string} component_type - type of the component that was changed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_changed - true/false
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} panel_name - image_settings, edit_section_settings)
* @property {string} parent_component_id - id of selected section
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {number} timeSpent - ime from Edit_Section_Settings_Panel_Opened event in ms
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: Component Settings Closed. Evid: 1378.
 * Event description: Edit Section Settings Closed  ('Edit Section' panel).

 * component_id - Type: string. Desc: id of selected component
 *
 * component_type - Type: string. Desc: type of the component that was changed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_changed - Type: bool. Desc: true/false
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * panel_name - Type: string. Desc: image_settings, edit_section_settings)
 *
 * parent_component_id - Type: string. Desc: id of selected section
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * timeSpent - Type: numeric. Desc: ime from Edit_Section_Settings_Panel_Opened event in ms
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionComponentSettingsClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionComponentSettingsClosed = function (params) {
    return { evid: 1378, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} translateGfppExposureParams
* @property {string} app_id - {Translation Key}
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - {}
* @property {string} page_name - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: translate_gfpp_exposure. Evid: 79.
 * Event description: user exposed to gfpp in secondary language mode on the Editor following clicked on component.

 * app_id - Type: string. Desc: {Translation Key}
 *
 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: {}
 *
 * page_name - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {translateGfppExposureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var translateGfppExposure = function (params) {
    return { evid: 79, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerCheckOutWixVideoClickParams
* @property {string} component_id - component_id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videoPlayer.checkOutWixVideo.click. Evid: 813.
 * Event description: User clicks on 'Check out wix video' link in Video Player settings.

 * component_id - Type: string. Desc: component_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerCheckOutWixVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerCheckOutWixVideoClick = function (params) {
    return { evid: 813, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelLineHeightRadioButtonsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - textStylePanel / themeManager.themeFontSettings
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {Auto, Custom}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Line_Height_Radio_Buttons. Evid: 247.
 * Event description: Text_Panel_Line_Height_Radio_Buttons.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: textStylePanel / themeManager.themeFontSettings
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {Auto, Custom}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelLineHeightRadioButtonsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelLineHeightRadioButtons = function (params) {
    return { evid: 247, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorInfoPopupShownParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} menuSetId - menu_set_id
* @property {string} message - what we are telling the user
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} source - default_menu, custom_menu, member_menu, login_bar_menu
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_info_popup_shown. Evid: 1048.
 * Event description: editor_info_popup_shown.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * menuSetId - Type: string. Desc: menu_set_id
 *
 * message - Type: string. Desc: what we are telling the user
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * source - Type: string. Desc: default_menu, custom_menu, member_menu, login_bar_menu
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {editorInfoPopupShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorInfoPopupShown = function (params) {
    return { evid: 1048, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sliderValueOnPreviewChangeParams
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_preview_mode_changed - is_preview_mode_changed
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} preview_mode - mobile / tablet / desktop / full_screen
* @property {string} previous_value - previous_value
* @property {string} selected_value - selected_value
* @property {GUID} site_id - {}
* @property {string} stage_type - .
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} value_change_origin - where value was changed from (slider / desktop_button / tablet_button)
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Slider value on preview change. Evid: 1508.
 * Event description: event which indicates the change of slider value in preview.

 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_preview_mode_changed - Type: bool. Desc: is_preview_mode_changed
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * preview_mode - Type: string. Desc: mobile / tablet / desktop / full_screen
 *
 * previous_value - Type: string. Desc: previous_value
 *
 * selected_value - Type: string. Desc: selected_value
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string. Desc: .
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * value_change_origin - Type: string. Desc: where value was changed from (slider / desktop_button / tablet_button)
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {sliderValueOnPreviewChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sliderValueOnPreviewChange = function (params) {
    return { evid: 1508, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorThumbnailClickParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ColorThumbnail_Click. Evid: 369.
 * Event description: ColorThumbnail_Click.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorThumbnailClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorThumbnailClick = function (params) {
    return { evid: 369, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} copyOfTopBarPagesStorePagesSettingsTabClickParams
* @property {string} category - {password, members}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} language_selected - {en, es, pt, ru...}
* @property {string} multilingual - null
* @property {string} page_type - {product, cart, thank you}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Copy of top_bar_PAGES_store_pages_settings_tab_click. Evid: 442.
 * Event description: top_bar_PAGES_store_pages_settings_tab_click.

 * category - Type: string. Desc: {password, members}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * language_selected - Type: string. Desc: {en, es, pt, ru...}
 *
 * multilingual - Type: string.
 *
 * page_type - Type: string. Desc: {product, cart, thank you}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {copyOfTopBarPagesStorePagesSettingsTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var copyOfTopBarPagesStorePagesSettingsTabClick = function (params) {
    return { evid: 442, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} oldBlogSinglePostFixParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Old Blog Single Post Fix. Evid: 759.
 * Event description: Old Blog Single Post Fix.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {oldBlogSinglePostFixParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oldBlogSinglePostFix = function (params) {
    return { evid: 759, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelClickParams
* @property {string} action_name - action: adjust etc.
* @property {string} component_id - id of the component
* @property {string} component_type - type of the component
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} panel_name - panel name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: panel_click. Evid: 949.
 * Event description: Clicking on panel elements.

 * action_name - Type: string. Desc: action: adjust etc.
 *
 * component_id - Type: string. Desc: id of the component
 *
 * component_type - Type: string. Desc: type of the component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * panel_name - Type: string. Desc: panel name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelClick = function (params) {
    return { evid: 949, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorpickerMainpanelAddcolorLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorpicker_mainpanel_addcolor_link_click. Evid: 134.
 * Event description: ColorPicker_MainPanel_AddColor_Link_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorpickerMainpanelAddcolorLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorpickerMainpanelAddcolorLinkClick = function (params) {
    return { evid: 134, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} switchToOldEditorLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: switch_to_old_editor_link_click. Evid: 489.
 * Event description: switch_to_old_editor_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {switchToOldEditorLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var switchToOldEditorLinkClick = function (params) {
    return { evid: 489, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionMigrationSuccessMigrationOfPageParams
* @property {string} components_json - components on the page
* @property {number} components_number - number of components on migrated page
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {number} duration - duration of migration
* @property {GUID} esi - {}
* @property {string} grouping_source - prediction/labelling
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {string} origin - init/shadow/navigation
* @property {string} pageId - page id
* @property {number} sections_number - number of sections on migrated page
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Section migration - success migration of page. Evid: 1245.
 * Event description: Page Migration to sections success.

 * components_json - Type: string. Desc: components on the page
 *
 * components_number - Type: numeric. Desc: number of components on migrated page
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * duration - Type: numeric. Desc: duration of migration
 *
 * esi - Type: guid. Desc: {}
 *
 * grouping_source - Type: string. Desc: prediction/labelling
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: init/shadow/navigation
 *
 * pageId - Type: string. Desc: page id
 *
 * sections_number - Type: numeric. Desc: number of sections on migrated page
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {sectionMigrationSuccessMigrationOfPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionMigrationSuccessMigrationOfPage = function (params) {
    return { evid: 1245, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickEditContentRceParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
* @property {number} timeSpent - time from 309 open event in ms
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Click_Edit_Content_RCE. Evid: 1124.
 * Event description: user click on edit content inside the panel of RCE.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
 *
 * timeSpent - Type: numeric. Desc: time from 309 open event in ms
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {clickEditContentRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickEditContentRce = function (params) {
    return { evid: 1124, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} zoomModeClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - desktop, mobile
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: zoom_mode_clicked. Evid: 548.
 * Event description: zoom_mode_clicked.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: desktop, mobile
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {zoomModeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var zoomModeClicked = function (params) {
    return { evid: 548, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuRelatedAppsMoreClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> related apps more click. Evid: 115.
 * Event description: add menu -> related apps more click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuRelatedAppsMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuRelatedAppsMoreClick = function (params) {
    return { evid: 115, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} myElementsAddElementToStageParams
* @property {string} adding_method - click/drag
* @property {string} content_type - container/group/multiselect etc.
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} element_id - id generated when adding new element to "my elements"
* @property {string} error_msg - error message
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - element adding success
* @property {string} theme - origin/target
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: my_designs.add_element_to_stage. Evid: 959.
 * Event description: Add element to the stage.

 * adding_method - Type: string. Desc: click/drag
 *
 * content_type - Type: string. Desc: container/group/multiselect etc.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * element_id - Type: guid. Desc: id generated when adding new element to "my elements"
 *
 * error_msg - Type: string. Desc: error message
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: element adding success
 *
 * theme - Type: string. Desc: origin/target
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {myElementsAddElementToStageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myElementsAddElementToStage = function (params) {
    return { evid: 959, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickCycleParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {number} cycle_id - {3,6..}
* @property {string} cycle_name - {monthly, yearly...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pp_origin - {fpp}
* @property {string} pp_type - {offering, package, cycle}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_cycle. Evid: 187.
 * Event description: click_cycle.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * cycle_id - Type: numeric. Desc: {3,6..}
 *
 * cycle_name - Type: string. Desc: {monthly, yearly...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pp_origin - Type: string. Desc: {fpp}
 *
 * pp_type - Type: string. Desc: {offering, package, cycle}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickCycleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickCycle = function (params) {
    return { evid: 187, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} refreshRevisionInOnlineEditorParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} new_revision - new revision number
* @property {number} old_revision - old revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Refresh revision in online editor. Evid: 904.
 * Event description: Fires when a user clicks on the final force-pushes an older revision to the online editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_revision - Type: numeric. Desc: new revision number
 *
 * old_revision - Type: numeric. Desc: old revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {refreshRevisionInOnlineEditorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var refreshRevisionInOnlineEditor = function (params) {
    return { evid: 904, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelActionClickedParams
* @property {string} actionName - the name of the action the user click in the panel (the action approve/ cancel/X)
* @property {string} apps_array - comma separated list of all Application tabs
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - dm_version
* @property {boolean} dont_show_this_again - true/ false
* @property {string} ds_origin - ds_origin
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {string} funnel_id - id generated when adding new element to "my elements"
* @property {boolean} isDesigner - true / false (filter that exclude designers who are working on new families \ fixes)
* @property {boolean} isMobileOnlyComponentSelected - if the component appears only in Mobile Editor
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - isSection
* @property {boolean} isSiteCreation - isSiteCreation
* @property {boolean} isZoomOut - t / f for zoom out mode on / off
* @property {string} item_id - the item id that the action in the panel relevant to
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - origin
* @property {string} panel_correlation_id - id, which should change after panel was closed
* @property {string} panel_name - {Translation Key}
* @property {string} panelProps - json with additional info about panel (for error panels - which error opened it)
* @property {string} panelname - panelname
* @property {string} section_correlation_id - id, which should change after layout section panel was closed
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_name - app id
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - workspace_mode
**/
/**
 * Name: Panel_action_clicked. Evid: 1470.
 * Event description: The action the user clicked on the panel.

 * actionName - Type: string. Desc: the name of the action the user click in the panel (the action approve/ cancel/X)
 *
 * apps_array - Type: string. Desc: comma separated list of all Application tabs
 *
 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * dont_show_this_again - Type: bool. Desc: true/ false
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * funnel_id - Type: string. Desc: id generated when adding new element to "my elements"
 *
 * isDesigner - Type: bool. Desc: true / false (filter that exclude designers who are working on new families \ fixes)
 *
 * isMobileOnlyComponentSelected - Type: bool. Desc: if the component appears only in Mobile Editor
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: isSection
 *
 * isSiteCreation - Type: bool. Desc: isSiteCreation
 *
 * isZoomOut - Type: bool. Desc: t / f for zoom out mode on / off
 *
 * item_id - Type: string. Desc: the item id that the action in the panel relevant to
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: origin
 *
 * panel_correlation_id - Type: string. Desc: id, which should change after panel was closed
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * panelProps - Type: string. Desc: json with additional info about panel (for error panels - which error opened it)
 *
 * panelname - Type: string. Desc: panelname
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout section panel was closed
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_name - Type: string. Desc: app id
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string. Desc: workspace_mode
 * @param {panelActionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelActionClicked = function (params) {
    return { evid: 1470, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorGotSiteFromAdiForAdiToEditorTestParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Editor got site from ADI (for ADI to Editor test). Evid: 1222.
 * Event description: Editor got site from ADI and start opening it.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorGotSiteFromAdiForAdiToEditorTestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorGotSiteFromAdiForAdiToEditorTest = function (params) {
    return { evid: 1222, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisExpandModeTextChangedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} new_name - new name
* @property {string} old_name - old name
* @property {string} origin - panel opening origin
* @property {string} page_id - page id
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.Expand_mode_text_changed. Evid: 1193.
 * Event description: TextEllipsis.Expand_mode_text_changed.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * new_name - Type: string. Desc: new name
 *
 * old_name - Type: string. Desc: old name
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisExpandModeTextChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisExpandModeTextChanged = function (params) {
    return { evid: 1193, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsElementsPlacedInDeadSpotWarningParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_elements_placed_in_dead_spot_warning. Evid: 578.
 * Event description: columns_elements_placed_in_dead_spot_warning.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsElementsPlacedInDeadSpotWarningParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsElementsPlacedInDeadSpotWarning = function (params) {
    return { evid: 578, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} firstPublishSendShoutOutLinkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected Premium}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: First_Publish_Send_ShoutOut_link_click. Evid: 383.
 * Event description: First_Publish_Send_ShoutOut_link_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected Premium}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {firstPublishSendShoutOutLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var firstPublishSendShoutOutLinkClick = function (params) {
    return { evid: 383, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} blogGfppOpenBlogManagerClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {manage posts, add new post}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: blog_gfpp_open_blog_manager_click. Evid: 424.
 * Event description: blog_gfpp_open_blog_manager_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {manage posts, add new post}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {blogGfppOpenBlogManagerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var blogGfppOpenBlogManagerClick = function (params) {
    return { evid: 424, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gfppMoreIconsOpenParams
* @property {string} component_id - component_id
* @property {string} component_type - {box,shape,text etc}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: gfpp -> more icons open. Evid: 129.
 * Event description: gfpp -> more icons open.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: {box,shape,text etc}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {gfppMoreIconsOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gfppMoreIconsOpen = function (params) {
    return { evid: 129, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} quickEditPanelReportingsParams
* @property {string} component_id - id of selected section
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} error_type - error_type (which flow in quickEdit we’re reporting to)
* @property {GUID} esi - .
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: QuickEditPanel: reportings. Evid: 1390.
 * Event description: QuickEditPanel: reportings.

 * component_id - Type: string. Desc: id of selected section
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * error_type - Type: string. Desc: error_type (which flow in quickEdit we’re reporting to)
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {quickEditPanelReportingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quickEditPanelReportings = function (params) {
    return { evid: 1390, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editGuideParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} editor_view_mode - {desktop,mobile}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {horizontal/vertical}
* @property {string} usedJsHeapSize - null
* @property {string} valid_value - {accepted/denied}
* @property {string} value - {e.g. 200}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: edit guide. Evid: 558.
 * Event description: The value within guide in edit mode (with delete icon and focus).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * editor_view_mode - Type: string. Desc: {desktop,mobile}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {horizontal/vertical}
 *
 * usedJsHeapSize - Type: string.
 *
 * valid_value - Type: string. Desc: {accepted/denied}
 *
 * value - Type: string. Desc: {e.g. 200}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editGuideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editGuide = function (params) {
    return { evid: 558, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} userInputSettingsConfigurationParams
* @property {string} component_id - comp id
* @property {string} component_name - comp name
* @property {string} component_type - comp type
* @property {string} content_on_load - none,placeholder,etc…
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {boolean} limit_length - true,false
* @property {boolean} is_max_value - true,false
* @property {boolean} is_min_value - true,false
* @property {string} multilingual - null
* @property {string} placeholder - placeholder text
* @property {boolean} read_only - true,false
* @property {string} regex_pattern - regex pattern
* @property {number} required - true,false
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} i1 - text,password,etc...
* @property {string} usedJsHeapSize - null
* @property {boolean} validation - true,false
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: user input settings: configuration. Evid: 649.
 * Event description: user input settings configuration on editor panel.

 * component_id - Type: string. Desc: comp id
 *
 * component_name - Type: string. Desc: comp name
 *
 * component_type - Type: string. Desc: comp type
 *
 * content_on_load - Type: string. Desc: none,placeholder,etc…
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * limit_length - Type: bool. Desc: true,false
 *
 * is_max_value - Type: bool. Desc: true,false
 *
 * is_min_value - Type: bool. Desc: true,false
 *
 * multilingual - Type: string.
 *
 * placeholder - Type: string. Desc: placeholder text
 *
 * read_only - Type: bool. Desc: true,false
 *
 * regex_pattern - Type: string. Desc: regex pattern
 *
 * required - Type: numeric. Desc: true,false
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * i1 - Type: string. Desc: text,password,etc...
 *
 * usedJsHeapSize - Type: string.
 *
 * validation - Type: bool. Desc: true,false
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {userInputSettingsConfigurationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var userInputSettingsConfiguration = function (params) {
    return { evid: 649, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionChangesInDropDownMenuParams
* @property {string} component_id - id of selected component
* @property {string} component_type - type of the component that was changed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} panel_name - image_settings, edit_section_settings)
* @property {string} parent_component_id - id of selected section
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} targetName - icon / text/ text_icon / empty
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: changes in drop down menu). Evid: 1379.
 * Event description: user changed value in drop down menu ('Edit Section' panel).

 * component_id - Type: string. Desc: id of selected component
 *
 * component_type - Type: string. Desc: type of the component that was changed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * panel_name - Type: string. Desc: image_settings, edit_section_settings)
 *
 * parent_component_id - Type: string. Desc: id of selected section
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * targetName - Type: string. Desc: icon / text/ text_icon / empty
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionChangesInDropDownMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionChangesInDropDownMenu = function (params) {
    return { evid: 1379, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} concurrentEditorVisitParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSameUser - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} pageId - page_id
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: concurrentEditor.visit. Evid: 1116.
 * Event description: Sends if the same site is edited at the same moment by 2 different contributors or by the same user in the different tabs.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSameUser - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * pageId - Type: string. Desc: page_id
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {concurrentEditorVisitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var concurrentEditorVisit = function (params) {
    return { evid: 1116, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteDetailsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - color name
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - edit, remove
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette details click. Evid: 1433.
 * Event description: Color palette details click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: color name
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: edit, remove
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteDetailsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteDetailsClick = function (params) {
    return { evid: 1433, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mediaControlClickParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: MediaControl_Click. Evid: 366.
 * Event description: MediaControl_Click.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mediaControlClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaControlClick = function (params) {
    return { evid: 366, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPanelAddDashboardClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: ADD_PANEL_add_dashboard_click. Evid: 1042.
 * Event description: when clicking on add a dashboard from page category in the add panel (dev mode).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPanelAddDashboardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPanelAddDashboardClick = function (params) {
    return { evid: 1042, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} popUpTooltipAppearanceOnDeleteXParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pop_up_tooltip_appearance_on_delete_x. Evid: 561.
 * Event description: pop_up_tooltip_appearance_on_delete_x.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {popUpTooltipAppearanceOnDeleteXParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var popUpTooltipAppearanceOnDeleteX = function (params) {
    return { evid: 561, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarMenuOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} menu_name - menu_name
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: top bar menu open. Evid: 1008.
 * Event description: sends when Site / Settings / Tools / Dev mode/ Help menu in top bar opens in any method hover/click.
Sends collapsed_menu for '...'-menu open and tools_collaped etc for panels from this menu..

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * menu_name - Type: string. Desc: menu_name
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {topBarMenuOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarMenuOpen = function (params) {
    return { evid: 1008, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuMaxCategoryScrollParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {number} max_hover_item - 1,2,3,4
* @property {string} multilingual - null
* @property {string} section - {titles, paragraph, basic shapes....}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> max category scroll. Evid: 111.
 * Event description: add menu -> max category scroll.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * max_hover_item - Type: numeric. Desc: 1,2,3,4
 *
 * multilingual - Type: string.
 *
 * section - Type: string. Desc: {titles, paragraph, basic shapes....}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuMaxCategoryScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuMaxCategoryScroll = function (params) {
    return { evid: 111, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} blogFeedDesignClickOnDesignParams
* @property {string} cardId - post body, image, etc...
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {GUID} metasiteid - msid
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: blog feed design - Click on design. Evid: 657.
 * Event description: Fired when a user click on the design button next to a card.

 * cardId - Type: string. Desc: post body, image, etc...
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * metasiteid - Type: guid. Desc: msid
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {blogFeedDesignClickOnDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var blogFeedDesignClickOnDesign = function (params) {
    return { evid: 657, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} fixedPositionParams
* @property {string} component - {header,footer}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_status - {on,off}
* @property {string} origin - {right click menu, tool bar}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: fixed position. Evid: 147.
 * Event description: fixed position.

 * component - Type: string. Desc: {header,footer}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_status - Type: string. Desc: {on,off}
 *
 * origin - Type: string. Desc: {right click menu, tool bar}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {fixedPositionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var fixedPosition = function (params) {
    return { evid: 147, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressLearnMoreInAddPanelTooltipParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tooltipname - {}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press learn more in add panel tooltip. Evid: 673.
 * Event description: pressing the "learn more" link that opens the help.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tooltipname - Type: string. Desc: {}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressLearnMoreInAddPanelTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressLearnMoreInAddPanelTooltip = function (params) {
    return { evid: 673, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesMenuCategoryViewParams
* @property {string} category - {main,  members, custom, blog, tpa etc, lightbox, router }
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: pages menu-> category view. Evid: 1005.
 * Event description: send on every category opened (it can be the category with which Pages Panel was opened or the one that was chosen after).

 * category - Type: string. Desc: {main,  members, custom, blog, tpa etc, lightbox, router }
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {pagesMenuCategoryViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesMenuCategoryView = function (params) {
    return { evid: 1005, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tooltipLearnMoreClickParams
* @property {string} control_name - {Control Label}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {string} section_name - {Section Label}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tooltip_LearnMore_Click. Evid: 344.
 * Event description: Tooltip_LearnMore_Click.

 * control_name - Type: string. Desc: {Control Label}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * section_name - Type: string. Desc: {Section Label}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tooltipLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tooltipLearnMoreClick = function (params) {
    return { evid: 344, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPageVerticalPostInstallationCtaParams
* @property {string} app_id - vertical app_id
* @property {string} app_name - stores/ booking / etc
* @property {string} button - see_vertical_pages / add_shop_page
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Add Page - Vertical Post Installation CTA. Evid: 1130.
 * Event description: Add Page - Vertical Post Installation CTA.

 * app_id - Type: string. Desc: vertical app_id
 *
 * app_name - Type: string. Desc: stores/ booking / etc
 *
 * button - Type: string. Desc: see_vertical_pages / add_shop_page
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {addPageVerticalPostInstallationCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPageVerticalPostInstallationCta = function (params) {
    return { evid: 1130, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pushClickedParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} revision - revision number
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: push clicked. Evid: 901.
 * Event description: Fires when a user clicks on the 'push'  button on the local editor.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * revision - Type: numeric. Desc: revision number
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pushClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pushClicked = function (params) {
    return { evid: 901, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} manageMyAppsSetUpActionDoneParams
* @property {string} app_id - app_id
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - main action / skip / undo
* @property {string} targetName - add product / set up payment method / set up shipping regions / etc
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: manage my apps -> set up action done. Evid: 1286.
 * Event description: We should have this event because we are marking action as done only in case when user really did this action.

 * app_id - Type: string. Desc: app_id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: main action / skip / undo
 *
 * targetName - Type: string. Desc: add product / set up payment method / set up shipping regions / etc
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {manageMyAppsSetUpActionDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var manageMyAppsSetUpActionDone = function (params) {
    return { evid: 1286, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} leftBarButtonHoveredParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editorMode - desktop / mobile
* @property {string} element_name - name of the button hovered in ENG (add / pages / etc)
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Left bar button hovered. Evid: 1177.
 * Event description: User hover the button in the left bar (element_name - name of the button hovered).

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editorMode - Type: string. Desc: desktop / mobile
 *
 * element_name - Type: string. Desc: name of the button hovered in ENG (add / pages / etc)
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {leftBarButtonHoveredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var leftBarButtonHovered = function (params) {
    return { evid: 1177, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondSavePublishNowClick335Params
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_save - {0,1)
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {not published not connected, not Published connected, published_connected, Published_not_connected}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Save_publish_now_click. Evid: 335.
 * Event description: Second_Save_publish_now_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_save - Type: bool. Desc: {0,1)
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {not published not connected, not Published connected, published_connected, Published_not_connected}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondSavePublishNowClick335Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondSavePublishNowClick335 = function (params) {
    return { evid: 335, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsDuplicatePageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {drag, quick actions}
* @property {boolean} renamed - {0,1}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab - {page info, layout, privacy, SEO}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_duplicate_page_click. Evid: 427.
 * Event description: PAGES_settings_duplicate_page_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {drag, quick actions}
 *
 * renamed - Type: bool. Desc: {0,1}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab - Type: string. Desc: {page info, layout, privacy, SEO}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsDuplicatePageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsDuplicatePageClick = function (params) {
    return { evid: 427, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} canvasOverlayTryToLoadParams
* @property {string} appDefinitionId - app definition id
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} site_builder_type - site_builder type: Editor, editor_x
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} url - url
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Canvas overlay try to load. Evid: 1459.
 * Event description: Canvas overlay try to load.

 * appDefinitionId - Type: string. Desc: app definition id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_builder_type - Type: string. Desc: site_builder type: Editor, editor_x
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * url - Type: string. Desc: url
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {canvasOverlayTryToLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var canvasOverlayTryToLoad = function (params) {
    return { evid: 1459, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addHoverInteractionParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - panel_name
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - parent_component_type
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add_hover_interaction. Evid: 1013.
 * Event description: Add hover interaction button click.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: parent_component_type
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addHoverInteractionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addHoverInteraction = function (params) {
    return { evid: 1013, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} vnBusinessNumberFromEditorLink1068Params
* @property {GUID} component_id - component_id
* @property {string} component_type - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - get,use
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: VN- business number from editor link. Evid: 1068.
 * Event description: VN- business number from editor link.

 * component_id - Type: guid. Desc: component_id
 *
 * component_type - Type: string.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: get,use
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {vnBusinessNumberFromEditorLink1068Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var vnBusinessNumberFromEditorLink1068 = function (params) {
    return { evid: 1068, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsUploadPinDesignClickParams
* @property {string} component_id - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google Maps -->  upload pin design click. Evid: 1218.
 * Event description: Move tab to pins tab click.

 * component_id - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleMapsUploadPinDesignClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsUploadPinDesignClick = function (params) {
    return { evid: 1218, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addSectionButtonParams
* @property {string} actionName - view / hover / click
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - multilingual
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: addSection.button. Evid: 1108.
 * Event description: Actions for Add Section on stage button (hover and click).

 * actionName - Type: string. Desc: view / hover / click
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {addSectionButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addSectionButton = function (params) {
    return { evid: 1108, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clicksOnPanelInCropModeParams
* @property {string} button_name - Zoom_in | zoom_out |shape_crop | reset_shape_propotions | close | flop_shape_vertically | flop_shape_horizontally
* @property {string} component_id - id of component
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - id of editor session
* @property {boolean} flip_shape - true if click on flip_shape activated
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Clicks on panel in crop mode. Evid: 1219.
 * Event description: clicks on panel in crop mode.

 * button_name - Type: string. Desc: Zoom_in | zoom_out |shape_crop | reset_shape_propotions | close | flop_shape_vertically | flop_shape_horizontally
 *
 * component_id - Type: string. Desc: id of component
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: id of editor session
 *
 * flip_shape - Type: bool. Desc: true if click on flip_shape activated
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {clicksOnPanelInCropModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clicksOnPanelInCropMode = function (params) {
    return { evid: 1219, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} topBarPagesQuickActionsMenuAddDynamicPageClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} page_id - page hidden
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: top_bar_PAGES_quick_actions_menu_add_dynamic_page_click. Evid: 701.
 * Event description: top_bar_PAGES_quick_actions_menu_add_dynamic_page_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: guid. Desc: page hidden
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {topBarPagesQuickActionsMenuAddDynamicPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var topBarPagesQuickActionsMenuAddDynamicPageClick = function (params) {
    return { evid: 701, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} googleMapsInsertAddressParams
* @property {string} address - Adress
* @property {string} addressId - Text the user inserted to find the adress
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} success - true - Google managed to return addresses; false - Google returned empty results or error
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Google maps ->Insert Address. Evid: 1213.
 * Event description: User insert address at manage locations panel..

 * address - Type: string. Desc: Adress
 *
 * addressId - Type: string. Desc: Text the user inserted to find the adress
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * success - Type: bool. Desc: true - Google managed to return addresses; false - Google returned empty results or error
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {googleMapsInsertAddressParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var googleMapsInsertAddress = function (params) {
    return { evid: 1213, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesStorePagesStoreManagerClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_store_pages_store_manager_click. Evid: 439.
 * Event description: PAGES_store_pages_store_manager_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesStorePagesStoreManagerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesStorePagesStoreManagerClick = function (params) {
    return { evid: 439, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorSpaceAddNewColorTintsParams
* @property {string} component_id - .
* @property {string} component_type - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {index of selected Tint}
* @property {string} value_change_origin - input /
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color_Space_Add_New_Color_Tints. Evid: 399.
 * Event description: Color_Space_Add_New_Color_Tints.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {index of selected Tint}
 *
 * value_change_origin - Type: string. Desc: input /
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorSpaceAddNewColorTintsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorSpaceAddNewColorTints = function (params) {
    return { evid: 399, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeBrowserThemePanelParams
* @property {string} close_method - {X, cancel, done ,click outside}
* @property {string} color - chosen color (if clicked done)
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: close_browser_theme_panel. Evid: 891.
 * Event description: Exit chrome theme color window.

 * close_method - Type: string. Desc: {X, cancel, done ,click outside}
 *
 * color - Type: string. Desc: chosen color (if clicked done)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeBrowserThemePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeBrowserThemePanel = function (params) {
    return { evid: 891, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} columnsAddColumnClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} num_of_columns_before - {num}
* @property {string} origin - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: columns_add_column_click. Evid: 573.
 * Event description: columns_add_column_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * num_of_columns_before - Type: numeric. Desc: {num}
 *
 * origin - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {columnsAddColumnClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var columnsAddColumnClick = function (params) {
    return { evid: 573, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} layoutQuickActionBarParams
* @property {string} alignment - alignment
* @property {string} component_type - component_TYPE
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: change_layout. Evid: 716.
 * Event description: change layout event.

 * alignment - Type: string. Desc: alignment
 *
 * component_type - Type: string. Desc: component_TYPE
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {layoutQuickActionBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var layoutQuickActionBar = function (params) {
    return { evid: 716, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspacePanelCloseParams
* @property {string} closed_from - button the panel closed from (add/cancel)
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_color_changed - T/F if the original color changed
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} position - position of the color changed (1-25)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - color or set of colors (single/set)
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_panel_close. Evid: 252.
 * Event description: ColorSpace_PanelClose.

 * closed_from - Type: string. Desc: button the panel closed from (add/cancel)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_color_changed - Type: bool. Desc: T/F if the original color changed
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * position - Type: numeric. Desc: position of the color changed (1-25)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: color or set of colors (single/set)
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspacePanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspacePanelClose = function (params) {
    return { evid: 252, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} componentPartiallyOutOfStageParams
* @property {string} component_id - id of component
* @property {string} component_type - type of component
* @property {string} dm_version - .
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} type - partially_placed or 50px_left
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Component partially out of stage. Evid: 1491.
 * Event description: Component partially out of stage.

 * component_id - Type: string. Desc: id of component
 *
 * component_type - Type: string. Desc: type of component
 *
 * dm_version - Type: string. Desc: .
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * type - Type: string. Desc: partially_placed or 50px_left
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {componentPartiallyOutOfStageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var componentPartiallyOutOfStage = function (params) {
    return { evid: 1491, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} gridLayoutSettingsCloseClickedParams
* @property {string} alignment_type - left, middle, right
* @property {string} component_id - comp id
* @property {string} coulmn_width_type - manually,automatically
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} has_rows_changed - if the number of rows has changed then 1 else 0
* @property {number} header_hight - header_hight
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Esc., 'x', Click outside}
* @property {boolean} pagination - 1,0
* @property {string} panel_name - {Translation Key}
* @property {string} resize_hight - manually,automatically
* @property {number} row_hight - row_hight
* @property {string} rows_add_method - toggle, input
* @property {number} rows_per_page - number of rows in page
* @property {boolean} show_header_row - show_header_row
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: grid - layout settings close clicked. Evid: 653.
 * Event description: send the settings snapshot on closing the layout window.

 * alignment_type - Type: string. Desc: left, middle, right
 *
 * component_id - Type: string. Desc: comp id
 *
 * coulmn_width_type - Type: string. Desc: manually,automatically
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * has_rows_changed - Type: bool. Desc: if the number of rows has changed then 1 else 0
 *
 * header_hight - Type: numeric. Desc: header_hight
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * pagination - Type: bool. Desc: 1,0
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * resize_hight - Type: string. Desc: manually,automatically
 *
 * row_hight - Type: numeric. Desc: row_hight
 *
 * rows_add_method - Type: string. Desc: toggle, input
 *
 * rows_per_page - Type: numeric. Desc: number of rows in page
 *
 * show_header_row - Type: bool. Desc: show_header_row
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {gridLayoutSettingsCloseClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var gridLayoutSettingsCloseClicked = function (params) {
    return { evid: 653, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pageMinHeightChangePositionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
* @property {string} yCoordinate_new - {value of new footer}
* @property {string} yCoordinate_old - {value of old footer}
**/
/**
 * Name: Page Min Height change position. Evid: 614.
 * Event description: manually change position of the handle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 *
 * yCoordinate_new - Type: string. Desc: {value of new footer}
 *
 * yCoordinate_old - Type: string. Desc: {value of old footer}
 * @param {pageMinHeightChangePositionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pageMinHeightChangePosition = function (params) {
    return { evid: 614, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rangeSliderHandleShapeChangedParams
* @property {string} behavior - Continuous/Stepped
* @property {string} component_id - null
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - Circle/Square/Rectangle /Bar
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: dummy-name. Evid: 1326.
 * Event description: range_slider_handle_shape_changed.

 * behavior - Type: string. Desc: Continuous/Stepped
 *
 * component_id - Type: string.
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: Circle/Square/Rectangle /Bar
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rangeSliderHandleShapeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rangeSliderHandleShapeChanged = function (params) {
    return { evid: 1326, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} adi2editorPreloaderStepEndParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {number} duration - duration of the step
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} step_name - name of the step
* @property {string} totalJsHeapSize - totalJsHeapSize
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: ADI2Editor - preloader step end. Evid: 1153.
 * Event description: ADI2Editor - preloader step end.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * duration - Type: numeric. Desc: duration of the step
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * step_name - Type: string. Desc: name of the step
 *
 * totalJsHeapSize - Type: string. Desc: totalJsHeapSize
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {adi2editorPreloaderStepEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adi2editorPreloaderStepEnd = function (params) {
    return { evid: 1153, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickToViewQrCodeParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} target - view_published_version_on_mobile
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Click to view QR code. Evid: 1134.
 * Event description: Click to view QR code.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: view_published_version_on_mobile
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {clickToViewQrCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToViewQrCode = function (params) {
    return { evid: 1134, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} musicCampaignSubmitYourVideoClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {image, date kink, submission button}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: music_campaign_submit_your_video_click. Evid: 306.
 * Event description: music_campaign_submit_your_video_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {image, date kink, submission button}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {musicCampaignSubmitYourVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var musicCampaignSubmitYourVideoClick = function (params) {
    return { evid: 306, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomePanelOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {number} loading_time - ms
* @property {string} multilingual - {}
* @property {string} origin - {keyboard, help_menu, help_home}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} visible_sections - {contact_us;article_id1,article_id2,article_id3,corvid_resources; etc.}
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_panel_open. Evid: 1089.
 * Event description: Event fires when help home panel is opened.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * loading_time - Type: numeric. Desc: ms
 *
 * multilingual - Type: string. Desc: {}
 *
 * origin - Type: string. Desc: {keyboard, help_menu, help_home}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * visible_sections - Type: string. Desc: {contact_us;article_id1,article_id2,article_id3,corvid_resources; etc.}
 *
 * workspace_mode - Type: string.
 * @param {helpHomePanelOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomePanelOpen = function (params) {
    return { evid: 1089, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressTheTOnTheFontsManagerParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: press the [T] on the fonts manager. Evid: 604.
 * Event description: press the [T] on the fonts manager.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressTheTOnTheFontsManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressTheTOnTheFontsManager = function (params) {
    return { evid: 604, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editsitecolorsBackbuttonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editsitecolors_backbutton_click. Evid: 211.
 * Event description: editsitecolors_backbutton_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editsitecolorsBackbuttonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editsitecolorsBackbuttonClick = function (params) {
    return { evid: 211, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaErrorParams
* @property {GUID} app_id - [guid]
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} error_desc - {'app cannot load'...}
* @property {string} error_type - {provision, deletion, loading_sdk, settings...}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_error. Evid: 190.
 * Event description: tpa_error.

 * app_id - Type: guid. Desc: [guid]
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * error_desc - Type: string. Desc: {'app cannot load'...}
 *
 * error_type - Type: string. Desc: {provision, deletion, loading_sdk, settings...}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {tpaErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaError = function (params) {
    return { evid: 190, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsLayoutMigrationRunParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: SectionsLayoutMigration_run. Evid: 757.
 * Event description: SectionsLayoutMigration fixer has been done.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionsLayoutMigrationRunParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsLayoutMigrationRun = function (params) {
    return { evid: 757, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} goToDynamicPagesClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {number} pages_count - 50/70/90
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: go to dynamic pages click. Evid: 965.
 * Event description: Click on Get Started in Heavy sites Modal.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * pages_count - Type: numeric. Desc: 50/70/90
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {goToDynamicPagesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var goToDynamicPagesClick = function (params) {
    return { evid: 965, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickAccessibilityFromHeaderMenuParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Click Accessibility from header menu. Evid: 679.
 * Event description: Click Accessibility from header menu.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickAccessibilityFromHeaderMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickAccessibilityFromHeaderMenu = function (params) {
    return { evid: 679, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} leftBarButtonClickParams
* @property {string} category - {pages, design, add, wix stores...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Left_Bar_Button_Click. Evid: 296.
 * Event description: Left_Bar_Button_Click.

 * category - Type: string. Desc: {pages, design, add, wix stores...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {leftBarButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var leftBarButtonClick = function (params) {
    return { evid: 296, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuHelpIconClickedParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel - {Manage,Pages,Add}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_help_icon_clicked. Evid: 210.
 * Event description: site_app_menu_help_icon_clicked.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel - Type: string. Desc: {Manage,Pages,Add}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuHelpIconClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuHelpIconClicked = function (params) {
    return { evid: 210, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} repeaterLayoutChangedParams
* @property {string} alignment - {left,center,right,justify}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: repeater_layout_changed. Evid: 744.
 * Event description: animation_panel_behavior_click.

 * alignment - Type: string. Desc: {left,center,right,justify}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {repeaterLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var repeaterLayoutChanged = function (params) {
    return { evid: 744, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionClickOnActionParams
* @property {string} action_name - action clicked
* @property {string} actions_disabled - list of actions that are disabled
* @property {string} app_id - id of app inside section
* @property {string} component_id - component_id of section
* @property {string} component_type - section / header / footer
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - isZoomOut
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} openedPanels - panels that are opened during section actions clicks
* @property {string} origin - RCM | action_bar
* @property {string} section_name - section_name
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} editor_working_mode - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Section - click on action. Evid: 1302.
 * Event description: user clicks on section action (both from action bar or RCM).

 * action_name - Type: string. Desc: action clicked
 *
 * actions_disabled - Type: string. Desc: list of actions that are disabled
 *
 * app_id - Type: string. Desc: id of app inside section
 *
 * component_id - Type: string. Desc: component_id of section
 *
 * component_type - Type: string. Desc: section / header / footer
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: isZoomOut
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * openedPanels - Type: string. Desc: panels that are opened during section actions clicks
 *
 * origin - Type: string. Desc: RCM | action_bar
 *
 * section_name - Type: string. Desc: section_name
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * editor_working_mode - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionClickOnActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionClickOnAction = function (params) {
    return { evid: 1302, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editSectionTextComponentStartChangingParams
* @property {string} action_origin - edit_section / <name>_settings (example: button_settings)
* @property {string} component_id - id of selected component
* @property {string} component_type - type of the component that was changed
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - true/false
* @property {boolean} isSection - true/false
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - true/false
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - from where the edit panel was opened
* @property {string} panel_correlation_id - id, that equal to correlation_id of 38:309 when layout panel was opened.
* @property {string} parent_component_id - id of selected section
* @property {string} section_correlation_id - id, which should change after layout panel was closed
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - (no description)
* @property {string} usedJsHeapSize - usedJsHeapSize
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - viewerVersion
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Section: Text Component start changing. Evid: 1375.
 * Event description: User entered the text change window (New event) inside the "Edit Section" panel.

 * action_origin - Type: string. Desc: edit_section / <name>_settings (example: button_settings)
 *
 * component_id - Type: string. Desc: id of selected component
 *
 * component_type - Type: string. Desc: type of the component that was changed
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: true/false
 *
 * isSection - Type: bool. Desc: true/false
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool. Desc: true/false
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: from where the edit panel was opened
 *
 * panel_correlation_id - Type: string. Desc: id, that equal to correlation_id of 38:309 when layout panel was opened.
 *
 * parent_component_id - Type: string. Desc: id of selected section
 *
 * section_correlation_id - Type: string. Desc: id, which should change after layout panel was closed
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: (no description)
 *
 * usedJsHeapSize - Type: string. Desc: usedJsHeapSize
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string. Desc: viewerVersion
 *
 * workspace_mode - Type: string.
 * @param {editSectionTextComponentStartChangingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editSectionTextComponentStartChanging = function (params) {
    return { evid: 1375, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileHomeButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_home_button_click. Evid: 781.
 * Event description: {}.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileHomeButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileHomeButtonClick = function (params) {
    return { evid: 781, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} widgetModeShownParams
* @property {string} app_def_id - {id of widget}
* @property {string} component_id - {id of the component}
* @property {string} component_type - {type of the component}
* @property {string} current_mode - {mode selected on open list}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {session id}
* @property {string} host_app_id - {host application id}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} modes - {json with available modes, ids and is default}
* @property {string} multilingual - null
* @property {string} origin - null
* @property {string} parent_component_id - {id of parent component id}
* @property {string} parent_component_type - {type of parent component}
* @property {boolean} root_widget - {is root widget: true, false}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Widget mode shown. Evid: 1477.
 * Event description: Widget modes shown.

 * app_def_id - Type: string. Desc: {id of widget}
 *
 * component_id - Type: string. Desc: {id of the component}
 *
 * component_type - Type: string. Desc: {type of the component}
 *
 * current_mode - Type: string. Desc: {mode selected on open list}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {session id}
 *
 * host_app_id - Type: string. Desc: {host application id}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * modes - Type: string. Desc: {json with available modes, ids and is default}
 *
 * multilingual - Type: string.
 *
 * origin - Type: string.
 *
 * parent_component_id - Type: string. Desc: {id of parent component id}
 *
 * parent_component_type - Type: string. Desc: {type of parent component}
 *
 * root_widget - Type: bool. Desc: {is root widget: true, false}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {widgetModeShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetModeShown = function (params) {
    return { evid: 1477, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorspaceAddbuttonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Main Panel, Edit Site Colors
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: colorspace_addbutton_click. Evid: 197.
 * Event description: ColorSpace_AddButton_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Main Panel, Edit Site Colors
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorspaceAddbuttonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorspaceAddbuttonClick = function (params) {
    return { evid: 197, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colorPaletteAdvancedSettingsOpenedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - background, textpanel, button design etc
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Color palette advanced settings opened. Evid: 1435.
 * Event description: Color palette advanced settings opened.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: background, textpanel, button design etc
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colorPaletteAdvancedSettingsOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colorPaletteAdvancedSettingsOpened = function (params) {
    return { evid: 1435, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} upgradeTopbarOpenParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} offering_type - offering name for editor fallback panels
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - {dealer,editor}
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: upgrade_topbar_open. Evid: 789.
 * Event description: sends when upgrade panel in top bar opens in any method hover/click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * offering_type - Type: string. Desc: offering name for editor fallback panels
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: {dealer,editor}
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {upgradeTopbarOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeTopbarOpen = function (params) {
    return { evid: 789, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textEllipsisHtmlTagChangeClickedParams
* @property {string} component_id - component id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - jsHeapSizeLimit
* @property {string} multilingual - multilingual
* @property {string} origin - Main GFPP button/Seo settings button
* @property {string} page_id - page id
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - .viewer_name
* @property {string} viewerVersion - .viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: TextEllipsis.html_tag_change_clicked. Evid: 1282.
 * Event description: TextEllipsis.html_tag_change_clicked.

 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: jsHeapSizeLimit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: Main GFPP button/Seo settings button
 *
 * page_id - Type: string. Desc: page id
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: .viewer_name
 *
 * viewerVersion - Type: string. Desc: .viewer_version
 *
 * workspace_mode - Type: string.
 * @param {textEllipsisHtmlTagChangeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textEllipsisHtmlTagChangeClicked = function (params) {
    return { evid: 1282, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} secondSaveConnectDomainClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {not published not connected, not Published connected, published_connected, Published_not_connected}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Second_Save_connect_domain_click. Evid: 338.
 * Event description: Second_Save_connect_domain_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {not published not connected, not Published connected, published_connected, Published_not_connected}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {secondSaveConnectDomainClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var secondSaveConnectDomainClick = function (params) {
    return { evid: 338, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoboxMaskParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {number} mask_index - {0,1, 2, 4...}
* @property {string} mask_media_name - image uri (+suffix)
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} input_source - video mask/box add source (preset, wix_media, user_upload)
* @property {boolean} is_changed - true - if something was changed during panel usage
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: videobox_mask. Evid: 978.
 * Event description: sent once video mask panel closed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * mask_index - Type: numeric. Desc: {0,1, 2, 4...}
 *
 * mask_media_name - Type: string. Desc: image uri (+suffix)
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * input_source - Type: string. Desc: video mask/box add source (preset, wix_media, user_upload)
 *
 * is_changed - Type: bool. Desc: true - if something was changed during panel usage
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {videoboxMaskParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoboxMask = function (params) {
    return { evid: 978, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editMainColorCancelParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panelName - theme_color_picker_single_color /   theme_color_picker_column_color /
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Edit_Main_Color_Cancel. Evid: 410.
 * Event description: Edit_Main_Color_Cancel.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panelName - Type: string. Desc: theme_color_picker_single_color /   theme_color_picker_column_color /
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editMainColorCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editMainColorCancel = function (params) {
    return { evid: 410, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelTextEffectsSelectedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} effect_id - {1,2,3...}
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Text_Effects_Selected. Evid: 244.
 * Event description: Text_Panel_Text_Effects_Selected.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * effect_id - Type: numeric. Desc: {1,2,3...}
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelTextEffectsSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelTextEffectsSelected = function (params) {
    return { evid: 244, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} reorderSectionParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {string} position_after - y
* @property {string} position_before - y
* @property {string} section_size - small,medium,large
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: reorder_section. Evid: 472.
 * Event description: reorder_section.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * position_after - Type: string. Desc: y
 *
 * position_before - Type: string. Desc: y
 *
 * section_size - Type: string. Desc: small,medium,large
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {reorderSectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reorderSection = function (params) {
    return { evid: 472, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} choseTimeframeInDropdownParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} selection - timeframe chosen [hours]
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: chose_timeframe_in_dropdown. Evid: 837.
 * Event description: chose_timeframe_in_dropdown.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * selection - Type: string. Desc: timeframe chosen [hours]
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {choseTimeframeInDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var choseTimeframeInDropdown = function (params) {
    return { evid: 837, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} dataItemRefsSaveDataFixerParams
* @property {string} dataItemType - dataItemType
* @property {string} dataType - dataType
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: data Item Refs SaveData Fixer. Evid: 659.
 * Event description: Send info about data items being fixed.

 * dataItemType - Type: string. Desc: dataItemType
 *
 * dataType - Type: string. Desc: dataType
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {dataItemRefsSaveDataFixerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dataItemRefsSaveDataFixer = function (params) {
    return { evid: 659, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorIntroVideoXButtonPressedExistingUsersParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {number} duration - {milliseconds)
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {x button; ESC}
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {Url} video_url - {}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editor_intro_video_X_button_pressed_existing_users. Evid: 592.
 * Event description: Intro video for existing users: pop up closes.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * duration - Type: numeric. Desc: {milliseconds)
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {x button; ESC}
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * video_url - Type: url. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editorIntroVideoXButtonPressedExistingUsersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorIntroVideoXButtonPressedExistingUsers = function (params) {
    return { evid: 592, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lightboxXIconToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {boolean} status - on/off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: lightbox_X_icon_toggle. Evid: 877.
 * Event description: pop_up_settings_page_selector_ok.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: on/off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {lightboxXIconToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lightboxXIconToggle = function (params) {
    return { evid: 877, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelFillTypeClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {regular hover}
* @property {string} totalJsHeapSize - null
* @property {string} type - (liner, Radial)
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->Fill type click. Evid: 941.
 * Event description: This event will be sent every time a user clicks on fill type.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {regular hover}
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: (liner, Radial)
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelFillTypeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelFillTypeClick = function (params) {
    return { evid: 941, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pagesSettingsSeoGooglePreviewClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: PAGES_settings_seo_google_preview_click. Evid: 432.
 * Event description: PAGES_settings_seo_google_preview_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pagesSettingsSeoGooglePreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pagesSettingsSeoGooglePreviewClick = function (params) {
    return { evid: 432, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} welcomeScreenPlayAnimationClickedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {string} editor_view_mode - editor_working_mode
* @property {string} element_name - element_name
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewMode - view_mode
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Welcome Screen: Play Animation clicked. Evid: 1161.
 * Event description: Welcome Screen: Play Animation clicked.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * editor_view_mode - Type: string. Desc: editor_working_mode
 *
 * element_name - Type: string. Desc: element_name
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewMode - Type: string. Desc: view_mode
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {welcomeScreenPlayAnimationClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var welcomeScreenPlayAnimationClicked = function (params) {
    return { evid: 1161, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videoPlayerSettingsOnPanelClosedParams
* @property {boolean} autoplay_status - null
* @property {boolean} cover_image_custom - {1,0}
* @property {string} cover_image_id - null
* @property {number} cover_image_position - null
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {boolean} loop_status - null
* @property {string} multilingual - null
* @property {boolean} mute_on_load_status - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: video_player_settings_on_panel_closed. Evid: 680.
 * Event description: video_player_settings_on_panel_closed.

 * autoplay_status - Type: bool.
 *
 * cover_image_custom - Type: bool. Desc: {1,0}
 *
 * cover_image_id - Type: string.
 *
 * cover_image_position - Type: numeric.
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * loop_status - Type: bool.
 *
 * multilingual - Type: string.
 *
 * mute_on_load_status - Type: bool.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videoPlayerSettingsOnPanelClosedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videoPlayerSettingsOnPanelClosed = function (params) {
    return { evid: 680, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} ecomMigrationShowModalParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} type - modal type - welcome / migrate / error
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: ecom migration - show modal. Evid: 504.
 * Event description: Show new ecom migration modal.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * type - Type: string. Desc: modal type - welcome / migrate / error
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {ecomMigrationShowModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ecomMigrationShowModal = function (params) {
    return { evid: 504, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} menuAddMenuNewPageClickParams
* @property {string} category - category
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - origin
* @property {GUID} site_id - null
* @property {string} source - source
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: MENU_add_menu_new_page_click. Evid: 1353.
 * Event description: Click on add new page from Manage menu.

 * category - Type: string. Desc: category
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: origin
 *
 * site_id - Type: guid.
 *
 * source - Type: string. Desc: source
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {menuAddMenuNewPageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuAddMenuNewPageClick = function (params) {
    return { evid: 1353, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} panelDragParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} new_position - {X,Y}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Panel_Drag. Evid: 312.
 * Event description: Panel_Drag.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * new_position - Type: string. Desc: {X,Y}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {panelDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelDrag = function (params) {
    return { evid: 312, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishFlowConnectDomainLaterButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_publish - {1,0}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish_flow_connect_domain_later_button_click. Evid: 305.
 * Event description: publish_connect_domain_later_button_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_publish - Type: bool. Desc: {1,0}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishFlowConnectDomainLaterButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishFlowConnectDomainLaterButtonClick = function (params) {
    return { evid: 305, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} widgetModeChangedParams
* @property {string} app_def_id - {id of widget}
* @property {string} component_id - {id of the component}
* @property {string} component_type - {type of the component}
* @property {string} current_mode - {mode selected}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {session id}
* @property {string} host_app_id - {host application id}
* @property {boolean} is_default_mode - {is default mode selected}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {Editor/Wix Studio/EditorX?}
* @property {string} parent_component_id - {id of parent component id}
* @property {string} parent_component_type - {type of parent component}
* @property {boolean} root_widget - {is root widget: true, false)
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Widget mode changed. Evid: 1479.
 * Event description: Widget mode changed.

 * app_def_id - Type: string. Desc: {id of widget}
 *
 * component_id - Type: string. Desc: {id of the component}
 *
 * component_type - Type: string. Desc: {type of the component}
 *
 * current_mode - Type: string. Desc: {mode selected}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {session id}
 *
 * host_app_id - Type: string. Desc: {host application id}
 *
 * is_default_mode - Type: bool. Desc: {is default mode selected}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {Editor/Wix Studio/EditorX?}
 *
 * parent_component_id - Type: string. Desc: {id of parent component id}
 *
 * parent_component_type - Type: string. Desc: {type of parent component}
 *
 * root_widget - Type: bool. Desc: {is root widget: true, false)
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {widgetModeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetModeChanged = function (params) {
    return { evid: 1479, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} colourPaletteHoverOverItemsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - {change theme colors, change text theme}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Colour palette hover over items. Evid: 1438.
 * Event description: Colour palette hover over change colour or text theme CTA.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: {change theme colors, change text theme}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {colourPaletteHoverOverItemsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var colourPaletteHoverOverItems = function (params) {
    return { evid: 1438, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} platformAppFailedToInstallParams
* @property {string} allAppsToInstall - all apps that was installed on this session
* @property {string} app_id - app_def_id
* @property {string} app_name - app name
* @property {string} app_type - TPA SECTION/ TPAWidget/ PLATFORM
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {string} errorCode - error_code
* @property {string} error_desc - Error Desc
* @property {GUID} esi - esi
* @property {GUID} flowId - Silent install flow id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - platform origin info
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Platform App failed to install. Evid: 772.
 * Event description: platform App failed to onstall.

 * allAppsToInstall - Type: string. Desc: all apps that was installed on this session
 *
 * app_id - Type: string. Desc: app_def_id
 *
 * app_name - Type: string. Desc: app name
 *
 * app_type - Type: string. Desc: TPA SECTION/ TPAWidget/ PLATFORM
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * errorCode - Type: string. Desc: error_code
 *
 * error_desc - Type: string. Desc: Error Desc
 *
 * esi - Type: guid. Desc: esi
 *
 * flowId - Type: guid. Desc: Silent install flow id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: platform origin info
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {platformAppFailedToInstallParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var platformAppFailedToInstall = function (params) {
    return { evid: 772, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} lightboxCloseButtonToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {boolean} status - on/off
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: lightbox_close_button_toggle. Evid: 881.
 * Event description: user changed 'Close' button toggle in Lightbox Settings.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: on/off
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {lightboxCloseButtonToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var lightboxCloseButtonToggle = function (params) {
    return { evid: 881, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishWorkNotPublishedErrorOkClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Publish_Work_not_Published_Error_ok_Click. Evid: 396.
 * Event description: Publish_Work_not_Published_Error_ok_Click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishWorkNotPublishedErrorOkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishWorkNotPublishedErrorOkClick = function (params) {
    return { evid: 396, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} helpHomeVideoClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - {}
* @property {string} multilingual - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - {}
* @property {string} usedJsHeapSize - {}
* @property {string} video_id - {}
* @property {string} video_Url - url
* @property {string} viewer_name - {}
* @property {string} viewerName - null
* @property {string} viewer_version - {}
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: help_home_video_click. Evid: 1094.
 * Event description: Event fires when clicking any video inside the step-by-step videos section, under the help home panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: {}
 *
 * multilingual - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: {}
 *
 * usedJsHeapSize - Type: string. Desc: {}
 *
 * video_id - Type: string. Desc: {}
 *
 * video_Url - Type: string. Desc: url
 *
 * viewer_name - Type: string. Desc: {}
 *
 * viewerName - Type: string.
 *
 * viewer_version - Type: string. Desc: {}
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {helpHomeVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var helpHomeVideoClick = function (params) {
    return { evid: 1094, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} designPanelThemeSelectedParams
* @property {string} component_id - .
* @property {string} component_type - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} selection - color&text theme kit / text theme kit
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {index of selected palette}
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Design Panel - Theme Selected. Evid: 1195.
 * Event description: Design Panel - Theme Selected.

 * component_id - Type: string. Desc: .
 *
 * component_type - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * selection - Type: string. Desc: color&text theme kit / text theme kit
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {index of selected palette}
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {designPanelThemeSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var designPanelThemeSelected = function (params) {
    return { evid: 1195, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylableButtonReplaceImageClickedParams
* @property {string} button_type - Icon only/text&icon
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {string} homepage_displaying - text/icon
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - is_section
* @property {boolean} isSiteCreation - is_site_creation
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Button - Replace Image clicked. Evid: 1367.
 * Event description: Stylable Button - Replace Image clicked.

 * button_type - Type: string. Desc: Icon only/text&icon
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * homepage_displaying - Type: string. Desc: text/icon
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool. Desc: is_section
 *
 * isSiteCreation - Type: bool. Desc: is_site_creation
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {stylableButtonReplaceImageClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylableButtonReplaceImageClicked = function (params) {
    return { evid: 1367, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} closeToolbarParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {GUID} esi - {}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {tools top bar, X}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: close_toolbar. Evid: 876.
 * Event description: close toolbar panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * esi - Type: guid. Desc: {}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {tools top bar, X}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {closeToolbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeToolbar = function (params) {
    return { evid: 876, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} codeEmbedTitleChangedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4/...
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isSuccess - true/false
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} title - title that user input
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: code_embed_title_changed. Evid: 1228.
 * Event description: send this event when user change name of embed code.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4/...
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isSuccess - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * title - Type: string. Desc: title that user input
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {codeEmbedTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var codeEmbedTitleChanged = function (params) {
    return { evid: 1228, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickAdvancedPageSettingsPagePanelParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: click_advanced_page_settings_page_panel. Evid: 835.
 * Event description: Click on the "advanced page settings"  in the page panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {clickAdvancedPageSettingsPagePanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickAdvancedPageSettingsPagePanel = function (params) {
    return { evid: 835, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} spaceBottomDragParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} page_id - string
* @property {string} section_size - small,medium,large
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: space_bottom_drag. Evid: 474.
 * Event description: space_bottom_drag.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * page_id - Type: string. Desc: string
 *
 * section_size - Type: string. Desc: small,medium,large
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {spaceBottomDragParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var spaceBottomDrag = function (params) {
    return { evid: 474, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} stylablePanelChangeStateClickParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} part - {}
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} state - {{regular hover}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Stylable Panel --->  change state click. Evid: 932.
 * Event description: This event will be sent every time a user clicks on the component state (regular hover).

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * part - Type: string. Desc: {}
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * state - Type: string. Desc: {{regular hover}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {stylablePanelChangeStateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var stylablePanelChangeStateClick = function (params) {
    return { evid: 932, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} connectDomainPanelClickParams
* @property {string} action - get_new_domain / connect_domain
* @property {string} dm_version - null
* @property {string} domain_type - general/suggested
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} origin - save_flow | url_bar
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Connect domain panel click. Evid: 1147.
 * Event description: User clicks on Connect domain panel.

 * action - Type: string. Desc: get_new_domain / connect_domain
 *
 * dm_version - Type: string.
 *
 * domain_type - Type: string. Desc: general/suggested
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * origin - Type: string. Desc: save_flow | url_bar
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {connectDomainPanelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var connectDomainPanelClick = function (params) {
    return { evid: 1147, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} unknownPasteOriginParams
* @property {string} content - content
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: unknown_paste_origin. Evid: 1176.
 * Event description: unknown_paste_origin.

 * content - Type: string. Desc: content
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {unknownPasteOriginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var unknownPasteOrigin = function (params) {
    return { evid: 1176, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> click. Evid: 101.
 * Event description: add menu -> click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuClick = function (params) {
    return { evid: 101, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} marketHelpClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} market_status - {open,close}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: market_help_click. Evid: 174.
 * Event description: market_help_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * market_status - Type: string. Desc: {open,close}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {marketHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var marketHelpClick = function (params) {
    return { evid: 174, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} shapeDividerClickInsideDividerPanelParams
* @property {string} component_id - {}
* @property {string} component_name - {slide gallery, box...}
* @property {string} dm_version - dm_version
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {string} field_name - field name
* @property {string} field_type - 'preset changed'
* @property {string} field_value - index value or 'custom'
* @property {boolean} is_rollout - .
* @property {boolean} isSection - .
* @property {boolean} isSiteCreation - .
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} svgId - divider's ID
* @property {string} tab - bottom / top
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - .
**/
/**
 * Name: Shape Divider - click inside divider panel. Evid: 1489.
 * Event description: Shape Divider - click inside divider panel.

 * component_id - Type: string. Desc: {}
 *
 * component_name - Type: string. Desc: {slide gallery, box...}
 *
 * dm_version - Type: string. Desc: dm_version
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * field_name - Type: string. Desc: field name
 *
 * field_type - Type: string. Desc: 'preset changed'
 *
 * field_value - Type: string. Desc: index value or 'custom'
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool. Desc: .
 *
 * isSiteCreation - Type: bool. Desc: .
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * svgId - Type: string. Desc: divider's ID
 *
 * tab - Type: string. Desc: bottom / top
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string. Desc: .
 * @param {shapeDividerClickInsideDividerPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shapeDividerClickInsideDividerPanel = function (params) {
    return { evid: 1489, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileViewModeToggleParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {top bar edit,top bar preview, mobile panel toggle, mobile pannel icons}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - {1,0}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile_view_mode_toggle. Evid: 292.
 * Event description: mobile_view_mode_toggle.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {top bar edit,top bar preview, mobile panel toggle, mobile pannel icons}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: {1,0}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileViewModeToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileViewModeToggle = function (params) {
    return { evid: 292, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} reorderQuickActionParams
* @property {string} action_type - action type moved
* @property {number} current_position - current position of action
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {number} previous_position - previous position of action
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: reorder_quick_action. Evid: 721.
 * Event description: reorder_quick_action.

 * action_type - Type: string. Desc: action type moved
 *
 * current_position - Type: numeric. Desc: current position of action
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * previous_position - Type: numeric. Desc: previous position of action
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {reorderQuickActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reorderQuickAction = function (params) {
    return { evid: 721, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuManagePanelButtonClickedParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} button_name - {ManageStore, AddProduct, ManageBlog, AddPost}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - the panel where the button is, same as panel_name in 38:309 event
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_manage_panel_button_clicked. Evid: 205.
 * Event description: site_app_menu_manage_panel_button_clicked.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * button_name - Type: string. Desc: {ManageStore, AddProduct, ManageBlog, AddPost}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: the panel where the button is, same as panel_name in 38:309 event
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuManagePanelButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuManagePanelButtonClicked = function (params) {
    return { evid: 205, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editsitecolorsPanelCloseParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: editsitecolors_panel_close. Evid: 253.
 * Event description: editsitecolors_PanelClose.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {editsitecolorsPanelCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editsitecolorsPanelClose = function (params) {
    return { evid: 253, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} pressingOnTheGoToUrlLinkParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: pressing on the Go to URL link. Evid: 663.
 * Event description: page URL as appears in the SEO tab in pages panel.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {pressingOnTheGoToUrlLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pressingOnTheGoToUrlLink = function (params) {
    return { evid: 663, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} previewSuccessParams
* @property {string} dm_version - null
* @property {string} ds_origin - {}
* @property {number} duration - time to preview
* @property {GUID} esi - {}
* @property {boolean} is_dev_mode - is_dev_mode
* @property {boolean} is_published - {true, false}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - top bar / site menu / interactions / dynamic pages
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - {}
* @property {string} viewerVersion - {}
* @property {string} workspace_mode - null
**/
/**
 * Name: Preview --> success. Evid: 957.
 * Event description: success_save_process.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: {}
 *
 * duration - Type: numeric. Desc: time to preview
 *
 * esi - Type: guid. Desc: {}
 *
 * is_dev_mode - Type: bool. Desc: is_dev_mode
 *
 * is_published - Type: bool. Desc: {true, false}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: top bar / site menu / interactions / dynamic pages
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: {}
 *
 * viewerVersion - Type: string. Desc: {}
 *
 * workspace_mode - Type: string.
 * @param {previewSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var previewSuccess = function (params) {
    return { evid: 957, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardAppInstallStartedParams
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} display_mode - wrap/ellipsis
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - is_rollout
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - is_zoom_out
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {string} page_id - page id where the component was added
* @property {string} selection - on/off
* @property {GUID} site_id - site_id
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: breadcrumb_separator_toggle_changed. Evid: 1315.
 * Event description: breadcrumb_separator_toggle_changed.

 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * display_mode - Type: string. Desc: wrap/ellipsis
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool. Desc: is_rollout
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: is_zoom_out
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * page_id - Type: string. Desc: page id where the component was added
 *
 * selection - Type: string. Desc: on/off
 *
 * site_id - Type: guid. Desc: site_id
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardAppInstallStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardAppInstallStarted = function (params) {
    return { evid: 1315, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} videosearchAddClickedInPopUpParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} service - {YouTube, Vimeo}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: videosearch_add_clicked_in_pop-up. Evid: 585.
 * Event description: videosearch_add_clicked_in_pop-up.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * service - Type: string. Desc: {YouTube, Vimeo}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {videosearchAddClickedInPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var videosearchAddClickedInPopUp = function (params) {
    return { evid: 585, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} moveToFooterClickParams
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: move_to_footer_click. Evid: 468.
 * Event description: Move_to_footer_click.

 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {moveToFooterClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var moveToFooterClick = function (params) {
    return { evid: 468, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelColorClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Color_Click. Evid: 241.
 * Event description: Text_Panel_Color_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelColorClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelColorClick = function (params) {
    return { evid: 241, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textLanguagesSupportLearnMoreClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: text_languages_support_learn_more_click. Evid: 271.
 * Event description: text_languages_support_learn_more_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textLanguagesSupportLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textLanguagesSupportLearnMoreClick = function (params) {
    return { evid: 271, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} textPanelBoldClickParams
* @property {string} component_id - .
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - panel opening origin
* @property {string} panelName - .
* @property {string} panel_name - panel_name
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Text_Panel_Bold_Click. Evid: 231.
 * Event description: Text_Panel_Bold_Click.

 * component_id - Type: string. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: panel opening origin
 *
 * panelName - Type: string. Desc: .
 *
 * panel_name - Type: string. Desc: panel_name
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {textPanelBoldClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var textPanelBoldClick = function (params) {
    return { evid: 231, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} introVideoPageLoadsParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Intro video page loads. Evid: 490.
 * Event description: Intro video for new users loads.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {introVideoPageLoadsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var introVideoPageLoads = function (params) {
    return { evid: 490, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} effectsPanelBackFromCustomSettingsParams
* @property {string} behavior_name - null
* @property {string} component_id - component id
* @property {string} component_type - component type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} interaction_id - interaction_id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: effects_panel_back_from_custom_settings. Evid: 1002.
 * Event description: Back to presets.

 * behavior_name - Type: string.
 *
 * component_id - Type: string. Desc: component id
 *
 * component_type - Type: string. Desc: component type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * interaction_id - Type: string. Desc: interaction_id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {effectsPanelBackFromCustomSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var effectsPanelBackFromCustomSettings = function (params) {
    return { evid: 1002, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} advancedDesignPanelTabSelectionClickParams
* @property {string} component_type - {gallery, box...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mouse_state - {active, hover, clicked}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} tab_id - {1,2,3...}
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} widgetName - widgetName
* @property {string} workspace_mode - null
**/
/**
 * Name: advanced_design_panel_tab_selection_click. Evid: 257.
 * Event description: advanced_design_panel_tab_selection_click.

 * component_type - Type: string. Desc: {gallery, box...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mouse_state - Type: string. Desc: {active, hover, clicked}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tab_id - Type: string. Desc: {1,2,3...}
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widgetName - Type: string. Desc: widgetName
 *
 * workspace_mode - Type: string.
 * @param {advancedDesignPanelTabSelectionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var advancedDesignPanelTabSelectionClick = function (params) {
    return { evid: 257, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} showSuggestedDomainOnTopBarParams
* @property {string} dm_version - null
* @property {string} ds_origin - ds_origin
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - js_heap_size_limit
* @property {string} multilingual - multilingual
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - total_js_heap_size
* @property {string} usedJsHeapSize - used_js_heap_size
* @property {string} viewerName - viewer_name
* @property {string} viewerVersion - viewer_version
* @property {string} workspace_mode - null
**/
/**
 * Name: Show suggested domain on Top bar. Evid: 1148.
 * Event description: User see suggested domain on Top bar.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: ds_origin
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: js_heap_size_limit
 *
 * multilingual - Type: string. Desc: multilingual
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: total_js_heap_size
 *
 * usedJsHeapSize - Type: string. Desc: used_js_heap_size
 *
 * viewerName - Type: string. Desc: viewer_name
 *
 * viewerVersion - Type: string. Desc: viewer_version
 *
 * workspace_mode - Type: string.
 * @param {showSuggestedDomainOnTopBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showSuggestedDomainOnTopBar = function (params) {
    return { evid: 1148, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addPanelLoadedParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add_panel_loaded. Evid: 700.
 * Event description: add_panel_loaded.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addPanelLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPanelLoaded = function (params) {
    return { evid: 700, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardScrollParams
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - editor session id, for every site editting session
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} mode - autoscroll / manual
* @property {string} multilingual - .
* @property {number} position - 1-3 {which page user scrolled}
* @property {string} screenResolution - height x width
* @property {GUID} site_id - .
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - user id
* @property {string} view - Wizard screen name
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: scroll. Evid: 1257.
 * Event description: Site Creation Wizard: scroll.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: editor session id, for every site editting session
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * mode - Type: string. Desc: autoscroll / manual
 *
 * multilingual - Type: string. Desc: .
 *
 * position - Type: numeric. Desc: 1-3 {which page user scrolled}
 *
 * screenResolution - Type: string. Desc: height x width
 *
 * site_id - Type: guid. Desc: .
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 *
 * view - Type: string. Desc: Wizard screen name
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardScrollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardScroll = function (params) {
    return { evid: 1257, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} mobileEditorTooltipSwitchToMobilePreviewClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - editor session guid
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: mobile editor tooltip --> switch to mobile preview click. Evid: 96.
 * Event description: Switch to mobile preview button click on the tooltip.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: editor session guid
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {mobileEditorTooltipSwitchToMobilePreviewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileEditorTooltipSwitchToMobilePreviewClick = function (params) {
    return { evid: 96, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteAppMenuUpgradeTooltipOpenedParams
* @property {string} app_id - guid
* @property {string} app_name - {WixStores,blog....}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: site_app_menu_upgrade_tooltip_opened. Evid: 206.
 * Event description: site_app_menu_upgrade_tooltip_opened.

 * app_id - Type: string. Desc: guid
 *
 * app_name - Type: string. Desc: {WixStores,blog....}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {siteAppMenuUpgradeTooltipOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteAppMenuUpgradeTooltipOpened = function (params) {
    return { evid: 206, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchItemCtaClickParams
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} clickOrigin - mouse / keyboard
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} itemId - item name / id
* @property {number} itemIndex - item index
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - what does user search for (term, phrase, word)
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.item.cta.click. Evid: 995.
 * Event description: click on CTA in search results: open, view, preview.

 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * clickOrigin - Type: string. Desc: mouse / keyboard
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * itemId - Type: string. Desc: item name / id
 *
 * itemIndex - Type: numeric. Desc: item index
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string. Desc: what does user search for (term, phrase, word)
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchItemCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchItemCtaClick = function (params) {
    return { evid: 995, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} singleVideoPlayerCoverImageChangedParams
* @property {string} actionType - add / change / select
* @property {number} cover_index - 0 = custom , 1-3 = selected from given options
* @property {Url} coverUrl - cover image url
* @property {string} dm_version - dm version
* @property {string} ds_origin - editor / editor x ...
* @property {GUID} esi - esi
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - true/false
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} videoId - video ID
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: singleVideoPlayer.coverImage.changed. Evid: 1510.
 * Event description: User changed the SVP cover image.

 * actionType - Type: string. Desc: add / change / select
 *
 * cover_index - Type: numeric. Desc: 0 = custom , 1-3 = selected from given options
 *
 * coverUrl - Type: url. Desc: cover image url
 *
 * dm_version - Type: string. Desc: dm version
 *
 * ds_origin - Type: string. Desc: editor / editor x ...
 *
 * esi - Type: guid. Desc: esi
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool. Desc: true/false
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * videoId - Type: string. Desc: video ID
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {singleVideoPlayerCoverImageChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var singleVideoPlayerCoverImageChanged = function (params) {
    return { evid: 1510, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} tpaHelpClickParams
* @property {GUID} app_id - [guid]
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} help_status - {open,close}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {gfpp,settings...}
* @property {string} panel_name - {}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {GUID} widget_id - [guid]
* @property {string} workspace_mode - null
**/
/**
 * Name: tpa_help_click. Evid: 175.
 * Event description: tpa_help_click.

 * app_id - Type: guid. Desc: [guid]
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * help_status - Type: string. Desc: {open,close}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {gfpp,settings...}
 *
 * panel_name - Type: string. Desc: {}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * widget_id - Type: guid. Desc: [guid]
 *
 * workspace_mode - Type: string.
 * @param {tpaHelpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tpaHelpClick = function (params) {
    return { evid: 175, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} soapOrderFixerRunParams
* @property {string} components_attached_to_header - List of components attached to header
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - {}
* @property {boolean} is_changed - Did the fixer change anything
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} soap_order_after - Order of SOAPs on site after migration
* @property {string} soap_order_before - Order of SOAPs on site before migration
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: SOAP_order_fixer_run. Evid: 842.
 * Event description: SOAP order fixer runs successfully.

 * components_attached_to_header - Type: string. Desc: List of components attached to header
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: {}
 *
 * is_changed - Type: bool. Desc: Did the fixer change anything
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * soap_order_after - Type: string. Desc: Order of SOAPs on site after migration
 *
 * soap_order_before - Type: string. Desc: Order of SOAPs on site before migration
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {soapOrderFixerRunParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var soapOrderFixerRun = function (params) {
    return { evid: 842, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} toolBarDistributionClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Tool_Bar_Distribution_click. Evid: 263.
 * Event description: Tool_Bar_Distribution_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {toolBarDistributionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolBarDistributionClick = function (params) {
    return { evid: 263, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} editorSearchItemViewParams
* @property {string} category - category name / id
* @property {number} categoryIndex - category index
* @property {string} correlationId - one search intent id
* @property {string} dm_version - null
* @property {string} ds_origin - Editor1.4
* @property {GUID} esi - editor session id
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} itemId - item name / id
* @property {number} itemIndex - item index
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - {}
* @property {string} requestId - id for each target search
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} target - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - bolt / santa
* @property {string} viewerVersion - bolt / santa vertion
* @property {string} workspace_mode - null
**/
/**
 * Name: editorSearch.item.view. Evid: 997.
 * Event description: Sent on each item after 3 seconds in a row of it is being in the viewport.

 * category - Type: string. Desc: category name / id
 *
 * categoryIndex - Type: numeric. Desc: category index
 *
 * correlationId - Type: string. Desc: one search intent id
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: Editor1.4
 *
 * esi - Type: guid. Desc: editor session id
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * itemId - Type: string. Desc: item name / id
 *
 * itemIndex - Type: numeric. Desc: item index
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: {}
 *
 * requestId - Type: string. Desc: id for each target search
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * target - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string. Desc: bolt / santa
 *
 * viewerVersion - Type: string. Desc: bolt / santa vertion
 *
 * workspace_mode - Type: string.
 * @param {editorSearchItemViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorSearchItemView = function (params) {
    return { evid: 997, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuSocialSettingsClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - temp field for test by valeryf (can be removed)
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu -> social settings click. Evid: 114.
 * Event description: add menu -> social settings click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: temp field for test by valeryf (can be removed)
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuSocialSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuSocialSettingsClick = function (params) {
    return { evid: 114, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} publishFlowUpgradeLaterButtonClickParams
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_first_publish - {1,0}
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} message - whats_next_content: {personal sale, music, connect domain, grow business, social}
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} user_status - {free user, Connected Premium, Not Connected...}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: publish_flow_upgrade_later_button_click. Evid: 273.
 * Event description: publish_upgrade_later_button_click.

 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_first_publish - Type: bool. Desc: {1,0}
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * message - Type: string. Desc: whats_next_content: {personal sale, music, connect domain, grow business, social}
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * user_status - Type: string. Desc: {free user, Connected Premium, Not Connected...}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {publishFlowUpgradeLaterButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishFlowUpgradeLaterButtonClick = function (params) {
    return { evid: 273, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} addMenuInnerNavigationCloseClickParams
* @property {string} category - {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: add menu-> inner navigation close click. Evid: 119.
 * Event description: add menu-> inner navigation close click.

 * category - Type: string. Desc: {text,image,gallert,button,shape,music,video,social,box,menu,contact,other,all}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {addMenuInnerNavigationCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMenuInnerNavigationCloseClick = function (params) {
    return { evid: 119, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} selectComponentParams
* @property {string} app_id - id of app inside section
* @property {string} compName - name, for example, section name
* @property {string} component_id - component_id
* @property {string} component_type - component_type
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - t/f
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} openedPanels - list of panel_names opened on component selection
* @property {string} origin - from where comp was selected
* @property {string} parent_component_id - parent_component_id
* @property {string} parent_component_type - Repeater/Strip/Container box
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: select_container_component. Evid: 1040.
 * Event description: select container component on the stage (container, repeater, section, strip).

 * app_id - Type: string. Desc: id of app inside section
 *
 * compName - Type: string. Desc: name, for example, section name
 *
 * component_id - Type: string. Desc: component_id
 *
 * component_type - Type: string. Desc: component_type
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: t/f
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * openedPanels - Type: string. Desc: list of panel_names opened on component selection
 *
 * origin - Type: string. Desc: from where comp was selected
 *
 * parent_component_id - Type: string. Desc: parent_component_id
 *
 * parent_component_type - Type: string. Desc: Repeater/Strip/Container box
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {selectComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectComponent = function (params) {
    return { evid: 1040, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} rotateComponentParams
* @property {string} component_type - What component is rotated
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - {tool bar, handle}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} status - linked to top/unlinked
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} value - {0,other}
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: rotate component. Evid: 153.
 * Event description: rotate component.

 * component_type - Type: string. Desc: What component is rotated
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: {tool bar, handle}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: string. Desc: linked to top/unlinked
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * value - Type: string. Desc: {0,other}
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {rotateComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rotateComponent = function (params) {
    return { evid: 153, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} clickOnPreviewRceParams
* @property {string} component_id - {}
* @property {string} component_type - {}
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} origin - {Esc., 'x', Click outside}
* @property {string} panel_name - {Translation Key}
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {boolean} status - if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
* @property {number} timeSpent - time from 309 open event in ms
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} value - True/False
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Click_On_Preview_RCE. Evid: 1126.
 * Event description: user click on preview inside the panel of RCE.

 * component_id - Type: string. Desc: {}
 *
 * component_type - Type: string. Desc: {}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * origin - Type: string. Desc: {Esc., 'x', Click outside}
 *
 * panel_name - Type: string. Desc: {Translation Key}
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * status - Type: bool. Desc: if checkbox status = ON then TRUE, if checkbox status = OFF then FALSE
 *
 * timeSpent - Type: numeric. Desc: time from 309 open event in ms
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * value - Type: string. Desc: True/False
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {clickOnPreviewRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnPreviewRce = function (params) {
    return { evid: 1126, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} sectionsStartAddingSectionParams
* @property {string} adding_method - click or drag
* @property {string} app_list - null
* @property {string} business_type - industry_id and structure_id upon click (aka business term) in json format
* @property {string} category - null
* @property {string} component_type - section
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - esi
* @property {boolean} is_app_installation_required - true if app installation is required; false if installation is not required, also in the case of non vertical sections
* @property {boolean} is_injected_content - true if content was already injected
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {number} itemIndex - for ai section creator - number of section in the list
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - from where the add section panel was opened or paste / duplicate
* @property {string} presetId - id of preset selected
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - uuid
* @property {string} version_of_content - version of the injected content
* @property {string} viewerName - viewerName
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Sections - start adding section. Evid: 1314.


 * adding_method - Type: string. Desc: click or drag
 *
 * app_list - Type: string.
 *
 * business_type - Type: string. Desc: industry_id and structure_id upon click (aka business term) in json format
 *
 * category - Type: string.
 *
 * component_type - Type: string. Desc: section
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: esi
 *
 * is_app_installation_required - Type: bool. Desc: true if app installation is required; false if installation is not required, also in the case of non vertical sections
 *
 * is_injected_content - Type: bool. Desc: true if content was already injected
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * itemIndex - Type: numeric. Desc: for ai section creator - number of section in the list
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: from where the add section panel was opened or paste / duplicate
 *
 * presetId - Type: string. Desc: id of preset selected
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * version_of_content - Type: string. Desc: version of the injected content
 *
 * viewerName - Type: string. Desc: viewerName
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {sectionsStartAddingSectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sectionsStartAddingSection = function (params) {
    return { evid: 1314, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} applyFromClipboardParams
* @property {GUID} app_id - [guid]
* @property {GUID} app_site_id - guid
* @property {string} component_type - {tpa,ed_component,list,blog...}
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {GUID} instance_id - [guid]
* @property {boolean} is_component_pinned - 0,1
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - null
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - null
* @property {string} origin - Right click,shortcut
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - null
* @property {string} usedJsHeapSize - null
* @property {string} viewerName - null
* @property {string} viewerVersion - null
* @property {string} workspace_mode - null
**/
/**
 * Name: Apply from clipboard. Evid: 633.
 * Event description: the ability of "Apply from clipboard" which is specific to hoverbox at the moment. User can do it from:
1. Right click
2. Shortcut.

 * app_id - Type: guid. Desc: [guid]
 *
 * app_site_id - Type: guid. Desc: guid
 *
 * component_type - Type: string. Desc: {tpa,ed_component,list,blog...}
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * instance_id - Type: guid. Desc: [guid]
 *
 * is_component_pinned - Type: bool. Desc: 0,1
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool.
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string.
 *
 * origin - Type: string. Desc: Right click,shortcut
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string.
 *
 * usedJsHeapSize - Type: string.
 *
 * viewerName - Type: string.
 *
 * viewerVersion - Type: string.
 *
 * workspace_mode - Type: string.
 * @param {applyFromClipboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var applyFromClipboard = function (params) {
    return { evid: 633, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} siteCreationWizardErrorUpdatingPropertiesParams
* @property {string} componentId - .
* @property {string} componentType - .
* @property {number} curatedTemplateId - .
* @property {string} dm_version - null
* @property {string} ds_origin - .
* @property {GUID} esi - .
* @property {boolean} is_rollout - .
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - .
* @property {string} multilingual - .
* @property {string} propertiesToUpdate - .
* @property {string} resultProperties - .
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - .
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Site Creation Wizard: ERROR UPDATING PROPERTIES. Evid: 1298.
 * Event description: an error BI for the site creation.

 * componentId - Type: string. Desc: .
 *
 * componentType - Type: string. Desc: .
 *
 * curatedTemplateId - Type: numeric. Desc: .
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string. Desc: .
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool. Desc: .
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string. Desc: .
 *
 * multilingual - Type: string. Desc: .
 *
 * propertiesToUpdate - Type: string. Desc: .
 *
 * resultProperties - Type: string. Desc: .
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string. Desc: .
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {siteCreationWizardErrorUpdatingPropertiesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteCreationWizardErrorUpdatingProperties = function (params) {
    return { evid: 1298, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} aiTextGeneratorTokensSpentParams
* @property {string} component_id - -
* @property {string} component_type - -
* @property {string} dm_version - -
* @property {string} ds_origin - null
* @property {GUID} esi - session id
* @property {boolean} is_rollout - -
* @property {boolean} isSection - -
* @property {boolean} isSiteCreation - -
* @property {boolean} isWixData - content manager connected components
* @property {boolean} isZoomOut - -
* @property {string} jsHeapSizeLimit - -
* @property {string} multilingual - -
* @property {string} parentComponentId - -
* @property {string} parentComponentType - -
* @property {string} query - request
* @property {GUID} site_id - {}
* @property {string} stage_type - null
* @property {number} tokensUsed - number of tokens used per request
* @property {string} totalJsHeapSize - -
* @property {string} usedJsHeapSize - -
* @property {string} viewerName - -
* @property {string} viewerVersion - -
* @property {string} workspace_mode - null
**/
/**
 * Name: AI Text Generator - Tokens Spent. Evid: 1457.
 * Event description: Number of tokens used per user request.

 * component_id - Type: string. Desc: -
 *
 * component_type - Type: string. Desc: -
 *
 * dm_version - Type: string. Desc: -
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: session id
 *
 * is_rollout - Type: bool. Desc: -
 *
 * isSection - Type: bool. Desc: -
 *
 * isSiteCreation - Type: bool. Desc: -
 *
 * isWixData - Type: bool. Desc: content manager connected components
 *
 * isZoomOut - Type: bool. Desc: -
 *
 * jsHeapSizeLimit - Type: string. Desc: -
 *
 * multilingual - Type: string. Desc: -
 *
 * parentComponentId - Type: string. Desc: -
 *
 * parentComponentType - Type: string. Desc: -
 *
 * query - Type: string. Desc: request
 *
 * site_id - Type: guid. Desc: {}
 *
 * stage_type - Type: string.
 *
 * tokensUsed - Type: numeric. Desc: number of tokens used per request
 *
 * totalJsHeapSize - Type: string. Desc: -
 *
 * usedJsHeapSize - Type: string. Desc: -
 *
 * viewerName - Type: string. Desc: -
 *
 * viewerVersion - Type: string. Desc: -
 *
 * workspace_mode - Type: string.
 * @param {aiTextGeneratorTokensSpentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var aiTextGeneratorTokensSpent = function (params) {
    return { evid: 1457, src: 38, endpoint: 'editor', params: params };
};
/**
* @typedef {Object} platformSilentInstallStartParams
* @property {string} appsToInstall - list that platform got from Editor
* @property {string} dm_version - null
* @property {string} ds_origin - null
* @property {GUID} esi - .
* @property {boolean} is_rollout - null
* @property {boolean} isSection - null
* @property {boolean} isSiteCreation - null
* @property {boolean} isZoomOut - .
* @property {string} jsHeapSizeLimit - null
* @property {string} multilingual - .
* @property {string} screenResolution - .
* @property {GUID} site_id - null
* @property {string} stage_type - null
* @property {string} totalJsHeapSize - .
* @property {string} usedJsHeapSize - null
* @property {GUID} uuid - .
* @property {string} view - first view in Wizard
* @property {string} viewerName - .
* @property {string} viewerVersion - .
* @property {string} workspace_mode - null
**/
/**
 * Name: Platform silent install start. Evid: 1336.
 * Event description: fire at the start of the silent install.

 * appsToInstall - Type: string. Desc: list that platform got from Editor
 *
 * dm_version - Type: string.
 *
 * ds_origin - Type: string.
 *
 * esi - Type: guid. Desc: .
 *
 * is_rollout - Type: bool.
 *
 * isSection - Type: bool.
 *
 * isSiteCreation - Type: bool.
 *
 * isZoomOut - Type: bool. Desc: .
 *
 * jsHeapSizeLimit - Type: string.
 *
 * multilingual - Type: string. Desc: .
 *
 * screenResolution - Type: string. Desc: .
 *
 * site_id - Type: guid.
 *
 * stage_type - Type: string.
 *
 * totalJsHeapSize - Type: string. Desc: .
 *
 * usedJsHeapSize - Type: string.
 *
 * uuid - Type: guid. Desc: .
 *
 * view - Type: string. Desc: first view in Wizard
 *
 * viewerName - Type: string. Desc: .
 *
 * viewerVersion - Type: string. Desc: .
 *
 * workspace_mode - Type: string.
 * @param {platformSilentInstallStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var platformSilentInstallStart = function (params) {
    return { evid: 1336, src: 38, endpoint: 'editor', params: params };
};
//# sourceMappingURL=index.js.map